/**
 * WikiConnector 页面多语言文案 & 内容配置
 * 修改文案直接编辑此文件对应语言的字段即可
 * lang key 与 store.state.locale 保持一致
 */

const t = {
  'zh-cn': {
    // 导航
    nav: 'WikiConnector',

    // Hero 区
    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView 信号自动连接 MetaTrader 执行交易',
    heroBtn: '免费开始使用',

    // 统计数字
    stat1Label: '平均延迟',
    stat2Label: '服务在线率',
    stat3Label: '全天候运行',
    stat4Label: '多账户分发',

    // 流程图节点副标题
    flowSub1: '策略 / Alert',
    flowSub2: '信号路由',
    flowSub3: '自动执行',

    // 核心优势
    featTitle: '为什么选择 WikiConnector',
    featSubtitle: '核心优势',
    features: [
      {
        icon: '⚡',
        title: '毫秒级执行',
        desc: '信号平均延迟 <100ms，配合 WikiFX VPS 可低至 1ms。'
      },
      {
        icon: '🔗',
        title: '多账户分发',
        desc: '一个证书连接多个 MT 终端，同一策略信号同时分发。'
      },
      {
        icon: '🔒',
        title: '安全加密',
        desc: '每位用户独立密钥体系，数据全链路加密传输。'
      },
      {
        icon: '📊',
        title: '实时监控',
        desc: '信号接收状态、执行延迟、成功率实时可见。'
      },
      {
        icon: '<>',
        title: '代码生成器',
        desc: '可视化生成 JSON 信号和 Pine Script 代码，无需编程。'
      },
      {
        icon: '🖥',
        title: 'VPS 深度集成',
        desc: '与天眼云 VPS 共享账户体系，7×24 低延迟运行。'
      }
    ],

    // 快速上手
    stepsTitle: '四步开始自动化交易',
    stepsSubtitle: '快速上手',
    steps: [
      {
        title: '登录账户',
        desc: '使用 WikiFX 账户登录，自动获取专属密钥和 License。'
      },
      {
        title: '配置 Webhook',
        desc: '将 Webhook URL 复制到 TradingView Alert 设置。'
      },
      {
        title: '安装 EA',
        desc: '下载 WikiConnector EA，输入 License ID 和 Secret Key。'
      },
      {
        title: '自动交易',
        desc: '策略触发 Alert 时，信号自动传达 MT 终端执行。'
      }
    ],

    // 登录引导
    loginTip: '登录后即可查看你的专属密钥和证书',
    loginBtn: '立即登录',

    // Dashboard 侧边栏导航
    navConn: '连接管理',
    navLog: '信号日志',
    navGen: '代码生成',
    navParams: '参数速查',
    navDl: '下载',
    navDoc: '使用教程',
    navFaq: '常见问题',

    // 密钥区
    keyLabel: 'Secret Key',
    keyTip1: '请勿分享给任何人',
    keyTip2: '用于 EA 鉴权',
    keyTip3: '重置后旧密钥立即失效',

    // 连接管理
    connSubtitle: '以下是你的 License 及其对应的 Webhook URL',
    noLicense: '暂无 License，请联系客服开通',
    needHelp: '需要帮助？',
    viewDoc: '查看使用教程',

    // 信号日志
    allLicense: '全部 License',
    allStatus: '全部状态',
    refresh: '刷新',
    signalId: '信号 ID',
    total: '共',
    records: '条记录',

    // 代码生成
    genIntro: '填写以下参数，自动生成可在 TradingView Alert 中使用的 JSON 信号和 Pine Script 代码。',
    genAuth: '鉴权信息',
    required: '必填',
    optional: '选填',
    genLicPlaceholder: '输入你的 License ID',
    genLicHint: '在连接管理页面查看',
    genKeyPlaceholder: '输入你的 Secret Key',
    genKeyHint: '在连接管理页面查看',
    genTrade: '交易指令',
    genCmd: '指令类型',
    genMarket: '市价单',
    genPending: '挂单',
    genClose: '平仓',
    cmdBuy: '市价买入',
    cmdSell: '市价卖出',
    cmdBuyLimit: '限价买入',
    cmdSellLimit: '限价卖出',
    cmdBuyStop: '突破买入',
    cmdSellStop: '突破卖出',
    cmdCloseBuy: '平多单',
    cmdCloseSell: '平空单',
    cmdCloseAll: '平该品种',
    cmdCloseAllOrders: '平全部',
    genSlTpHint: '三选一 · 优先级：价格 > 点数 > 百分比',
    genTsHint: '信号发送时间',
    genTsBtn: '当前时间',
    presetSimple: '📝 简单买入',
    presetSltp: '🛡 带止损止盈',
    presetFull: '📋 完整参数',
    presetClose: '❌ 平仓信号',
    presetPending: '📌 挂单',
    presetReverse: '🔄 反手（平+开）',
    genAlertTab: '🔔 Alert 设置说明',
    toastIncomplete: '信息不完整，请填写必填项',
    toastRegen: '新密钥已生成，请立即复制并更新所有已配置的 EA',
    toastKeyCopied: '密钥已复制',
    toastCopied: '已复制',
    toastCodeCopied: '代码已复制',
    copyTitle: '复制',
    genSymbol: '交易品种',
    genPrice: '挂单价格',
    genParams: '交易参数',
    genLots: '手数',
    genLotsHint: '留空则使用 EA 默认值',
    genMagic: 'Magic Number',
    genMagicHint: '用于区分不同策略的订单',
    genComment: '订单备注',
    genCommentHint: '如：Strategy A',
    genSL: '止损设置',
    genPoints: '点数',
    genPrice2: '固定价格',
    genPct: '百分比 %',
    genTP: '止盈设置',
    genAdvanced: '高级参数',
    genSigIdHint: '留空则自动生成，用于去重',
    genGenId: '自动生成',
    genBtn: '生成代码',
    genFormat: '信号格式',
    genGuideTitle: '如何在 TradingView 中使用',
    genGuideSteps: [
      '在 TradingView 图表上创建 <strong>Alert（警报）</strong>',
      '在 <strong>Alert 触发条件</strong>中选择你的策略或指标',
      '展开 <strong>Notifications（通知）</strong> → 勾选 <strong>Webhook URL</strong>',
      '将 Webhook URL 填写为：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      '将上方生成的 JSON 粘贴到 <strong>Message（消息）</strong> 框中',
      '点击 <strong>Create（创建）</strong> 保存 Alert'
    ],
    genGuideNote: '<strong>提示：</strong> 如使用 Pine Script，将生成的代码添加到你的脚本中，并在 <code>strategy.entry()</code> 或 <code>strategy.close()</code> 中使用 <code>alert_message</code> 参数。',

    // 参数速查 - 分组结构
    paramsGroups: [
      {
        title: '🔐 Authorization（授权）— 必须修改',
        rows: [
          ['License', '—', '授权 ID，必须与信号 JSON 中的 license 字段完全一致', 'req'],
          ['SecretKey', '—', '安全密钥（wc_sk_ 开头），必须与信号 JSON 中的 key 字段完全一致', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters（默认交易参数）',
        rows: [
          ['InpLots', '0.1', '默认手数，信号 JSON 未包含 lots 时使用', ''],
          ['InpMagic', '888', '默认魔术号，用于区分不同策略的订单', ''],
          ['InpComment', 'TV Signal', '默认订单注释', ''],
          ['InpDeviation', '30', '最大滑点（点数），外汇建议 10–30，黄金/指数建议 30–50', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit（止损止盈）',
        note: '优先级：sl_price（固定价格）> sl_points（点数）> sl_pct（百分比），三项均为 0 则不设止损，止盈同理',
        rows: [
          ['InpSLPoints', '0', '默认止损点数（0 = 不启用）', ''],
          ['InpSLPrice', '0', '默认止损固定价格（0 = 不启用，优先级最高）', ''],
          ['InpSLPct', '0', '默认止损百分比（0 = 不启用）', ''],
          ['InpTPPoints', '0', '默认止盈点数（0 = 不启用）', ''],
          ['InpTPPrice', '0', '默认止盈固定价格（0 = 不启用）', ''],
          ['InpTPPct', '0', '默认止盈百分比（0 = 不启用）', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping（品种名称映射）',
        note: '不同券商品种命名可能不同（如 TradingView 叫 XAUUSD，你的券商叫 GOLD），使用映射可自动转换',
        rows: [
          ['InpPrefix', '（空）', '品种名前缀，如券商品种为 m.EURUSD 则填 m.', ''],
          ['InpSuffix', '（空）', '品种名后缀，如券商品种为 EURUSD.pro 则填 .pro', ''],
          ['InpEnableMap1~5', 'false', '设为 true 启用对应映射规则', ''],
          ['InpMapping1', 'XAUUSD|GOLD', '映射规则，格式：TradingView品种名|MT5品种名，支持 5 条', ''],
          ['InpMapping2', 'EURUSD|EUR', '同上', ''],
          ['InpMapping3', 'GBPUSD|GBP', '同上', ''],
          ['InpMapping4', 'BTCUSD|BTC', '同上', ''],
          ['InpMapping5', 'USOUSD|WTI', '同上', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log（时间过滤 / 日志）',
        rows: [
          ['InpUseTimeFilter', 'false', '启用后只在 StartTime~EndTime 内处理信号', ''],
          ['InpStartTime', '00:00', '允许交易开始时间（MT5 服务器时间，格式 HH:MM）', ''],
          ['InpEndTime', '23:59', '允许交易结束时间', ''],
          ['InpShowPanel', 'true', '在图表上显示连接状态、信号统计等信息面板', ''],
          ['InpUpdateInterval', '1000', '面板刷新间隔（毫秒），建议 1000~3000', ''],
          ['InpLogLevel', '1', '日志级别：0=关闭 1=基本 2=详细 3=调试（排错时用 2 或 3）', ''],
          ['InpLogToFile', 'true', '写入日志文件至 MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', '输出到 MT5 底部"专家"标签页', ''],
          ['InpMaxLogMB', '5', '日志文件最大体积（MB），超出后自动轮换', '']
        ]
      }
    ],
    // 保留旧字段兼容（不再使用但防止报错）
    paramsEATitle: 'EA 参数说明',
    paramsEADesc: '以下参数在 MT5 中打开 EA 时可设置，也可通过 JSON 信号中对应字段覆盖。',
    paramName: '参数名',
    paramDefault: '默认值',
    paramDesc: '说明',
    paramOverride: 'JSON 覆盖字段',
    eaParams: [
      ['DefaultLots', '0.1', '默认手数（JSON 未指定时使用）', 'lots'],
      ['DefaultMagic', '0', '默认 Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', '默认订单备注', 'comment'],
      ['SlippagePoints', '3', '最大滑点（点数）', '—'],
      ['OfflineBuffer', 'false', '是否开启离线缓冲', '—'],
      ['ReconnectSeconds', '5', 'WebSocket 断线重连间隔（秒）', '—']
    ],
    cmdTableTitle: '指令类型说明',
    cmdCol: '指令 (cmd)',
    typeCol: '类型',
    actionCol: '动作',
    extraCol: '额外参数',
    cmdTable: [
      ['buy', '市价单', '立即买入', 'lots, sl_*, tp_*'],
      ['sell', '市价单', '立即卖出', 'lots, sl_*, tp_*'],
      ['buylimit', '挂单', '价格触及时买入', 'price, lots, sl_*, tp_*'],
      ['selllimit', '挂单', '价格触及时卖出', 'price, lots, sl_*, tp_*'],
      ['buystop', '挂单', '价格突破时买入', 'price, lots, sl_*, tp_*'],
      ['sellstop', '挂单', '价格突破时卖出', 'price, lots, sl_*, tp_*'],
      ['closebuy', '平仓', '平所有多单', 'magic（可选）'],
      ['closesell', '平仓', '平所有空单', 'magic（可选）'],
      ['closeall', '平仓', '平所有持仓', '—'],
      ['closeallorders', '平仓', '删除所有挂单', '—']
    ],
    jsonFieldTitle: 'JSON 字段说明',
    fieldCol: '字段名',
    requiredCol: '是否必填',
    descCol: '说明',
    jsonFields: [
      ['license', 'string', '必填', 'License ID'],
      ['key', 'string', '必填', 'Secret Key'],
      ['cmd', 'string', '必填', '交易指令，见上表'],
      ['symbol', 'string', '必填', '交易品种，如 EURUSD'],
      ['lots', 'number', '选填', '手数，留空使用 EA 默认值'],
      ['price', 'number', '挂单必填', '挂单价格'],
      ['sl_points', 'number', '选填', '止损点数'],
      ['sl_price', 'number', '选填', '止损固定价格'],
      ['sl_pct', 'number', '选填', '止损百分比（0-100）'],
      ['tp_points', 'number', '选填', '止盈点数'],
      ['tp_price', 'number', '选填', '止盈固定价格'],
      ['tp_pct', 'number', '选填', '止盈百分比（0-100）'],
      ['magic', 'number', '选填', 'Magic Number'],
      ['comment', 'string', '选填', '订单备注'],
      ['signalid', 'string', '选填', '信号唯一 ID，用于去重'],
      ['expiryseconds', 'number', '选填', '信号有效期（秒），默认 60']
    ],

    // 下载
    dlMt5Desc: 'MT5 版本 EA，支持全部指令，推荐使用',
    dlMt5Btn: '下载 MT5 EA',
    dlMt4Desc: 'MT4 版本 EA，开发中，敬请期待',
    dlMt4Dev: '开发中',
    dlInstallDoc: `<h4>安装说明</h4>
<ol>
<li>下载 <code>WikiConnector_MT5.ex5</code> 文件</li>
<li>打开 MT5，菜单栏 → <strong>文件 → 打开数据目录</strong></li>
<li>将 <code>.ex5</code> 文件复制到 <code>MQL5/Experts/</code> 目录</li>
<li>在 MT5 中按 <strong>F5</strong> 刷新导航器，找到 WikiConnector EA</li>
<li>将 EA 拖拽到任意图表，填入 <strong>License ID</strong> 和 <strong>Secret Key</strong></li>
<li>在 EA 选项中勾选 <strong>允许 WebRequest</strong>，并添加 <code>api-gw.interface003.com</code> 到允许的 URL 列表</li>
</ol>`,

    // 弹窗
    disclaimerTitle: '风险免责声明',
    disclaimerContent: `<p>在下载和使用 WikiConnector EA 之前，请仔细阅读以下免责声明：</p>
<p><strong>1. 交易风险</strong><br/>外汇和差价合约交易存在重大风险，可能导致全部或部分资金损失。WikiConnector 仅为信号传输工具，不对任何交易结果负责。</p>
<p><strong>2. 策略风险</strong><br/>自动化交易策略的历史表现不代表未来结果。请在真实账户中使用前充分测试。</p>
<p><strong>3. 技术风险</strong><br/>网络延迟、服务器故障、API 限制等技术因素可能导致信号丢失或执行延迟。请勿将本工具用于对延迟极度敏感的高频策略。</p>
<p><strong>4. 使用责任</strong><br/>用户对使用 WikiConnector EA 产生的所有交易结果承担全部责任。WikiFX 不提供投资建议，亦不对交易盈亏负责。</p>`,
    disclaimerAgree: '我已阅读并同意上述免责声明，了解交易风险',
    disclaimerDownload: '同意并下载',

    regenTitle: '确认重置密钥？',
    regenSubtitle: '此操作不可撤销，请确认你已了解以下影响：',
    regenWarnings: ['所有已配置此密钥的 EA 将<strong>立即断开连接</strong>', '旧密钥<strong>永久失效</strong>，无法恢复', '你需要手动更新所有 EA 中的 Secret Key 配置', '重置期间可能有<strong>信号丢失</strong>风险'],

    // Dashboard
    dashTitle: '我的 WikiConnector',
    myKey: '我的密钥',
    keyPrefix: 'Secret Key',
    copyBtn: '复制',
    regenBtn: '重新生成',
    regenConfirm: '重新生成密钥后，所有正在连接的 EA 将断开，需重新配置。确认继续？',
    regenConfirmBtn: '确认重置',
    cancelBtn: '取消',
    copiedTip: '已复制',

    // 证书
    licenseTitle: '我的证书 (License)',
    licenseId: '证书 ID',
    maxConn: '最大连接数',
    activeConn: '当前连接',
    webhookUrl: 'Webhook URL',

    // 信号统计
    statsTitle: '信号统计',
    statTotal: '总信号数',
    statDelivered: '已投递',
    statFailed: '失败',
    statConnections: '当前连接',

    // 信号日志
    signalTitle: '最近信号记录',
    signalTime: '时间',
    signalCmd: '指令',
    signalSymbol: '品种',
    signalLots: '手数',
    signalStatus: '状态',
    signalLicense: '证书',
    statusDelivered: '已投递',
    statusPending: '待投递',
    statusFailed: '失败',
    statusExpired: '已过期',
    noSignal: '暂无信号记录',
    loadMore: '加载更多',

    // 离线缓冲
    offlineBuffer: '离线缓冲',
    offlineBufferDesc: '开启后，EA 重连时将投递离线期间积累的信号（默认关闭，防止亏损）',

    // 使用教程
    docTitle: '使用教程',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 WikiConnector 工作原理</p>
  <p>WikiConnector 通过 <strong>WebSocket 长连接</strong>实时接收 TradingView 信号，并在交易软件中自动执行交易。</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① 安装 EA 到交易软件</p>
  <ol class="doc-steps">
    <li><strong>打开数据文件夹</strong>：交易软件菜单 → 文件 → 打开数据文件夹</li>
    <li><strong>复制 EA 文件</strong>：将 EA 文件复制到 <code>Experts/</code> 目录</li>
    <li><strong>刷新导航器</strong>：打开导航器 → 在"智能交易系统"右键 → 刷新，列表中应出现 <strong>SignalReceiver</strong></li>
    <li><strong>开启自动交易</strong>：顶部工具栏"自动交易"按钮必须为 🟢 绿色</li>
    <li><strong>挂载到图表</strong>：将 SignalReceiver 拖放到任意图表，弹出设置窗口后配置参数</li>
  </ol>
  <div class="doc-tip"><strong>提示：</strong>EA 只需挂载在一张图表上，即可处理所有品种的信号，无需在每个品种图表上分别挂载。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② 配置 EA 参数</p>
  <p>参数分两类：<strong>必填</strong>（License / SecretKey）和<strong>默认值参数</strong>（信号 JSON 未包含某字段时使用，信号中的值始终优先于 EA 默认值）。</p>
  <div class="doc-warn"><strong>安全警告：</strong>License 和 SecretKey 是保护账户的唯一屏障。若泄露，任何人都可以向你的交易软件发送交易指令。请勿截图或分享给他人，建议定期更换 SecretKey。</div>
  <p>设置完成后，图表右上角出现 EA 名称 + <strong>😊</strong> 表示已连接服务端；若显示 😞，检查"自动交易"按钮是否为绿色。</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ 编写 Pine Script 信号代码</p>
  <p>WikiConnector 使用 <code>alert()</code> 函数触发信号，而非 <code>strategy.entry(alert_message=)</code> 方式，两种机制不同，请勿混用。</p>
  <div class="doc-danger"><strong>关键：alert.freq_all</strong> — Pine Script 默认同一 K 线内只有第一个 <code>alert()</code> 触发，后续全部静默丢弃。需要连续发送多条信号时（如反手：先平空再开多），每个 <code>alert()</code> 都必须加 <code>alert.freq_all</code>，否则第二条信号永远不会到达服务端。</div>
<pre>//@version=6
strategy("WikiConnector 策略", overlay=true)

// 定义信号消息（将 YOUR_LICENSE 和 YOUR_KEY 替换为你自己的值）
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// 策略条件示例（3/13 均线交叉）
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// 使用 alert.freq_all 确保同一 K 线内多条信号都能发出
if longCondition
    alert(closesellMessage, alert.freq_all)  // 先平空单
    alert(buyMessage,       alert.freq_all)  // 再开多单

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // 先平多单
    alert(sellMessage,     alert.freq_all)   // 再开空单</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ 在 TradingView 创建警报</p>
  <p>Webhook URL：</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>图表右键 → "<strong>添加警报...</strong>" 或按 <strong>Alt+A</strong></li>
    <li>触发条件选择 <strong>"仅 alert() 函数调用"</strong>（关键！）</li>
    <li>到期时间选择尽量长，或"Open-ended"永不过期</li>
    <li>Message 框 <strong>保持默认，不填任何内容</strong>（信号内容由代码中的 alert() 决定）</li>
    <li>通知设置：勾选 <strong>Webhook URL</strong> 并填入上方地址；<strong>取消勾选"发送纯文本"</strong></li>
    <li>点击"创建"保存警报</li>
  </ol>
  <div class="doc-tip"><strong>提示：</strong>Webhook 功能需要 TradingView Pro 或更高级别订阅。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ 信号 JSON 格式说明</p>
  <p><strong>必填字段：</strong><code>license</code>（授权ID）、<code>key</code>（密钥）、<code>cmd</code>（指令）、<code>symbol</code>（品种名）</p>
  <p><strong>选填字段：</strong><code>lots</code>（手数）、<code>price</code>（挂单价格）、<code>sl_points / sl_price / sl_pct</code>（止损三选一）、<code>tp_points / tp_price / tp_pct</code>（止盈三选一）、<code>magic</code>、<code>comment</code>、<code>signal_id</code>、<code>expiry_seconds</code>（默认300秒）</p>
  <p><strong>支持的 cmd：</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>止损止盈优先级：</strong><code>sl_price</code>（固定价格）&gt; <code>sl_points</code>（点数）&gt; <code>sl_pct</code>（百分比），三项均为 0 则不设止损，止盈同理。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ 上线前检查清单</p>
  <ul class="doc-checklist">
    <li class="ok">✅ 交易软件自动交易按钮为 🟢 绿色</li>
    <li class="ok">✅ 图表右上角 EA 显示 😊（已连接服务端）</li>
    <li class="ok">✅ License / SecretKey 与 TradingView JSON 中的值完全一致</li>
    <li class="ok">✅ 警报触发条件选择"<strong>仅 alert() 函数调用</strong>"</li>
    <li class="ok">✅ 每个 <code>alert()</code> 都加了 <code>alert.freq_all</code></li>
    <li class="ok">✅ Webhook URL：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message 框保持默认，不填任何内容</li>
    <li class="no">❌ 取消勾选"发送纯文本"</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ 安全与风险提示</p>
  <div class="doc-warn">
    <strong>账户安全：</strong><br>
    · 不要将 License 和 SecretKey 截图或分享给任何人<br>
    · 若怀疑密钥泄露，立即在控制台重置 SecretKey<br>
    · 建议定期更换 SecretKey
  </div>
  <div class="doc-warn">
    <strong>交易风险控制：</strong><br>
    · 始终设置止损，切勿裸仓运行自动化策略<br>
    · 单笔风险建议控制在账户资金的 1–2% 以内<br>
    · 重大经济数据（非农、CPI、FOMC）发布前建议暂停自动交易
  </div>
  <div class="doc-tip">
    <strong>最佳实践：</strong><br>
    · 先在模拟账户（Demo）测试至少 1–2 周，确认链路正常后再切换真实账户<br>
    · 真实账户初期使用最小手数（0.01手）<br>
    · 使用 VPS（如天眼云 VPS）确保交易软件和 EA 24 小时在线
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook 信号格式',
        content: `在 TradingView Alert 的 Message 中填写以下 JSON：
<pre>{
  "license": "{{你的LicenseID}}",
  "key": "{{你的SecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>支持的 <strong>cmd</strong> 指令：buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook 地址',
        content: `<p>在 TradingView Alert 设置中，将 Webhook URL 填写为：</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>在 Message 框中填写上方 JSON 信号格式，将 license 和 key 替换为你自己的值。</p>`
      },
      {
        title: '3. 安装 WikiConnector EA',
        content: `<p>1. 下载 WikiConnector EA（.ex5 文件）</p>
<p>2. 将 EA 复制到 MT5 的 <code>MQL5/Experts</code> 目录</p>
<p>3. 在 MT5 中打开 EA，填入 <strong>License ID</strong> 和 <strong>Secret Key</strong></p>
<p>4. 允许 EA 进行 WebSocket 连接（在 MT5 选项 → EA 中开启网络连接权限）</p>`
      },
      {
        title: '4. 频率限制',
        content: `<p>每个 License 最多 <strong>30 次 / 60 秒</strong>，超过限制将返回 429 错误。</p>
<p>如需更高频率，请联系客服升级套餐。</p>`
      }
    ],

    // 常见问题
    faqTitle: '常见问题',
    faqs: [
      {
        q: '密钥泄露了怎么办？',
        a: '在控制台点击「重新生成」，旧密钥立即失效，所有 EA 连接会被踢下线，使用新密钥重新配置 EA 即可。'
      },
      {
        q: 'EA 断线重连后会补发信号吗？',
        a: '默认不补发（防止亏损）。如需补发，在控制台开启「离线缓冲」开关，EA 重连后将接收离线期间的信号。'
      },
      {
        q: '一个 License 可以连接几个 MT 账户？',
        a: '每个 License 最多支持 10 个并发 WebSocket 连接，可同时连接 10 个 MT 终端接收同一信号。'
      },
      {
        q: '支持 MT4 吗？',
        a: '当前版本主要支持 MT5。MT4 版本 EA 正在开发中，敬请期待。'
      },
      {
        q: '信号延迟有多高？',
        a: '平均延迟 <100ms，配合天眼云 VPS 部署可低至 1ms。'
      },
      {
        q: '如何测试 Webhook 是否正常工作？',
        a: '在证书列表中查看「当前连接数」，连接数 > 0 表示 EA 在线。发送测试信号后，在「最近信号记录」中可看到状态为「已投递」。'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script 与信号发送',
        items: [
          {
            q: '我用了两个 alert() 发平仓和开仓，但交易软件只收到一条信号？',
            a: '这是 Pine Script 的默认限制，同一 K 线内只有第一个 alert() 触发。解决方法是给<strong>每个 alert() 都加上 <code>alert.freq_all</code> 参数</strong>：<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: '警报触发条件应该选哪个？',
            a: '使用 <code>alert()</code> 函数方式时，必须选择 <strong>"仅 alert() 函数调用"</strong>。如果使用 <code>strategy.entry(..., alert_message=xxx)</code> 方式则选 "Order fills only"。两种方式不能混用。'
          },
          {
            q: 'Message 框里需要填写什么？',
            a: '使用 <code>alert()</code> 方式时，<strong>Message 框保持默认，什么都不需要填</strong>。信号内容由代码中 <code>alert(xxx)</code> 里的字符串决定，Webhook 收到的就是那个 JSON。'
          }
        ]
      },
      {
        title: '🔌 连接与信号接收',
        items: [
          {
            q: 'EA 图标显示红色哭脸 😞，怎么办？',
            a: '检查交易软件工具栏的"自动交易"按钮是否为绿色。若是红色，点击切换为绿色，EA 会自动恢复正常。'
          },
          {
            q: '信号从 TradingView 发出，但交易软件没有反应？',
            a: '按顺序检查：<br>1. 交易软件自动交易是否绿色<br>2. EA 面板是否显示 Connected<br>3. Webhook URL 是否为 <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code><br>4. 警报触发条件是否选了"仅 alert() 函数调用"<br>5. 每个 alert() 是否都加了 <code>alert.freq_all</code><br>6. JSON 中 license 和 key 是否与 EA 设置完全一致'
          }
        ]
      },
      {
        title: '💰 交易执行',
        items: [
          {
            q: '下单失败，是什么原因？',
            a: '常见原因：余额不足 / 品种名不一致（需配置 Symbol Mapping）/ 手数超限 / 滑点过大（增大 InpDeviation）/ 市场已关闭。请查看交易软件底部"专家"日志获取具体错误信息。'
          },
          {
            q: '订单没有止损止盈？',
            a: '检查：① 信号 JSON 是否包含 <code>sl_points</code> / <code>tp_points</code> 等字段；② EA 默认止损止盈参数是否为 0。两边都没有设置时，订单不会有止损止盈。'
          },
          {
            q: '品种名不一致怎么办？',
            a: '在 EA 参数中启用 Symbol Mapping：<br>设置 <code>InpEnableMap1 = true</code><br>设置 <code>InpMapping1 = XAUUSD|GOLD</code>（TradingView品种名|交易软件品种名）'
          },
          {
            q: '可以先用模拟账户测试吗？',
            a: '<strong>强烈建议！</strong>首次使用必须在模拟账户（Demo）上测试至少 1–2 周，确认链路正常、订单执行正确后再切换真实账户，初期使用最小手数 0.01。'
          }
        ]
      }
    ]
  },

  'zh-tw': {
    nav: 'WikiConnector',
    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView 訊號自動連接 MetaTrader 執行交易',
    heroBtn: '免費開始使用',
    stat1Label: '平均延遲',
    stat2Label: '服務在線率',
    stat3Label: '全天候運行',
    stat4Label: '多帳戶分發',
    flowSub1: '策略 / Alert',
    flowSub2: '訊號路由',
    flowSub3: '自動執行',
    featTitle: '為什麼選擇 WikiConnector',
    featSubtitle: '核心優勢',
    features: [
      {
        icon: '⚡',
        title: '毫秒級執行',
        desc: '訊號平均延遲 <100ms，配合 WikiFX VPS 可低至 1ms。'
      },
      {
        icon: '🔗',
        title: '多帳戶分發',
        desc: '一個證書連接多個 MT 終端，同一策略訊號同時分發。'
      },
      {
        icon: '🔒',
        title: '安全加密',
        desc: '每位用戶獨立密鑰體系，資料全鏈路加密傳輸。'
      },
      {
        icon: '📊',
        title: '實時監控',
        desc: '訊號接收狀態、執行延遲、成功率實時可見。'
      },
      {
        icon: '<>',
        title: '代碼生成器',
        desc: '可視化生成 JSON 訊號和 Pine Script 代碼，無需編程。'
      },
      {
        icon: '🖥',
        title: 'VPS 深度集成',
        desc: '與天眼雲 VPS 共享帳戶體系，7×24 低延遲運行。'
      }
    ],
    stepsTitle: '四步開始自動化交易',
    stepsSubtitle: '快速上手',
    steps: [
      {
        title: '登錄帳戶',
        desc: '使用 WikiFX 帳戶登錄，自動獲取專屬密鑰和 License。'
      },
      {
        title: '配置 Webhook',
        desc: '將 Webhook URL 複製到 TradingView Alert 設置。'
      },
      {
        title: '安裝 EA',
        desc: '下載 WikiConnector EA，輸入 License ID 和 Secret Key。'
      },
      {
        title: '自動交易',
        desc: '策略觸發 Alert 時，訊號自動傳達 MT 終端執行。'
      }
    ],
    loginTip: '登錄後即可查看你的專屬密鑰和證書',
    loginBtn: '立即登錄',
    navConn: '連接管理',
    navLog: '訊號日誌',
    navGen: '代碼生成',
    navParams: '參數速查',
    navDl: '下載',
    navDoc: '接入文檔',
    navFaq: '常見問題',
    keyLabel: 'Secret Key',
    keyTip1: '請勿分享給任何人',
    keyTip2: '用於 EA 鑑權',
    keyTip3: '重置後舊密鑰立即失效',
    connSubtitle: '以下是你的 License 及其對應的 Webhook URL',
    noLicense: '暫無 License，請聯繫客服開通',
    needHelp: '需要幫助？',
    viewDoc: '查看接入文檔',
    allLicense: '全部 License',
    allStatus: '全部狀態',
    refresh: '刷新',
    signalId: '訊號 ID',
    total: '共',
    records: '條記錄',
    genIntro: '填寫以下參數，自動生成可在 TradingView Alert 中使用的 JSON 訊號和 Pine Script 代碼。',
    genAuth: '鑑權信息',
    required: '必填',
    optional: '選填',
    genLicPlaceholder: '輸入你的 License ID',
    genLicHint: '在連接管理頁面查看',
    genKeyPlaceholder: '輸入你的 Secret Key',
    genKeyHint: '在連接管理頁面查看',
    genTrade: '交易指令',
    genCmd: '指令類型',
    genMarket: '市價單',
    genPending: '掛單',
    genClose: '平倉',
    cmdBuy: '市價買入',
    cmdSell: '市價賣出',
    cmdBuyLimit: '限價買入',
    cmdSellLimit: '限價賣出',
    cmdBuyStop: '突破買入',
    cmdSellStop: '突破賣出',
    cmdCloseBuy: '平多單',
    cmdCloseSell: '平空單',
    cmdCloseAll: '平該品種',
    cmdCloseAllOrders: '平全部',
    genSlTpHint: '三選一 · 優先級：價格 > 點數 > 百分比',
    genTsHint: '訊號發送時間',
    genTsBtn: '當前時間',
    presetSimple: '📝 簡單買入',
    presetSltp: '🛡 帶止損止盈',
    presetFull: '📋 完整參數',
    presetClose: '❌ 平倉訊號',
    presetPending: '📌 掛單',
    toastRegen: '新密鑰已生成，請立即複製並更新所有已配置的 EA',
    toastKeyCopied: '密鑰已複製',
    toastCopied: '已複製',
    toastCodeCopied: '代碼已複製',
    copyTitle: '複製',
    genSymbol: '交易品種',
    genPrice: '掛單價格',
    genParams: '交易參數',
    genLots: '手數',
    genLotsHint: '留空則使用 EA 預設值',
    genMagic: 'Magic Number',
    genMagicHint: '用於區分不同策略的訂單',
    genComment: '訂單備注',
    genCommentHint: '如：Strategy A',
    genSL: '止損設置',
    genPoints: '點數',
    genPrice2: '固定價格',
    genPct: '百分比 %',
    genTP: '止盈設置',
    genAdvanced: '高級參數',
    genSigIdHint: '留空則自動生成，用於去重',
    genGenId: '自動生成',
    genBtn: '生成代碼',
    genFormat: '訊號格式',
    genGuideTitle: '如何在 TradingView 中使用',
    genGuideSteps: [
      '在 TradingView 圖表上創建 <strong>Alert（警報）</strong>',
      '在 <strong>Alert 觸發條件</strong>中選擇你的策略或指標',
      '展開 <strong>Notifications（通知）</strong> → 勾選 <strong>Webhook URL</strong>',
      '將 Webhook URL 填寫為：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      '將上方生成的 JSON 粘貼到 <strong>Message（消息）</strong> 框中',
      '點擊 <strong>Create（創建）</strong> 保存 Alert'
    ],
    genGuideNote: '<strong>提示：</strong> 如使用 Pine Script，將生成的代碼添加到你的腳本中，並在 <code>strategy.entry()</code> 或 <code>strategy.close()</code> 中使用 <code>alert_message</code> 參數。',
    paramsEATitle: 'EA 參數說明',
    paramsEADesc: '以下參數在 MT5 中打開 EA 時可設置，也可通過 JSON 訊號中對應字段覆蓋。',
    paramName: '參數名',
    paramDefault: '預設值',
    paramDesc: '說明',
    paramOverride: 'JSON 覆蓋字段',
    eaParams: [
      ['DefaultLots', '0.1', '預設手數（JSON 未指定時使用）', 'lots'],
      ['DefaultMagic', '0', '預設 Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', '預設訂單備注', 'comment'],
      ['SlippagePoints', '3', '最大滑點（點數）', '—'],
      ['OfflineBuffer', 'false', '是否開啟離線緩衝', '—'],
      ['ReconnectSeconds', '5', 'WebSocket 斷線重連間隔（秒）', '—']
    ],
    cmdTableTitle: '指令類型說明',
    cmdCol: '指令 (cmd)',
    typeCol: '類型',
    actionCol: '動作',
    extraCol: '額外參數',
    cmdTable: [
      ['buy', '市價單', '立即買入', 'lots, sl_*, tp_*'],
      ['sell', '市價單', '立即賣出', 'lots, sl_*, tp_*'],
      ['buylimit', '掛單', '價格觸及時買入', 'price, lots, sl_*, tp_*'],
      ['selllimit', '掛單', '價格觸及時賣出', 'price, lots, sl_*, tp_*'],
      ['buystop', '掛單', '價格突破時買入', 'price, lots, sl_*, tp_*'],
      ['sellstop', '掛單', '價格突破時賣出', 'price, lots, sl_*, tp_*'],
      ['closebuy', '平倉', '平所有多單', 'magic（可選）'],
      ['closesell', '平倉', '平所有空單', 'magic（可選）'],
      ['closeall', '平倉', '平所有持倉', '—'],
      ['closeallorders', '平倉', '刪除所有掛單', '—']
    ],
    jsonFieldTitle: 'JSON 字段說明',
    fieldCol: '字段名',
    requiredCol: '是否必填',
    descCol: '說明',
    jsonFields: [
      ['license', 'string', '必填', 'License ID'],
      ['key', 'string', '必填', 'Secret Key'],
      ['cmd', 'string', '必填', '交易指令，見上表'],
      ['symbol', 'string', '必填', '交易品種，如 EURUSD'],
      ['lots', 'number', '選填', '手數，留空使用 EA 預設值'],
      ['price', 'number', '掛單必填', '掛單價格'],
      ['sl_points', 'number', '選填', '止損點數'],
      ['sl_price', 'number', '選填', '止損固定價格'],
      ['sl_pct', 'number', '選填', '止損百分比（0-100）'],
      ['tp_points', 'number', '選填', '止盈點數'],
      ['tp_price', 'number', '選填', '止盈固定價格'],
      ['tp_pct', 'number', '選填', '止盈百分比（0-100）'],
      ['magic', 'number', '選填', 'Magic Number'],
      ['comment', 'string', '選填', '訂單備注'],
      ['signalid', 'string', '選填', '訊號唯一 ID，用於去重'],
      ['expiryseconds', 'number', '選填', '訊號有效期（秒），預設 60']
    ],
    dlMt5Desc: 'MT5 版本 EA，支持全部指令，推薦使用',
    dlMt5Btn: '下載 MT5 EA',
    dlMt4Desc: 'MT4 版本 EA，開發中，敬請期待',
    dlMt4Dev: '開發中',
    dlInstallDoc:
      '<h4>安裝說明</h4><ol><li>下載 <code>WikiConnector_MT5.ex5</code> 文件</li><li>打開 MT5，菜單欄 → <strong>文件 → 打開數據目錄</strong></li><li>將 <code>.ex5</code> 文件複製到 <code>MQL5/Experts/</code> 目錄</li><li>在 MT5 中按 <strong>F5</strong> 刷新導航器，找到 WikiConnector EA</li><li>將 EA 拖拽到任意圖表，填入 <strong>License ID</strong> 和 <strong>Secret Key</strong></li></ol>',
    disclaimerTitle: '風險免責聲明',
    disclaimerContent: '<p>外匯和差價合約交易存在重大風險，可能導致全部或部分資金損失。WikiConnector 僅為訊號傳輸工具，不對任何交易結果負責。請在真實帳戶中使用前充分測試，用戶對所有交易結果承擔全部責任。</p>',
    disclaimerAgree: '我已閱讀並同意上述免責聲明，了解交易風險',
    disclaimerDownload: '同意並下載',
    regenTitle: '確認重置密鑰？',
    regenSubtitle: '此操作不可撤銷，請確認你已了解以下影響：',
    regenWarnings: ['所有已配置此密鑰的 EA 將<strong>立即斷開連接</strong>', '舊密鑰<strong>永久失效</strong>，無法恢復', '你需要手動更新所有 EA 中的 Secret Key 配置', '重置期間可能有<strong>訊號丟失</strong>風險'],
    dashTitle: '我的 WikiConnector',
    myKey: '我的密鑰',
    keyPrefix: 'Secret Key',
    copyBtn: '複製',
    regenBtn: '重新生成',
    regenConfirm: '重新生成密鑰後，所有正在連接的 EA 將斷開，需重新配置。確認繼續？',
    regenConfirmBtn: '確認重置',
    cancelBtn: '取消',
    copiedTip: '已複製',
    licenseTitle: '我的證書 (License)',
    licenseId: '證書 ID',
    maxConn: '最大連接數',
    activeConn: '當前連接',
    webhookUrl: 'Webhook URL',
    statsTitle: '訊號統計',
    statTotal: '總訊號數',
    statDelivered: '已投遞',
    statFailed: '失敗',
    statConnections: '當前連接',
    signalTitle: '最近訊號記錄',
    signalTime: '時間',
    signalCmd: '指令',
    signalSymbol: '品種',
    signalLots: '手數',
    signalStatus: '狀態',
    signalLicense: '證書',
    statusDelivered: '已投遞',
    statusPending: '待投遞',
    statusFailed: '失敗',
    statusExpired: '已過期',
    noSignal: '暫無訊號記錄',
    loadMore: '加載更多',
    offlineBuffer: '離線緩衝',
    offlineBufferDesc: '開啟後，EA 重連時將投遞離線期間積累的訊號（預設關閉，防止虧損）',
    docTitle: '接入文檔',
    docContent:
      '<h4>1. Webhook 訊號格式</h4><p>在 TradingView Alert 的 Message 中填寫以下 JSON，將 license 和 key 替換為你自己的值。</p><h4>2. TradingView Webhook 地址</h4><pre style="background:#1e293b;color:#e2e8f0;padding:16px;border-radius:8px;font-size:13px">https://api-gw.interface003.com/api/mtbridge/webhook/</pre><h4>3. 安裝 WikiConnector EA</h4><ol><li>下載 WikiConnector EA（.ex5 文件）</li><li>將 EA 複製到 MT5 的 <code>MQL5/Experts</code> 目錄</li><li>在 MT5 中打開 EA，填入 License ID 和 Secret Key</li></ol>',
    docSections: [],
    faqTitle: '常見問題',
    faqs: [],
    faqGroups: [
      {
        title: '連接與密鑰',
        items: [
          {
            q: '密鑰泄露了怎麼辦？',
            a: '在控制台點擊「重新生成」，舊密鑰立即失效，所有 EA 連接會被踢下線，使用新密鑰重新配置 EA 即可。'
          },
          {
            q: '一個 License 可以連接幾個 MT 帳戶？',
            a: '每個 License 最多支持 10 個並發 WebSocket 連接，可同時連接 10 個 MT 終端接收同一訊號。'
          }
        ]
      },
      {
        title: '訊號與執行',
        items: [
          {
            q: 'EA 斷線重連後會補發訊號嗎？',
            a: '預設不補發（防止虧損）。如需補發，在控制台開啟「離線緩衝」開關。'
          },
          {
            q: '訊號延遲有多高？',
            a: '平均延遲 &lt;100ms，配合天眼雲 VPS 部署可低至 1ms。'
          }
        ]
      },
      {
        title: '兼容性',
        items: [
          {
            q: '支持 MT4 嗎？',
            a: '當前版本主要支持 MT5。MT4 版本 EA 正在開發中，敬請期待。'
          }
        ]
      }
    ]
  },
  // = zh 繁体中文 =
  zh: {
    nav: 'WikiConnector',
    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView 訊號自動連接 MetaTrader 執行交易',
    heroBtn: '免費開始使用',
    stat1Label: '平均延遲',
    stat2Label: '服務在線率',
    stat3Label: '全天候運行',
    stat4Label: '多帳戶分發',
    flowSub1: '策略 / Alert',
    flowSub2: '訊號路由',
    flowSub3: '自動執行',
    featTitle: '為什麼選擇 WikiConnector',
    featSubtitle: '核心優勢',
    features: [
      {
        icon: '⚡',
        title: '毫秒級執行',
        desc: '訊號平均延遲 <100ms，配合 WikiFX VPS 可低至 1ms。'
      },
      {
        icon: '🔗',
        title: '多帳戶分發',
        desc: '一個證書連接多個 MT 終端，同一策略訊號同時分發。'
      },
      {
        icon: '🔒',
        title: '安全加密',
        desc: '每位用戶獨立密鑰體系，資料全鏈路加密傳輸。'
      },
      {
        icon: '📊',
        title: '實時監控',
        desc: '訊號接收狀態、執行延遲、成功率實時可見。'
      },
      {
        icon: '<>',
        title: '代碼生成器',
        desc: '可視化生成 JSON 訊號和 Pine Script 代碼，無需編程。'
      },
      {
        icon: '🖥',
        title: 'VPS 深度集成',
        desc: '與天眼雲 VPS 共享帳戶體系，7×24 低延遲運行。'
      }
    ],
    stepsTitle: '四步開始自動化交易',
    stepsSubtitle: '快速上手',
    steps: [
      {
        title: '登錄帳戶',
        desc: '使用 WikiFX 帳戶登錄，自動獲取專屬密鑰和 License。'
      },
      {
        title: '配置 Webhook',
        desc: '將 Webhook URL 複製到 TradingView Alert 設置。'
      },
      {
        title: '安裝 EA',
        desc: '下載 WikiConnector EA，輸入 License ID 和 Secret Key。'
      },
      {
        title: '自動交易',
        desc: '策略觸發 Alert 時，訊號自動傳達 MT 終端執行。'
      }
    ],
    loginTip: '登錄後即可查看你的專屬密鑰和證書',
    loginBtn: '立即登錄',
    navConn: '連接管理',
    navLog: '訊號日誌',
    navGen: '代碼生成',
    navParams: '參數速查',
    navDl: '下載',
    navDoc: '使用教學',
    navFaq: '常見問題',
    keyLabel: 'Secret Key',
    keyTip1: '請勿分享給任何人',
    keyTip2: '用於 EA 鑑權',
    keyTip3: '重置後舊密鑰立即失效',
    connSubtitle: '以下是你的 License 及其對應的 Webhook URL',
    noLicense: '暫無 License，請聯繫客服開通',
    needHelp: '需要幫助？',
    viewDoc: '查看使用教學',
    allLicense: '全部 License',
    allStatus: '全部狀態',
    refresh: '刷新',
    signalId: '訊號 ID',
    total: '共',
    records: '條記錄',
    genIntro: '填寫以下參數，自動生成可在 TradingView Alert 中使用的 JSON 訊號和 Pine Script 代碼。',
    genAuth: '鑑權資訊',
    required: '必填',
    optional: '選填',
    genLicPlaceholder: '輸入你的 License ID',
    genLicHint: '在連接管理頁面查看',
    genKeyPlaceholder: '輸入你的 Secret Key',
    genKeyHint: '在連接管理頁面查看',
    genTrade: '交易指令',
    genCmd: '指令類型',
    genMarket: '市價單',
    genPending: '掛單',
    genClose: '平倉',
    cmdBuy: '市價買入',
    cmdSell: '市價賣出',
    cmdBuyLimit: '限價買入',
    cmdSellLimit: '限價賣出',
    cmdBuyStop: '突破買入',
    cmdSellStop: '突破賣出',
    cmdCloseBuy: '平多單',
    cmdCloseSell: '平空單',
    cmdCloseAll: '平該品種',
    cmdCloseAllOrders: '平全部',
    genSlTpHint: '三選一 · 優先級：價格 > 點數 > 百分比',
    genTsHint: '訊號發送時間',
    genTsBtn: '當前時間',
    presetSimple: '📝 簡單買入',
    presetSltp: '🛡 帶止損止盈',
    presetFull: '📋 完整參數',
    presetClose: '❌ 平倉訊號',
    presetPending: '📌 掛單',
    presetReverse: '🔄 反手（平+開）',
    genAlertTab: '🔔 Alert 設定說明',
    toastIncomplete: '資訊不完整，請填寫必填項',
    toastRegen: '新密鑰已生成，請立即複製並更新所有已配置的 EA',
    toastKeyCopied: '密鑰已複製',
    toastCopied: '已複製',
    toastCodeCopied: '代碼已複製',
    copyTitle: '複製',
    genSymbol: '交易品種',
    genPrice: '掛單價格',
    genParams: '交易參數',
    genLots: '手數',
    genLotsHint: '留空則使用 EA 預設值',
    genMagic: 'Magic Number',
    genMagicHint: '用於區分不同策略的訂單',
    genComment: '訂單備註',
    genCommentHint: '如：Strategy A',
    genSL: '止損設置',
    genPoints: '點數',
    genPrice2: '固定價格',
    genPct: '百分比 %',
    genTP: '止盈設置',
    genAdvanced: '進階參數',
    genSigIdHint: '留空則自動生成，用於去重',
    genGenId: '自動生成',
    genBtn: '生成代碼',
    genFormat: '訊號格式',
    genGuideTitle: '如何在 TradingView 中使用',
    genGuideSteps: [
      '在 TradingView 圖表上建立 <strong>Alert（警報）</strong>',
      '在 <strong>Alert 觸發條件</strong>中選擇你的策略或指標',
      '展開 <strong>Notifications（通知）</strong> → 勾選 <strong>Webhook URL</strong>',
      '將 Webhook URL 填寫為：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      '將上方生成的 JSON 貼到 <strong>Message（訊息）</strong> 框中',
      '點擊 <strong>Create（建立）</strong> 儲存 Alert'
    ],
    genGuideNote: '<strong>提示：</strong> 如使用 Pine Script，將生成的代碼添加到你的腳本中，並在 <code>strategy.entry()</code> 或 <code>strategy.close()</code> 中使用 <code>alert_message</code> 參數。',
    paramsGroups: [
      {
        title: '🔐 Authorization（授權）— 必須修改',
        rows: [
          ['License', '—', '授權 ID，必須與訊號 JSON 中的 license 欄位完全一致', 'req'],
          ['SecretKey', '—', '安全金鑰（wc_sk_ 開頭），必須與訊號 JSON 中的 key 欄位完全一致', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters（預設交易參數）',
        rows: [
          ['InpLots', '0.1', '預設手數，訊號 JSON 未包含 lots 時使用', ''],
          ['InpMagic', '888', '預設魔術號碼，用於區分不同策略的訂單', ''],
          ['InpComment', 'TV Signal', '預設訂單備註', ''],
          ['InpDeviation', '30', '最大滑點（點數），外匯建議 10–30，黃金/指數建議 30–50', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit（止損止盈）',
        note: '優先級：sl_price（固定價格）> sl_points（點數）> sl_pct（百分比），三項均為 0 則不設止損，止盈同理',
        rows: [
          ['InpSLPoints', '0', '預設止損點數（0 = 不啟用）', ''],
          ['InpSLPrice', '0', '預設止損固定價格（0 = 不啟用，優先級最高）', ''],
          ['InpSLPct', '0', '預設止損百分比（0 = 不啟用）', ''],
          ['InpTPPoints', '0', '預設止盈點數（0 = 不啟用）', ''],
          ['InpTPPrice', '0', '預設止盈固定價格（0 = 不啟用）', ''],
          ['InpTPPct', '0', '預設止盈百分比（0 = 不啟用）', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping（品種名稱映射）',
        note: '不同券商品種命名可能不同（如 TradingView 叫 XAUUSD，你的券商叫 GOLD），使用映射可自動轉換',
        rows: [
          ['InpPrefix', '（空）', '品種名前綴，如券商品種為 m.EURUSD 則填 m.', ''],
          ['InpSuffix', '（空）', '品種名後綴，如券商品種為 EURUSD.pro 則填 .pro', ''],
          ['InpEnableMap1~5', 'false', '設為 true 啟用對應映射規則', ''],
          ['InpMapping1', 'XAUUSDGOLD', '映射規則，格式：TradingView品種名|MT5品種名，支援 5 條', ''],
          ['InpMapping2', 'EURUSD|EUR', '同上', ''],
          ['InpMapping3', 'GBPUSD|GBP', '同上', ''],
          ['InpMapping4', 'BTCUSD|BTC', '同上', ''],
          ['InpMapping5', 'USOUSD|WTI', '同上', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log（時間過濾 / 日誌）',
        rows: [
          ['InpUseTimeFilter', 'false', '啟用後只在 StartTime~EndTime 內處理訊號', ''],
          ['InpStartTime', '00:00', '允許交易開始時間（MT5 伺服器時間，格式 HH:MM）', ''],
          ['InpEndTime', '23:59', '允許交易結束時間', ''],
          ['InpShowPanel', 'true', '在圖表上顯示連接狀態、訊號統計等資訊面板', ''],
          ['InpUpdateInterval', '1000', '面板刷新間隔（毫秒），建議 1000~3000', ''],
          ['InpLogLevel', '1', '日誌級別：0=關閉 1=基本 2=詳細 3=偵錯（排錯時用 2 或 3）', ''],
          ['InpLogToFile', 'true', '寫入日誌檔案至 MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', '輸出到 MT5 底部「專家」標籤頁', ''],
          ['InpMaxLogMB', '5', '日誌檔案最大體積（MB），超出後自動輪換', '']
        ]
      }
    ],
    paramsEATitle: 'EA 參數說明',
    paramsEADesc: '以下參數在 MT5 中打開 EA 時可設置，也可透過 JSON 訊號中對應欄位覆蓋。',
    paramName: '參數名',
    paramDefault: '預設值',
    paramDesc: '說明',
    paramOverride: 'JSON 覆蓋欄位',
    eaParams: [
      ['DefaultLots', '0.1', '預設手數（JSON 未指定時使用）', 'lots'],
      ['DefaultMagic', '0', '預設 Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', '預設訂單備註', 'comment'],
      ['SlippagePoints', '3', '最大滑點（點數）', '—'],
      ['OfflineBuffer', 'false', '是否開啟離線緩衝', '—'],
      ['ReconnectSeconds', '5', 'WebSocket 斷線重連間隔（秒）', '—']
    ],
    cmdTableTitle: '指令類型說明',
    cmdCol: '指令 (cmd)',
    typeCol: '類型',
    actionCol: '動作',
    extraCol: '額外參數',
    cmdTable: [
      ['buy', '市價單', '立即買入', 'lots, sl_, tp_'],
      ['sell', '市價單', '立即賣出', 'lots, sl_, tp_'],
      ['buylimit', '掛單', '價格觸及時買入', 'price, lots, sl_, tp_'],
      ['selllimit', '掛單', '價格觸及時賣出', 'price, lots, sl_, tp_'],
      ['buystop', '掛單', '價格突破時買入', 'price, lots, sl_, tp_'],
      ['sellstop', '掛單', '價格突破時賣出', 'price, lots, sl_, tp_'],
      ['closebuy', '平倉', '平所有多單', 'magic（可選）'],
      ['closesell', '平倉', '平所有空單', 'magic（可選）'],
      ['closeall', '平倉', '平所有持倉', '—'],
      ['closeallorders', '平倉', '刪除所有掛單', '—']
    ],
    jsonFieldTitle: 'JSON 欄位說明',
    fieldCol: '欄位名',
    requiredCol: '是否必填',
    descCol: '說明',
    jsonFields: [
      ['license', 'string', '必填', 'License ID'],
      ['key', 'string', '必填', 'Secret Key'],
      ['cmd', 'string', '必填', '交易指令，見上表'],
      ['symbol', 'string', '必填', '交易品種，如 EURUSD'],
      ['lots', 'number', '選填', '手數，留空使用 EA 預設值'],
      ['price', 'number', '掛單必填', '掛單價格'],
      ['sl_points', 'number', '選填', '止損點數'],
      ['sl_price', 'number', '選填', '止損固定價格'],
      ['sl_pct', 'number', '選填', '止損百分比（0-100）'],
      ['tp_points', 'number', '選填', '止盈點數'],
      ['tp_price', 'number', '選填', '止盈固定價格'],
      ['tp_pct', 'number', '選填', '止盈百分比（0-100）'],
      ['magic', 'number', '選填', 'Magic Number'],
      ['comment', 'string', '選填', '訂單備註'],
      ['signalid', 'string', '選填', '訊號唯一 ID，用於去重'],
      ['expiryseconds', 'number', '選填', '訊號有效期（秒），預設 60']
    ],
    dlMt5Desc: 'MT5 版本 EA，支援全部指令，推薦使用',
    dlMt5Btn: '下載 MT5 EA',
    dlMt4Desc: 'MT4 版本 EA，開發中，敬請期待',
    dlMt4Dev: '開發中',
    dlInstallDoc: `<h4>安裝說明</h4>
<ol>
<li>下載 <code>WikiConnector_MT5.ex5</code> 檔案</li>
<li>打開 MT5，選單列 → <strong>檔案 → 打開資料目錄</strong></li>
<li>將 <code>.ex5</code> 檔案複製到 <code>MQL5/Experts/</code> 目錄</li>
<li>在 MT5 中按 <strong>F5</strong> 重新整理導航器，找到 WikiConnector EA</li>
<li>將 EA 拖曳到任意圖表，填入 <strong>License ID</strong> 和 <strong>Secret Key</strong></li>
<li>在 EA 選項中勾選 <strong>允許 WebRequest</strong>，並新增 <code>api-gw.interface003.com</code> 到允許的 URL 清單</li>
</ol>`,
    disclaimerTitle: '風險免責聲明',
    disclaimerContent: `<p>在下載和使用 WikiConnector EA 之前，請仔細閱讀以下免責聲明：</p>
<p><strong>1. 交易風險</strong><br/>外匯和差價合約交易存在重大風險，可能導致全部或部分資金損失。WikiConnector 僅為訊號傳輸工具，不對任何交易結果負責。</p>
<p><strong>2. 策略風險</strong><br/>自動化交易策略的歷史表現不代表未來結果。請在真實帳戶中使用前充分測試。</p>
<p><strong>3. 技術風險</strong><br/>網路延遲、伺服器故障、API 限制等技術因素可能導致訊號遺失或執行延遲。請勿將本工具用於對延遲極度敏感的高頻策略。</p>
<p><strong>4. 使用責任</strong><br/>使用者對使用 WikiConnector EA 產生的所有交易結果承擔全部責任。WikiFX 不提供投資建議，亦不對交易盈虧負責。</p>`,
    disclaimerAgree: '我已閱讀並同意上述免責聲明，了解交易風險',
    disclaimerDownload: '同意並下載',
    regenTitle: '確認重設金鑰？',
    regenSubtitle: '此操作不可撤銷，請確認你已了解以下影響：',
    regenWarnings: ['所有已配置此金鑰的 EA 將<strong>立即斷開連接</strong>', '舊金鑰<strong>永久失效</strong>，無法恢復', '你需要手動更新所有 EA 中的 Secret Key 配置', '重設期間可能有<strong>訊號遺失</strong>風險'],
    dashTitle: '我的 WikiConnector',
    myKey: '我的金鑰',
    keyPrefix: 'Secret Key',
    copyBtn: '複製',
    regenBtn: '重新產生',
    regenConfirm: '重新產生金鑰後，所有正在連接的 EA 將斷開，需重新配置。確認繼續？',
    regenConfirmBtn: '確認重設',
    cancelBtn: '取消',
    copiedTip: '已複製',
    licenseTitle: '我的憑證 (License)',
    licenseId: '憑證 ID',
    maxConn: '最大連接數',
    activeConn: '當前連接',
    webhookUrl: 'Webhook URL',
    statsTitle: '訊號統計',
    statTotal: '總訊號數',
    statDelivered: '已投遞',
    statFailed: '失敗',
    statConnections: '當前連接',
    signalTitle: '最近訊號記錄',
    signalTime: '時間',
    signalCmd: '指令',
    signalSymbol: '品種',
    signalLots: '手數',
    signalStatus: '狀態',
    signalLicense: '憑證',
    statusDelivered: '已投遞',
    statusPending: '待投遞',
    statusFailed: '失敗',
    statusExpired: '已過期',
    noSignal: '暫無訊號記錄',
    loadMore: '載入更多',
    offlineBuffer: '離線緩衝',
    offlineBufferDesc: '開啟後，EA 重連時將投遞離線期間累積的訊號（預設關閉，防止虧損）',
    docTitle: '使用教學',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 WikiConnector 工作原理</p>
  <p>WikiConnector 透過 <strong>WebSocket 長連接</strong>即時接收 TradingView 訊號，並在交易軟體中自動執行交易。</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① 安裝 EA 到交易軟體</p>
  <ol class="doc-steps">
    <li><strong>打開資料資料夾</strong>：交易軟體選單 → 檔案 → 打開資料資料夾</li>
    <li><strong>複製 EA 檔案</strong>：將 EA 檔案複製到 <code>Experts/</code> 目錄</li>
    <li><strong>重新整理導航器</strong>：打開導航器 → 在「智能交易系統」右鍵 → 重新整理，清單中應出現 <strong>SignalReceiver</strong></li>
    <li><strong>開啟自動交易</strong>：頂部工具列「自動交易」按鈕必須為 🟢 綠色</li>
    <li><strong>掛載到圖表</strong>：將 SignalReceiver 拖放到任意圖表，彈出設定視窗後配置參數</li>
  </ol>
  <div class="doc-tip"><strong>提示：</strong>EA 只需掛載在一張圖表上，即可處理所有品種的訊號，無需在每個品種圖表上分別掛載。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② 配置 EA 參數</p>
  <p>參數分兩類：<strong>必填</strong>（License / SecretKey）和<strong>預設值參數</strong>（訊號 JSON 未包含某欄位時使用，訊號中的值始終優先於 EA 預設值）。</p>
  <div class="doc-warn"><strong>安全警告：</strong>License 和 SecretKey 是保護帳戶的唯一屏障。若洩露，任何人都可以向你的交易軟體發送交易指令。請勿截圖或分享給他人，建議定期更換 SecretKey。</div>
  <p>設定完成後，圖表右上角出現 EA 名稱 + <strong>😊</strong> 表示已連接服務端；若顯示 😞，檢查「自動交易」按鈕是否為綠色。</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ 編寫 Pine Script 訊號代碼</p>
  <p>WikiConnector 使用 <code>alert()</code> 函數觸發訊號，而非 <code>strategy.entry(alert_message=)</code> 方式，兩種機制不同，請勿混用。</p>
  <div class="doc-danger"><strong>關鍵：alert.freq_all</strong> — Pine Script 預設同一 K 線內只有第一個 <code>alert()</code> 觸發，後續全部靜默丟棄。需要連續發送多條訊號時（如反手：先平空再開多），每個 <code>alert()</code> 都必須加 <code>alert.freq_all</code>，否則第二條訊號永遠不會到達服務端。</div>
<pre>//@version=6
strategy("WikiConnector 策略", overlay=true)

// 定義訊號訊息（將 YOUR_LICENSE 和 YOUR_KEY 替換為你自己的值）
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// 策略條件範例（3/13 均線交叉）
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// 使用 alert.freq_all 確保同一 K 線內多條訊號都能發出
if longCondition
    alert(closesellMessage, alert.freq_all)  // 先平空單
    alert(buyMessage,       alert.freq_all)  // 再開多單

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // 先平多單
    alert(sellMessage,     alert.freq_all)   // 再開空單</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ 在 TradingView 建立警報</p>
  <p>Webhook URL：</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>圖表右鍵 → "<strong>新增警報...</strong>" 或按 <strong>Alt+A</strong></li>
    <li>觸發條件選擇 <strong>"僅 alert() 函數呼叫"</strong>（關鍵！）</li>
    <li>到期時間選擇盡量長，或"Open-ended"永不過期</li>
    <li>Message 框 <strong>保持預設，不填任何內容</strong>（訊號內容由程式碼中的 alert() 決定）</li>
    <li>通知設定：勾選 <strong>Webhook URL</strong> 並填入上方地址；<strong>取消勾選「發送純文字」</strong></li>
    <li>點擊「建立」儲存警報</li>
  </ol>
  <div class="doc-tip"><strong>提示：</strong>Webhook 功能需要 TradingView Pro 或更高級別訂閱。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ 訊號 JSON 格式說明</p>
  <p><strong>必填欄位：</strong><code>license</code>（授權ID）、<code>key</code>（金鑰）、<code>cmd</code>（指令）、<code>symbol</code>（品種名）</p>
  <p><strong>選填欄位：</strong><code>lots</code>（手數）、<code>price</code>（掛單價格）、<code>sl_points / sl_price / sl_pct</code>（止損三選一）、<code>tp_points / tp_price / tp_pct</code>（止盈三選一）、<code>magic</code>、<code>comment</code>、<code>signal_id</code>、<code>expiry_seconds</code>（預設300秒）</p>
  <p><strong>支援的 cmd：</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>止損止盈優先級：</strong><code>sl_price</code>（固定價格）&gt; <code>sl_points</code>（點數）&gt; <code>sl_pct</code>（百分比），三項均為 0 則不設止損，止盈同理。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ 上線前檢查清單</p>
  <ul class="doc-checklist">
    <li class="ok">✅ 交易軟體自動交易按鈕為 🟢 綠色</li>
    <li class="ok">✅ 圖表右上角 EA 顯示 😊（已連接服務端）</li>
    <li class="ok">✅ License / SecretKey 與 TradingView JSON 中的值完全一致</li>
    <li class="ok">✅ 警報觸發條件選擇「<strong>僅 alert() 函數呼叫</strong>」</li>
    <li class="ok">✅ 每個 <code>alert()</code> 都加了 <code>alert.freq_all</code></li>
    <li class="ok">✅ Webhook URL：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message 框保持預設，不填任何內容</li>
    <li class="no">❌ 取消勾選「發送純文字」</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ 安全與風險提示</p>
  <div class="doc-warn">
    <strong>帳戶安全：</strong><br>
    · 不要將 License 和 SecretKey 截圖或分享給任何人<br>
    · 若懷疑金鑰洩露，立即在主控台重設 SecretKey<br>
    · 建議定期更換 SecretKey
  </div>
  <div class="doc-warn">
    <strong>交易風險控制：</strong><br>
    · 始終設定止損，切勿裸倉執行自動化策略<br>
    · 單筆風險建議控制在帳戶資金的 1–2% 以內<br>
    · 重大經濟數據（非農、CPI、FOMC）發布前建議暫停自動交易
  </div>
  <div class="doc-tip">
    <strong>最佳實踐：</strong><br>
    · 先在模擬帳戶（Demo）測試至少 1–2 週，確認鏈路正常後再切換真實帳戶<br>
    · 真實帳戶初期使用最小手數（0.01手）<br>
    · 使用 VPS（如天眼雲 VPS）確保交易軟體和 EA 24 小時在線
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook 訊號格式',
        content: `在 TradingView Alert 的 Message 中填寫以下 JSON：
<pre>{
  "license": "{{你的LicenseID}}",
  "key": "{{你的SecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>支援的 <strong>cmd</strong> 指令：buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook 地址',
        content: `<p>在 TradingView Alert 設定中，將 Webhook URL 填寫為：</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>在 Message 框中填寫上方 JSON 訊號格式，將 license 和 key 替換為你自己的值。</p>`
      },
      {
        title: '3. 安裝 WikiConnector EA',
        content: `<p>1. 下載 WikiConnector EA（.ex5 檔案）</p>
<p>2. 將 EA 複製到 MT5 的 <code>MQL5/Experts</code> 目錄</p>
<p>3. 在 MT5 中打開 EA，填入 <strong>License ID</strong> 和 <strong>Secret Key</strong></p>
<p>4. 允許 EA 進行 WebSocket 連接（在 MT5 選項 → EA 中開啟網路連接權限）</p>`
      },
      {
        title: '4. 頻率限制',
        content: `<p>每個 License 最多 <strong>30 次 / 60 秒</strong>，超過限制將返回 429 錯誤。</p>
<p>如需更高頻率，請聯繫客服升級方案。</p>`
      }
    ],
    faqTitle: '常見問題',
    faqs: [
      {
        q: '金鑰洩露了怎麼辦？',
        a: '在主控台點擊「重新產生」，舊金鑰立即失效，所有 EA 連接會被踢下線，使用新金鑰重新配置 EA 即可。'
      },
      {
        q: 'EA 斷線重連後會補發訊號嗎？',
        a: '預設不補發（防止虧損）。如需補發，在主控台開啟「離線緩衝」開關，EA 重連後將接收離線期間的訊號。'
      },
      {
        q: '一個 License 可以連接幾個 MT 帳戶？',
        a: '每個 License 最多支援 10 個並發 WebSocket 連接，可同時連接 10 個 MT 終端接收同一訊號。'
      },
      {
        q: '支援 MT4 嗎？',
        a: '當前版本主要支援 MT5。MT4 版本 EA 正在開發中，敬請期待。'
      },
      {
        q: '訊號延遲有多高？',
        a: '平均延遲 <100ms，配合天眼雲 VPS 部署可低至 1ms。'
      },
      {
        q: '如何測試 Webhook 是否正常工作？',
        a: '在憑證列表中查看「當前連接數」，連接數 > 0 表示 EA 在線。發送測試訊號後，在「最近訊號記錄」中可看到狀態為「已投遞」。'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script 與訊號發送',
        items: [
          {
            q: '我用了兩個 alert() 發平倉和開倉，但交易軟體只收到一條訊號？',
            a: '這是 Pine Script 的預設限制，同一 K 線內只有第一個 alert() 觸發。解決方法是給<strong>每個 alert() 都加上 <code>alert.freq_all</code> 參數</strong>：<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: '警報觸發條件應該選哪個？',
            a: '使用 <code>alert()</code> 函數方式時，必須選擇 <strong>"僅 alert() 函數呼叫"</strong>。如果使用 <code>strategy.entry(..., alert_message=xxx)</code> 方式則選 "Order fills only"。兩種方式不能混用。'
          },
          {
            q: 'Message 框裡需要填寫什麼？',
            a: '使用 <code>alert()</code> 方式時，<strong>Message 框保持預設，什麼都不需要填</strong>。訊號內容由程式碼中 <code>alert(xxx)</code> 裡的字串決定，Webhook 收到的就是那個 JSON。'
          }
        ]
      },
      {
        title: '🔌 連接與訊號接收',
        items: [
          {
            q: 'EA 圖示顯示紅色哭臉 😞，怎麼辦？',
            a: '檢查交易軟體工具列的「自動交易」按鈕是否為綠色。若是紅色，點擊切換為綠色，EA 會自動恢復正常。'
          },
          {
            q: '訊號從 TradingView 發出，但交易軟體沒有反應？',
            a: '依序檢查：<br>1. 交易軟體自動交易是否綠色<br>2. EA 面板是否顯示 Connected<br>3. Webhook URL 是否為 <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code><br>4. 警報觸發條件是否選了「僅 alert() 函數呼叫」<br>5. 每個 alert() 是否都加了 <code>alert.freq_all</code><br>6. JSON 中 license 和 key 是否與 EA 設定完全一致'
          }
        ]
      },
      {
        title: '💰 交易執行',
        items: [
          {
            q: '下單失敗，是什麼原因？',
            a: '常見原因：餘額不足 / 品種名不一致（需配置 Symbol Mapping）/ 手數超限 / 滑點過大（增大 InpDeviation）/ 市場已關閉。請查看交易軟體底部「專家」日誌獲取具體錯誤資訊。'
          },
          {
            q: '訂單沒有止損止盈？',
            a: '檢查：① 訊號 JSON 是否包含 <code>sl_points</code> / <code>tp_points</code> 等欄位；② EA 預設止損止盈參數是否為 0。兩邊都沒有設定時，訂單不會有止損止盈。'
          },
          {
            q: '品種名不一致怎麼辦？',
            a: '在 EA 參數中啟用 Symbol Mapping：<br>設定 <code>InpEnableMap1 = true</code><br>設定 <code>InpMapping1 = XAUUSDGOLD</code>（TradingView品種名|交易軟體品種名）'
          },
          {
            q: '可以先用模擬帳戶測試嗎？',
            a: '<strong>強烈建議！</strong>首次使用必須在模擬帳戶（Demo）上測試至少 1–2 週，確認鏈路正常、訂單執行正確後再切換真實帳戶，初期使用最小手數 0.01。'
          }
        ]
      }
    ]
  },

  // === en 英语 ===

  en: {
    nav: 'WikiConnector',
    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Connect TradingView signals to MetaTrader for automated trading',
    heroBtn: 'Start for Free',
    stat1Label: 'Avg Latency',
    stat2Label: 'Service Uptime',
    stat3Label: '24/7 Operation',
    stat4Label: 'Multi-Account Distribution',
    flowSub1: 'Strategy / Alert',
    flowSub2: 'Signal Routing',
    flowSub3: 'Auto Execution',
    featTitle: 'Why Choose WikiConnector',
    featSubtitle: 'Core Advantages',
    features: [
      {
        icon: '⚡',
        title: 'Millisecond Execution',
        desc: 'Average signal latency <100ms, as low as 1ms with WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Multi-Account Distribution',
        desc: 'One license connects multiple MT terminals, distributing signals from the same strategy simultaneously.'
      },
      {
        icon: '🔒',
        title: 'Secure Encryption',
        desc: 'Independent key system for each user, full-chain encrypted data transmission.'
      },
      {
        icon: '📊',
        title: 'Real-Time Monitoring',
        desc: 'Signal reception status, execution latency, and success rate visible in real time.'
      },
      {
        icon: '<>',
        title: 'Code Generator',
        desc: 'Visually generate JSON signals and Pine Script code without programming.'
      },
      {
        icon: '🖥',
        title: 'VPS Deep Integration',
        desc: 'Shares account system with Tianyan Cloud VPS for 24/7 low-latency operation.'
      }
    ],
    stepsTitle: 'Four Steps to Automated Trading',
    stepsSubtitle: 'Quick Start',
    steps: [
      {
        title: 'Log In',
        desc: 'Log in with your WikiFX account to automatically obtain your exclusive key and License.'
      },
      {
        title: 'Configure Webhook',
        desc: 'Copy the Webhook URL into your TradingView Alert settings.'
      },
      {
        title: 'Install EA',
        desc: 'Download the WikiConnector EA and enter your License ID and Secret Key.'
      },
      {
        title: 'Auto Trade',
        desc: 'When your strategy triggers an Alert, the signal is automatically sent to the MT terminal for execution.'
      }
    ],
    loginTip: 'Log in to view your exclusive key and license',
    loginBtn: 'Log In Now',
    navConn: 'Connection Management',
    navLog: 'Signal Logs',
    navGen: 'Code Generator',
    navParams: 'Parameter Reference',
    navDl: 'Download',
    navDoc: 'User Guide',
    navFaq: 'FAQ',
    keyLabel: 'Secret Key',
    keyTip1: 'Do not share with anyone',
    keyTip2: 'Used for EA authentication',
    keyTip3: 'Old key becomes invalid immediately after reset',
    connSubtitle: 'Below are your Licenses and their corresponding Webhook URLs',
    noLicense: 'No License available. Please contact customer service to activate.',
    needHelp: 'Need Help?',
    viewDoc: 'View User Guide',
    allLicense: 'All Licenses',
    allStatus: 'All Statuses',
    refresh: 'Refresh',
    signalId: 'Signal ID',
    total: 'Total',
    records: 'records',
    genIntro: 'Fill in the parameters below to automatically generate JSON signals and Pine Script code for use in TradingView Alerts.',
    genAuth: 'Authentication Info',
    required: 'Required',
    optional: 'Optional',
    genLicPlaceholder: 'Enter your License ID',
    genLicHint: 'View on the Connection Management page',
    genKeyPlaceholder: 'Enter your Secret Key',
    genKeyHint: 'View on the Connection Management page',
    genTrade: 'Trade Command',
    genCmd: 'Command Type',
    genMarket: 'Market Order',
    genPending: 'Pending Order',
    genClose: 'Close Position',
    cmdBuy: 'Market Buy',
    cmdSell: 'Market Sell',
    cmdBuyLimit: 'Buy Limit',
    cmdSellLimit: 'Sell Limit',
    cmdBuyStop: 'Buy Stop',
    cmdSellStop: 'Sell Stop',
    cmdCloseBuy: 'Close Buy Positions',
    cmdCloseSell: 'Close Sell Positions',
    cmdCloseAll: 'Close This Symbol',
    cmdCloseAllOrders: 'Close All',
    genSlTpHint: 'Choose one · Priority: Price > Points > Percentage',
    genTsHint: 'Signal send time',
    genTsBtn: 'Current Time',
    presetSimple: '📝 Simple Buy',
    presetSltp: '🛡 With Stop Loss/Take Profit',
    presetFull: '📋 Full Parameters',
    presetClose: '❌ Close Signal',
    presetPending: '📌 Pending Order',
    presetReverse: '🔄 Reverse (Close + Open)',
    genAlertTab: '🔔 Alert Setup Instructions',
    toastIncomplete: 'Information incomplete. Please fill in required fields.',
    toastRegen: 'New key has been generated. Please copy it immediately and update all configured EAs.',
    toastKeyCopied: 'Key copied',
    toastCopied: 'Copied',
    toastCodeCopied: 'Code copied',
    copyTitle: 'Copy',
    genSymbol: 'Trading Symbol',
    genPrice: 'Pending Order Price',
    genParams: 'Trade Parameters',
    genLots: 'Lots',
    genLotsHint: 'Leave blank to use EA default value',
    genMagic: 'Magic Number',
    genMagicHint: 'Used to distinguish orders from different strategies',
    genComment: 'Order Comment',
    genCommentHint: 'e.g.: Strategy A',
    genSL: 'Stop Loss Settings',
    genPoints: 'Points',
    genPrice2: 'Fixed Price',
    genPct: 'Percentage %',
    genTP: 'Take Profit Settings',
    genAdvanced: 'Advanced Parameters',
    genSigIdHint: 'Leave blank to auto-generate, used for deduplication',
    genGenId: 'Auto Generate',
    genBtn: 'Generate Code',
    genFormat: 'Signal Format',
    genGuideTitle: 'How to Use in TradingView',
    genGuideSteps: [
      'Create an <strong>Alert</strong> on your TradingView chart',
      'Select your strategy or indicator under <strong>Alert Condition</strong>',
      'Expand <strong>Notifications</strong> → Check <strong>Webhook URL</strong>',
      'Set the Webhook URL to: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Paste the generated JSON into the <strong>Message</strong> box',
      'Click <strong>Create</strong> to save the Alert'
    ],
    genGuideNote: '<strong>Tip:</strong> If using Pine Script, add the generated code to your script and use the <code>alert_message</code> parameter in <code>strategy.entry()</code> or <code>strategy.close()</code>.',
    paramsGroups: [
      {
        title: '🔐 Authorization — Must Modify',
        rows: [
          ['License', '—', 'Authorization ID, must exactly match the license field in the signal JSON', 'req'],
          ['SecretKey', '—', 'Security key (starts with wc_sk_), must exactly match the key field in the signal JSON', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters',
        rows: [
          ['InpLots', '0.1', 'Default lot size, used when the signal JSON does not include lots', ''],
          ['InpMagic', '888', 'Default magic number, used to distinguish orders from different strategies', ''],
          ['InpComment', 'TV Signal', 'Default order comment', ''],
          ['InpDeviation', '30', 'Maximum slippage (points), 10–30 recommended for forex, 30–50 for gold/indices', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Priority: sl_price (fixed price) > sl_points (points) > sl_pct (percentage). If all three are 0, no stop loss is set. Same for take profit.',
        rows: [
          ['InpSLPoints', '0', 'Default stop loss points (0 = disabled)', ''],
          ['InpSLPrice', '0', 'Default stop loss fixed price (0 = disabled, highest priority)', ''],
          ['InpSLPct', '0', 'Default stop loss percentage (0 = disabled)', ''],
          ['InpTPPoints', '0', 'Default take profit points (0 = disabled)', ''],
          ['InpTPPrice', '0', 'Default take profit fixed price (0 = disabled)', ''],
          ['InpTPPct', '0', 'Default take profit percentage (0 = disabled)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping',
        note: 'Different brokers may name symbols differently (e.g., TradingView calls it XAUUSD, your broker calls it GOLD). Use mapping to convert automatically.',
        rows: [
          ['InpPrefix', '(empty)', 'Symbol prefix, e.g., if your broker symbol is m.EURUSD, enter m.', ''],
          ['InpSuffix', '(empty)', 'Symbol suffix, e.g., if your broker symbol is EURUSD.pro, enter .pro', ''],
          ['InpEnableMap1~5', 'false', 'Set to true to enable the corresponding mapping rule', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Mapping rule, format: TradingViewSymbol|MT5Symbol, supports up to 5 rules', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Same as above', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Same as above', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Same as above', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Same as above', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log',
        rows: [
          ['InpUseTimeFilter', 'false', 'When enabled, only processes signals within StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Allowed trading start time (MT5 server time, format HH:MM)', ''],
          ['InpEndTime', '23:59', 'Allowed trading end time', ''],
          ['InpShowPanel', 'true', 'Display connection status, signal statistics and other info panel on the chart', ''],
          ['InpUpdateInterval', '1000', 'Panel refresh interval (milliseconds), recommended 1000~3000', ''],
          ['InpLogLevel', '1', 'Log level: 0=Off 1=Basic 2=Detailed 3=Debug (use 2 or 3 for troubleshooting)', ''],
          ['InpLogToFile', 'true', 'Write log file to MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Output to MT5 bottom "Experts" tab', ''],
          ['InpMaxLogMB', '5', 'Maximum log file size (MB), automatically rotates when exceeded', '']
        ]
      }
    ],
    paramsEATitle: 'EA Parameter Description',
    paramsEADesc: 'The following parameters can be set when opening the EA in MT5, or overridden by corresponding fields in the JSON signal.',
    paramName: 'Parameter Name',
    paramDefault: 'Default Value',
    paramDesc: 'Description',
    paramOverride: 'JSON Override Field',
    eaParams: [
      ['DefaultLots', '0.1', 'Default lot size (used when JSON does not specify)', 'lots'],
      ['DefaultMagic', '0', 'Default Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Default order comment', 'comment'],
      ['SlippagePoints', '3', 'Maximum slippage (points)', '—'],
      ['OfflineBuffer', 'false', 'Whether to enable offline buffer', '—'],
      ['ReconnectSeconds', '5', 'WebSocket reconnection interval (seconds)', '—']
    ],
    cmdTableTitle: 'Command Type Description',
    cmdCol: 'Command (cmd)',
    typeCol: 'Type',
    actionCol: 'Action',
    extraCol: 'Extra Parameters',
    cmdTable: [
      ['buy', 'Market Order', 'Buy immediately', 'lots, sl_*, tp_*'],
      ['sell', 'Market Order', 'Sell immediately', 'lots, sl_*, tp_*'],
      ['buylimit', 'Pending Order', 'Buy when price is reached', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Pending Order', 'Sell when price is reached', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Pending Order', 'Buy on breakout', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Pending Order', 'Sell on breakout', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Close Position', 'Close all buy positions', 'magic (optional)'],
      ['closesell', 'Close Position', 'Close all sell positions', 'magic (optional)'],
      ['closeall', 'Close Position', 'Close all open positions', '—'],
      ['closeallorders', 'Close Position', 'Delete all pending orders', '—']
    ],
    jsonFieldTitle: 'JSON Field Description',
    fieldCol: 'Field Name',
    requiredCol: 'Required',
    descCol: 'Description',
    jsonFields: [
      ['license', 'string', 'Required', 'License ID'],
      ['key', 'string', 'Required', 'Secret Key'],
      ['cmd', 'string', 'Required', 'Trade command, see table above'],
      ['symbol', 'string', 'Required', 'Trading symbol, e.g. EURUSD'],
      ['lots', 'number', 'Optional', 'Lot size, leave blank to use EA default'],
      ['price', 'number', 'Required for pending orders', 'Pending order price'],
      ['sl_points', 'number', 'Optional', 'Stop loss in points'],
      ['sl_price', 'number', 'Optional', 'Stop loss fixed price'],
      ['sl_pct', 'number', 'Optional', 'Stop loss percentage (0-100)'],
      ['tp_points', 'number', 'Optional', 'Take profit in points'],
      ['tp_price', 'number', 'Optional', 'Take profit fixed price'],
      ['tp_pct', 'number', 'Optional', 'Take profit percentage (0-100)'],
      ['magic', 'number', 'Optional', 'Magic Number'],
      ['comment', 'string', 'Optional', 'Order comment'],
      ['signalid', 'string', 'Optional', 'Unique signal ID for deduplication'],
      ['expiryseconds', 'number', 'Optional', 'Signal validity period (seconds), default 60']
    ],
    dlMt5Desc: 'MT5 version EA, supports all commands, recommended',
    dlMt5Btn: 'Download MT5 EA',
    dlMt4Desc: 'MT4 version EA, under development, stay tuned',
    dlMt4Dev: 'Under Development',
    dlInstallDoc: `<h4>Installation Guide</h4>
<ol>
<li>Download the <code>WikiConnector_MT5.ex5</code> file</li>
<li>Open MT5, menu bar → <strong>File → Open Data Folder</strong></li>
<li>Copy the <code>.ex5</code> file to the <code>MQL5/Experts/</code> directory</li>
<li>Press <strong>F5</strong> in MT5 to refresh the Navigator and find the WikiConnector EA</li>
<li>Drag the EA onto any chart, enter your <strong>License ID</strong> and <strong>Secret Key</strong></li>
<li>In EA options, check <strong>Allow WebRequest</strong> and add <code>api-gw.interface003.com</code> to the allowed URL list</li>
</ol>`,
    disclaimerTitle: 'Risk Disclaimer',
    disclaimerContent: `<p>Before downloading and using the WikiConnector EA, please read the following disclaimer carefully:</p>
<p><strong>1. Trading Risk</strong><br/>Foreign exchange and CFD trading involves significant risk and may result in the loss of all or part of your funds. WikiConnector is solely a signal transmission tool and is not responsible for any trading results.</p>
<p><strong>2. Strategy Risk</strong><br/>Past performance of automated trading strategies does not guarantee future results. Please test thoroughly before using on a live account.</p>
<p><strong>3. Technical Risk</strong><br/>Technical factors such as network latency, server failures, and API limitations may cause signal loss or execution delays. Do not use this tool for high-frequency strategies that are extremely sensitive to latency.</p>
<p><strong>4. User Responsibility</strong><br/>Users assume full responsibility for all trading results arising from the use of the WikiConnector EA. WikiFX does not provide investment advice and is not responsible for any trading profits or losses.</p>`,
    disclaimerAgree: 'I have read and agree to the above disclaimer and understand the trading risks',
    disclaimerDownload: 'Agree & Download',
    regenTitle: 'Confirm Key Reset?',
    regenSubtitle: 'This action cannot be undone. Please confirm you understand the following impacts:',
    regenWarnings: ['All EAs configured with this key will <strong>disconnect immediately</strong>', 'The old key will be <strong>permanently invalidated</strong> and cannot be recovered', 'You need to manually update the Secret Key configuration in all EAs', 'There is a risk of <strong>signal loss</strong> during the reset process'],
    dashTitle: 'My WikiConnector',
    myKey: 'My Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Copy',
    regenBtn: 'Regenerate',
    regenConfirm: 'After regenerating the key, all currently connected EAs will disconnect and need to be reconfigured. Confirm to continue?',
    regenConfirmBtn: 'Confirm Reset',
    cancelBtn: 'Cancel',
    copiedTip: 'Copied',
    licenseTitle: 'My Licenses',
    licenseId: 'License ID',
    maxConn: 'Max Connections',
    activeConn: 'Current Connections',
    webhookUrl: 'Webhook URL',
    statsTitle: 'Signal Statistics',
    statTotal: 'Total Signals',
    statDelivered: 'Delivered',
    statFailed: 'Failed',
    statConnections: 'Current Connections',
    signalTitle: 'Recent Signal Records',
    signalTime: 'Time',
    signalCmd: 'Command',
    signalSymbol: 'Symbol',
    signalLots: 'Lots',
    signalStatus: 'Status',
    signalLicense: 'License',
    statusDelivered: 'Delivered',
    statusPending: 'Pending',
    statusFailed: 'Failed',
    statusExpired: 'Expired',
    noSignal: 'No signal records yet',
    loadMore: 'Load More',
    offlineBuffer: 'Offline Buffer',
    offlineBufferDesc: 'When enabled, the EA will deliver signals accumulated during offline periods upon reconnection (disabled by default to prevent losses)',
    docTitle: 'User Guide',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 How WikiConnector Works</p>
  <p>WikiConnector receives TradingView signals in real time via <strong>WebSocket persistent connection</strong> and automatically executes trades in the trading software.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Install the EA in Your Trading Software</p>
  <ol class="doc-steps">
    <li><strong>Open Data Folder</strong>: Trading software menu → File → Open Data Folder</li>
    <li><strong>Copy the EA File</strong>: Copy the EA file to the <code>Experts/</code> directory</li>
    <li><strong>Refresh Navigator</strong>: Open Navigator → right-click on "Expert Advisors" → Refresh, you should see <strong>SignalReceiver</strong> in the list</li>
    <li><strong>Enable Auto Trading</strong>: The "Auto Trading" button on the top toolbar must be 🟢 green</li>
    <li><strong>Attach to Chart</strong>: Drag SignalReceiver onto any chart and configure parameters in the pop-up window</li>
  </ol>
  <div class="doc-tip"><strong>Tip:</strong> The EA only needs to be attached to one chart to handle signals for all symbols. No need to attach it separately to each symbol's chart.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Configure EA Parameters</p>
  <p>Parameters are divided into two categories: <strong>Required</strong> (License / SecretKey) and <strong>Default Value Parameters</strong> (used when the signal JSON does not include a certain field; values in the signal always take precedence over EA defaults).</p>
  <div class="doc-warn"><strong>Security Warning:</strong> License and SecretKey are the only barriers protecting your account. If leaked, anyone can send trading instructions to your trading software. Do not screenshot or share them with others, and consider changing your SecretKey regularly.</div>
  <p>After setup, the EA name + <strong>😊</strong> appearing in the upper right corner of the chart indicates a successful connection to the server. If you see 😞, check whether the "Auto Trading" button is green.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Write Pine Script Signal Code</p>
  <p>WikiConnector uses the <code>alert()</code> function to trigger signals, not the <code>strategy.entry(alert_message=)</code> method. These two mechanisms are different, so do not mix them.</p>
  <div class="doc-danger"><strong>Critical: alert.freq_all</strong> — By default, Pine Script only triggers the first <code>alert()</code> within the same bar, silently discarding subsequent ones. When you need to send multiple signals consecutively (e.g., reverse position: first close short then open long), every <code>alert()</code> must include <code>alert.freq_all</code>, otherwise the second signal will never reach the server.</div>
<pre>//@version=6
strategy("WikiConnector Strategy", overlay=true)

// Define signal messages (replace YOUR_LICENSE and YOUR_KEY with your own values)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Example strategy conditions (3/13 MA crossover)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Use alert.freq_all to ensure multiple signals can be sent within the same bar
if longCondition
    alert(closesellMessage, alert.freq_all)  // First close short positions
    alert(buyMessage,       alert.freq_all)  // Then open long positions

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // First close long positions
    alert(sellMessage,     alert.freq_all)   // Then open short positions</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Create an Alert in TradingView</p>
  <p>Webhook URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Right-click on chart → "<strong>Add Alert...</strong>" or press <strong>Alt+A</strong></li>
    <li>Set Condition to <strong>"alert() function call only"</strong> (critical!)</li>
    <li>Set expiration to as long as possible, or "Open-ended"</li>
    <li>Keep the <strong>Message</strong> box <strong>as default, leave it empty</strong> (signal content is determined by the alert() in your code)</li>
    <li>Notification settings: Check <strong>Webhook URL</strong> and enter the address above; <strong>uncheck "Send plain text"</strong></li>
    <li>Click "Create" to save the alert</li>
  </ol>
  <div class="doc-tip"><strong>Tip:</strong> Webhook functionality requires a TradingView Pro subscription or higher.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Signal JSON Format Explanation</p>
  <p><strong>Required Fields:</strong> <code>license</code> (Authorization ID), <code>key</code> (Secret Key), <code>cmd</code> (Command), <code>symbol</code> (Symbol Name)</p>
  <p><strong>Optional Fields:</strong> <code>lots</code> (Lot Size), <code>price</code> (Pending Order Price), <code>sl_points / sl_price / sl_pct</code> (Stop Loss - choose one), <code>tp_points / tp_price / tp_pct</code> (Take Profit - choose one), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (default 300 seconds)</p>
  <p><strong>Supported cmd:</strong> <code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Stop Loss/Take Profit Priority:</strong> <code>sl_price</code> (Fixed Price) &gt; <code>sl_points</code> (Points) &gt; <code>sl_pct</code> (Percentage). If all three are 0, no stop loss is set. Same applies to take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Pre-Launch Checklist</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Trading software auto-trading button is 🟢 green</li>
    <li class="ok">✅ EA in upper right corner of chart shows 😊 (connected to server)</li>
    <li class="ok">✅ License / SecretKey exactly match the values in the TradingView JSON</li>
    <li class="ok">✅ Alert condition set to "<strong>alert() function call only</strong>"</li>
    <li class="ok">✅ Every <code>alert()</code> includes <code>alert.freq_all</code></li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message box kept as default, left empty</li>
    <li class="no">❌ Unchecked "Send plain text"</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Security and Risk Tips</p>
  <div class="doc-warn">
    <strong>Account Security:</strong><br>
    · Do not screenshot or share your License and SecretKey with anyone<br>
    · If you suspect your key has been leaked, immediately reset your SecretKey in the console<br>
    · It is recommended to change your SecretKey regularly
  </div>
  <div class="doc-warn">
    <strong>Trading Risk Control:</strong><br>
    · Always set stop losses; never run automated strategies without protection<br>
    · Single trade risk should be limited to 1–2% of account funds<br>
    · Consider pausing automated trading before major economic data releases (NFP, CPI, FOMC)
  </div>
  <div class="doc-tip">
    <strong>Best Practices:</strong><br>
    · Test on a demo account for at least 1–2 weeks before switching to a live account<br>
    · Start with the minimum lot size (0.01) on a live account<br>
    · Use a VPS (such as Tianyan Cloud VPS) to ensure your trading software and EA run 24/7
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook Signal Format',
        content: `Fill in the following JSON in the TradingView Alert Message:
<pre>{
  "license": "{{your_license_id}}",
  "key": "{{your_secret_key}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Supported <strong>cmd</strong> commands: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook Address',
        content: `<p>In TradingView Alert settings, set the Webhook URL to:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Fill the Message box with the JSON signal format above, replacing license and key with your own values.</p>`
      },
      {
        title: '3. Install WikiConnector EA',
        content: `<p>1. Download the WikiConnector EA (.ex5 file)</p>
<p>2. Copy the EA to the <code>MQL5/Experts</code> directory in MT5</p>
<p>3. Open the EA in MT5 and enter your <strong>License ID</strong> and <strong>Secret Key</strong></p>
<p>4. Allow the EA to make WebSocket connections (enable network connection permissions in MT5 Options → EA)</p>`
      },
      {
        title: '4. Rate Limits',
        content: `<p>Maximum <strong>30 requests / 60 seconds</strong> per License. Exceeding the limit will return a 429 error.</p>
<p>For higher frequency requirements, please contact customer service to upgrade your plan.</p>`
      }
    ],
    faqTitle: 'Frequently Asked Questions',
    faqs: [
      {
        q: 'What if my key is leaked?',
        a: 'Click "Regenerate" in the console. The old key will become invalid immediately, all EA connections will be disconnected, and you can reconfigure your EAs with the new key.'
      },
      {
        q: 'Will the EA replay signals after reconnecting?',
        a: 'By default, no (to prevent losses). If you need signal replay, enable the "Offline Buffer" switch in the console, and the EA will receive signals accumulated during the offline period upon reconnection.'
      },
      {
        q: 'How many MT accounts can one License connect?',
        a: 'Each License supports up to 10 concurrent WebSocket connections, allowing up to 10 MT terminals to receive the same signal simultaneously.'
      },
      {
        q: 'Does it support MT4?',
        a: 'The current version primarily supports MT5. The MT4 version EA is under development. Stay tuned!'
      },
      {
        q: 'How high is the signal latency?',
        a: 'Average latency is <100ms, and can be as low as 1ms when deployed with Tianyan Cloud VPS.'
      },
      {
        q: 'How do I test if the Webhook is working properly?',
        a: 'Check "Current Connections" in the license list. If the connection count is > 0, the EA is online. After sending a test signal, you can see the status as "Delivered" in "Recent Signal Records".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script and Signal Sending',
        items: [
          {
            q: 'I used two alert() functions to close and open positions, but the trading software only received one signal?',
            a: 'This is a default limitation of Pine Script. Only the first alert() triggers within the same bar. The solution is to add the <code>alert.freq_all</code> parameter to <strong>every alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Which alert condition should I select?',
            a: 'When using the <code>alert()</code> function method, you must select <strong>"alert() function call only"</strong>. If using the <code>strategy.entry(..., alert_message=xxx)</code> method, select "Order fills only". Do not mix these two methods.'
          },
          {
            q: 'What should I fill in the Message box?',
            a: 'When using the <code>alert()</code> method, <strong>keep the Message box as default and leave it empty</strong>. The signal content is determined by the string inside <code>alert(xxx)</code> in your code, and that JSON is what the Webhook receives.'
          }
        ]
      },
      {
        title: '🔌 Connection and Signal Reception',
        items: [
          {
            q: 'The EA icon shows a red crying face 😞. What should I do?',
            a: 'Check whether the "Auto Trading" button on the trading software toolbar is green. If it is red, click it to turn it green, and the EA will automatically return to normal.'
          },
          {
            q: 'A signal was sent from TradingView, but the trading software did not respond?',
            a: 'Check in order:<br>1. Is the trading software auto-trading green?<br>2. Does the EA panel show "Connected"?<br>3. Is the Webhook URL <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. Is the alert condition set to "alert() function call only"?<br>5. Does every alert() include <code>alert.freq_all</code>?<br>6. Do the license and key in the JSON exactly match the EA settings?'
          }
        ]
      },
      {
        title: '💰 Trade Execution',
        items: [
          {
            q: 'Order placement failed. What could be the reason?',
            a: 'Common reasons: insufficient balance / symbol name mismatch (need to configure Symbol Mapping) / lot size exceeds limit / slippage too large (increase InpDeviation) / market closed. Check the "Experts" log at the bottom of the trading software for specific error information.'
          },
          {
            q: 'The order has no stop loss or take profit?',
            a: 'Check: ① Whether the signal JSON contains fields like <code>sl_points</code> / <code>tp_points</code>; ② Whether the EA default stop loss/take profit parameters are 0. If neither side has settings, the order will not have stop loss or take profit.'
          },
          {
            q: 'What if the symbol names are inconsistent?',
            a: 'Enable Symbol Mapping in the EA parameters:<br>Set <code>InpEnableMap1 = true</code><br>Set <code>InpMapping1 = XAUUSD|GOLD</code> (TradingViewSymbol|TradingSoftwareSymbol)'
          },
          {
            q: 'Can I test with a demo account first?',
            a: '<strong>Highly recommended!</strong> First-time users must test on a demo account for at least 1–2 weeks to confirm the link is working and orders are executed correctly before switching to a live account. Start with the minimum lot size of 0.01.'
          }
        ]
      }
    ]
  },
  // === ja 日本語 ===
  ja: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView シグナルを MetaTrader に自動接続して取引を実行',
    heroBtn: '無料で始める',

    stat1Label: '平均遅延',
    stat2Label: 'サービス稼働率',
    stat3Label: '24時間稼働',
    stat4Label: 'マルチ口座配信',

    flowSub1: '戦略 / Alert',
    flowSub2: 'シグナルルーティング',
    flowSub3: '自動実行',

    featTitle: 'なぜ WikiConnector を選ぶのか',
    featSubtitle: '中核となる強み',
    features: [
      {
        icon: '⚡',
        title: 'ミリ秒単位の実行',
        desc: 'シグナル平均遅延 <100ms、WikiFX VPS と併用で 1ms まで低減可能。'
      },
      {
        icon: '🔗',
        title: 'マルチ口座配信',
        desc: '1つの証明書で複数の MT 端末に接続し、同一戦略のシグナルを同時配信。'
      },
      {
        icon: '🔒',
        title: '安全な暗号化',
        desc: 'ユーザーごとに独立した鍵体系、データは全経路暗号化されて転送。'
      },
      {
        icon: '📊',
        title: 'リアルタイム監視',
        desc: 'シグナル受信状態、実行遅延、成功率をリアルタイムで確認可能。'
      },
      {
        icon: '<>',
        title: 'コード生成ツール',
        desc: 'JSON シグナルと Pine Script コードをビジュアルに生成、プログラミング不要。'
      },
      {
        icon: '🖥',
        title: 'VPS との深い統合',
        desc: '天眼雲 VPS とアカウント体系を共有し、年中無休で低遅延運用。'
      }
    ],

    stepsTitle: '4ステップで自動取引を開始',
    stepsSubtitle: 'クイックスタート',
    steps: [
      {
        title: 'アカウントにログイン',
        desc: 'WikiFX アカウントでログインすると、専用の鍵とライセンスが自動発行されます。'
      },
      {
        title: 'Webhook を設定',
        desc: 'Webhook URL を TradingView の Alert 設定にコピーします。'
      },
      {
        title: 'EA をインストール',
        desc: 'WikiConnector EA をダウンロードし、License ID と Secret Key を入力します。'
      },
      {
        title: '自動取引を開始',
        desc: '戦略が Alert をトリガーすると、シグナルが自動的に MT 端末に伝達され実行されます。'
      }
    ],

    loginTip: 'ログインすると、あなた専用の鍵と証明書を確認できます',
    loginBtn: '今すぐログイン',

    navConn: '接続管理',
    navLog: 'シグナルログ',
    navGen: 'コード生成',
    navParams: 'パラメータ早見表',
    navDl: 'ダウンロード',
    navDoc: '利用チュートリアル',
    navFaq: 'よくある質問',

    keyLabel: 'Secret Key',
    keyTip1: '誰とも共有しないでください',
    keyTip2: 'EA 認証に使用',
    keyTip3: 'リセット後、古い鍵は即座に無効になります',

    connSubtitle: '以下はあなたのライセンスとそれに対応する Webhook URL です',
    noLicense: 'ライセンスがありません。カスタマーサポートにお問い合わせください',
    needHelp: 'ヘルプが必要ですか？',
    viewDoc: '利用チュートリアルを見る',

    allLicense: 'すべてのライセンス',
    allStatus: 'すべてのステータス',
    refresh: '更新',
    signalId: 'シグナル ID',
    total: '合計',
    records: '件の記録',

    genIntro: '以下のパラメータを入力すると、TradingView Alert で使用できる JSON シグナルと Pine Script コードが自動生成されます。',
    genAuth: '認証情報',
    required: '必須',
    optional: '任意',
    genLicPlaceholder: 'あなたの License ID を入力',
    genLicHint: '接続管理ページで確認できます',
    genKeyPlaceholder: 'あなたの Secret Key を入力',
    genKeyHint: '接続管理ページで確認できます',
    genTrade: '取引指示',
    genCmd: '指示タイプ',
    genMarket: '成行注文',
    genPending: '指値注文',
    genClose: '決済',
    cmdBuy: '成行買い',
    cmdSell: '成行売り',
    cmdBuyLimit: '指値買い',
    cmdSellLimit: '指値売り',
    cmdBuyStop: '逆指値買い',
    cmdSellStop: '逆指値売り',
    cmdCloseBuy: '買いポジションを決済',
    cmdCloseSell: '売りポジションを決済',
    cmdCloseAll: '該当銘柄を決済',
    cmdCloseAllOrders: '全決済',
    genSlTpHint: '3つから1つ選択 · 優先順位：価格 > ポイント > パーセンテージ',
    genTsHint: 'シグナル送信時刻',
    genTsBtn: '現在時刻',
    presetSimple: '📝 シンプル買い',
    presetSltp: '🛡 ストップロス・テイクプロフィット付き',
    presetFull: '📋 完全パラメータ',
    presetClose: '❌ 決済シグナル',
    presetPending: '📌 指値注文',
    presetReverse: '🔄 反転（決済＋新規）',
    genAlertTab: '🔔 Alert 設定の説明',
    toastIncomplete: '情報が不完全です。必須項目を入力してください',
    toastRegen: '新しい鍵が生成されました。すぐにコピーし、設定済みのすべての EA を更新してください',
    toastKeyCopied: '鍵をコピーしました',
    toastCopied: 'コピーしました',
    toastCodeCopied: 'コードをコピーしました',
    copyTitle: 'コピー',
    genSymbol: '取引銘柄',
    genPrice: '指値価格',
    genParams: '取引パラメータ',
    genLots: 'ロット数',
    genLotsHint: '空欄の場合は EA のデフォルト値を使用',
    genMagic: 'Magic Number',
    genMagicHint: '異なる戦略の注文を区別するために使用',
    genComment: '注文メモ',
    genCommentHint: '例：Strategy A',
    genSL: 'ストップロス設定',
    genPoints: 'ポイント',
    genPrice2: '固定価格',
    genPct: 'パーセンテージ %',
    genTP: 'テイクプロフィット設定',
    genAdvanced: '高度なパラメータ',
    genSigIdHint: '空欄の場合は自動生成され、重複除去に使用',
    genGenId: '自動生成',
    genBtn: 'コードを生成',
    genFormat: 'シグナル形式',
    genGuideTitle: 'TradingView での使用方法',
    genGuideSteps: [
      'TradingView チャートで <strong>Alert（アラート）</strong> を作成',
      '<strong>Alert トリガー条件</strong> で戦略または指標を選択',
      '<strong>Notifications（通知）</strong> を展開 → <strong>Webhook URL</strong> にチェック',
      'Webhook URL に次のアドレスを入力：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      '上記で生成した JSON を <strong>Message（メッセージ）</strong> ボックスに貼り付け',
      '<strong>Create（作成）</strong> をクリックして Alert を保存'
    ],
    genGuideNote: '<strong>ヒント：</strong> Pine Script を使用する場合、生成されたコードをスクリプトに追加し、<code>strategy.entry()</code> または <code>strategy.close()</code> で <code>alert_message</code> パラメータを使用してください。',

    paramsGroups: [
      {
        title: '🔐 Authorization（認証）— 必ず変更',
        rows: [
          ['License', '—', '認証 ID。シグナル JSON の license フィールドと完全に一致させる必要があります', 'req'],
          ['SecretKey', '—', 'セキュリティキー（wc_sk_ で始まる）。シグナル JSON の key フィールドと完全に一致させる必要があります', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters（デフォルト取引パラメータ）',
        rows: [
          ['InpLots', '0.1', 'デフォルトのロット数。シグナル JSON に lots が含まれていない場合に使用', ''],
          ['InpMagic', '888', 'デフォルトのマジックナンバー。異なる戦略の注文を区別するため', ''],
          ['InpComment', 'TV Signal', 'デフォルトの注文コメント', ''],
          ['InpDeviation', '30', '最大スリッページ（ポイント）。外国為替は 10–30、金/指数は 30–50 を推奨', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit（ストップロス／テイクプロフィット）',
        note: '優先順位：sl_price（固定価格）> sl_points（ポイント）> sl_pct（パーセンテージ）。3項目すべてが 0 の場合はストップロスを設定しません。テイクプロフィットも同様です',
        rows: [
          ['InpSLPoints', '0', 'デフォルトのストップロスポイント数（0 = 無効）', ''],
          ['InpSLPrice', '0', 'デフォルトのストップロス固定価格（0 = 無効、優先度最高）', ''],
          ['InpSLPct', '0', 'デフォルトのストップロスパーセンテージ（0 = 無効）', ''],
          ['InpTPPoints', '0', 'デフォルトのテイクプロフィットポイント数（0 = 無効）', ''],
          ['InpTPPrice', '0', 'デフォルトのテイクプロフィット固定価格（0 = 無効）', ''],
          ['InpTPPct', '0', 'デフォルトのテイクプロフィットパーセンテージ（0 = 無効）', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping（銘柄名マッピング）',
        note: '証券会社によって銘柄名が異なる場合があります（例：TradingView では XAUUSD、証券会社では GOLD）。マッピングを使用すると自動変換できます',
        rows: [
          ['InpPrefix', '（空欄）', '銘柄名のプレフィックス。証券会社の銘柄が m.EURUSD の場合は m. と入力', ''],
          ['InpSuffix', '（空欄）', '銘柄名のサフィックス。証券会社の銘柄が EURUSD.pro の場合は .pro と入力', ''],
          ['InpEnableMap1~5', 'false', 'true に設定すると対応するマッピングルールが有効になります', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'マッピングルール。形式：TradingView銘柄名|MT5銘柄名。最大5つまで設定可能', ''],
          ['InpMapping2', 'EURUSD|EUR', '同上', ''],
          ['InpMapping3', 'GBPUSD|GBP', '同上', ''],
          ['InpMapping4', 'BTCUSD|BTC', '同上', ''],
          ['InpMapping5', 'USOUSD|WTI', '同上', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log（時間フィルター／表示＆ログ）',
        rows: [
          ['InpUseTimeFilter', 'false', '有効にすると、StartTime～EndTime の間のみシグナルを処理します', ''],
          ['InpStartTime', '00:00', '取引許可開始時間（MT5 サーバー時間、形式 HH:MM）', ''],
          ['InpEndTime', '23:59', '取引許可終了時間', ''],
          ['InpShowPanel', 'true', 'チャートに接続状態やシグナル統計などの情報パネルを表示', ''],
          ['InpUpdateInterval', '1000', 'パネルの更新間隔（ミリ秒）。1000～3000 を推奨', ''],
          ['InpLogLevel', '1', 'ログレベル：0=オフ 1=基本 2=詳細 3=デバッグ（トラブルシューティング時は 2 または 3）', ''],
          ['InpLogToFile', 'true', 'ログファイルを MQL5/Logs/ に出力', ''],
          ['InpLogToConsole', 'true', 'MT5 下部の「エキスパート」タブに出力', ''],
          ['InpMaxLogMB', '5', 'ログファイルの最大サイズ（MB）。超過すると自動ローテーション', '']
        ]
      }
    ],

    paramsEATitle: 'EA パラメータの説明',
    paramsEADesc: '以下のパラメータは MT5 で EA を開くときに設定でき、JSON シグナルの対応フィールドで上書きすることもできます。',
    paramName: 'パラメータ名',
    paramDefault: 'デフォルト値',
    paramDesc: '説明',
    paramOverride: 'JSON 上書きフィールド',
    eaParams: [
      ['DefaultLots', '0.1', 'デフォルトのロット数（JSON で指定がない場合に使用）', 'lots'],
      ['DefaultMagic', '0', 'デフォルトの Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', 'デフォルトの注文メモ', 'comment'],
      ['SlippagePoints', '3', '最大スリッページ（ポイント）', '—'],
      ['OfflineBuffer', 'false', 'オフラインバッファを有効にするかどうか', '—'],
      ['ReconnectSeconds', '5', 'WebSocket 切断後の再接続間隔（秒）', '—']
    ],
    cmdTableTitle: '指示タイプの説明',
    cmdCol: '指示 (cmd)',
    typeCol: 'タイプ',
    actionCol: '動作',
    extraCol: '追加パラメータ',
    cmdTable: [
      ['buy', '成行注文', '即時買い', 'lots, sl_*, tp_*'],
      ['sell', '成行注文', '即時売り', 'lots, sl_*, tp_*'],
      ['buylimit', '指値注文', '価格到達時に買い', 'price, lots, sl_*, tp_*'],
      ['selllimit', '指値注文', '価格到達時に売り', 'price, lots, sl_*, tp_*'],
      ['buystop', '指値注文', '価格突破時に買い', 'price, lots, sl_*, tp_*'],
      ['sellstop', '指値注文', '価格突破時に売り', 'price, lots, sl_*, tp_*'],
      ['closebuy', '決済', 'すべての買いポジションを決済', 'magic（任意）'],
      ['closesell', '決済', 'すべての売りポジションを決済', 'magic（任意）'],
      ['closeall', '決済', 'すべての保有ポジションを決済', '—'],
      ['closeallorders', '決済', 'すべての指値注文を削除', '—']
    ],
    jsonFieldTitle: 'JSON フィールドの説明',
    fieldCol: 'フィールド名',
    requiredCol: '必須かどうか',
    descCol: '説明',
    jsonFields: [
      ['license', 'string', '必須', 'License ID'],
      ['key', 'string', '必須', 'Secret Key'],
      ['cmd', 'string', '必須', '取引指示。上の表を参照'],
      ['symbol', 'string', '必須', '取引銘柄。例：EURUSD'],
      ['lots', 'number', '任意', 'ロット数。空欄の場合は EA のデフォルト値を使用'],
      ['price', 'number', '指値注文の場合必須', '指値価格'],
      ['sl_points', 'number', '任意', 'ストップロスのポイント数'],
      ['sl_price', 'number', '任意', 'ストップロスの固定価格'],
      ['sl_pct', 'number', '任意', 'ストップロスのパーセンテージ（0-100）'],
      ['tp_points', 'number', '任意', 'テイクプロフィットのポイント数'],
      ['tp_price', 'number', '任意', 'テイクプロフィットの固定価格'],
      ['tp_pct', 'number', '任意', 'テイクプロフィットのパーセンテージ（0-100）'],
      ['magic', 'number', '任意', 'Magic Number'],
      ['comment', 'string', '任意', '注文メモ'],
      ['signalid', 'string', '任意', 'シグナル一意 ID。重複除去に使用'],
      ['expiryseconds', 'number', '任意', 'シグナルの有効期間（秒）。デフォルト 60']
    ],

    dlMt5Desc: 'MT5 版 EA。すべての指示に対応。推奨',
    dlMt5Btn: 'MT5 EA をダウンロード',
    dlMt4Desc: 'MT4 版 EA。開発中。ご期待ください',
    dlMt4Dev: '開発中',
    dlInstallDoc: `<h4>インストール手順</h4>
<ol>
<li><code>WikiConnector_MT5.ex5</code> ファイルをダウンロード</li>
<li>MT5 を開き、メニューバー → <strong>ファイル → データフォルダを開く</strong></li>
<li><code>.ex5</code> ファイルを <code>MQL5/Experts/</code> ディレクトリにコピー</li>
<li>MT5 で <strong>F5</strong> を押してナビゲーターを更新し、WikiConnector EA を見つけます</li>
<li>EA を任意のチャートにドラッグし、<strong>License ID</strong> と <strong>Secret Key</strong> を入力</li>
<li>EA オプションで <strong>WebRequest を許可</strong> にチェックを入れ、許可 URL リストに <code>api-gw.interface003.com</code> を追加</li>
</ol>`,

    disclaimerTitle: 'リスク免責事項',
    disclaimerContent: `<p>WikiConnector EA をダウンロードして使用する前に、以下の免責事項をよくお読みください。</p>
<p><strong>1. 取引リスク</strong><br/>外国為替および差金決済取引には重大なリスクが伴い、資金の全部または一部を失う可能性があります。WikiConnector はシグナル伝達ツールにすぎず、いかなる取引結果に対しても責任を負いません。</p>
<p><strong>2. 戦略リスク</strong><br/>自動取引戦略の過去の実績は将来の結果を保証するものではありません。実際の口座で使用する前に十分にテストしてください。</p>
<p><strong>3. 技術的リスク</strong><br/>ネットワーク遅延、サーバー障害、API 制限などの技術的要因により、シグナルの喪失や実行遅延が発生する可能性があります。レイテンシに非常に敏感な高頻度戦略には本ツールを使用しないでください。</p>
<p><strong>4. 使用責任</strong><br/>ユーザーは WikiConnector EA の使用によって生じたすべての取引結果に対して全責任を負います。WikiFX は投資助言を提供せず、取引の損益に対しても責任を負いません。</p>`,
    disclaimerAgree: '上記の免責事項を読み、取引リスクを理解した上で同意します',
    disclaimerDownload: '同意してダウンロード',

    regenTitle: '鍵のリセットを確認',
    regenSubtitle: 'この操作は元に戻せません。以下の影響を理解していることを確認してください：',
    regenWarnings: ['この鍵が設定されているすべての EA が<strong>即座に切断されます</strong>', '古い鍵は<strong>永久に無効</strong>になり、復元できません', 'すべての EA の Secret Key 設定を手動で更新する必要があります', 'リセット中に<strong>シグナルが失われる</strong>リスクがあります'],

    dashTitle: 'マイ WikiConnector',
    myKey: 'マイシークレットキー',
    keyPrefix: 'Secret Key',
    copyBtn: 'コピー',
    regenBtn: '再生成',
    regenConfirm: '鍵を再生成すると、接続中のすべての EA が切断され、再設定が必要になります。続行しますか？',
    regenConfirmBtn: 'リセットを確認',
    cancelBtn: 'キャンセル',
    copiedTip: 'コピーしました',

    licenseTitle: 'マイ証明書 (License)',
    licenseId: '証明書 ID',
    maxConn: '最大接続数',
    activeConn: '現在の接続',
    webhookUrl: 'Webhook URL',

    statsTitle: 'シグナル統計',
    statTotal: '総シグナル数',
    statDelivered: '配信済み',
    statFailed: '失敗',
    statConnections: '現在の接続',

    signalTitle: '最近のシグナル記録',
    signalTime: '時刻',
    signalCmd: '指示',
    signalSymbol: '銘柄',
    signalLots: 'ロット数',
    signalStatus: 'ステータス',
    signalLicense: '証明書',
    statusDelivered: '配信済み',
    statusPending: '配信待ち',
    statusFailed: '失敗',
    statusExpired: '期限切れ',
    noSignal: 'シグナル記録はまだありません',
    loadMore: 'さらに読み込む',

    offlineBuffer: 'オフラインバッファ',
    offlineBufferDesc: '有効にすると、EA 再接続時にオフライン中に蓄積されたシグナルが配信されます（デフォルトでは無効。損失防止のため）',

    docTitle: '利用チュートリアル',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 WikiConnector の仕組み</p>
  <p>WikiConnector は <strong>WebSocket 長接続</strong>を介して TradingView のシグナルをリアルタイムで受信し、取引ソフトウェアで自動的に取引を実行します。</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① EA を取引ソフトウェアにインストール</p>
  <ol class="doc-steps">
    <li><strong>データフォルダを開く</strong>：取引ソフトウェアのメニュー → ファイル → データフォルダを開く</li>
    <li><strong>EA ファイルをコピー</strong>：EA ファイルを <code>Experts/</code> ディレクトリにコピー</li>
    <li><strong>ナビゲーターを更新</strong>：ナビゲーターを開き、「エキスパートアドバイザー」を右クリック → 更新。リストに <strong>SignalReceiver</strong> が表示されるはずです</li>
    <li><strong>自動取引を有効化</strong>：上部ツールバーの「自動取引」ボタンが 🟢 緑色になっている必要があります</li>
    <li><strong>チャートに適用</strong>：SignalReceiver を任意のチャートにドラッグ＆ドロップし、設定ウィンドウが表示されたらパラメータを設定します</li>
  </ol>
  <div class="doc-tip"><strong>ヒント：</strong>EA は1つのチャートに適用するだけで、すべての銘柄のシグナルを処理できます。銘柄ごとに個別に適用する必要はありません。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② EA パラメータを設定</p>
  <p>パラメータは2種類あります：<strong>必須</strong>（License / SecretKey）と<strong>デフォルト値パラメータ</strong>（シグナル JSON に特定のフィールドが含まれていない場合に使用。シグナル内の値は常に EA のデフォルト値より優先されます）。</p>
  <div class="doc-warn"><strong>セキュリティ警告：</strong>License と SecretKey はアカウントを保護する唯一の防御壁です。漏洩すると、誰でもあなたの取引ソフトウェアに取引指示を送信できるようになります。スクリーンショットを撮ったり他人と共有したりせず、定期的に SecretKey を変更することをお勧めします。</div>
  <p>設定が完了すると、チャートの右上隅に EA 名 + <strong>😊</strong> が表示され、サーバーに接続されたことを示します。😞 が表示される場合は、「自動取引」ボタンが緑色になっているか確認してください。</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Pine Script シグナルコードを作成</p>
  <p>WikiConnector は <code>alert()</code> 関数を使用してシグナルをトリガーします。<code>strategy.entry(alert_message=)</code> 方式とは異なるメカニズムなので、混在させないでください。</p>
  <div class="doc-danger"><strong>重要：alert.freq_all</strong> — Pine Script はデフォルトで同じローソク足内では最初の <code>alert()</code> のみがトリガーされ、以降はすべて破棄されます。複数のシグナルを連続して送信する必要がある場合（例：反転処理で売りポジションを決済してから買いポジションを新規）、各 <code>alert()</code> に <code>alert.freq_all</code> を追加する必要があります。そうしないと、2番目以降のシグナルはサーバーに届きません。</div>
<pre>//@version=6
strategy("WikiConnector 戦略", overlay=true)

// シグナルメッセージを定義（YOUR_LICENSE と YOUR_KEY は自分の値に置き換えてください）
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// 戦略条件の例（3/13 移動平均線のクロス）
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// alert.freq_all を使用して、同じローソク足内で複数のシグナルを確実に送信
if longCondition
    alert(closesellMessage, alert.freq_all)  // まず売りポジションを決済
    alert(buyMessage,       alert.freq_all)  // 次に買いポジションを新規

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // まず買いポジションを決済
    alert(sellMessage,     alert.freq_all)   // 次に売りポジションを新規</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ TradingView でアラートを作成</p>
  <p>Webhook URL：</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>チャートを右クリック → "<strong>アラートを追加...</strong>" または <strong>Alt+A</strong></li>
    <li>トリガー条件で <strong>"alert() 関数呼び出しのみ"</strong> を選択（重要！）</li>
    <li>有効期限はできるだけ長く、または「無期限」を選択</li>
    <li>Message ボックスは <strong>デフォルトのまま、何も入力しない</strong>（シグナル内容はコード内の alert() で決定されます）</li>
    <li>通知設定：<strong>Webhook URL</strong> にチェックを入れ、上記のアドレスを入力。<strong>「プレーンテキストを送信」のチェックを外す</strong></li>
    <li>「作成」をクリックしてアラートを保存</li>
  </ol>
  <div class="doc-tip"><strong>ヒント：</strong>Webhook 機能には TradingView Pro 以上のサブスクリプションが必要です。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ シグナル JSON 形式の説明</p>
  <p><strong>必須フィールド：</strong><code>license</code>（認証ID）、<code>key</code>（鍵）、<code>cmd</code>（指示）、<code>symbol</code>（銘柄名）</p>
  <p><strong>任意フィールド：</strong><code>lots</code>（ロット数）、<code>price</code>（指値価格）、<code>sl_points / sl_price / sl_pct</code>（ストップロス3択）、<code>tp_points / tp_price / tp_pct</code>（テイクプロフィット3択）、<code>magic</code>、<code>comment</code>、<code>signal_id</code>、<code>expiry_seconds</code>（デフォルト300秒）</p>
  <p><strong>対応 cmd：</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>ストップロス・テイクプロフィットの優先順位：</strong><code>sl_price</code>（固定価格）&gt; <code>sl_points</code>（ポイント）&gt; <code>sl_pct</code>（パーセンテージ）。3項目すべてが 0 の場合はストップロスを設定しません。テイクプロフィットも同様です。</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ 運用開始前のチェックリスト</p>
  <ul class="doc-checklist">
    <li class="ok">✅ 取引ソフトウェアの自動取引ボタンが 🟢 緑色</li>
    <li class="ok">✅ チャート右上の EA が 😊 を表示（サーバーに接続済み）</li>
    <li class="ok">✅ License / SecretKey が TradingView JSON の値と完全に一致</li>
    <li class="ok">✅ アラートのトリガー条件が "<strong>alert() 関数呼び出しのみ</strong>"</li>
    <li class="ok">✅ 各 <code>alert()</code> に <code>alert.freq_all</code> が追加されている</li>
    <li class="ok">✅ Webhook URL：<code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message ボックスはデフォルトのまま、何も入力しない</li>
    <li class="no">❌ 「プレーンテキストを送信」のチェックを外す</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ セキュリティとリスクに関する注意事項</p>
  <div class="doc-warn">
    <strong>アカウントセキュリティ：</strong><br>
    · License と SecretKey のスクリーンショットを撮ったり、他人と共有しないでください<br>
    · 鍵の漏洩が疑われる場合は、すぐにコンソールで SecretKey をリセットしてください<br>
    · 定期的に SecretKey を変更することをお勧めします
  </div>
  <div class="doc-warn">
    <strong>取引リスク管理：</strong><br>
    · 常にストップロスを設定し、自動戦略を素の状態で運用しないでください<br>
    · 1回の取引リスクは口座資金の 1～2％ 以内に抑えることを推奨します<br>
    · 重要な経済指標発表（雇用統計、CPI、FOMC など）の前は自動取引を一時停止することを推奨します
  </div>
  <div class="doc-tip">
    <strong>ベストプラクティス：</strong><br>
    · まずデモ口座で少なくとも 1～2 週間テストし、経路が正常であることを確認してからリアル口座に切り替えてください<br>
    · リアル口座では最初は最小ロット（0.01ロット）を使用してください<br>
    · VPS（例：天眼雲 VPS）を使用して、取引ソフトウェアと EA を 24 時間オンラインに保ってください
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook シグナル形式',
        content: `TradingView Alert の Message に以下の JSON を入力します：
<pre>{
  "license": "{{あなたのLicenseID}}",
  "key": "{{あなたのSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>対応 <strong>cmd</strong> 指示：buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook アドレス',
        content: `<p>TradingView Alert 設定で、Webhook URL に次のアドレスを入力します：</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Message ボックスに上記の JSON シグナル形式を入力し、license と key を自分の値に置き換えてください。</p>`
      },
      {
        title: '3. WikiConnector EA のインストール',
        content: `<p>1. WikiConnector EA（.ex5 ファイル）をダウンロード</p>
<p>2. EA を MT5 の <code>MQL5/Experts</code> ディレクトリにコピー</p>
<p>3. MT5 で EA を開き、<strong>License ID</strong> と <strong>Secret Key</strong> を入力</p>
<p>4. EA が WebSocket 接続を行えるようにする（MT5 オプション → EA でネットワーク接続権限を有効化）</p>`
      },
      {
        title: '4. レート制限',
        content: `<p>各ライセンスあたり最大 <strong>30 回 / 60 秒</strong>。制限を超えると 429 エラーが返されます。</p>
<p>より高い頻度が必要な場合は、カスタマーサポートに連絡してプランをアップグレードしてください。</p>`
      }
    ],

    faqTitle: 'よくある質問',
    faqs: [
      {
        q: '鍵が漏洩した場合はどうすればいいですか？',
        a: 'コンソールで「再生成」をクリックしてください。古い鍵は即座に無効になり、すべての EA 接続が切断されます。新しい鍵で EA を再設定してください。'
      },
      {
        q: 'EA が再接続した後、シグナルは再送信されますか？',
        a: 'デフォルトでは再送信されません（損失防止のため）。再送信が必要な場合は、コンソールで「オフラインバッファ」を有効にしてください。EA 再接続時にオフライン中のシグナルを受信します。'
      },
      {
        q: '1つのライセンスでいくつの MT 口座に接続できますか？',
        a: '各ライセンスは最大 10 の同時 WebSocket 接続をサポートし、10 の MT 端末が同一シグナルを同時に受信できます。'
      },
      {
        q: 'MT4 はサポートされていますか？',
        a: '現在のバージョンは主に MT5 をサポートしています。MT4 版 EA は開発中ですので、ご期待ください。'
      },
      {
        q: 'シグナルの遅延はどのくらいですか？',
        a: '平均遅延 <100ms です。天眼雲 VPS と併用すると 1ms まで低減可能です。'
      },
      {
        q: 'Webhook が正常に動作しているかテストするには？',
        a: '証明書リストで「現在の接続数」を確認してください。接続数が 0 より大きければ EA はオンラインです。テストシグナルを送信後、「最近のシグナル記録」でステータスが「配信済み」になっていることを確認できます。'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script とシグナル送信',
        items: [
          {
            q: '決済と新規の2つの alert() を使っていますが、取引ソフトウェアには1つのシグナルしか届きません。',
            a: 'これは Pine Script のデフォルト制限です。同じローソク足内では最初の alert() のみがトリガーされます。解決策は、<strong>各 alert() に <code>alert.freq_all</code> パラメータを追加すること</strong>です：<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'アラートのトリガー条件はどれを選べばいいですか？',
            a: '<code>alert()</code> 関数を使用する場合、<strong>"alert() 関数呼び出しのみ"</strong> を選択する必要があります。<code>strategy.entry(..., alert_message=xxx)</code> 方式を使用する場合は "Order fills only" を選択します。両方を混在させることはできません。'
          },
          {
            q: 'Message ボックスには何を入力すればいいですか？',
            a: '<code>alert()</code> 方式を使用する場合、<strong>Message ボックスはデフォルトのまま、何も入力する必要はありません</strong>。シグナル内容はコード内の <code>alert(xxx)</code> の文字列で決定され、Webhook はその JSON を受信します。'
          }
        ]
      },
      {
        title: '🔌 接続とシグナル受信',
        items: [
          {
            q: 'EA アイコンが赤い泣き顔 😞 を表示しています。どうすればいいですか？',
            a: '取引ソフトウェアのツールバーにある「自動取引」ボタンが緑色かどうかを確認してください。赤色の場合はクリックして緑色に切り替えると、EA は自動的に正常状態に戻ります。'
          },
          {
            q: 'TradingView からシグナルを送信しましたが、取引ソフトウェアが反応しません。',
            a: '以下の順序で確認してください：<br>1. 取引ソフトウェアの自動取引が緑色か<br>2. EA パネルが Connected を表示しているか<br>3. Webhook URL が <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code> か<br>4. アラートのトリガー条件が "alert() 関数呼び出しのみ" か<br>5. 各 alert() に <code>alert.freq_all</code> が追加されているか<br>6. JSON の license と key が EA 設定と完全に一致しているか'
          }
        ]
      },
      {
        title: '💰 取引実行',
        items: [
          {
            q: '注文が失敗しました。原因は何ですか？',
            a: 'よくある原因：残高不足 / 銘柄名の不一致（Symbol Mapping の設定が必要）/ ロット数超過 / スリッページ超過（InpDeviation を大きくする）/ 市場が閉鎖中。取引ソフトウェア下部の「エキスパート」ログで具体的なエラー情報を確認してください。'
          },
          {
            q: '注文にストップロス・テイクプロフィットが設定されていません。',
            a: '確認事項：① シグナル JSON に <code>sl_points</code> / <code>tp_points</code> などのフィールドが含まれているか；② EA のデフォルトストップロス・テイクプロフィットパラメータが 0 になっていないか。両方とも設定されていない場合、注文にストップロス・テイクプロフィットは付きません。'
          },
          {
            q: '銘柄名が一致しません。どうすればいいですか？',
            a: 'EA パラメータで Symbol Mapping を有効にしてください：<br><code>InpEnableMap1 = true</code> を設定<br><code>InpMapping1 = XAUUSD|GOLD</code> を設定（TradingView銘柄名|取引ソフトウェア銘柄名）'
          },
          {
            q: 'まずデモ口座でテストできますか？',
            a: '<strong>強くお勧めします！</strong>初めて使用する際は、必ずデモ口座で少なくとも 1～2 週間テストし、経路が正常で注文が正しく実行されることを確認してからリアル口座に切り替えてください。初期は最小ロット 0.01 を使用してください。'
          }
        ]
      }
    ]
  },

  // === ko 한국어 ===
  ko: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView 신호를 MetaTrader에 자동 연결하여 거래 실행',
    heroBtn: '무료로 시작하기',

    stat1Label: '평균 지연',
    stat2Label: '서비스 가동률',
    stat3Label: '연중무휴 운영',
    stat4Label: '멀티 계좌 분배',

    flowSub1: '전략 / Alert',
    flowSub2: '신호 라우팅',
    flowSub3: '자동 실행',

    featTitle: '왜 WikiConnector를 선택해야 할까요',
    featSubtitle: '핵심 강점',
    features: [
      {
        icon: '⚡',
        title: '밀리초 단위 실행',
        desc: '신호 평균 지연 <100ms, WikiFX VPS와 함께 사용 시 1ms까지 낮출 수 있습니다.'
      },
      {
        icon: '🔗',
        title: '멀티 계좌 분배',
        desc: '하나의 인증서로 여러 MT 단말기에 연결, 동일 전략 신호를 동시에 분배합니다.'
      },
      {
        icon: '🔒',
        title: '안전한 암호화',
        desc: '사용자별 독립 키 체계, 데이터 전체 구간 암호화 전송.'
      },
      {
        icon: '📊',
        title: '실시간 모니터링',
        desc: '신호 수신 상태, 실행 지연, 성공률을 실시간으로 확인 가능.'
      },
      {
        icon: '<>',
        title: '코드 생성기',
        desc: 'JSON 신호와 Pine Script 코드를 시각적으로 생성, 프로그래밍 불필요.'
      },
      {
        icon: '🖥',
        title: 'VPS 심층 통합',
        desc: '천안운 VPS와 계정 체계 공유, 연중무휴 저지연 운영.'
      }
    ],

    stepsTitle: '네 단계로 자동 거래 시작',
    stepsSubtitle: '빠른 시작',
    steps: [
      {
        title: '계정 로그인',
        desc: 'WikiFX 계정으로 로그인하면 전용 키와 License가 자동으로 발급됩니다.'
      },
      {
        title: 'Webhook 설정',
        desc: 'Webhook URL을 TradingView Alert 설정에 복사합니다.'
      },
      {
        title: 'EA 설치',
        desc: 'WikiConnector EA를 다운로드하고 License ID와 Secret Key를 입력합니다.'
      },
      {
        title: '자동 거래',
        desc: '전략이 Alert를 트리거하면 신호가 자동으로 MT 단말기에 전달되어 실행됩니다.'
      }
    ],

    loginTip: '로그인하면 전용 키와 인증서를 확인할 수 있습니다',
    loginBtn: '지금 로그인',

    navConn: '연결 관리',
    navLog: '신호 로그',
    navGen: '코드 생성',
    navParams: '파라미터 빠른 조회',
    navDl: '다운로드',
    navDoc: '사용 튜토리얼',
    navFaq: '자주 묻는 질문',

    keyLabel: 'Secret Key',
    keyTip1: '누구와도 공유하지 마세요',
    keyTip2: 'EA 인증에 사용',
    keyTip3: '재설정 후 이전 키는 즉시 무효화됩니다',

    connSubtitle: '다음은 귀하의 License와 이에 해당하는 Webhook URL입니다',
    noLicense: 'License가 없습니다. 고객센터에 문의해 주세요',
    needHelp: '도움이 필요하신가요?',
    viewDoc: '사용 튜토리얼 보기',

    allLicense: '전체 License',
    allStatus: '전체 상태',
    refresh: '새로고침',
    signalId: '신호 ID',
    total: '총',
    records: '개 기록',

    genIntro: '다음 파라미터를 입력하면 TradingView Alert에서 사용할 수 있는 JSON 신호와 Pine Script 코드가 자동 생성됩니다.',
    genAuth: '인증 정보',
    required: '필수',
    optional: '선택',
    genLicPlaceholder: 'License ID를 입력하세요',
    genLicHint: '연결 관리 페이지에서 확인 가능',
    genKeyPlaceholder: 'Secret Key를 입력하세요',
    genKeyHint: '연결 관리 페이지에서 확인 가능',
    genTrade: '거래 지시',
    genCmd: '지시 유형',
    genMarket: '시장가 주문',
    genPending: '지정가 주문',
    genClose: '청산',
    cmdBuy: '시장가 매수',
    cmdSell: '시장가 매도',
    cmdBuyLimit: '지정가 매수',
    cmdSellLimit: '지정가 매도',
    cmdBuyStop: '돌파 매수',
    cmdSellStop: '돌파 매도',
    cmdCloseBuy: '매수 포지션 청산',
    cmdCloseSell: '매도 포지션 청산',
    cmdCloseAll: '해당 종목 청산',
    cmdCloseAllOrders: '전체 청산',
    genSlTpHint: '세 가지 중 하나 선택 · 우선순위: 가격 > 포인트 > 백분율',
    genTsHint: '신호 전송 시간',
    genTsBtn: '현재 시간',
    presetSimple: '📝 간단 매수',
    presetSltp: '🛡 손절매/이익실현 포함',
    presetFull: '📋 전체 파라미터',
    presetClose: '❌ 청산 신호',
    presetPending: '📌 지정가 주문',
    presetReverse: '🔄 반대매매(청산+신규)',
    genAlertTab: '🔔 Alert 설정 설명',
    toastIncomplete: '정보가 불완전합니다. 필수 항목을 입력해 주세요',
    toastRegen: '새 키가 생성되었습니다. 즉시 복사하여 설정된 모든 EA를 업데이트하세요',
    toastKeyCopied: '키가 복사되었습니다',
    toastCopied: '복사되었습니다',
    toastCodeCopied: '코드가 복사되었습니다',
    copyTitle: '복사',
    genSymbol: '거래 종목',
    genPrice: '지정가',
    genParams: '거래 파라미터',
    genLots: '로트 수',
    genLotsHint: '비워두면 EA 기본값 사용',
    genMagic: 'Magic Number',
    genMagicHint: '다른 전략의 주문을 구분하는 데 사용',
    genComment: '주문 메모',
    genCommentHint: '예: Strategy A',
    genSL: '손절매 설정',
    genPoints: '포인트',
    genPrice2: '고정 가격',
    genPct: '백분율 %',
    genTP: '이익실현 설정',
    genAdvanced: '고급 파라미터',
    genSigIdHint: '비워두면 자동 생성, 중복 제거에 사용',
    genGenId: '자동 생성',
    genBtn: '코드 생성',
    genFormat: '신호 형식',
    genGuideTitle: 'TradingView에서 사용하는 방법',
    genGuideSteps: [
      'TradingView 차트에서 <strong>Alert(알림)</strong> 생성',
      '<strong>Alert 트리거 조건</strong>에서 전략 또는 지표 선택',
      '<strong>Notifications(알림)</strong> 펼치기 → <strong>Webhook URL</strong> 체크',
      'Webhook URL 입력: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      '위에서 생성한 JSON을 <strong>Message(메시지)</strong> 상자에 붙여넣기',
      '<strong>Create(생성)</strong> 클릭하여 Alert 저장'
    ],
    genGuideNote: '<strong>힌트:</strong> Pine Script를 사용하는 경우, 생성된 코드를 스크립트에 추가하고 <code>strategy.entry()</code> 또는 <code>strategy.close()</code>에서 <code>alert_message</code> 파라미터를 사용하세요.',

    paramsGroups: [
      {
        title: '🔐 Authorization(인증) — 반드시 수정',
        rows: [
          ['License', '—', '인증 ID. 신호 JSON의 license 필드와 완전히 일치해야 함', 'req'],
          ['SecretKey', '—', '보안 키(wc_sk_로 시작). 신호 JSON의 key 필드와 완전히 일치해야 함', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters(기본 거래 파라미터)',
        rows: [
          ['InpLots', '0.1', '기본 로트 수. 신호 JSON에 lots가 포함되지 않은 경우 사용', ''],
          ['InpMagic', '888', '기본 매직 넘버. 다른 전략의 주문을 구분하는 데 사용', ''],
          ['InpComment', 'TV Signal', '기본 주문 메모', ''],
          ['InpDeviation', '30', '최대 슬리피지(포인트). 외환 10–30, 금/지수 30–50 권장', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit(손절매/이익실현)',
        note: '우선순위: sl_price(고정 가격) > sl_points(포인트) > sl_pct(백분율). 세 항목 모두 0이면 손절매 미설정, 이익실현도 동일',
        rows: [
          ['InpSLPoints', '0', '기본 손절매 포인트(0 = 비활성화)', ''],
          ['InpSLPrice', '0', '기본 손절매 고정 가격(0 = 비활성화, 우선순위 최고)', ''],
          ['InpSLPct', '0', '기본 손절매 백분율(0 = 비활성화)', ''],
          ['InpTPPoints', '0', '기본 이익실현 포인트(0 = 비활성화)', ''],
          ['InpTPPrice', '0', '기본 이익실현 고정 가격(0 = 비활성화)', ''],
          ['InpTPPct', '0', '기본 이익실현 백분율(0 = 비활성화)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping(종목명 매핑)',
        note: '증권사마다 종목명이 다를 수 있습니다(예: TradingView는 XAUUSD, 증권사는 GOLD). 매핑을 사용하면 자동 변환됩니다',
        rows: [
          ['InpPrefix', '(비움)', '종목명 접두사. 증권사 종목이 m.EURUSD인 경우 m. 입력', ''],
          ['InpSuffix', '(비움)', '종목명 접미사. 증권사 종목이 EURUSD.pro인 경우 .pro 입력', ''],
          ['InpEnableMap1~5', 'false', 'true로 설정하면 해당 매핑 규칙 활성화', ''],
          ['InpMapping1', 'XAUUSD|GOLD', '매핑 규칙. 형식: TradingView종목명|MT5종목명, 최대 5개 지원', ''],
          ['InpMapping2', 'EURUSD|EUR', '위와 동일', ''],
          ['InpMapping3', 'GBPUSD|GBP', '위와 동일', ''],
          ['InpMapping4', 'BTCUSD|BTC', '위와 동일', ''],
          ['InpMapping5', 'USOUSD|WTI', '위와 동일', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log(시간 필터/표시 및 로그)',
        rows: [
          ['InpUseTimeFilter', 'false', '활성화하면 StartTime~EndTime 사이에서만 신호 처리', ''],
          ['InpStartTime', '00:00', '거래 허용 시작 시간(MT5 서버 시간, 형식 HH:MM)', ''],
          ['InpEndTime', '23:59', '거래 허용 종료 시간', ''],
          ['InpShowPanel', 'true', '차트에 연결 상태, 신호 통계 등 정보 패널 표시', ''],
          ['InpUpdateInterval', '1000', '패널 갱신 간격(밀리초). 1000~3000 권장', ''],
          ['InpLogLevel', '1', '로그 레벨: 0=끄기 1=기본 2=상세 3=디버그(문제 해결 시 2 또는 3 사용)', ''],
          ['InpLogToFile', 'true', '로그 파일을 MQL5/Logs/에 기록', ''],
          ['InpLogToConsole', 'true', 'MT5 하단 "전문가" 탭에 출력', ''],
          ['InpMaxLogMB', '5', '로그 파일 최대 크기(MB). 초과 시 자동 순환', '']
        ]
      }
    ],

    paramsEATitle: 'EA 파라미터 설명',
    paramsEADesc: '다음 파라미터는 MT5에서 EA를 열 때 설정할 수 있으며, JSON 신호의 해당 필드로 재정의할 수도 있습니다.',
    paramName: '파라미터명',
    paramDefault: '기본값',
    paramDesc: '설명',
    paramOverride: 'JSON 재정의 필드',
    eaParams: [
      ['DefaultLots', '0.1', '기본 로트 수(JSON에 지정되지 않은 경우 사용)', 'lots'],
      ['DefaultMagic', '0', '기본 Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', '기본 주문 메모', 'comment'],
      ['SlippagePoints', '3', '최대 슬리피지(포인트)', '—'],
      ['OfflineBuffer', 'false', '오프라인 버퍼 활성화 여부', '—'],
      ['ReconnectSeconds', '5', 'WebSocket 연결 끊김 후 재연결 간격(초)', '—']
    ],
    cmdTableTitle: '지시 유형 설명',
    cmdCol: '지시(cmd)',
    typeCol: '유형',
    actionCol: '동작',
    extraCol: '추가 파라미터',
    cmdTable: [
      ['buy', '시장가 주문', '즉시 매수', 'lots, sl_*, tp_*'],
      ['sell', '시장가 주문', '즉시 매도', 'lots, sl_*, tp_*'],
      ['buylimit', '지정가 주문', '가격 도달 시 매수', 'price, lots, sl_*, tp_*'],
      ['selllimit', '지정가 주문', '가격 도달 시 매도', 'price, lots, sl_*, tp_*'],
      ['buystop', '지정가 주문', '가격 돌파 시 매수', 'price, lots, sl_*, tp_*'],
      ['sellstop', '지정가 주문', '가격 돌파 시 매도', 'price, lots, sl_*, tp_*'],
      ['closebuy', '청산', '모든 매수 포지션 청산', 'magic(선택)'],
      ['closesell', '청산', '모든 매도 포지션 청산', 'magic(선택)'],
      ['closeall', '청산', '모든 보유 포지션 청산', '—'],
      ['closeallorders', '청산', '모든 지정가 주문 삭제', '—']
    ],
    jsonFieldTitle: 'JSON 필드 설명',
    fieldCol: '필드명',
    requiredCol: '필수 여부',
    descCol: '설명',
    jsonFields: [
      ['license', 'string', '필수', 'License ID'],
      ['key', 'string', '필수', 'Secret Key'],
      ['cmd', 'string', '필수', '거래 지시. 위 표 참조'],
      ['symbol', 'string', '필수', '거래 종목. 예: EURUSD'],
      ['lots', 'number', '선택', '로트 수. 비워두면 EA 기본값 사용'],
      ['price', 'number', '지정가 주문 시 필수', '지정가'],
      ['sl_points', 'number', '선택', '손절매 포인트'],
      ['sl_price', 'number', '선택', '손절매 고정 가격'],
      ['sl_pct', 'number', '선택', '손절매 백분율(0-100)'],
      ['tp_points', 'number', '선택', '이익실현 포인트'],
      ['tp_price', 'number', '선택', '이익실현 고정 가격'],
      ['tp_pct', 'number', '선택', '이익실현 백분율(0-100)'],
      ['magic', 'number', '선택', 'Magic Number'],
      ['comment', 'string', '선택', '주문 메모'],
      ['signalid', 'string', '선택', '신호 고유 ID. 중복 제거에 사용'],
      ['expiryseconds', 'number', '선택', '신호 유효 기간(초). 기본값 60']
    ],

    dlMt5Desc: 'MT5 버전 EA. 모든 지시 지원. 권장',
    dlMt5Btn: 'MT5 EA 다운로드',
    dlMt4Desc: 'MT4 버전 EA. 개발 중입니다. 기대해 주세요',
    dlMt4Dev: '개발 중',
    dlInstallDoc: `<h4>설치 방법</h4>
<ol>
<li><code>WikiConnector_MT5.ex5</code> 파일 다운로드</li>
<li>MT5 열기, 메뉴바 → <strong>파일 → 데이터 폴더 열기</strong></li>
<li><code>.ex5</code> 파일을 <code>MQL5/Experts/</code> 디렉토리에 복사</li>
<li>MT5에서 <strong>F5</strong>를 눌러 내비게이터 새로고침, WikiConnector EA 찾기</li>
<li>EA를 아무 차트에 드래그하여 <strong>License ID</strong>와 <strong>Secret Key</strong> 입력</li>
<li>EA 옵션에서 <strong>WebRequest 허용</strong> 체크, 허용 URL 목록에 <code>api-gw.interface003.com</code> 추가</li>
</ol>`,

    disclaimerTitle: '위험 면책 고지',
    disclaimerContent: `<p>WikiConnector EA를 다운로드하여 사용하기 전에 다음 면책 고지를 주의 깊게 읽어 주십시오.</p>
<p><strong>1. 거래 위험</strong><br/>외환 및 CFD 거래는 중대한 위험을 수반하며, 자금의 전부 또는 일부를 잃을 수 있습니다. WikiConnector는 신호 전송 도구일 뿐이며, 어떠한 거래 결과에 대해서도 책임을 지지 않습니다.</p>
<p><strong>2. 전략 위험</strong><br/>자동 거래 전략의 과거 실적은 미래 결과를 보장하지 않습니다. 실제 계좌에서 사용하기 전에 충분히 테스트하십시오.</p>
<p><strong>3. 기술적 위험</strong><br/>네트워크 지연, 서버 장애, API 제한 등의 기술적 요인으로 인해 신호 손실이나 실행 지연이 발생할 수 있습니다. 지연에 매우 민감한 고빈도 전략에는 본 도구를 사용하지 마십시오.</p>
<p><strong>4. 사용 책임</strong><br/>사용자는 WikiConnector EA 사용으로 인해 발생한 모든 거래 결과에 대해 전적인 책임을 집니다. WikiFX는 투자 조언을 제공하지 않으며, 거래 손익에 대해 책임을 지지 않습니다.</p>`,
    disclaimerAgree: '위 면책 고지를 읽고 거래 위험을 이해했으며 동의합니다',
    disclaimerDownload: '동의하고 다운로드',

    regenTitle: '키 재설정 확인',
    regenSubtitle: '이 작업은 되돌릴 수 없습니다. 다음 영향을 이해했는지 확인해 주십시오:',
    regenWarnings: ['이 키가 설정된 모든 EA가 <strong>즉시 연결 해제됩니다</strong>', '이전 키는 <strong>영구적으로 무효화</strong>되며 복구할 수 없습니다', '모든 EA의 Secret Key 설정을 수동으로 업데이트해야 합니다', '재설정 중 <strong>신호 손실</strong> 위험이 있습니다'],

    dashTitle: '내 WikiConnector',
    myKey: '내 시크릿 키',
    keyPrefix: 'Secret Key',
    copyBtn: '복사',
    regenBtn: '재생성',
    regenConfirm: '키를 재생성하면 연결된 모든 EA가 끊어지고 재설정이 필요합니다. 계속하시겠습니까?',
    regenConfirmBtn: '재설정 확인',
    cancelBtn: '취소',
    copiedTip: '복사되었습니다',

    licenseTitle: '내 인증서(License)',
    licenseId: '인증서 ID',
    maxConn: '최대 연결 수',
    activeConn: '현재 연결',
    webhookUrl: 'Webhook URL',

    statsTitle: '신호 통계',
    statTotal: '총 신호 수',
    statDelivered: '전달됨',
    statFailed: '실패',
    statConnections: '현재 연결',

    signalTitle: '최근 신호 기록',
    signalTime: '시간',
    signalCmd: '지시',
    signalSymbol: '종목',
    signalLots: '로트 수',
    signalStatus: '상태',
    signalLicense: '인증서',
    statusDelivered: '전달됨',
    statusPending: '전달 대기',
    statusFailed: '실패',
    statusExpired: '만료됨',
    noSignal: '아직 신호 기록이 없습니다',
    loadMore: '더 불러오기',

    offlineBuffer: '오프라인 버퍼',
    offlineBufferDesc: '활성화하면 EA 재연결 시 오프라인 중 축적된 신호가 전달됩니다(기본적으로 비활성화, 손실 방지).',

    docTitle: '사용 튜토리얼',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 WikiConnector 작동 원리</p>
  <p>WikiConnector는 <strong>WebSocket 장기 연결</strong>을 통해 TradingView 신호를 실시간으로 수신하고, 거래 소프트웨어에서 자동으로 거래를 실행합니다.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① EA를 거래 소프트웨어에 설치</p>
  <ol class="doc-steps">
    <li><strong>데이터 폴더 열기</strong>: 거래 소프트웨어 메뉴 → 파일 → 데이터 폴더 열기</li>
    <li><strong>EA 파일 복사</strong>: EA 파일을 <code>Experts/</code> 디렉토리에 복사</li>
    <li><strong>내비게이터 새로고침</strong>: 내비게이터 열기 → "전문가 어드바이저" 우클릭 → 새로고침. 목록에 <strong>SignalReceiver</strong>가 나타나야 합니다</li>
    <li><strong>자동 거래 활성화</strong>: 상단 도구 모음의 "자동 거래" 버튼이 🟢 녹색이어야 합니다</li>
    <li><strong>차트에 적용</strong>: SignalReceiver를 아무 차트에 드래그 앤 드롭하고, 설정 창이 나타나면 파라미터를 설정합니다</li>
  </ol>
  <div class="doc-tip"><strong>힌트:</strong> EA는 하나의 차트에만 적용하면 모든 종목의 신호를 처리할 수 있습니다. 종목마다 개별적으로 적용할 필요가 없습니다.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② EA 파라미터 설정</p>
  <p>파라미터는 두 가지 유형이 있습니다: <strong>필수</strong>(License / SecretKey)와 <strong>기본값 파라미터</strong>(신호 JSON에 특정 필드가 포함되지 않은 경우 사용. 신호의 값이 항상 EA 기본값보다 우선).</p>
  <div class="doc-warn"><strong>보안 경고:</strong> License와 SecretKey는 계정을 보호하는 유일한 방어벽입니다. 유출되면 누구나 귀하의 거래 소프트웨어에 거래 지시를 보낼 수 있습니다. 스크린샷을 찍거나 타인과 공유하지 말고, 정기적으로 SecretKey를 변경하는 것을 권장합니다.</div>
  <p>설정이 완료되면 차트 오른쪽 상단에 EA 이름 + <strong>😊</strong>가 표시되어 서버에 연결되었음을 나타냅니다. 😞가 표시되면 "자동 거래" 버튼이 녹색인지 확인하십시오.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Pine Script 신호 코드 작성</p>
  <p>WikiConnector는 <code>alert()</code> 함수를 사용하여 신호를 트리거합니다. <code>strategy.entry(alert_message=)</code> 방식과는 다른 메커니즘이므로 혼용하지 마십시오.</p>
  <div class="doc-danger"><strong>중요: alert.freq_all</strong> — Pine Script는 기본적으로 같은 캔들 내에서 첫 번째 <code>alert()</code>만 트리거되고 이후는 모두 무시됩니다. 여러 신호를 연속으로 보내야 하는 경우(예: 반대매매로 매도 포지션 청산 후 매수 포지션 신규), 각 <code>alert()</code>에 <code>alert.freq_all</code>을 추가해야 합니다. 그렇지 않으면 두 번째 이후 신호는 서버에 도달하지 않습니다.</div>
<pre>//@version=6
strategy("WikiConnector 전략", overlay=true)

// 신호 메시지 정의(YOUR_LICENSE와 YOUR_KEY를 자신의 값으로 바꾸세요)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// 전략 조건 예시(3/13 이동평균선 교차)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// alert.freq_all을 사용하여 같은 캔들 내에서 여러 신호를 확실히 전송
if longCondition
    alert(closesellMessage, alert.freq_all)  // 먼저 매도 포지션 청산
    alert(buyMessage,       alert.freq_all)  // 그 다음 매수 포지션 신규

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // 먼저 매수 포지션 청산
    alert(sellMessage,     alert.freq_all)   // 그 다음 매도 포지션 신규</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ TradingView에서 알림 생성</p>
  <p>Webhook URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>차트 우클릭 → "<strong>알림 추가...</strong>" 또는 <strong>Alt+A</strong></li>
    <li>트리거 조건에서 <strong>"alert() 함수 호출만"</strong> 선택(중요!)</li>
    <li>만료 시간은 가능한 길게, 또는 "무기한" 선택</li>
    <li>Message 상자는 <strong>기본값 그대로, 아무것도 입력하지 않음</strong>(신호 내용은 코드 내 alert()에서 결정)</li>
    <li>알림 설정: <strong>Webhook URL</strong> 체크하고 위 주소 입력. <strong>"일반 텍스트 보내기" 체크 해제</strong></li>
    <li>"생성" 클릭하여 알림 저장</li>
  </ol>
  <div class="doc-tip"><strong>힌트:</strong> Webhook 기능은 TradingView Pro 이상의 구독이 필요합니다.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ 신호 JSON 형식 설명</p>
  <p><strong>필수 필드:</strong><code>license</code>(인증ID), <code>key</code>(키), <code>cmd</code>(지시), <code>symbol</code>(종목명)</p>
  <p><strong>선택 필드:</strong><code>lots</code>(로트 수), <code>price</code>(지정가), <code>sl_points / sl_price / sl_pct</code>(손절매 3택), <code>tp_points / tp_price / tp_pct</code>(이익실현 3택), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code>(기본값 300초)</p>
  <p><strong>지원 cmd:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>손절매/이익실현 우선순위:</strong><code>sl_price</code>(고정 가격)&gt; <code>sl_points</code>(포인트)&gt; <code>sl_pct</code>(백분율). 세 항목 모두 0이면 손절매 미설정, 이익실현도 동일.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ 운영 시작 전 체크리스트</p>
  <ul class="doc-checklist">
    <li class="ok">✅ 거래 소프트웨어 자동 거래 버튼 🟢 녹색</li>
    <li class="ok">✅ 차트 오른쪽 상단 EA가 😊 표시(서버에 연결됨)</li>
    <li class="ok">✅ License / SecretKey가 TradingView JSON의 값과 완전히 일치</li>
    <li class="ok">✅ 알림 트리거 조건 "<strong>alert() 함수 호출만</strong>"</li>
    <li class="ok">✅ 각 <code>alert()</code>에 <code>alert.freq_all</code> 추가됨</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message 상자는 기본값 그대로, 아무것도 입력하지 않음</li>
    <li class="no">❌ "일반 텍스트 보내기" 체크 해제</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ 보안 및 위험 주의사항</p>
  <div class="doc-warn">
    <strong>계정 보안:</strong><br>
    · License와 SecretKey를 스크린샷으로 찍거나 타인과 공유하지 마십시오<br>
    · 키 유출이 의심되면 즉시 콘솔에서 SecretKey를 재설정하십시오<br>
    · 정기적으로 SecretKey를 변경하는 것을 권장합니다
  </div>
  <div class="doc-warn">
    <strong>거래 위험 관리:</strong><br>
    · 항상 손절매를 설정하고, 자동 전략을 베어 상태로 운영하지 마십시오<br>
    · 단일 거래 위험은 계좌 자금의 1~2% 이내로 제한할 것을 권장합니다<br>
    · 주요 경제 지표 발표(고용, CPI, FOMC 등) 전에는 자동 거래를 일시 중지할 것을 권장합니다
  </div>
  <div class="doc-tip">
    <strong>모범 사례:</strong><br>
    · 먼저 데모 계좌에서 최소 1~2주 테스트하여 경로가 정상인지 확인한 후 실제 계좌로 전환하십시오<br>
    · 실제 계좌에서는 처음에 최소 로트(0.01로트)를 사용하십시오<br>
    · VPS(예: 천안운 VPS)를 사용하여 거래 소프트웨어와 EA를 24시간 온라인 상태로 유지하십시오
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook 신호 형식',
        content: `TradingView Alert의 Message에 다음 JSON을 입력합니다:
<pre>{
  "license": "{{귀하의 LicenseID}}",
  "key": "{{귀하의 SecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>지원 <strong>cmd</strong> 지시: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook 주소',
        content: `<p>TradingView Alert 설정에서 Webhook URL을 다음으로 설정합니다:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Message 상자에 위의 JSON 신호 형식을 입력하고 license와 key를 자신의 값으로 바꾸십시오.</p>`
      },
      {
        title: '3. WikiConnector EA 설치',
        content: `<p>1. WikiConnector EA(.ex5 파일) 다운로드</p>
<p>2. EA를 MT5의 <code>MQL5/Experts</code> 디렉토리에 복사</p>
<p>3. MT5에서 EA를 열고 <strong>License ID</strong>와 <strong>Secret Key</strong> 입력</p>
<p>4. EA가 WebSocket 연결을 수행할 수 있도록 설정(MT5 옵션 → EA에서 네트워크 연결 권한 활성화)</p>`
      },
      {
        title: '4. 속도 제한',
        content: `<p>License당 최대 <strong>30회 / 60초</strong>. 제한을 초과하면 429 오류가 반환됩니다.</p>
<p>더 높은 빈도가 필요한 경우 고객센터에 연락하여 플랜을 업그레이드하십시오.</p>`
      }
    ],

    faqTitle: '자주 묻는 질문',
    faqs: [
      {
        q: '키가 유출되면 어떻게 해야 하나요?',
        a: '콘솔에서 "재생성"을 클릭하십시오. 이전 키는 즉시 무효화되고 모든 EA 연결이 끊어집니다. 새 키로 EA를 재설정하십시오.'
      },
      {
        q: 'EA가 재연결된 후 신호가 재전송되나요?',
        a: '기본적으로 재전송되지 않습니다(손실 방지). 재전송이 필요한 경우 콘솔에서 "오프라인 버퍼"를 활성화하십시오. EA 재연결 시 오프라인 중 신호를 수신합니다.'
      },
      {
        q: '하나의 License로 몇 개의 MT 계좌에 연결할 수 있나요?',
        a: '각 License는 최대 10개의 동시 WebSocket 연결을 지원하여 10개의 MT 단말기가 동일 신호를 동시에 수신할 수 있습니다.'
      },
      {
        q: 'MT4를 지원하나요?',
        a: '현재 버전은 주로 MT5를 지원합니다. MT4 버전 EA는 개발 중입니다. 기대해 주세요.'
      },
      {
        q: '신호 지연은 어느 정도인가요?',
        a: '평균 지연 <100ms입니다. 천안운 VPS와 함께 사용하면 1ms까지 낮출 수 있습니다.'
      },
      {
        q: 'Webhook이 정상 작동하는지 테스트하려면 어떻게 해야 하나요?',
        a: '인증서 목록에서 "현재 연결 수"를 확인하십시오. 연결 수가 0보다 크면 EA가 온라인 상태입니다. 테스트 신호를 보낸 후 "최근 신호 기록"에서 상태가 "전달됨"인지 확인할 수 있습니다.'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script와 신호 전송',
        items: [
          {
            q: '청산과 신규 두 개의 alert()를 사용했는데 거래 소프트웨어에 하나의 신호만 도착합니다.',
            a: '이는 Pine Script의 기본 제한입니다. 같은 캔들 내에서 첫 번째 alert()만 트리거됩니다. 해결 방법은 <strong>각 alert()에 <code>alert.freq_all</code> 파라미터를 추가하는 것</strong>입니다:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: '알림 트리거 조건은 무엇을 선택해야 하나요?',
            a: '<code>alert()</code> 함수를 사용하는 경우 <strong>"alert() 함수 호출만"</strong>을 선택해야 합니다. <code>strategy.entry(..., alert_message=xxx)</code> 방식을 사용하는 경우 "Order fills only"를 선택합니다. 둘을 혼용할 수 없습니다.'
          },
          {
            q: 'Message 상자에 무엇을 입력해야 하나요?',
            a: '<code>alert()</code> 방식을 사용하는 경우 <strong>Message 상자는 기본값 그대로, 아무것도 입력할 필요가 없습니다</strong>. 신호 내용은 코드 내 <code>alert(xxx)</code>의 문자열로 결정되며, Webhook은 해당 JSON을 수신합니다.'
          }
        ]
      },
      {
        title: '🔌 연결과 신호 수신',
        items: [
          {
            q: 'EA 아이콘이 빨간색 우는 얼굴 😞을 표시합니다. 어떻게 해야 하나요?',
            a: '거래 소프트웨어 도구 모음의 "자동 거래" 버튼이 녹색인지 확인하십시오. 빨간색인 경우 클릭하여 녹색으로 전환하면 EA가 자동으로 정상 상태로 돌아옵니다.'
          },
          {
            q: 'TradingView에서 신호를 보냈지만 거래 소프트웨어가 반응하지 않습니다.',
            a: '다음 순서로 확인하십시오:<br>1. 거래 소프트웨어 자동 거래가 녹색인가요?<br>2. EA 패널이 Connected를 표시하나요?<br>3. Webhook URL이 <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>인가요?<br>4. 알림 트리거 조건이 "alert() 함수 호출만"인가요?<br>5. 각 alert()에 <code>alert.freq_all</code>이 추가되었나요?<br>6. JSON의 license와 key가 EA 설정과 완전히 일치하나요?'
          }
        ]
      },
      {
        title: '💰 거래 실행',
        items: [
          {
            q: '주문이 실패했습니다. 원인이 무엇인가요?',
            a: '일반적인 원인: 잔고 부족 / 종목명 불일치(Symbol Mapping 설정 필요) / 로트 수 초과 / 슬리피지 초과(InpDeviation 증가) / 시장 마감. 거래 소프트웨어 하단 "전문가" 로그에서 구체적인 오류 정보를 확인하십시오.'
          },
          {
            q: '주문에 손절매/이익실현이 설정되지 않았습니다.',
            a: '확인 사항: ① 신호 JSON에 <code>sl_points</code> / <code>tp_points</code> 등의 필드가 포함되어 있는지; ② EA 기본 손절매/이익실현 파라미터가 0이 아닌지. 양쪽 모두 설정되지 않은 경우 주문에 손절매/이익실현이 적용되지 않습니다.'
          },
          {
            q: '종목명이 일치하지 않습니다. 어떻게 해야 하나요?',
            a: 'EA 파라미터에서 Symbol Mapping을 활성화하십시오:<br><code>InpEnableMap1 = true</code> 설정<br><code>InpMapping1 = XAUUSD|GOLD</code> 설정(TradingView종목명|거래소프트웨어종목명)'
          },
          {
            q: '먼저 데모 계좌로 테스트할 수 있나요?',
            a: '<strong>강력히 권장합니다!</strong> 처음 사용 시 반드시 데모 계좌에서 최소 1~2주 테스트하여 경로가 정상이고 주문이 올바르게 실행되는지 확인한 후 실제 계좌로 전환하십시오. 초기에는 최소 로트 0.01을 사용하십시오.'
          }
        ]
      }
    ]
  },

  // === ar العربية ===
  ar: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView ← MT4/MT5',
    heroSubtitle: 'ربط إشارات TradingView تلقائياً بـ MetaTrader لتنفيذ التداول',
    heroBtn: 'ابدأ مجاناً',

    stat1Label: 'متوسط زمن الاستجابة',
    stat2Label: 'معدل توفر الخدمة',
    stat3Label: 'تشغيل على مدار الساعة',
    stat4Label: 'توزيع متعدد الحسابات',

    flowSub1: 'الاستراتيجية / التنبيه',
    flowSub2: 'توجيه الإشارات',
    flowSub3: 'التنفيذ التلقائي',

    featTitle: 'لماذا تختار WikiConnector',
    featSubtitle: 'المزايا الأساسية',
    features: [
      {
        icon: '⚡',
        title: 'تنفيذ بالمللي ثانية',
        desc: 'متوسط زمن استجابة الإشارة <100 مللي ثانية، ويمكن أن يصل إلى 1 مللي ثانية مع WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'توزيع متعدد الحسابات',
        desc: 'شهادة واحدة تربط عدة محطات MT، وتوزيع نفس الإشارة الاستراتيجية في وقت واحد.'
      },
      {
        icon: '🔒',
        title: 'تشفير آمن',
        desc: 'نظام مفاتيح مستقل لكل مستخدم، تشفير كامل لمسار البيانات.'
      },
      {
        icon: '📊',
        title: 'مراقبة فورية',
        desc: 'حالة استقبال الإشارة وزمن التنفيذ ومعدل النجاح مرئية في الوقت الفعلي.'
      },
      {
        icon: '<>',
        title: 'مولد الأكواد',
        desc: 'إنشاء إشارات JSON وأكواد Pine Script بشكل بصري، بدون برمجة.'
      },
      {
        icon: '🖥',
        title: 'تكامل عميق مع VPS',
        desc: 'مشاركة نظام الحسابات مع Tianyan Cloud VPS، تشغيل منخفض زمن الاستجابة على مدار الساعة.'
      }
    ],

    stepsTitle: 'أربع خطوات لبدء التداول الآلي',
    stepsSubtitle: 'بداية سريعة',
    steps: [
      {
        title: 'تسجيل الدخول',
        desc: 'سجل الدخول باستخدام حساب WikiFX الخاص بك، واحصل تلقائياً على المفتاح والترخيص الخاصين بك.'
      },
      {
        title: 'إعداد Webhook',
        desc: 'انسخ عنوان Webhook URL إلى إعدادات تنبيه TradingView.'
      },
      {
        title: 'تثبيت EA',
        desc: 'قم بتنزيل WikiConnector EA وأدخل License ID و Secret Key.'
      },
      {
        title: 'التداول الآلي',
        desc: 'عند تفعيل الاستراتيجية للتنبيه، يتم إرسال الإشارة تلقائياً إلى محطة MT للتنفيذ.'
      }
    ],

    loginTip: 'بعد تسجيل الدخول، يمكنك عرض المفتاح والترخيص الخاصين بك',
    loginBtn: 'تسجيل الدخول الآن',

    navConn: 'إدارة الاتصالات',
    navLog: 'سجل الإشارات',
    navGen: 'توليد الأكواد',
    navParams: 'مرجع سريع للمعلمات',
    navDl: 'التحميل',
    navDoc: 'دليل الاستخدام',
    navFaq: 'الأسئلة الشائعة',

    keyLabel: 'Secret Key',
    keyTip1: 'لا تشاركه مع أي شخص',
    keyTip2: 'يستخدم لمصادقة EA',
    keyTip3: 'بعد إعادة التعيين، يصبح المفتاح القديم غير صالح فوراً',

    connSubtitle: 'فيما يلي تراخيصك وعناوين Webhook URL المقابلة لها',
    noLicense: 'لا يوجد ترخيص حالياً، يرجى الاتصال بخدمة العملاء',
    needHelp: 'هل تحتاج إلى مساعدة؟',
    viewDoc: 'عرض دليل الاستخدام',

    allLicense: 'جميع التراخيص',
    allStatus: 'جميع الحالات',
    refresh: 'تحديث',
    signalId: 'معرف الإشارة',
    total: 'إجمالي',
    records: 'سجل',

    genIntro: 'املأ المعلمات التالية، وسيتم إنشاء إشارات JSON وأكواد Pine Script تلقائياً لاستخدامها في تنبيهات TradingView.',
    genAuth: 'معلومات المصادقة',
    required: 'إجباري',
    optional: 'اختياري',
    genLicPlaceholder: 'أدخل License ID الخاص بك',
    genLicHint: 'يمكنك الاطلاع عليه في صفحة إدارة الاتصالات',
    genKeyPlaceholder: 'أدخل Secret Key الخاص بك',
    genKeyHint: 'يمكنك الاطلاع عليه في صفحة إدارة الاتصالات',
    genTrade: 'أمر التداول',
    genCmd: 'نوع الأمر',
    genMarket: 'أمر سوقي',
    genPending: 'أمر معلق',
    genClose: 'إغلاق',
    cmdBuy: 'شراء بسعر السوق',
    cmdSell: 'بيع بسعر السوق',
    cmdBuyLimit: 'شراء محدود',
    cmdSellLimit: 'بيع محدود',
    cmdBuyStop: 'شراء اختراق',
    cmdSellStop: 'بيع اختراق',
    cmdCloseBuy: 'إغلاق صفقات الشراء',
    cmdCloseSell: 'إغلاق صفقات البيع',
    cmdCloseAll: 'إغلاق الزوج',
    cmdCloseAllOrders: 'إغلاق الكل',
    genSlTpHint: 'اختيار واحد من ثلاثة · الأولوية: السعر > النقاط > النسبة المئوية',
    genTsHint: 'وقت إرسال الإشارة',
    genTsBtn: 'الوقت الحالي',
    presetSimple: '📝 شراء بسيط',
    presetSltp: '🛡 مع وقف الخسارة وجني الأرباح',
    presetFull: '📋 معلمات كاملة',
    presetClose: '❌ إشارة إغلاق',
    presetPending: '📌 أمر معلق',
    presetReverse: '🔄 عكس (إغلاق + فتح)',
    genAlertTab: '🔔 شرح إعداد التنبيه',
    toastIncomplete: 'المعلومات غير مكتملة، يرجى ملء الحقول الإجبارية',
    toastRegen: 'تم إنشاء مفتاح جديد، يرجى نسخه فوراً وتحديث جميع EAs المكونة',
    toastKeyCopied: 'تم نسخ المفتاح',
    toastCopied: 'تم النسخ',
    toastCodeCopied: 'تم نسخ الكود',
    copyTitle: 'نسخ',
    genSymbol: 'زوج التداول',
    genPrice: 'سعر الأمر المعلق',
    genParams: 'معلمات التداول',
    genLots: 'حجم العقد',
    genLotsHint: 'اتركه فارغاً لاستخدام القيمة الافتراضية لـ EA',
    genMagic: 'Magic Number',
    genMagicHint: 'يستخدم للتمييز بين أوامر الاستراتيجيات المختلفة',
    genComment: 'تعليق الأمر',
    genCommentHint: 'مثال: Strategy A',
    genSL: 'إعداد وقف الخسارة',
    genPoints: 'نقاط',
    genPrice2: 'سعر ثابت',
    genPct: 'نسبة مئوية %',
    genTP: 'إعداد جني الأرباح',
    genAdvanced: 'معلمات متقدمة',
    genSigIdHint: 'اتركه فارغاً ليتم إنشاؤه تلقائياً، يستخدم لمنع التكرار',
    genGenId: 'إنشاء تلقائي',
    genBtn: 'توليد الكود',
    genFormat: 'تنسيق الإشارة',
    genGuideTitle: 'كيفية الاستخدام في TradingView',
    genGuideSteps: [
      'أنشئ <strong>تنبيهاً (Alert)</strong> على الرسم البياني لـ TradingView',
      'اختر استراتيجيتك أو مؤشرك في <strong>شرط تفعيل التنبيه</strong>',
      'وسّع <strong>الإشعارات (Notifications)</strong> ← فعّل <strong>Webhook URL</strong>',
      'أدخل عنوان Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'الصق JSON الذي تم توليده أعلاه في مربع <strong>الرسالة (Message)</strong>',
      'انقر <strong>إنشاء (Create)</strong> لحفظ التنبيه'
    ],
    genGuideNote: '<strong>تلميح:</strong> إذا كنت تستخدم Pine Script، أضف الكود المولد إلى البرنامج النصي الخاص بك واستخدم معلمة <code>alert_message</code> في <code>strategy.entry()</code> أو <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (التفويض) — يجب التعديل',
        rows: [
          ['License', '—', 'معرف التفويض، يجب أن يتطابق تماماً مع حقل license في JSON الإشارة', 'req'],
          ['SecretKey', '—', 'مفتاح الأمان (يبدأ بـ wc_sk_)، يجب أن يتطابق تماماً مع حقل key في JSON الإشارة', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (معلمات التداول الافتراضية)',
        rows: [
          ['InpLots', '0.1', 'حجم العقد الافتراضي، يُستخدم عندما لا يحتوي JSON الإشارة على lots', ''],
          ['InpMagic', '888', 'الرقم السحري الافتراضي، للتمييز بين أوامر الاستراتيجيات المختلفة', ''],
          ['InpComment', 'TV Signal', 'تعليق الأمر الافتراضي', ''],
          ['InpDeviation', '30', 'أقصى انزلاق (نقاط)، للفوركس 10–30، للذهب/المؤشرات 30–50', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit (وقف الخسارة / جني الأرباح)',
        note: 'الأولوية: sl_price (السعر الثابت) > sl_points (النقاط) > sl_pct (النسبة المئوية)، إذا كانت الثلاثة 0 فلا يتم تعيين وقف خسارة، وكذلك جني الأرباح',
        rows: [
          ['InpSLPoints', '0', 'نقاط وقف الخسارة الافتراضية (0 = غير مفعل)', ''],
          ['InpSLPrice', '0', 'سعر وقف الخسارة الثابت الافتراضي (0 = غير مفعل، أعلى أولوية)', ''],
          ['InpSLPct', '0', 'نسبة وقف الخسارة الافتراضية (0 = غير مفعل)', ''],
          ['InpTPPoints', '0', 'نقاط جني الأرباح الافتراضية (0 = غير مفعل)', ''],
          ['InpTPPrice', '0', 'سعر جني الأرباح الثابت الافتراضي (0 = غير مفعل)', ''],
          ['InpTPPct', '0', 'نسبة جني الأرباح الافتراضية (0 = غير مفعل)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (تعيين أسماء الأزواج)',
        note: 'قد تختلف تسمية الأزواج بين الوسطاء (مثل: TradingView يسمي XAUUSD، وسيطك يسمي GOLD)، استخدام التعيين يحول تلقائياً',
        rows: [
          ['InpPrefix', '(فارغ)', 'بادئة اسم الزوج، إذا كان زوج الوسيط m.EURUSD فأدخل m.', ''],
          ['InpSuffix', '(فارغ)', 'لاحقة اسم الزوج، إذا كان زوج الوسيط EURUSD.pro فأدخل .pro', ''],
          ['InpEnableMap1~5', 'false', 'عيّنه إلى true لتفعيل قاعدة التعيين المقابلة', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'قاعدة التعيين، التنسيق: اسم الزوج في TradingView|اسم الزوج في MT5، يدعم حتى 5 قواعد', ''],
          ['InpMapping2', 'EURUSD|EUR', 'نفس ما سبق', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'نفس ما سبق', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'نفس ما سبق', ''],
          ['InpMapping5', 'USOUSD|WTI', 'نفس ما سبق', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (تصفية الوقت / العرض والسجل)',
        rows: [
          ['InpUseTimeFilter', 'false', 'عند التفعيل، تتم معالجة الإشارات فقط بين StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'وقت بدء التداول المسموح (بتوقيت خادم MT5، التنسيق HH:MM)', ''],
          ['InpEndTime', '23:59', 'وقت انتهاء التداول المسموح', ''],
          ['InpShowPanel', 'true', 'عرض لوحة معلومات حالة الاتصال وإحصائيات الإشارات على الرسم البياني', ''],
          ['InpUpdateInterval', '1000', 'فاصل تحديث اللوحة (مللي ثانية)، يوصى بـ 1000~3000', ''],
          ['InpLogLevel', '1', 'مستوى السجل: 0=إيقاف 1=أساسي 2=مفصل 3=تصحيح (استخدم 2 أو 3 عند حل المشكلات)', ''],
          ['InpLogToFile', 'true', 'كتابة ملف السجل إلى MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'الإخراج إلى علامة تبويب "الخبراء" أسفل MT5', ''],
          ['InpMaxLogMB', '5', 'الحد الأقصى لحجم ملف السجل (ميغابايت)، يتم التدوير تلقائياً عند تجاوزه', '']
        ]
      }
    ],

    paramsEATitle: 'شرح معلمات EA',
    paramsEADesc: 'يمكن ضبط المعلمات التالية عند فتح EA في MT5، ويمكن أيضاً تجاوزها عبر الحقول المقابلة في JSON الإشارة.',
    paramName: 'اسم المعلمة',
    paramDefault: 'القيمة الافتراضية',
    paramDesc: 'الشرح',
    paramOverride: 'حقل التجاوز في JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'حجم العقد الافتراضي (يُستخدم عندما لا يحدد JSON)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number الافتراضي', 'magic'],
      ['DefaultComment', 'WikiConnector', 'تعليق الأمر الافتراضي', 'comment'],
      ['SlippagePoints', '3', 'أقصى انزلاق (نقاط)', '—'],
      ['OfflineBuffer', 'false', 'تفعيل المخزن المؤقت غير المتصل', '—'],
      ['ReconnectSeconds', '5', 'فاصل إعادة اتصال WebSocket (ثوانٍ)', '—']
    ],
    cmdTableTitle: 'شرح أنواع الأوامر',
    cmdCol: 'الأمر (cmd)',
    typeCol: 'النوع',
    actionCol: 'الإجراء',
    extraCol: 'معلمات إضافية',
    cmdTable: [
      ['buy', 'أمر سوقي', 'شراء فوري', 'lots, sl_*, tp_*'],
      ['sell', 'أمر سوقي', 'بيع فوري', 'lots, sl_*, tp_*'],
      ['buylimit', 'أمر معلق', 'شراء عند الوصول للسعر', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'أمر معلق', 'بيع عند الوصول للسعر', 'price, lots, sl_*, tp_*'],
      ['buystop', 'أمر معلق', 'شراء عند الاختراق', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'أمر معلق', 'بيع عند الاختراق', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'إغلاق', 'إغلاق جميع صفقات الشراء', 'magic (اختياري)'],
      ['closesell', 'إغلاق', 'إغلاق جميع صفقات البيع', 'magic (اختياري)'],
      ['closeall', 'إغلاق', 'إغلاق جميع الصفقات المفتوحة', '—'],
      ['closeallorders', 'إغلاق', 'حذف جميع الأوامر المعلقة', '—']
    ],
    jsonFieldTitle: 'شرح حقول JSON',
    fieldCol: 'اسم الحقل',
    requiredCol: 'إجباري',
    descCol: 'الشرح',
    jsonFields: [
      ['license', 'string', 'إجباري', 'License ID'],
      ['key', 'string', 'إجباري', 'Secret Key'],
      ['cmd', 'string', 'إجباري', 'أمر التداول، انظر الجدول أعلاه'],
      ['symbol', 'string', 'إجباري', 'زوج التداول، مثل EURUSD'],
      ['lots', 'number', 'اختياري', 'حجم العقد، اتركه فارغاً لاستخدام القيمة الافتراضية لـ EA'],
      ['price', 'number', 'إجباري للأمر المعلق', 'سعر الأمر المعلق'],
      ['sl_points', 'number', 'اختياري', 'نقاط وقف الخسارة'],
      ['sl_price', 'number', 'اختياري', 'سعر وقف الخسارة الثابت'],
      ['sl_pct', 'number', 'اختياري', 'نسبة وقف الخسارة (0-100)'],
      ['tp_points', 'number', 'اختياري', 'نقاط جني الأرباح'],
      ['tp_price', 'number', 'اختياري', 'سعر جني الأرباح الثابت'],
      ['tp_pct', 'number', 'اختياري', 'نسبة جني الأرباح (0-100)'],
      ['magic', 'number', 'اختياري', 'Magic Number'],
      ['comment', 'string', 'اختياري', 'تعليق الأمر'],
      ['signalid', 'string', 'اختياري', 'معرف فريد للإشارة، يستخدم لمنع التكرار'],
      ['expiryseconds', 'number', 'اختياري', 'صلاحية الإشارة (ثوانٍ)، الافتراضي 60']
    ],

    dlMt5Desc: 'إصدار MT5 من EA، يدعم جميع الأوامر، موصى به',
    dlMt5Btn: 'تحميل MT5 EA',
    dlMt4Desc: 'إصدار MT4 من EA، قيد التطوير، ترقبوا',
    dlMt4Dev: 'قيد التطوير',
    dlInstallDoc: `<h4>تعليمات التثبيت</h4>
<ol>
<li>قم بتنزيل ملف <code>WikiConnector_MT5.ex5</code></li>
<li>افتح MT5، شريط القائمة ← <strong>ملف ← فتح مجلد البيانات</strong></li>
<li>انسخ ملف <code>.ex5</code> إلى مجلد <code>MQL5/Experts/</code></li>
<li>اضغط <strong>F5</strong> في MT5 لتحديث المستعرض، ابحث عن WikiConnector EA</li>
<li>اسحب EA إلى أي رسم بياني، أدخل <strong>License ID</strong> و <strong>Secret Key</strong></li>
<li>في خيارات EA، فعّل <strong>السماح بـ WebRequest</strong>، وأضف <code>api-gw.interface003.com</code> إلى قائمة عناوين URL المسموح بها</li>
</ol>`,

    disclaimerTitle: 'إخلاء المسؤولية عن المخاطر',
    disclaimerContent: `<p>قبل تنزيل واستخدام WikiConnector EA، يرجى قراءة إخلاء المسؤولية التالي بعناية:</p>
<p><strong>1. مخاطر التداول</strong><br/>ينطوي تداول العملات الأجنبية وعقود الفروقات على مخاطر كبيرة قد تؤدي إلى خسارة كل أو جزء من رأس المال. WikiConnector هو مجرد أداة لنقل الإشارات ولا يتحمل أي مسؤولية عن نتائج التداول.</p>
<p><strong>2. مخاطر الاستراتيجية</strong><br/>الأداء السابق لاستراتيجيات التداول الآلي لا يضمن النتائج المستقبلية. يرجى الاختبار الكافي قبل الاستخدام على الحسابات الحقيقية.</p>
<p><strong>3. مخاطر تقنية</strong><br/>قد تؤدي عوامل تقنية مثل تأخير الشبكة وأعطال الخادم وقيود API إلى فقدان الإشارات أو تأخير التنفيذ. لا تستخدم هذه الأداة للاستراتيجيات عالية التردد الحساسة جداً لزمن الاستجابة.</p>
<p><strong>4. مسؤولية الاستخدام</strong><br/>يتحمل المستخدم المسؤولية الكاملة عن جميع نتائج التداول الناتجة عن استخدام WikiConnector EA. لا تقدم WikiFX نصائح استثمارية ولا تتحمل مسؤولية أرباح أو خسائر التداول.</p>`,
    disclaimerAgree: 'لقد قرأت وأوافق على إخلاء المسؤولية أعلاه وأتفهم مخاطر التداول',
    disclaimerDownload: 'أوافق وأقوم بالتحميل',

    regenTitle: 'تأكيد إعادة تعيين المفتاح؟',
    regenSubtitle: 'هذا الإجراء لا يمكن التراجع عنه، يرجى التأكد من فهمك للتأثيرات التالية:',
    regenWarnings: ['جميع EAs المكونة بهذا المفتاح ستنقطع <strong>فوراً</strong>', 'المفتاح القديم <strong>غير صالح نهائياً</strong> ولا يمكن استعادته', 'تحتاج إلى تحديث تكوين Secret Key يدوياً في جميع EAs', 'قد يكون هناك <strong>فقدان للإشارات</strong> أثناء إعادة التعيين'],

    dashTitle: 'WikiConnector الخاص بي',
    myKey: 'المفتاح السري الخاص بي',
    keyPrefix: 'Secret Key',
    copyBtn: 'نسخ',
    regenBtn: 'إعادة إنشاء',
    regenConfirm: 'بعد إعادة إنشاء المفتاح، ستنقطع جميع EAs المتصلة وتحتاج إلى إعادة التكوين. هل تريد المتابعة؟',
    regenConfirmBtn: 'تأكيد إعادة التعيين',
    cancelBtn: 'إلغاء',
    copiedTip: 'تم النسخ',

    licenseTitle: 'شهاداتي (License)',
    licenseId: 'معرف الشهادة',
    maxConn: 'الحد الأقصى للاتصالات',
    activeConn: 'الاتصالات الحالية',
    webhookUrl: 'Webhook URL',

    statsTitle: 'إحصائيات الإشارات',
    statTotal: 'إجمالي الإشارات',
    statDelivered: 'تم التسليم',
    statFailed: 'فشل',
    statConnections: 'الاتصالات الحالية',

    signalTitle: 'أحدث سجلات الإشارات',
    signalTime: 'الوقت',
    signalCmd: 'الأمر',
    signalSymbol: 'الزوج',
    signalLots: 'حجم العقد',
    signalStatus: 'الحالة',
    signalLicense: 'الشهادة',
    statusDelivered: 'تم التسليم',
    statusPending: 'بانتظار التسليم',
    statusFailed: 'فشل',
    statusExpired: 'منتهي الصلاحية',
    noSignal: 'لا توجد سجلات إشارات بعد',
    loadMore: 'تحميل المزيد',

    offlineBuffer: 'المخزن المؤقت غير المتصل',
    offlineBufferDesc: 'عند التفعيل، سيتم تسليم الإشارات المتراكمة أثناء فترة عدم الاتصال عند إعادة اتصال EA (معطل افتراضياً لمنع الخسائر)',

    docTitle: 'دليل الاستخدام',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 آلية عمل WikiConnector</p>
  <p>يستقبل WikiConnector إشارات TradingView في الوقت الفعلي عبر <strong>اتصال WebSocket طويل الأمد</strong> وينفذ التداول تلقائياً في برنامج التداول.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① تثبيت EA في برنامج التداول</p>
  <ol class="doc-steps">
    <li><strong>فتح مجلد البيانات</strong>: قائمة برنامج التداول → ملف → فتح مجلد البيانات</li>
    <li><strong>نسخ ملف EA</strong>: انسخ ملف EA إلى مجلد <code>Experts/</code></li>
    <li><strong>تحديث المستعرض</strong>: افتح المستعرض → انقر بزر الماوس الأيمن على "أنظمة الخبراء" → تحديث. يجب أن يظهر <strong>SignalReceiver</strong> في القائمة</li>
    <li><strong>تفعيل التداول الآلي</strong>: يجب أن يكون زر "التداول الآلي" في الشريط العلوي 🟢 أخضر</li>
    <li><strong>تطبيق على الرسم البياني</strong>: اسحب SignalReceiver إلى أي رسم بياني، ستظهر نافذة الإعدادات لضبط المعلمات</li>
  </ol>
  <div class="doc-tip"><strong>تلميح:</strong> يكفي تطبيق EA على رسم بياني واحد لمعالجة إشارات جميع الأزواج، لا حاجة لتطبيقه على كل زوج على حدة.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② تكوين معلمات EA</p>
  <p>تنقسم المعلمات إلى نوعين: <strong>إجبارية</strong> (License / SecretKey) و<strong>معلمات افتراضية</strong> (تُستخدم عندما لا يحتوي JSON الإشارة على حقل معين، قيمة الإشارة تسبق دائماً القيمة الافتراضية لـ EA).</p>
  <div class="doc-warn"><strong>تحذير أمني:</strong> License و SecretKey هما الدرع الوحيد لحماية حسابك. إذا تسربا، يمكن لأي شخص إرسال أوامر تداول إلى برنامج التداول الخاص بك. لا تلتقط لقطات شاشة أو تشاركهما مع الآخرين، ويوصى بتغيير SecretKey بانتظام.</div>
  <p>بعد اكتمال الإعداد، يظهر اسم EA + <strong>😊</strong> في الزاوية اليمنى العليا من الرسم البياني للإشارة إلى الاتصال بالخادم؛ إذا ظهر 😞، تحقق مما إذا كان زر "التداول الآلي" أخضر.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ كتابة كود Pine Script للإشارة</p>
  <p>يستخدم WikiConnector دالة <code>alert()</code> لتفعيل الإشارة، وليس طريقة <code>strategy.entry(alert_message=)</code>، فهما آليتان مختلفتان، لا تخلطهما.</p>
  <div class="doc-danger"><strong>هام: alert.freq_all</strong> — افتراضياً، في Pine Script، يتم تفعيل أول <code>alert()</code> فقط داخل نفس الشمعة، ويتم تجاهل الباقي. إذا كنت بحاجة إلى إرسال إشارات متعددة متتالية (مثل العكس: إغلاق البيع أولاً ثم فتح الشراء)، يجب إضافة <code>alert.freq_all</code> إلى كل <code>alert()</code>، وإلا لن تصل الإشارة الثانية إلى الخادم أبداً.</div>
<pre>//@version=6
strategy("استراتيجية WikiConnector", overlay=true)

// تعريف رسائل الإشارة (استبدل YOUR_LICENSE و YOUR_KEY بقيمك الخاصة)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// مثال على شروط الاستراتيجية (تقاطع متوسطي 3/13)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// استخدام alert.freq_all لضمان إرسال إشارات متعددة داخل نفس الشمعة
if longCondition
    alert(closesellMessage, alert.freq_all)  // أغلق صفقات البيع أولاً
    alert(buyMessage,       alert.freq_all)  // ثم افتح صفقة شراء

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // أغلق صفقات الشراء أولاً
    alert(sellMessage,     alert.freq_all)   // ثم افتح صفقة بيع</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ إنشاء تنبيه في TradingView</p>
  <p>عنوان Webhook URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>انقر بزر الماوس الأيمن على الرسم البياني ← "<strong>إضافة تنبيه...</strong>" أو <strong>Alt+A</strong></li>
    <li>اختر شرط التفعيل <strong>"استدعاء دالة alert() فقط"</strong> (هام!)</li>
    <li>اختر مدة صلاحية طويلة قدر الإمكان، أو "مفتوح" (Open-ended)</li>
    <li>مربع الرسالة <strong>اتركه افتراضياً، لا تملأ أي شيء</strong> (محتوى الإشارة يحدده alert() في الكود)</li>
    <li>إعدادات الإشعارات: فعّل <strong>Webhook URL</strong> وأدخل العنوان أعلاه؛ <strong>ألغِ تحديد "إرسال نص عادي"</strong></li>
    <li>انقر "إنشاء" لحفظ التنبيه</li>
  </ol>
  <div class="doc-tip"><strong>تلميح:</strong> تتطلب ميزة Webhook اشتراك TradingView Pro أو أعلى.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ شرح تنسيق JSON للإشارة</p>
  <p><strong>الحقول الإجبارية:</strong><code>license</code> (معرف التفويض)، <code>key</code> (المفتاح)، <code>cmd</code> (الأمر)، <code>symbol</code> (اسم الزوج)</p>
  <p><strong>الحقول الاختيارية:</strong><code>lots</code> (حجم العقد)، <code>price</code> (سعر الأمر المعلق)، <code>sl_points / sl_price / sl_pct</code> (وقف الخسارة ثلاث اختيارات)، <code>tp_points / tp_price / tp_pct</code> (جني الأرباح ثلاث اختيارات)، <code>magic</code>، <code>comment</code>، <code>signal_id</code>، <code>expiry_seconds</code> (افتراضي 300 ثانية)</p>
  <p><strong>الأوامر المدعومة:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>أولوية وقف الخسارة وجني الأرباح:</strong><code>sl_price</code> (السعر الثابت)&gt; <code>sl_points</code> (النقاط)&gt; <code>sl_pct</code> (النسبة المئوية)، إذا كانت الثلاثة 0 فلا يتم تعيين وقف خسارة، وكذلك جني الأرباح.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ قائمة التحقق قبل التشغيل</p>
  <ul class="doc-checklist">
    <li class="ok">✅ زر التداول الآلي في برنامج التداول 🟢 أخضر</li>
    <li class="ok">✅ EA في الزاوية اليمنى العليا من الرسم البياني يعرض 😊 (متصل بالخادم)</li>
    <li class="ok">✅ License / SecretKey متطابقان تماماً مع القيم في JSON TradingView</li>
    <li class="ok">✅ شرط تفعيل التنبيه "<strong>استدعاء دالة alert() فقط</strong>"</li>
    <li class="ok">✅ تمت إضافة <code>alert.freq_all</code> إلى كل <code>alert()</code></li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ مربع الرسالة متروك افتراضياً، لم يتم ملء أي شيء</li>
    <li class="no">❌ تم إلغاء تحديد "إرسال نص عادي"</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ تنبيهات الأمان والمخاطر</p>
  <div class="doc-warn">
    <strong>أمان الحساب:</strong><br>
    · لا تلتقط لقطات شاشة لـ License و SecretKey أو تشاركهما مع أي شخص<br>
    · إذا اشتبهت في تسرب المفتاح، أعد تعيين SecretKey فوراً في لوحة التحكم<br>
    · يوصى بتغيير SecretKey بانتظام
  </div>
  <div class="doc-warn">
    <strong>التحكم في مخاطر التداول:</strong><br>
    · حدد دائماً وقف الخسارة، ولا تدير الاستراتيجية الآلية بدون حماية<br>
    · يوصى بأن تكون مخاطر الصفقة الواحدة ضمن 1-2% من رصيد الحساب<br>
    · يوصى بإيقاف التداول الآلي مؤقتاً قبل البيانات الاقتصادية الهامة (الوظائف غير الزراعية، CPI، FOMC)
  </div>
  <div class="doc-tip">
    <strong>أفضل الممارسات:</strong><br>
    · اختبر على حساب تجريبي (Demo) لمدة أسبوع إلى أسبوعين على الأقل، وتأكد من سلامة المسار قبل التبديل إلى الحساب الحقيقي<br>
    · استخدم أصغر حجم عقد (0.01) في البداية على الحساب الحقيقي<br>
    · استخدم VPS (مثل Tianyan Cloud VPS) لضمان بقاء برنامج التداول و EA متصلين على مدار الساعة
  </div>
</div>`,
    docSections: [
      {
        title: '1. تنسيق إشارة Webhook',
        content: `في مربع رسالة تنبيه TradingView، املأ JSON التالي:
<pre>{
  "license": "{{معرف الترخيص الخاص بك}}",
  "key": "{{مفتاحك السري}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>الأوامر <strong>cmd</strong> المدعومة: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. عنوان Webhook في TradingView',
        content: `<p>في إعدادات تنبيه TradingView، أدخل عنوان Webhook URL التالي:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>في مربع الرسالة، املأ تنسيق JSON للإشارة أعلاه، واستبدل license و key بقيمك الخاصة.</p>`
      },
      {
        title: '3. تثبيت WikiConnector EA',
        content: `<p>1. قم بتنزيل WikiConnector EA (ملف .ex5)</p>
<p>2. انسخ EA إلى مجلد <code>MQL5/Experts</code> في MT5</p>
<p>3. افتح EA في MT5، أدخل <strong>License ID</strong> و <strong>Secret Key</strong></p>
<p>4. اسمح لـ EA بإجراء اتصال WebSocket (في خيارات MT5 → EA، فعّل صلاحية الاتصال بالشبكة)</p>`
      },
      {
        title: '4. حدود التردد',
        content: `<p>الحد الأقصى لكل ترخيص <strong>30 مرة / 60 ثانية</strong>، تجاوز الحد يعيد خطأ 429.</p>
<p>إذا كنت بحاجة إلى تردد أعلى، اتصل بخدمة العملاء لترقية الباقة.</p>`
      }
    ],

    faqTitle: 'الأسئلة الشائعة',
    faqs: [
      {
        q: 'ماذا أفعل إذا تم تسريب المفتاح؟',
        a: 'انقر على "إعادة إنشاء" في لوحة التحكم، سيصبح المفتاح القديم غير صالح فوراً، وسيتم قطع جميع اتصالات EA. أعد تكوين EA باستخدام المفتاح الجديد.'
      },
      {
        q: 'هل سيتم إعادة إرسال الإشارات بعد إعادة اتصال EA؟',
        a: 'افتراضياً لا يتم إعادة الإرسال (لمنع الخسائر). إذا كنت بحاجة إلى إعادة الإرسال، فعّل "المخزن المؤقت غير المتصل" في لوحة التحكم، وسيستقبل EA الإشارات المتراكمة أثناء فترة عدم الاتصال عند إعادة الاتصال.'
      },
      {
        q: 'كم عدد حسابات MT التي يمكن لترخيص واحد الاتصال بها؟',
        a: 'يدعم كل ترخيص ما يصل إلى 10 اتصالات WebSocket متزامنة، ويمكن لما يصل إلى 10 محطات MT استقبال نفس الإشارة في وقت واحد.'
      },
      {
        q: 'هل يدعم MT4؟',
        a: 'الإصدار الحالي يدعم MT5 بشكل أساسي. إصدار MT4 من EA قيد التطوير، ترقبوا.'
      },
      {
        q: 'ما هو زمن استجابة الإشارة؟',
        a: 'متوسط زمن الاستجابة <100 مللي ثانية. مع نشر Tianyan Cloud VPS، يمكن أن يصل إلى 1 مللي ثانية.'
      },
      {
        q: 'كيف أختبر أن Webhook يعمل بشكل صحيح؟',
        a: 'في قائمة الشهادات، تحقق من "عدد الاتصالات الحالية". إذا كان أكبر من 0، فإن EA متصل. بعد إرسال إشارة اختبار، تحقق من "أحدث سجلات الإشارات" لترى الحالة "تم التسليم".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script وإرسال الإشارات',
        items: [
          {
            q: 'استخدمت دالتي alert() للإغلاق والفتح، لكن برنامج التداول استقبل إشارة واحدة فقط.',
            a: 'هذا هو الحد الافتراضي لـ Pine Script، حيث يتم تفعيل أول alert() فقط داخل نفس الشمعة. الحل هو <strong>إضافة معلمة <code>alert.freq_all</code> إلى كل alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'ما هو شرط تفعيل التنبيه الذي يجب اختياره؟',
            a: 'عند استخدام دالة <code>alert()</code>، يجب اختيار <strong>"استدعاء دالة alert() فقط"</strong>. إذا كنت تستخدم طريقة <code>strategy.entry(..., alert_message=xxx)</code> فاختر "Order fills only". لا يمكن خلط الطريقتين.'
          },
          {
            q: 'ماذا يجب أن أملأ في مربع الرسالة؟',
            a: 'عند استخدام طريقة <code>alert()</code>، <strong>اترك مربع الرسالة افتراضياً، لا تملأ أي شيء</strong>. محتوى الإشارة يحدده النص داخل <code>alert(xxx)</code> في الكود، وسيستقبل Webhook ذلك JSON.'
          }
        ]
      },
      {
        title: '🔌 الاتصال واستقبال الإشارات',
        items: [
          {
            q: 'أيقونة EA تظهر وجهاً أحمر باكياً 😞، ماذا أفعل؟',
            a: 'تحقق مما إذا كان زر "التداول الآلي" في شريط أدوات برنامج التداول أخضر. إذا كان أحمر، انقر لتحويله إلى أخضر، وسيعود EA تلقائياً إلى الحالة الطبيعية.'
          },
          {
            q: 'أرسلت إشارة من TradingView لكن برنامج التداول لم يستجب.',
            a: 'تحقق بالترتيب التالي:<br>1. هل التداول الآلي في برنامج التداول أخضر<br>2. هل لوحة EA تظهر Connected<br>3. هل Webhook URL هو <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code><br>4. هل شرط تفعيل التنبيه هو "استدعاء دالة alert() فقط"<br>5. هل تمت إضافة <code>alert.freq_all</code> إلى كل alert()<br>6. هل license و key في JSON متطابقان تماماً مع إعدادات EA'
          }
        ]
      },
      {
        title: '💰 تنفيذ التداول',
        items: [
          {
            q: 'فشل الأمر، ما السبب؟',
            a: 'الأسباب الشائعة: رصيد غير كاف / عدم تطابق اسم الزوج (تحتاج إلى تكوين Symbol Mapping) / تجاوز حد حجم العقد / انزلاق كبير جداً (زيادة InpDeviation) / السوق مغلق. يرجى مراجعة سجل "الخبراء" أسفل برنامج التداول للحصول على معلومات الخطأ المحددة.'
          },
          {
            q: 'الأمر ليس لديه وقف خسارة أو جني أرباح؟',
            a: 'تحقق من: ① هل يحتوي JSON الإشارة على حقول <code>sl_points</code> / <code>tp_points</code> إلخ؛ ② هل معلمات وقف الخسارة وجني الأرباح الافتراضية لـ EA هي 0. إذا لم يتم تعيين أي منهما، فلن يكون للأمر وقف خسارة أو جني أرباح.'
          },
          {
            q: 'اسم الزوج غير متطابق، ماذا أفعل؟',
            a: 'فعّل Symbol Mapping في معلمات EA:<br>اضبط <code>InpEnableMap1 = true</code><br>اضبط <code>InpMapping1 = XAUUSD|GOLD</code> (اسم الزوج في TradingView|اسم الزوج في برنامج التداول)'
          },
          {
            q: 'هل يمكنني الاختبار على حساب تجريبي أولاً؟',
            a: '<strong>نوصي بشدة!</strong> عند الاستخدام الأول، يجب الاختبار على حساب تجريبي (Demo) لمدة أسبوع إلى أسبوعين على الأقل، والتأكد من أن المسار طبيعي وتنفيذ الأوامر صحيح قبل التبديل إلى الحساب الحقيقي. استخدم أصغر حجم عقد 0.01 في البداية.'
          }
        ]
      }
    ]
  },

  // === de Deutsch ===
  de: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView-Signale automatisch mit MetaTrader verbinden und Trades ausführen',
    heroBtn: 'Kostenlos starten',

    stat1Label: 'Durchschnittliche Latenz',
    stat2Label: 'Service-Verfügbarkeit',
    stat3Label: 'Rund-um-die-Uhr-Betrieb',
    stat4Label: 'Multi-Konto-Verteilung',

    flowSub1: 'Strategie / Alert',
    flowSub2: 'Signal-Routing',
    flowSub3: 'Automatische Ausführung',

    featTitle: 'Warum WikiConnector wählen',
    featSubtitle: 'Kernvorteile',
    features: [
      {
        icon: '⚡',
        title: 'Ausführung in Millisekunden',
        desc: 'Durchschnittliche Signallatenz <100 ms, mit WikiFX VPS bis zu 1 ms möglich.'
      },
      {
        icon: '🔗',
        title: 'Multi-Konto-Verteilung',
        desc: 'Ein Zertifikat verbindet mehrere MT-Terminals und verteilt dasselbe Strategiesignal gleichzeitig.'
      },
      {
        icon: '🔒',
        title: 'Sichere Verschlüsselung',
        desc: 'Unabhängiges Schlüsselsystem pro Benutzer, vollständig verschlüsselte Datenübertragung.'
      },
      {
        icon: '📊',
        title: 'Echtzeit-Überwachung',
        desc: 'Signalempfangsstatus, Ausführungslatenz und Erfolgsrate in Echtzeit einsehbar.'
      },
      {
        icon: '<>',
        title: 'Code-Generator',
        desc: 'Visuelle Generierung von JSON-Signalen und Pine Script-Code, keine Programmierung erforderlich.'
      },
      {
        icon: '🖥',
        title: 'VPS-Tiefenintegration',
        desc: 'Geteiltes Kontosystem mit Tianyan Cloud VPS, 24/7 Betrieb mit niedriger Latenz.'
      }
    ],

    stepsTitle: 'In vier Schritten zum automatisierten Handel',
    stepsSubtitle: 'Schnellstart',
    steps: [
      {
        title: 'Anmelden',
        desc: 'Melden Sie sich mit Ihrem WikiFX-Konto an und erhalten Sie automatisch Ihren persönlichen Schlüssel und Ihre Lizenz.'
      },
      {
        title: 'Webhook konfigurieren',
        desc: 'Kopieren Sie die Webhook-URL in die TradingView Alert-Einstellungen.'
      },
      {
        title: 'EA installieren',
        desc: 'Laden Sie den WikiConnector EA herunter und geben Sie License ID und Secret Key ein.'
      },
      {
        title: 'Automatischer Handel',
        desc: 'Wenn Ihre Strategie einen Alert auslöst, wird das Signal automatisch an das MT-Terminal zur Ausführung gesendet.'
      }
    ],

    loginTip: 'Nach dem Einloggen können Sie Ihren persönlichen Schlüssel und Ihr Zertifikat einsehen',
    loginBtn: 'Jetzt einloggen',

    navConn: 'Verbindungsverwaltung',
    navLog: 'Signallog',
    navGen: 'Code-Generator',
    navParams: 'Parameter-Schnellreferenz',
    navDl: 'Download',
    navDoc: 'Bedienungsanleitung',
    navFaq: 'Häufig gestellte Fragen',

    keyLabel: 'Secret Key',
    keyTip1: 'Niemanden damit teilen',
    keyTip2: 'Wird für die EA-Authentifizierung verwendet',
    keyTip3: 'Nach dem Zurücksetzen wird der alte Schlüssel sofort ungültig',

    connSubtitle: 'Im Folgenden finden Sie Ihre Lizenzen und die dazugehörigen Webhook-URLs',
    noLicense: 'Keine Lizenz vorhanden. Bitte kontaktieren Sie den Kundenservice',
    needHelp: 'Benötigen Sie Hilfe?',
    viewDoc: 'Bedienungsanleitung anzeigen',

    allLicense: 'Alle Lizenzen',
    allStatus: 'Alle Status',
    refresh: 'Aktualisieren',
    signalId: 'Signal-ID',
    total: 'Insgesamt',
    records: 'Datensätze',

    genIntro: 'Füllen Sie die folgenden Parameter aus, um automatisch JSON-Signale und Pine Script-Code für TradingView Alerts zu generieren.',
    genAuth: 'Authentifizierungsinformationen',
    required: 'Pflichtfeld',
    optional: 'Optional',
    genLicPlaceholder: 'Geben Sie Ihre License ID ein',
    genLicHint: 'Auf der Verbindungsverwaltungsseite einsehbar',
    genKeyPlaceholder: 'Geben Sie Ihren Secret Key ein',
    genKeyHint: 'Auf der Verbindungsverwaltungsseite einsehbar',
    genTrade: 'Handelsauftrag',
    genCmd: 'Auftragstyp',
    genMarket: 'Marktauftrag',
    genPending: 'Schwebender Auftrag',
    genClose: 'Schließen',
    cmdBuy: 'Marktkauf',
    cmdSell: 'Marktverkauf',
    cmdBuyLimit: 'Limit-Kauf',
    cmdSellLimit: 'Limit-Verkauf',
    cmdBuyStop: 'Stop-Kauf',
    cmdSellStop: 'Stop-Verkauf',
    cmdCloseBuy: 'Long-Positionen schließen',
    cmdCloseSell: 'Short-Positionen schließen',
    cmdCloseAll: 'Symbol schließen',
    cmdCloseAllOrders: 'Alle schließen',
    genSlTpHint: 'Eins aus drei · Priorität: Preis > Punkte > Prozent',
    genTsHint: 'Signal-Sendezeit',
    genTsBtn: 'Aktuelle Zeit',
    presetSimple: '📝 Einfacher Kauf',
    presetSltp: '🛡 Mit Stop-Loss/Take-Profit',
    presetFull: '📋 Vollständige Parameter',
    presetClose: '❌ Schließsignal',
    presetPending: '📌 Schwebender Auftrag',
    presetReverse: '🔄 Umkehrung (Schließen + Eröffnen)',
    genAlertTab: '🔔 Erklärung der Alert-Einstellungen',
    toastIncomplete: 'Informationen unvollständig. Bitte füllen Sie die Pflichtfelder aus',
    toastRegen: 'Neuer Schlüssel wurde generiert. Bitte kopieren Sie ihn sofort und aktualisieren Sie alle konfigurierten EAs',
    toastKeyCopied: 'Schlüssel kopiert',
    toastCopied: 'Kopiert',
    toastCodeCopied: 'Code kopiert',
    copyTitle: 'Kopieren',
    genSymbol: 'Handelssymbol',
    genPrice: 'Preis für schwebenden Auftrag',
    genParams: 'Handelsparameter',
    genLots: 'Lotgröße',
    genLotsHint: 'Leer lassen, um EA-Standardwert zu verwenden',
    genMagic: 'Magic Number',
    genMagicHint: 'Zur Unterscheidung von Aufträgen verschiedener Strategien',
    genComment: 'Auftragskommentar',
    genCommentHint: 'Z.B.: Strategy A',
    genSL: 'Stop-Loss-Einstellung',
    genPoints: 'Punkte',
    genPrice2: 'Fester Preis',
    genPct: 'Prozent %',
    genTP: 'Take-Profit-Einstellung',
    genAdvanced: 'Erweiterte Parameter',
    genSigIdHint: 'Leer lassen für automatische Generierung, dient der Deduplizierung',
    genGenId: 'Automatisch generieren',
    genBtn: 'Code generieren',
    genFormat: 'Signalformat',
    genGuideTitle: 'So verwenden Sie es in TradingView',
    genGuideSteps: [
      'Erstellen Sie einen <strong>Alert</strong> auf Ihrem TradingView-Chart',
      'Wählen Sie unter <strong>Alert-Bedingung</strong> Ihre Strategie oder Ihren Indikator',
      'Erweitern Sie <strong>Benachrichtigungen</strong> → aktivieren Sie <strong>Webhook URL</strong>',
      'Geben Sie als Webhook-URL ein: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Fügen Sie das oben generierte JSON in das <strong>Message</strong>-Feld ein',
      'Klicken Sie auf <strong>Create</strong>, um den Alert zu speichern'
    ],
    genGuideNote: '<strong>Hinweis:</strong> Wenn Sie Pine Script verwenden, fügen Sie den generierten Code zu Ihrem Skript hinzu und verwenden Sie den Parameter <code>alert_message</code> in <code>strategy.entry()</code> oder <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Autorisierung) — Muss geändert werden',
        rows: [
          ['License', '—', 'Autorisierungs-ID, muss exakt mit dem license-Feld im Signal-JSON übereinstimmen', 'req'],
          ['SecretKey', '—', 'Sicherheitsschlüssel (beginnt mit wc_sk_), muss exakt mit dem key-Feld im Signal-JSON übereinstimmen', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Standard-Handelsparameter)',
        rows: [
          ['InpLots', '0.1', 'Standard-Lotgröße, wird verwendet wenn Signal-JSON kein lots enthält', ''],
          ['InpMagic', '888', 'Standard-Magic-Nummer, zur Unterscheidung von Aufträgen verschiedener Strategien', ''],
          ['InpComment', 'TV Signal', 'Standard-Auftragskommentar', ''],
          ['InpDeviation', '30', 'Maximaler Slippage (Punkte), für Forex 10–30, für Gold/Indizes 30–50 empfohlen', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Priorität: sl_price (fester Preis) > sl_points (Punkte) > sl_pct (Prozent). Sind alle drei 0, wird kein Stop-Loss gesetzt, gleiches gilt für Take-Profit',
        rows: [
          ['InpSLPoints', '0', 'Standard-Stop-Loss-Punkte (0 = deaktiviert)', ''],
          ['InpSLPrice', '0', 'Standard-Stop-Loss-Festpreis (0 = deaktiviert, höchste Priorität)', ''],
          ['InpSLPct', '0', 'Standard-Stop-Loss-Prozent (0 = deaktiviert)', ''],
          ['InpTPPoints', '0', 'Standard-Take-Profit-Punkte (0 = deaktiviert)', ''],
          ['InpTPPrice', '0', 'Standard-Take-Profit-Festpreis (0 = deaktiviert)', ''],
          ['InpTPPct', '0', 'Standard-Take-Profit-Prozent (0 = deaktiviert)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Symbolnamen-Zuordnung)',
        note: 'Broker können unterschiedliche Symbolnamen verwenden (z.B. TradingView nennt XAUUSD, Ihr Broker nennt GOLD). Die Zuordnung ermöglicht automatische Konvertierung',
        rows: [
          ['InpPrefix', '(leer)', 'Präfix des Symbolnamens, z.B. wenn Ihr Broker m.EURUSD verwendet, geben Sie m. ein', ''],
          ['InpSuffix', '(leer)', 'Suffix des Symbolnamens, z.B. wenn Ihr Broker EURUSD.pro verwendet, geben Sie .pro ein', ''],
          ['InpEnableMap1~5', 'false', 'Auf true setzen, um die entsprechende Zuordnungsregel zu aktivieren', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Zuordnungsregel, Format: TradingView-Symbolname|MT5-Symbolname, unterstützt bis zu 5 Regeln', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Gleiches Format', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Gleiches Format', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Gleiches Format', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Gleiches Format', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Zeitfilter / Anzeige & Protokoll)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Wenn aktiviert, werden Signale nur zwischen StartTime~EndTime verarbeitet', ''],
          ['InpStartTime', '00:00', 'Erlaubte Handelsstartzeit (MT5-Serverzeit, Format HH:MM)', ''],
          ['InpEndTime', '23:59', 'Erlaubte Handelsendzeit', ''],
          ['InpShowPanel', 'true', 'Informationspanel mit Verbindungsstatus und Signalstatistiken auf dem Chart anzeigen', ''],
          ['InpUpdateInterval', '1000', 'Panel-Aktualisierungsintervall (ms), 1000~3000 empfohlen', ''],
          ['InpLogLevel', '1', 'Protokollebene: 0=aus 1=basisch 2=detailliert 3=Debug (bei Fehlersuche 2 oder 3 verwenden)', ''],
          ['InpLogToFile', 'true', 'Protokolldatei nach MQL5/Logs/ schreiben', ''],
          ['InpLogToConsole', 'true', 'Im "Experten"-Tab unten in MT5 ausgeben', ''],
          ['InpMaxLogMB', '5', 'Maximale Protokolldateigröße (MB), bei Überschreitung automatische Rotation', '']
        ]
      }
    ],

    paramsEATitle: 'EA-Parameterbeschreibung',
    paramsEADesc: 'Die folgenden Parameter können beim Öffnen des EA in MT5 eingestellt oder durch die entsprechenden Felder im Signal-JSON überschrieben werden.',
    paramName: 'Parametername',
    paramDefault: 'Standardwert',
    paramDesc: 'Beschreibung',
    paramOverride: 'JSON-Überschreibungsfeld',
    eaParams: [
      ['DefaultLots', '0.1', 'Standard-Lotgröße (wenn JSON keine Angabe macht)', 'lots'],
      ['DefaultMagic', '0', 'Standard-Magic-Nummer', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Standard-Auftragskommentar', 'comment'],
      ['SlippagePoints', '3', 'Maximaler Slippage (Punkte)', '—'],
      ['OfflineBuffer', 'false', 'Offline-Puffer aktivieren', '—'],
      ['ReconnectSeconds', '5', 'WebSocket-Wiederverbindungsintervall (Sekunden)', '—']
    ],
    cmdTableTitle: 'Befehlstypen-Beschreibung',
    cmdCol: 'Befehl (cmd)',
    typeCol: 'Typ',
    actionCol: 'Aktion',
    extraCol: 'Zusätzliche Parameter',
    cmdTable: [
      ['buy', 'Marktauftrag', 'Sofort kaufen', 'lots, sl_*, tp_*'],
      ['sell', 'Marktauftrag', 'Sofort verkaufen', 'lots, sl_*, tp_*'],
      ['buylimit', 'Schwebender Auftrag', 'Kaufen bei Preiserreichung', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Schwebender Auftrag', 'Verkaufen bei Preiserreichung', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Schwebender Auftrag', 'Kaufen bei Durchbruch', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Schwebender Auftrag', 'Verkaufen bei Durchbruch', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Schließen', 'Alle Long-Positionen schließen', 'magic (optional)'],
      ['closesell', 'Schließen', 'Alle Short-Positionen schließen', 'magic (optional)'],
      ['closeall', 'Schließen', 'Alle offenen Positionen schließen', '—'],
      ['closeallorders', 'Schließen', 'Alle schwebenden Aufträge löschen', '—']
    ],
    jsonFieldTitle: 'JSON-Feldbeschreibung',
    fieldCol: 'Feldname',
    requiredCol: 'Pflichtfeld',
    descCol: 'Beschreibung',
    jsonFields: [
      ['license', 'string', 'Pflicht', 'License ID'],
      ['key', 'string', 'Pflicht', 'Secret Key'],
      ['cmd', 'string', 'Pflicht', 'Handelsbefehl, siehe Tabelle oben'],
      ['symbol', 'string', 'Pflicht', 'Handelssymbol, z.B. EURUSD'],
      ['lots', 'number', 'Optional', 'Lotgröße, leer lassen für EA-Standardwert'],
      ['price', 'number', 'Pflicht bei schwebendem Auftrag', 'Preis für schwebenden Auftrag'],
      ['sl_points', 'number', 'Optional', 'Stop-Loss-Punkte'],
      ['sl_price', 'number', 'Optional', 'Stop-Loss-Festpreis'],
      ['sl_pct', 'number', 'Optional', 'Stop-Loss-Prozent (0-100)'],
      ['tp_points', 'number', 'Optional', 'Take-Profit-Punkte'],
      ['tp_price', 'number', 'Optional', 'Take-Profit-Festpreis'],
      ['tp_pct', 'number', 'Optional', 'Take-Profit-Prozent (0-100)'],
      ['magic', 'number', 'Optional', 'Magic Number'],
      ['comment', 'string', 'Optional', 'Auftragskommentar'],
      ['signalid', 'string', 'Optional', 'Eindeutige Signal-ID, zur Deduplizierung'],
      ['expiryseconds', 'number', 'Optional', 'Signal-Gültigkeitsdauer (Sekunden), Standard 60']
    ],

    dlMt5Desc: 'MT5-Version des EA, unterstützt alle Befehle, empfohlen',
    dlMt5Btn: 'MT5 EA herunterladen',
    dlMt4Desc: 'MT4-Version des EA, in Entwicklung, bleiben Sie gespannt',
    dlMt4Dev: 'In Entwicklung',
    dlInstallDoc: `<h4>Installationsanleitung</h4>
<ol>
<li>Laden Sie die Datei <code>WikiConnector_MT5.ex5</code> herunter</li>
<li>Öffnen Sie MT5, Menüleiste → <strong>Datei → Datenordner öffnen</strong></li>
<li>Kopieren Sie die <code>.ex5</code>-Datei in das Verzeichnis <code>MQL5/Experts/</code></li>
<li>Drücken Sie <strong>F5</strong> in MT5, um den Navigator zu aktualisieren und den WikiConnector EA zu finden</li>
<li>Ziehen Sie den EA auf ein beliebiges Chart, geben Sie <strong>License ID</strong> und <strong>Secret Key</strong> ein</li>
<li>Aktivieren Sie in den EA-Optionen <strong>WebRequest erlauben</strong> und fügen Sie <code>api-gw.interface003.com</code> zur Liste der erlaubten URLs hinzu</li>
</ol>`,

    disclaimerTitle: 'Risikohaftungsausschluss',
    disclaimerContent: `<p>Bevor Sie den WikiConnector EA herunterladen und verwenden, lesen Sie bitte den folgenden Haftungsausschluss sorgfältig durch:</p>
<p><strong>1. Handelsrisiko</strong><br/>Devisen- und CFD-Handel birgt erhebliche Risiken, die zum vollständigen oder teilweisen Verlust Ihres Kapitals führen können. WikiConnector ist lediglich ein Signalübertragungswerkzeug und übernimmt keine Verantwortung für Handelsergebnisse.</p>
<p><strong>2. Strategierisiko</strong><br/>Die historische Performance automatisierter Handelsstrategien garantiert keine zukünftigen Ergebnisse. Testen Sie gründlich, bevor Sie es auf echten Konten einsetzen.</p>
<p><strong>3. Technisches Risiko</strong><br/>Netzwerklatenz, Serverausfälle und API-Beschränkungen können zu Signalverlusten oder Ausführungsverzögerungen führen. Verwenden Sie dieses Werkzeug nicht für latenzempfindliche Hochfrequenzstrategien.</p>
<p><strong>4. Nutzungsverantwortung</strong><br/>Der Benutzer trägt die volle Verantwortung für alle Handelsergebnisse, die aus der Nutzung des WikiConnector EA resultieren. WikiFX bietet keine Anlageberatung und übernimmt keine Verantwortung für Handelsgewinne oder -verluste.</p>`,
    disclaimerAgree: 'Ich habe den obigen Haftungsausschluss gelesen und stimme ihm zu, ich verstehe die Handelsrisiken',
    disclaimerDownload: 'Zustimmen und herunterladen',

    regenTitle: 'Schlüssel zurücksetzen bestätigen?',
    regenSubtitle: 'Dieser Vorgang kann nicht rückgängig gemacht werden. Bitte bestätigen Sie, dass Sie die folgenden Auswirkungen verstehen:',
    regenWarnings: ['Alle mit diesem Schlüssel konfigurierten EAs werden <strong>sofort getrennt</strong>', 'Der alte Schlüssel ist <strong>dauerhaft ungültig</strong> und kann nicht wiederhergestellt werden', 'Sie müssen die Secret Key-Konfiguration in allen EAs manuell aktualisieren', 'Während des Zurücksetzens besteht <strong>Risiko von Signalverlusten</strong>'],

    dashTitle: 'Mein WikiConnector',
    myKey: 'Mein Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Kopieren',
    regenBtn: 'Neu generieren',
    regenConfirm: 'Nach dem Neugenerieren des Schlüssels werden alle verbundenen EAs getrennt und müssen neu konfiguriert werden. Fortfahren?',
    regenConfirmBtn: 'Zurücksetzen bestätigen',
    cancelBtn: 'Abbrechen',
    copiedTip: 'Kopiert',

    licenseTitle: 'Meine Zertifikate (License)',
    licenseId: 'Zertifikats-ID',
    maxConn: 'Maximale Verbindungen',
    activeConn: 'Aktuelle Verbindung',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Signalstatistiken',
    statTotal: 'Gesamtsignale',
    statDelivered: 'Zugestellt',
    statFailed: 'Fehlgeschlagen',
    statConnections: 'Aktuelle Verbindungen',

    signalTitle: 'Letzte Signalaufzeichnungen',
    signalTime: 'Zeit',
    signalCmd: 'Befehl',
    signalSymbol: 'Symbol',
    signalLots: 'Lotgröße',
    signalStatus: 'Status',
    signalLicense: 'Zertifikat',
    statusDelivered: 'Zugestellt',
    statusPending: 'Ausstehend',
    statusFailed: 'Fehlgeschlagen',
    statusExpired: 'Abgelaufen',
    noSignal: 'Noch keine Signalaufzeichnungen',
    loadMore: 'Mehr laden',

    offlineBuffer: 'Offline-Puffer',
    offlineBufferDesc: 'Wenn aktiviert, werden während der Offline-Zeit angesammelte Signale bei Wiederverbindung des EA zugestellt (standardmäßig deaktiviert, um Verluste zu vermeiden)',

    docTitle: 'Bedienungsanleitung',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Funktionsweise von WikiConnector</p>
  <p>WikiConnector empfängt TradingView-Signale in Echtzeit über eine <strong>WebSocket-Dauerverbindung</strong> und führt Trades automatisch in der Handelsoftware aus.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① EA in der Handelsoftware installieren</p>
  <ol class="doc-steps">
    <li><strong>Datenordner öffnen</strong>: Menü der Handelsoftware → Datei → Datenordner öffnen</li>
    <li><strong>EA-Datei kopieren</strong>: Kopieren Sie die EA-Datei in das Verzeichnis <code>Experts/</code></li>
    <li><strong>Navigator aktualisieren</strong>: Navigator öffnen → Rechtsklick auf "Expert Advisors" → Aktualisieren. <strong>SignalReceiver</strong> sollte in der Liste erscheinen</li>
    <li><strong>Automatischen Handel aktivieren</strong>: Der "Automatischer Handel"-Button in der oberen Symbolleiste muss 🟢 grün sein</li>
    <li><strong>Auf Chart anwenden</strong>: Ziehen Sie SignalReceiver auf ein beliebiges Chart. Nachdem das Einstellungsfenster erscheint, konfigurieren Sie die Parameter</li>
  </ol>
  <div class="doc-tip"><strong>Hinweis:</strong> Der EA muss nur auf einem Chart platziert werden, um Signale aller Symbole zu verarbeiten. Es ist nicht nötig, ihn auf jedem einzelnen Chart zu platzieren.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② EA-Parameter konfigurieren</p>
  <p>Es gibt zwei Parametertypen: <strong>Pflichtfelder</strong> (License / SecretKey) und <strong>Standardparameter</strong> (werden verwendet, wenn das Signal-JSON ein bestimmtes Feld nicht enthält; Werte im Signal haben immer Vorrang vor EA-Standardwerten).</p>
  <div class="doc-warn"><strong>Sicherheitswarnung:</strong> License und SecretKey sind die einzige Barriere zum Schutz Ihres Kontos. Bei Leckage kann jeder Handelsbefehle an Ihre Handelsoftware senden. Machen Sie keine Screenshots und teilen Sie sie nicht mit anderen. Es wird empfohlen, den SecretKey regelmäßig zu ändern.</div>
  <p>Nach Abschluss der Einrichtung erscheint in der oberen rechten Ecke des Charts der EA-Name + <strong>😊</strong>, was die Verbindung zum Server anzeigt. Wenn 😞 angezeigt wird, überprüfen Sie, ob der "Automatischer Handel"-Button grün ist.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Pine Script-Signalcode schreiben</p>
  <p>WikiConnector verwendet die <code>alert()</code>-Funktion zum Auslösen von Signalen, nicht die <code>strategy.entry(alert_message=)</code>-Methode. Die beiden Mechanismen sind unterschiedlich und sollten nicht vermischt werden.</p>
  <div class="doc-danger"><strong>Wichtig: alert.freq_all</strong> — Standardmäßig wird in Pine Script nur der erste <code>alert()</code> innerhalb derselben Kerze ausgelöst, alle weiteren werden stillschweigend verworfen. Wenn Sie mehrere Signale hintereinander senden müssen (z.B. bei einer Umkehrung: zuerst Short schließen, dann Long eröffnen), muss jeder <code>alert()</code> mit <code>alert.freq_all</code> versehen werden, sonst erreicht das zweite Signal nie den Server.</div>
<pre>//@version=6
strategy("WikiConnector Strategie", overlay=true)

// Signalmeldungen definieren (ersetzen Sie YOUR_LICENSE und YOUR_KEY durch Ihre eigenen Werte)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Beispiel für Strategiebedingungen (3/13-Gleitendendurchschnitts-Kreuzung)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// alert.freq_all verwenden, um mehrere Signale innerhalb derselben Kerze sicherzustellen
if longCondition
    alert(closesellMessage, alert.freq_all)  // Zuerst Short-Positionen schließen
    alert(buyMessage,       alert.freq_all)  // Dann Long-Position eröffnen

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Zuerst Long-Positionen schließen
    alert(sellMessage,     alert.freq_all)   // Dann Short-Position eröffnen</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Alert in TradingView erstellen</p>
  <p>Webhook-URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Rechtsklick auf das Chart → "<strong>Alert hinzufügen...</strong>" oder <strong>Alt+A</strong></li>
    <li>Als Auslösebedingung <strong>"Nur alert()-Funktionsaufrufe"</strong> wählen (wichtig!)</li>
    <li>Ablaufzeit möglichst lang wählen, oder "Ohne Ablauf"</li>
    <li>Das Message-Feld <strong>standardmäßig leer lassen, nichts eintragen</strong> (Signalinhalt wird durch alert() im Code bestimmt)</li>
    <li>Benachrichtigungseinstellungen: <strong>Webhook URL</strong> aktivieren und obige Adresse eintragen; <strong>"Klartext senden" deaktivieren</strong></li>
    <li>Auf "Erstellen" klicken, um den Alert zu speichern</li>
  </ol>
  <div class="doc-tip"><strong>Hinweis:</strong> Die Webhook-Funktion erfordert ein TradingView Pro-Abonnement oder höher.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Erklärung des Signal-JSON-Formats</p>
  <p><strong>Pflichtfelder:</strong><code>license</code> (Autorisierungs-ID), <code>key</code> (Schlüssel), <code>cmd</code> (Befehl), <code>symbol</code> (Symbolname)</p>
  <p><strong>Optionale Felder:</strong><code>lots</code> (Lotgröße), <code>price</code> (Preis für schwebenden Auftrag), <code>sl_points / sl_price / sl_pct</code> (Stop-Loss-Dreierwahl), <code>tp_points / tp_price / tp_pct</code> (Take-Profit-Dreierwahl), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (Standard 300 Sekunden)</p>
  <p><strong>Unterstützte cmds:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Stop-Loss/Take-Profit-Priorität:</strong><code>sl_price</code> (fester Preis)&gt; <code>sl_points</code> (Punkte)&gt; <code>sl_pct</code> (Prozent). Sind alle drei 0, wird kein Stop-Loss gesetzt, gleiches gilt für Take-Profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Checkliste vor dem Betrieb</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Automatischer Handel-Button der Handelsoftware ist 🟢 grün</li>
    <li class="ok">✅ EA in der oberen rechten Ecke des Charts zeigt 😊 (mit Server verbunden)</li>
    <li class="ok">✅ License / SecretKey stimmen exakt mit den Werten im TradingView-JSON überein</li>
    <li class="ok">✅ Alert-Auslösebedingung "<strong>Nur alert()-Funktionsaufrufe</strong>"</li>
    <li class="ok">✅ Jeder <code>alert()</code> hat <code>alert.freq_all</code> hinzugefügt</li>
    <li class="ok">✅ Webhook-URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message-Feld standardmäßig leer gelassen, nichts eingetragen</li>
    <li class="no">❌ "Klartext senden" deaktiviert</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Sicherheits- und Risikohinweise</p>
  <div class="doc-warn">
    <strong>Kontosicherheit:</strong><br>
    · Machen Sie keine Screenshots von License und SecretKey und teilen Sie sie nicht mit anderen<br>
    · Bei Verdacht auf Schlüssel-Leckage setzen Sie den SecretKey sofort in der Konsole zurück<br>
    · Es wird empfohlen, den SecretKey regelmäßig zu ändern
  </div>
  <div class="doc-warn">
    <strong>Handelsrisikomanagement:</strong><br>
    · Setzen Sie immer einen Stop-Loss und betreiben Sie keine automatischen Strategien ohne Absicherung<br>
    · Das Risiko pro Trade sollte innerhalb von 1–2 % des Kontoguthabens liegen<br>
    · Vor wichtigen Wirtschaftsdaten (Non-Farm Payrolls, CPI, FOMC) wird empfohlen, den automatischen Handel zu pausieren
  </div>
  <div class="doc-tip">
    <strong>Best Practices:</strong><br>
    · Testen Sie zuerst mindestens 1–2 Wochen auf einem Demokonto, um sicherzustellen, dass die Verbindung funktioniert, bevor Sie zu einem echten Konto wechseln<br>
    · Verwenden Sie auf dem echten Konto zunächst die minimale Lotgröße (0,01)<br>
    · Nutzen Sie einen VPS (z.B. Tianyan Cloud VPS), um die Handelsoftware und den EA rund um die Uhr online zu halten
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook-Signalformat',
        content: `Füllen Sie im Message-Feld des TradingView-Alerts folgendes JSON aus:
<pre>{
  "license": "{{IhreLicenseID}}",
  "key": "{{IhrSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Unterstützte <strong>cmd</strong>-Befehle: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook-Adresse',
        content: `<p>Geben Sie in den TradingView Alert-Einstellungen als Webhook-URL ein:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Füllen Sie im Message-Feld das obige JSON-Signalformat aus und ersetzen Sie license und key durch Ihre eigenen Werte.</p>`
      },
      {
        title: '3. WikiConnector EA installieren',
        content: `<p>1. Laden Sie den WikiConnector EA (.ex5-Datei) herunter</p>
<p>2. Kopieren Sie den EA in das Verzeichnis <code>MQL5/Experts</code> von MT5</p>
<p>3. Öffnen Sie den EA in MT5 und geben Sie <strong>License ID</strong> und <strong>Secret Key</strong> ein</p>
<p>4. Erlauben Sie dem EA WebSocket-Verbindungen (in MT5-Optionen → EA, Netzwerkverbindungsberechtigung aktivieren)</p>`
      },
      {
        title: '4. Ratenbegrenzung',
        content: `<p>Maximal <strong>30 Anfragen / 60 Sekunden</strong> pro Lizenz. Bei Überschreitung wird ein 429-Fehler zurückgegeben.</p>
<p>Wenn Sie eine höhere Frequenz benötigen, kontaktieren Sie den Kundenservice für ein Upgrade Ihres Tarifs.</p>`
      }
    ],

    faqTitle: 'Häufig gestellte Fragen',
    faqs: [
      {
        q: 'Was tun, wenn der Schlüssel geleakt wurde?',
        a: 'Klicken Sie in der Konsole auf "Neu generieren". Der alte Schlüssel wird sofort ungültig, alle EA-Verbindungen werden getrennt. Konfigurieren Sie den EA mit dem neuen Schlüssel neu.'
      },
      {
        q: 'Werden Signale nach einer EA-Wiederverbindung nachgesendet?',
        a: 'Standardmäßig nicht (zur Verlustvermeidung). Wenn Sie eine Nachsendung benötigen, aktivieren Sie den "Offline-Puffer" in der Konsole. Nach der Wiederverbindung empfängt der EA die während der Offline-Zeit angesammelten Signale.'
      },
      {
        q: 'Wie viele MT-Konten kann eine Lizenz verbinden?',
        a: 'Jede Lizenz unterstützt bis zu 10 gleichzeitige WebSocket-Verbindungen, sodass bis zu 10 MT-Terminals dasselbe Signal gleichzeitig empfangen können.'
      },
      {
        q: 'Wird MT4 unterstützt?',
        a: 'Die aktuelle Version unterstützt hauptsächlich MT5. Eine MT4-Version des EA befindet sich in Entwicklung – bleiben Sie gespannt.'
      },
      {
        q: 'Wie hoch ist die Signallatenz?',
        a: 'Die durchschnittliche Latenz beträgt <100 ms. Mit Tianyan Cloud VPS kann sie auf bis zu 1 ms reduziert werden.'
      },
      {
        q: 'Wie teste ich, ob der Webhook ordnungsgemäß funktioniert?',
        a: 'Überprüfen Sie in der Zertifikatsliste die "Aktuelle Verbindungsanzahl". Ist diese größer als 0, ist der EA online. Senden Sie ein Testsignal und prüfen Sie in den "Letzten Signalaufzeichnungen" den Status "Zugestellt".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script und Signalversand',
        items: [
          {
            q: 'Ich verwende zwei alert() zum Schließen und Eröffnen, aber die Handelsoftware erhält nur ein Signal.',
            a: 'Dies ist die Standardeinschränkung von Pine Script: Innerhalb derselben Kerze wird nur der erste alert() ausgelöst. Die Lösung ist, <strong>jedem alert() den Parameter <code>alert.freq_all</code> hinzuzufügen</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Welche Auslösebedingung soll ich für den Alert wählen?',
            a: 'Bei Verwendung der <code>alert()</code>-Funktion müssen Sie <strong>"Nur alert()-Funktionsaufrufe"</strong> wählen. Bei Verwendung von <code>strategy.entry(..., alert_message=xxx)</code> wählen Sie "Order fills only". Beide Methoden können nicht gemischt werden.'
          },
          {
            q: 'Was muss ich in das Message-Feld eintragen?',
            a: 'Bei Verwendung der <code>alert()</code>-Methode <strong>lassen Sie das Message-Feld standardmäßig leer, tragen Sie nichts ein</strong>. Der Signalinhalt wird durch den String in <code>alert(xxx)</code> im Code bestimmt, und der Webhook empfängt dieses JSON.'
          }
        ]
      },
      {
        title: '🔌 Verbindung und Signalempfang',
        items: [
          {
            q: 'Das EA-Symbol zeigt ein rotes weinendes Gesicht 😞. Was tun?',
            a: 'Überprüfen Sie, ob der "Automatischer Handel"-Button in der Symbolleiste der Handelsoftware grün ist. Wenn er rot ist, klicken Sie ihn, um ihn auf grün zu stellen. Der EA kehrt automatisch in den Normalzustand zurück.'
          },
          {
            q: 'Ich habe ein Signal von TradingView gesendet, aber die Handelsoftware reagiert nicht.',
            a: 'Überprüfen Sie in dieser Reihenfolge:<br>1. Ist der automatische Handel der Handelsoftware grün?<br>2. Zeigt das EA-Panel "Connected" an?<br>3. Ist die Webhook-URL <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. Ist die Alert-Auslösebedingung "Nur alert()-Funktionsaufrufe"?<br>5. Hat jeder alert() <code>alert.freq_all</code> hinzugefügt?<br>6. Stimmen license und key im JSON exakt mit den EA-Einstellungen überein?'
          }
        ]
      },
      {
        title: '💰 Handelsausführung',
        items: [
          {
            q: 'Der Auftrag ist fehlgeschlagen. Was ist die Ursache?',
            a: 'Häufige Ursachen: Unzureichendes Guthaben / Symbolname stimmt nicht überein (Symbol Mapping konfigurieren erforderlich) / Lotgröße überschritten / Slippage zu groß (InpDeviation erhöhen) / Markt geschlossen. Überprüfen Sie das "Experten"-Protokoll unten in der Handelsoftware auf spezifische Fehlerinformationen.'
          },
          {
            q: 'Der Auftrag hat keinen Stop-Loss oder Take-Profit?',
            a: 'Überprüfen Sie: ① Enthält das Signal-JSON Felder wie <code>sl_points</code> / <code>tp_points</code> usw.; ② Sind die Standard-Stop-Loss/Take-Profit-Parameter des EA auf 0 gesetzt. Wenn beide Seiten nicht gesetzt sind, hat der Auftrag keinen Stop-Loss oder Take-Profit.'
          },
          {
            q: 'Der Symbolname stimmt nicht überein. Was tun?',
            a: 'Aktivieren Sie Symbol Mapping in den EA-Parametern:<br>Setzen Sie <code>InpEnableMap1 = true</code><br>Setzen Sie <code>InpMapping1 = XAUUSD|GOLD</code> (TradingView-Symbolname|Handelsoftware-Symbolname)'
          },
          {
            q: 'Kann ich zuerst auf einem Demokonto testen?',
            a: '<strong>Stark empfohlen!</strong> Bei der ersten Verwendung müssen Sie mindestens 1–2 Wochen auf einem Demokonto testen, um sicherzustellen, dass die Verbindung normal ist und die Auftragsausführung korrekt funktioniert, bevor Sie zu einem echten Konto wechseln. Verwenden Sie anfangs die minimale Lotgröße von 0,01.'
          }
        ]
      }
    ]
  },

  // === es Español ===
  es: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Conecta señales de TradingView automáticamente con MetaTrader para ejecutar operaciones',
    heroBtn: 'Empieza gratis',

    stat1Label: 'Latencia media',
    stat2Label: 'Disponibilidad del servicio',
    stat3Label: 'Funcionamiento 24/7',
    stat4Label: 'Distribución multi-cuenta',

    flowSub1: 'Estrategia / Alerta',
    flowSub2: 'Enrutamiento de señales',
    flowSub3: 'Ejecución automática',

    featTitle: 'Por qué elegir WikiConnector',
    featSubtitle: 'Ventajas principales',
    features: [
      {
        icon: '⚡',
        title: 'Ejecución en milisegundos',
        desc: 'Latencia media de señal <100 ms, tan baja como 1 ms con WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Distribución multi-cuenta',
        desc: 'Un certificado conecta múltiples terminales MT y distribuye la misma señal de estrategia simultáneamente.'
      },
      {
        icon: '🔒',
        title: 'Cifrado seguro',
        desc: 'Sistema de claves independiente por usuario, transmisión de datos cifrada de extremo a extremo.'
      },
      {
        icon: '📊',
        title: 'Monitoreo en tiempo real',
        desc: 'Estado de recepción de señales, latencia de ejecución y tasa de éxito visibles en tiempo real.'
      },
      {
        icon: '<>',
        title: 'Generador de código',
        desc: 'Genera visualmente señales JSON y código Pine Script, sin necesidad de programación.'
      },
      {
        icon: '🖥',
        title: 'Integración profunda con VPS',
        desc: 'Sistema de cuentas compartido con Tianyun Cloud VPS, funcionamiento 24/7 con baja latencia.'
      }
    ],

    stepsTitle: 'Cuatro pasos para empezar con el trading automatizado',
    stepsSubtitle: 'Inicio rápido',
    steps: [
      {
        title: 'Iniciar sesión',
        desc: 'Inicia sesión con tu cuenta de WikiFX y obtén automáticamente tu clave y licencia exclusivas.'
      },
      {
        title: 'Configurar Webhook',
        desc: 'Copia la URL del Webhook en la configuración de Alertas de TradingView.'
      },
      {
        title: 'Instalar EA',
        desc: 'Descarga el EA de WikiConnector e ingresa tu License ID y Secret Key.'
      },
      {
        title: 'Trading automático',
        desc: 'Cuando tu estrategia active una Alerta, la señal se enviará automáticamente al terminal MT para su ejecución.'
      }
    ],

    loginTip: 'Después de iniciar sesión, podrás ver tu clave y certificado exclusivos',
    loginBtn: 'Iniciar sesión ahora',

    navConn: 'Gestión de conexiones',
    navLog: 'Registro de señales',
    navGen: 'Generador de código',
    navParams: 'Referencia rápida de parámetros',
    navDl: 'Descargas',
    navDoc: 'Tutorial de uso',
    navFaq: 'Preguntas frecuentes',

    keyLabel: 'Secret Key',
    keyTip1: 'No lo compartas con nadie',
    keyTip2: 'Se usa para la autenticación del EA',
    keyTip3: 'Después de restablecerlo, la clave anterior queda inmediatamente inválida',

    connSubtitle: 'A continuación se muestran tus Licencias y sus correspondientes URLs de Webhook',
    noLicense: 'No hay Licencia disponible. Ponte en contacto con el servicio de atención al cliente',
    needHelp: '¿Necesitas ayuda?',
    viewDoc: 'Ver tutorial de uso',

    allLicense: 'Todas las Licencias',
    allStatus: 'Todos los estados',
    refresh: 'Actualizar',
    signalId: 'ID de señal',
    total: 'Total',
    records: 'registros',

    genIntro: 'Completa los siguientes parámetros para generar automáticamente señales JSON y código Pine Script utilizables en Alertas de TradingView.',
    genAuth: 'Información de autenticación',
    required: 'Obligatorio',
    optional: 'Opcional',
    genLicPlaceholder: 'Ingresa tu License ID',
    genLicHint: 'Puedes consultarlo en la página de gestión de conexiones',
    genKeyPlaceholder: 'Ingresa tu Secret Key',
    genKeyHint: 'Puedes consultarlo en la página de gestión de conexiones',
    genTrade: 'Orden de trading',
    genCmd: 'Tipo de orden',
    genMarket: 'Orden de mercado',
    genPending: 'Orden pendiente',
    genClose: 'Cierre',
    cmdBuy: 'Compra a mercado',
    cmdSell: 'Venta a mercado',
    cmdBuyLimit: 'Compra limitada',
    cmdSellLimit: 'Venta limitada',
    cmdBuyStop: 'Compra por ruptura',
    cmdSellStop: 'Venta por ruptura',
    cmdCloseBuy: 'Cerrar posiciones largas',
    cmdCloseSell: 'Cerrar posiciones cortas',
    cmdCloseAll: 'Cerrar este símbolo',
    cmdCloseAllOrders: 'Cerrar todo',
    genSlTpHint: 'Elige uno de tres · Prioridad: Precio > Puntos > Porcentaje',
    genTsHint: 'Hora de envío de la señal',
    genTsBtn: 'Hora actual',
    presetSimple: '📝 Compra simple',
    presetSltp: '🛡 Con stop loss y take profit',
    presetFull: '📋 Parámetros completos',
    presetClose: '❌ Señal de cierre',
    presetPending: '📌 Orden pendiente',
    presetReverse: '🔄 Inversión (cierre + apertura)',
    genAlertTab: '🔔 Explicación de configuración de Alerta',
    toastIncomplete: 'Información incompleta. Por favor, completa los campos obligatorios',
    toastRegen: 'Se ha generado una nueva clave. Cópiala inmediatamente y actualiza todos los EA configurados',
    toastKeyCopied: 'Clave copiada',
    toastCopied: 'Copiado',
    toastCodeCopied: 'Código copiado',
    copyTitle: 'Copiar',
    genSymbol: 'Símbolo de trading',
    genPrice: 'Precio de orden pendiente',
    genParams: 'Parámetros de trading',
    genLots: 'Volumen (lotes)',
    genLotsHint: 'Déjalo vacío para usar el valor predeterminado del EA',
    genMagic: 'Magic Number',
    genMagicHint: 'Se utiliza para distinguir órdenes de diferentes estrategias',
    genComment: 'Comentario de la orden',
    genCommentHint: 'Ejemplo: Strategy A',
    genSL: 'Configuración de stop loss',
    genPoints: 'Puntos',
    genPrice2: 'Precio fijo',
    genPct: 'Porcentaje %',
    genTP: 'Configuración de take profit',
    genAdvanced: 'Parámetros avanzados',
    genSigIdHint: 'Déjalo vacío para que se genere automáticamente, se usa para evitar duplicados',
    genGenId: 'Generar automáticamente',
    genBtn: 'Generar código',
    genFormat: 'Formato de señal',
    genGuideTitle: 'Cómo usarlo en TradingView',
    genGuideSteps: [
      'Crea una <strong>Alerta (Alert)</strong> en tu gráfico de TradingView',
      'En <strong>Condición de activación de la Alerta</strong>, selecciona tu estrategia o indicador',
      'Expande <strong>Notificaciones (Notifications)</strong> → marca <strong>Webhook URL</strong>',
      'Introduce la URL del Webhook: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Pega el JSON generado arriba en el cuadro <strong>Mensaje (Message)</strong>',
      'Haz clic en <strong>Crear (Create)</strong> para guardar la Alerta'
    ],
    genGuideNote: '<strong>Consejo:</strong> Si usas Pine Script, añade el código generado a tu script y usa el parámetro <code>alert_message</code> en <code>strategy.entry()</code> o <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Autorización) — Debe modificarse',
        rows: [
          ['License', '—', 'ID de autorización, debe coincidir exactamente con el campo license en el JSON de la señal', 'req'],
          ['SecretKey', '—', 'Clave de seguridad (comienza con wc_sk_), debe coincidir exactamente con el campo key en el JSON de la señal', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Parámetros de trading predeterminados)',
        rows: [
          ['InpLots', '0.1', 'Volumen predeterminado, se usa cuando el JSON de la señal no incluye lots', ''],
          ['InpMagic', '888', 'Magic Number predeterminado, para distinguir órdenes de diferentes estrategias', ''],
          ['InpComment', 'TV Signal', 'Comentario de orden predeterminado', ''],
          ['InpDeviation', '30', 'Deslizamiento máximo (puntos), para Forex 10–30, para Oro/Índices 30–50 recomendado', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Prioridad: sl_price (precio fijo) > sl_points (puntos) > sl_pct (porcentaje). Si los tres son 0, no se establece stop loss, igual para take profit',
        rows: [
          ['InpSLPoints', '0', 'Puntos de stop loss predeterminados (0 = desactivado)', ''],
          ['InpSLPrice', '0', 'Precio fijo de stop loss predeterminado (0 = desactivado, prioridad máxima)', ''],
          ['InpSLPct', '0', 'Porcentaje de stop loss predeterminado (0 = desactivado)', ''],
          ['InpTPPoints', '0', 'Puntos de take profit predeterminados (0 = desactivado)', ''],
          ['InpTPPrice', '0', 'Precio fijo de take profit predeterminado (0 = desactivado)', ''],
          ['InpTPPct', '0', 'Porcentaje de take profit predeterminado (0 = desactivado)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Mapeo de nombres de símbolos)',
        note: 'Los brókers pueden usar nombres de símbolos diferentes (ej: TradingView llama XAUUSD, tu bróker lo llama GOLD). El mapeo permite la conversión automática',
        rows: [
          ['InpPrefix', '(vacío)', 'Prefijo del nombre del símbolo, si el símbolo del bróker es m.EURUSD, introduce m.', ''],
          ['InpSuffix', '(vacío)', 'Sufijo del nombre del símbolo, si el símbolo del bróker es EURUSD.pro, introduce .pro', ''],
          ['InpEnableMap1~5', 'false', 'Establécelo en true para activar la regla de mapeo correspondiente', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Regla de mapeo, formato: NombreTradingView|NombreMT5, soporta hasta 5 reglas', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Igual que arriba', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Igual que arriba', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Igual que arriba', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Igual que arriba', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Filtro de tiempo / Visualización y registro)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Cuando está activado, solo procesa señales entre StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Hora de inicio permitida para trading (hora del servidor MT5, formato HH:MM)', ''],
          ['InpEndTime', '23:59', 'Hora de finalización permitida para trading', ''],
          ['InpShowPanel', 'true', 'Muestra un panel informativo con estado de conexión y estadísticas de señales en el gráfico', ''],
          ['InpUpdateInterval', '1000', 'Intervalo de actualización del panel (ms), se recomienda 1000~3000', ''],
          ['InpLogLevel', '1', 'Nivel de registro: 0=desactivado 1=básico 2=detallado 3=depuración (usa 2 o 3 para solucionar problemas)', ''],
          ['InpLogToFile', 'true', 'Escribe archivo de registro en MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Salida en la pestaña "Expertos" en la parte inferior de MT5', ''],
          ['InpMaxLogMB', '5', 'Tamaño máximo del archivo de registro (MB), rotación automática al excederse', '']
        ]
      }
    ],

    paramsEATitle: 'Explicación de parámetros del EA',
    paramsEADesc: 'Los siguientes parámetros se pueden configurar al abrir el EA en MT5, y también se pueden sobrescribir mediante los campos correspondientes en el JSON de la señal.',
    paramName: 'Nombre del parámetro',
    paramDefault: 'Valor predeterminado',
    paramDesc: 'Descripción',
    paramOverride: 'Campo de sobrescritura en JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'Volumen predeterminado (se usa cuando el JSON no lo especifica)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number predeterminado', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Comentario de orden predeterminado', 'comment'],
      ['SlippagePoints', '3', 'Deslizamiento máximo (puntos)', '—'],
      ['OfflineBuffer', 'false', 'Activar búfer fuera de línea', '—'],
      ['ReconnectSeconds', '5', 'Intervalo de reconexión de WebSocket (segundos)', '—']
    ],
    cmdTableTitle: 'Explicación de tipos de órdenes',
    cmdCol: 'Orden (cmd)',
    typeCol: 'Tipo',
    actionCol: 'Acción',
    extraCol: 'Parámetros adicionales',
    cmdTable: [
      ['buy', 'Orden de mercado', 'Comprar inmediatamente', 'lots, sl_*, tp_*'],
      ['sell', 'Orden de mercado', 'Vender inmediatamente', 'lots, sl_*, tp_*'],
      ['buylimit', 'Orden pendiente', 'Comprar al alcanzar el precio', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Orden pendiente', 'Vender al alcanzar el precio', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Orden pendiente', 'Comprar en ruptura', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Orden pendiente', 'Vender en ruptura', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Cierre', 'Cerrar todas las posiciones largas', 'magic (opcional)'],
      ['closesell', 'Cierre', 'Cerrar todas las posiciones cortas', 'magic (opcional)'],
      ['closeall', 'Cierre', 'Cerrar todas las posiciones abiertas', '—'],
      ['closeallorders', 'Cierre', 'Eliminar todas las órdenes pendientes', '—']
    ],
    jsonFieldTitle: 'Explicación de campos JSON',
    fieldCol: 'Nombre del campo',
    requiredCol: 'Obligatorio',
    descCol: 'Descripción',
    jsonFields: [
      ['license', 'string', 'Obligatorio', 'License ID'],
      ['key', 'string', 'Obligatorio', 'Secret Key'],
      ['cmd', 'string', 'Obligatorio', 'Orden de trading, ver tabla arriba'],
      ['symbol', 'string', 'Obligatorio', 'Símbolo de trading, ej. EURUSD'],
      ['lots', 'number', 'Opcional', 'Volumen, dejar vacío para usar valor predeterminado del EA'],
      ['price', 'number', 'Obligatorio para orden pendiente', 'Precio de orden pendiente'],
      ['sl_points', 'number', 'Opcional', 'Puntos de stop loss'],
      ['sl_price', 'number', 'Opcional', 'Precio fijo de stop loss'],
      ['sl_pct', 'number', 'Opcional', 'Porcentaje de stop loss (0-100)'],
      ['tp_points', 'number', 'Opcional', 'Puntos de take profit'],
      ['tp_price', 'number', 'Opcional', 'Precio fijo de take profit'],
      ['tp_pct', 'number', 'Opcional', 'Porcentaje de take profit (0-100)'],
      ['magic', 'number', 'Opcional', 'Magic Number'],
      ['comment', 'string', 'Opcional', 'Comentario de la orden'],
      ['signalid', 'string', 'Opcional', 'ID único de señal, para evitar duplicados'],
      ['expiryseconds', 'number', 'Opcional', 'Período de validez de la señal (segundos), predeterminado 60']
    ],

    dlMt5Desc: 'Versión MT5 del EA, compatible con todas las órdenes, recomendada',
    dlMt5Btn: 'Descargar MT5 EA',
    dlMt4Desc: 'Versión MT4 del EA, en desarrollo, permanece atento',
    dlMt4Dev: 'En desarrollo',
    dlInstallDoc: `<h4>Instrucciones de instalación</h4>
<ol>
<li>Descarga el archivo <code>WikiConnector_MT5.ex5</code></li>
<li>Abre MT5, barra de menú → <strong>Archivo → Abrir carpeta de datos</strong></li>
<li>Copia el archivo <code>.ex5</code> en el directorio <code>MQL5/Experts/</code></li>
<li>Presiona <strong>F5</strong> en MT5 para actualizar el navegador y encontrar el EA WikiConnector</li>
<li>Arrastra el EA a cualquier gráfico e introduce <strong>License ID</strong> y <strong>Secret Key</strong></li>
<li>En las opciones del EA, marca <strong>Permitir WebRequest</strong> y añade <code>api-gw.interface003.com</code> a la lista de URLs permitidas</li>
</ol>`,

    disclaimerTitle: 'Descargo de responsabilidad sobre riesgos',
    disclaimerContent: `<p>Antes de descargar y usar WikiConnector EA, lee atentamente el siguiente descargo de responsabilidad:</p>
<p><strong>1. Riesgo de trading</strong><br/>El trading de divisas y CFD conlleva riesgos significativos que pueden resultar en la pérdida total o parcial del capital. WikiConnector es solo una herramienta de transmisión de señales y no asume ninguna responsabilidad por los resultados de las operaciones.</p>
<p><strong>2. Riesgo de estrategia</strong><br/>El rendimiento pasado de las estrategias de trading automatizado no garantiza resultados futuros. Realiza pruebas exhaustivas antes de usarlas en cuentas reales.</p>
<p><strong>3. Riesgo técnico</strong><br/>Factores técnicos como la latencia de red, fallos del servidor y limitaciones de API pueden causar pérdida de señales o retrasos en la ejecución. No uses esta herramienta para estrategias de alta frecuencia sensibles a la latencia.</p>
<p><strong>4. Responsabilidad del usuario</strong><br/>El usuario asume toda la responsabilidad por todos los resultados de trading derivados del uso de WikiConnector EA. WikiFX no proporciona asesoramiento de inversión ni asume responsabilidad por ganancias o pérdidas de trading.</p>`,
    disclaimerAgree: 'He leído y acepto el descargo de responsabilidad anterior y entiendo los riesgos del trading',
    disclaimerDownload: 'Aceptar y descargar',

    regenTitle: '¿Confirmar restablecimiento de clave?',
    regenSubtitle: 'Esta acción no se puede deshacer. Por favor, confirma que entiendes las siguientes consecuencias:',
    regenWarnings: ['Todos los EA configurados con esta clave se <strong>desconectarán inmediatamente</strong>', 'La clave anterior quedará <strong>permanentemente inválida</strong> y no se podrá recuperar', 'Debes actualizar manualmente la configuración de Secret Key en todos los EA', 'Existe riesgo de <strong>pérdida de señales</strong> durante el restablecimiento'],

    dashTitle: 'Mi WikiConnector',
    myKey: 'Mi Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Copiar',
    regenBtn: 'Regenerar',
    regenConfirm: 'Después de regenerar la clave, todos los EA conectados se desconectarán y será necesario reconfigurarlos. ¿Continuar?',
    regenConfirmBtn: 'Confirmar restablecimiento',
    cancelBtn: 'Cancelar',
    copiedTip: 'Copiado',

    licenseTitle: 'Mis Certificados (License)',
    licenseId: 'ID del Certificado',
    maxConn: 'Conexiones máximas',
    activeConn: 'Conexión actual',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Estadísticas de señales',
    statTotal: 'Total de señales',
    statDelivered: 'Entregadas',
    statFailed: 'Fallidas',
    statConnections: 'Conexiones actuales',

    signalTitle: 'Registros de señales recientes',
    signalTime: 'Hora',
    signalCmd: 'Orden',
    signalSymbol: 'Símbolo',
    signalLots: 'Volumen',
    signalStatus: 'Estado',
    signalLicense: 'Certificado',
    statusDelivered: 'Entregada',
    statusPending: 'Pendiente',
    statusFailed: 'Fallida',
    statusExpired: 'Expirada',
    noSignal: 'Aún no hay registros de señales',
    loadMore: 'Cargar más',

    offlineBuffer: 'Búfer fuera de línea',
    offlineBufferDesc: 'Cuando está activado, las señales acumuladas durante el período fuera de línea se entregarán al reconectarse el EA (desactivado por defecto para evitar pérdidas)',

    docTitle: 'Tutorial de uso',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Cómo funciona WikiConnector</p>
  <p>WikiConnector recibe señales de TradingView en tiempo real a través de una <strong>conexión persistente WebSocket</strong> y ejecuta operaciones automáticamente en el software de trading.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Instalar el EA en el software de trading</p>
  <ol class="doc-steps">
    <li><strong>Abrir carpeta de datos</strong>: Menú del software de trading → Archivo → Abrir carpeta de datos</li>
    <li><strong>Copiar archivo EA</strong>: Copia el archivo EA en el directorio <code>Experts/</code></li>
    <li><strong>Actualizar el navegador</strong>: Abre el navegador → haz clic derecho en "Asesores Expertos" → Actualizar. <strong>SignalReceiver</strong> debería aparecer en la lista</li>
    <li><strong>Activar trading automático</strong>: El botón "Trading automático" en la barra de herramientas superior debe estar 🟢 verde</li>
    <li><strong>Aplicar al gráfico</strong>: Arrastra SignalReceiver a cualquier gráfico. Cuando aparezca la ventana de configuración, ajusta los parámetros</li>
  </ol>
  <div class="doc-tip"><strong>Consejo:</strong> Solo necesitas aplicar el EA en un gráfico para procesar señales de todos los símbolos. No es necesario aplicarlo en cada gráfico individualmente.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Configurar los parámetros del EA</p>
  <p>Hay dos tipos de parámetros: <strong>obligatorios</strong> (License / SecretKey) y <strong>parámetros predeterminados</strong> (se usan cuando el JSON de la señal no incluye un campo específico; los valores de la señal siempre tienen prioridad sobre los valores predeterminados del EA).</p>
  <div class="doc-warn"><strong>Advertencia de seguridad:</strong> License y SecretKey son la única barrera para proteger tu cuenta. Si se filtran, cualquiera podría enviar órdenes de trading a tu software de trading. No hagas capturas de pantalla ni los compartas con otros. Se recomienda cambiar el SecretKey periódicamente.</div>
  <p>Una vez completada la configuración, aparecerá el nombre del EA + <strong>😊</strong> en la esquina superior derecha del gráfico, indicando que está conectado al servidor. Si aparece 😞, verifica que el botón "Trading automático" esté en verde.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Escribir código Pine Script para la señal</p>
  <p>WikiConnector utiliza la función <code>alert()</code> para activar señales, no el método <code>strategy.entry(alert_message=)</code>. Son mecanismos diferentes, no los mezcles.</p>
  <div class="doc-danger"><strong>Importante: alert.freq_all</strong> — Por defecto, en Pine Script solo se activa el primer <code>alert()</code> dentro de la misma vela, y los siguientes se descartan silenciosamente. Si necesitas enviar múltiples señales consecutivas (por ejemplo, en una inversión: primero cerrar corto y luego abrir largo), debes añadir <code>alert.freq_all</code> a cada <code>alert()</code>, de lo contrario la segunda señal nunca llegará al servidor.</div>
<pre>//@version=6
strategy("Estrategia WikiConnector", overlay=true)

// Definir mensajes de señal (reemplaza YOUR_LICENSE y YOUR_KEY con tus propios valores)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Ejemplo de condiciones de estrategia (cruce de medias móviles 3/13)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Usar alert.freq_all para asegurar que múltiples señales se envíen dentro de la misma vela
if longCondition
    alert(closesellMessage, alert.freq_all)  // Primero cerrar posiciones cortas
    alert(buyMessage,       alert.freq_all)  // Luego abrir posición larga

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Primero cerrar posiciones largas
    alert(sellMessage,     alert.freq_all)   // Luego abrir posición corta</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Crear una Alerta en TradingView</p>
  <p>URL del Webhook:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Haz clic derecho en el gráfico → "<strong>Añadir Alerta...</strong>" o <strong>Alt+A</strong></li>
    <li>Como condición de activación, selecciona <strong>"Solo llamadas a la función alert()"</strong> (¡importante!)</li>
    <li>Elige una fecha de caducidad lo más larga posible, o "Sin caducidad"</li>
    <li>El cuadro de Mensaje <strong>déjalo por defecto, no introduzcas nada</strong> (el contenido de la señal lo determina alert() en el código)</li>
    <li>Configuración de notificaciones: marca <strong>Webhook URL</strong> e introduce la dirección anterior; <strong>desmarca "Enviar texto plano"</strong></li>
    <li>Haz clic en "Crear" para guardar la Alerta</li>
  </ol>
  <div class="doc-tip"><strong>Consejo:</strong> La función Webhook requiere una suscripción TradingView Pro o superior.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Explicación del formato JSON de la señal</p>
  <p><strong>Campos obligatorios:</strong><code>license</code> (ID de autorización), <code>key</code> (clave), <code>cmd</code> (orden), <code>symbol</code> (nombre del símbolo)</p>
  <p><strong>Campos opcionales:</strong><code>lots</code> (volumen), <code>price</code> (precio de orden pendiente), <code>sl_points / sl_price / sl_pct</code> (stop loss triple opción), <code>tp_points / tp_price / tp_pct</code> (take profit triple opción), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (predeterminado 300 segundos)</p>
  <p><strong>Órdenes compatibles:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Prioridad de stop loss/take profit:</strong><code>sl_price</code> (precio fijo)&gt; <code>sl_points</code> (puntos)&gt; <code>sl_pct</code> (porcentaje). Si los tres son 0, no se establece stop loss, igual para take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Lista de verificación antes de operar</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Botón de trading automático del software de trading 🟢 verde</li>
    <li class="ok">✅ EA en la esquina superior derecha del gráfico muestra 😊 (conectado al servidor)</li>
    <li class="ok">✅ License / SecretKey coinciden exactamente con los valores en el JSON de TradingView</li>
    <li class="ok">✅ Condición de activación de la Alerta "<strong>Solo llamadas a la función alert()</strong>"</li>
    <li class="ok">✅ Cada <code>alert()</code> tiene <code>alert.freq_all</code> añadido</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Cuadro de Mensaje dejado por defecto, sin contenido</li>
    <li class="no">❌ Desmarcado "Enviar texto plano"</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Consejos de seguridad y riesgo</p>
  <div class="doc-warn">
    <strong>Seguridad de la cuenta:</strong><br>
    · No hagas capturas de pantalla de License y SecretKey ni los compartas con nadie<br>
    · Si sospechas que la clave se ha filtrado, restablece el SecretKey inmediatamente en la consola<br>
    · Se recomienda cambiar el SecretKey periódicamente
  </div>
  <div class="doc-warn">
    <strong>Control de riesgos de trading:</strong><br>
    · Establece siempre un stop loss, nunca ejecutes estrategias automatizadas sin protección<br>
    · Se recomienda que el riesgo por operación no supere el 1-2% del saldo de la cuenta<br>
    · Se recomienda pausar el trading automático antes de eventos económicos importantes (NFP, IPC, FOMC)
  </div>
  <div class="doc-tip">
    <strong>Mejores prácticas:</strong><br>
    · Prueba primero en una cuenta demo durante al menos 1-2 semanas para confirmar que el enlace funciona correctamente antes de cambiar a una cuenta real<br>
    · En la cuenta real, comienza con el volumen mínimo (0.01 lote)<br>
    · Utiliza un VPS (como Tianyun Cloud VPS) para mantener el software de trading y el EA en línea las 24 horas
  </div>
</div>`,
    docSections: [
      {
        title: '1. Formato de señal Webhook',
        content: `En el cuadro de Mensaje de la Alerta de TradingView, introduce el siguiente JSON:
<pre>{
  "license": "{{tuLicenseID}}",
  "key": "{{tuSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Órdenes <strong>cmd</strong> compatibles: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. Dirección Webhook de TradingView',
        content: `<p>En la configuración de la Alerta de TradingView, introduce la siguiente URL de Webhook:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>En el cuadro de Mensaje, introduce el formato JSON de señal anterior y reemplaza license y key con tus propios valores.</p>`
      },
      {
        title: '3. Instalar WikiConnector EA',
        content: `<p>1. Descarga el WikiConnector EA (archivo .ex5)</p>
<p>2. Copia el EA en el directorio <code>MQL5/Experts</code> de MT5</p>
<p>3. Abre el EA en MT5 e introduce <strong>License ID</strong> y <strong>Secret Key</strong></p>
<p>4. Permite que el EA realice conexiones WebSocket (en Opciones de MT5 → EA, activa el permiso de conexión de red)</p>`
      },
      {
        title: '4. Límites de frecuencia',
        content: `<p>Máximo <strong>30 solicitudes / 60 segundos</strong> por Licencia. Superar el límite devolverá un error 429.</p>
<p>Si necesitas una frecuencia mayor, contacta con el servicio de atención al cliente para mejorar tu plan.</p>`
      }
    ],

    faqTitle: 'Preguntas frecuentes',
    faqs: [
      {
        q: '¿Qué hago si mi clave se ha filtrado?',
        a: 'Haz clic en "Regenerar" en la consola. La clave antigua quedará inmediatamente inválida y todas las conexiones de EA se interrumpirán. Vuelve a configurar el EA con la nueva clave.'
      },
      {
        q: '¿Se reenviarán las señales después de que el EA se reconecte?',
        a: 'Por defecto no se reenvían (para evitar pérdidas). Si necesitas reenvío, activa el "Búfer fuera de línea" en la consola. Cuando el EA se reconecte, recibirá las señales acumuladas durante el período fuera de línea.'
      },
      {
        q: '¿Cuántas cuentas MT puede conectar una Licencia?',
        a: 'Cada Licencia admite hasta 10 conexiones WebSocket simultáneas, por lo que hasta 10 terminales MT pueden recibir la misma señal al mismo tiempo.'
      },
      {
        q: '¿Es compatible con MT4?',
        a: 'La versión actual es compatible principalmente con MT5. La versión para MT4 del EA está en desarrollo. ¡Permanece atento!'
      },
      {
        q: '¿Cuál es la latencia de la señal?',
        a: 'La latencia media es <100 ms. Con Tianyun Cloud VPS, puede ser tan baja como 1 ms.'
      },
      {
        q: '¿Cómo pruebo si el Webhook funciona correctamente?',
        a: 'En la lista de certificados, verifica el "Número de conexiones actuales". Si es mayor que 0, el EA está en línea. Después de enviar una señal de prueba, revisa los "Registros de señales recientes" para ver el estado "Entregada".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script y envío de señales',
        items: [
          {
            q: 'Uso dos alert() para cerrar y abrir, pero el software de trading solo recibe una señal.',
            a: 'Esta es la limitación predeterminada de Pine Script: dentro de la misma vela, solo se activa el primer alert(). La solución es <strong>añadir el parámetro <code>alert.freq_all</code> a cada alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: '¿Qué condición de activación debo elegir para la Alerta?',
            a: 'Al usar la función <code>alert()</code>, debes seleccionar <strong>"Solo llamadas a la función alert()"</strong>. Si usas el método <code>strategy.entry(..., alert_message=xxx)</code>, selecciona "Order fills only". No se pueden mezclar ambos métodos.'
          },
          {
            q: '¿Qué debo poner en el cuadro de Mensaje?',
            a: 'Al usar el método <code>alert()</code>, <strong>deja el cuadro de Mensaje por defecto, no introduzcas nada</strong>. El contenido de la señal lo determina el string dentro de <code>alert(xxx)</code> en el código, y el Webhook recibirá ese JSON.'
          }
        ]
      },
      {
        title: '🔌 Conexión y recepción de señales',
        items: [
          {
            q: 'El icono del EA muestra una cara roja llorando 😞. ¿Qué hago?',
            a: 'Verifica si el botón "Trading automático" en la barra de herramientas del software de trading está verde. Si está rojo, haz clic para cambiarlo a verde. El EA volverá automáticamente al estado normal.'
          },
          {
            q: 'Envié una señal desde TradingView pero el software de trading no responde.',
            a: 'Verifica en este orden:<br>1. ¿Está verde el trading automático del software de trading?<br>2. ¿El panel del EA muestra "Connected"?<br>3. ¿La URL del Webhook es <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. ¿La condición de activación de la Alerta es "Solo llamadas a la función alert()"?<br>5. ¿Cada alert() tiene <code>alert.freq_all</code> añadido?<br>6. ¿Coinciden exactamente license y key en el JSON con la configuración del EA?'
          }
        ]
      },
      {
        title: '💰 Ejecución de trading',
        items: [
          {
            q: 'La orden falló. ¿Cuál es la causa?',
            a: 'Causas comunes: Saldo insuficiente / El nombre del símbolo no coincide (se necesita configurar Symbol Mapping) / Volumen excedido / Deslizamiento demasiado grande (aumentar InpDeviation) / Mercado cerrado. Revisa el registro de "Expertos" en la parte inferior del software de trading para obtener información específica del error.'
          },
          {
            q: 'La orden no tiene stop loss o take profit.',
            a: 'Verifica: ① ¿El JSON de la señal incluye campos como <code>sl_points</code> / <code>tp_points</code> etc.?; ② ¿Los parámetros predeterminados de stop loss/take profit del EA están en 0? Si ninguno está configurado, la orden no tendrá stop loss ni take profit.'
          },
          {
            q: 'El nombre del símbolo no coincide. ¿Qué hago?',
            a: 'Activa Symbol Mapping en los parámetros del EA:<br>Establece <code>InpEnableMap1 = true</code><br>Establece <code>InpMapping1 = XAUUSD|GOLD</code> (NombreTradingView|NombreSoftwareTrading)'
          },
          {
            q: '¿Puedo probar primero en una cuenta demo?',
            a: '<strong>¡Altamente recomendado!</strong> En el primer uso, debes probar en una cuenta demo durante al menos 1-2 semanas para confirmar que el enlace funciona correctamente y la ejecución de órdenes es correcta antes de cambiar a una cuenta real. Comienza con el volumen mínimo de 0.01 lote.'
          }
        ]
      }
    ]
  },

  // === fil Filipino (Tagalog) ===
  fil: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Ikonekta ang mga signal ng TradingView sa MetaTrader nang awtomatiko para mag-execute ng trades',
    heroBtn: 'Magsimula nang libre',

    stat1Label: 'Average na latency',
    stat2Label: 'Availability ng serbisyo',
    stat3Label: '24/7 na operasyon',
    stat4Label: 'Multi-account distribution',

    flowSub1: 'Strategy / Alert',
    flowSub2: 'Signal routing',
    flowSub3: 'Awtomatikong execution',

    featTitle: 'Bakit piliin ang WikiConnector',
    featSubtitle: 'Mga pangunahing bentahe',
    features: [
      {
        icon: '⚡',
        title: 'Execution sa millisecond',
        desc: 'Average na signal latency <100ms, kasing-baba ng 1ms gamit ang WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Multi-account distribution',
        desc: 'Isang certificate ang nagkokonekta ng maraming MT terminal, sabay-sabay na namamahagi ng parehong strategy signal.'
      },
      {
        icon: '🔒',
        title: 'Secure encryption',
        desc: 'Independent key system bawat user, full-chain encrypted data transmission.'
      },
      {
        icon: '📊',
        title: 'Real-time monitoring',
        desc: 'Katayuan ng pagtanggap ng signal, execution latency, at success rate makikita sa real time.'
      },
      {
        icon: '<>',
        title: 'Code generator',
        desc: 'Biswal na bumubuo ng JSON signal at Pine Script code, hindi kailangan ng programming.'
      },
      {
        icon: '🖥',
        title: 'Malalim na integrasyon sa VPS',
        desc: 'Pinaghahati ang account system sa Tianyun Cloud VPS, 24/7 low-latency operation.'
      }
    ],

    stepsTitle: 'Apat na hakbang para simulan ang automated trading',
    stepsSubtitle: 'Mabilis na pagsisimula',
    steps: [
      {
        title: 'Mag-login',
        desc: 'Mag-login gamit ang iyong WikiFX account, awtomatikong makukuha ang iyong eksklusibong key at License.'
      },
      {
        title: 'I-configure ang Webhook',
        desc: 'Kopyahin ang Webhook URL sa TradingView Alert settings.'
      },
      {
        title: 'I-install ang EA',
        desc: 'I-download ang WikiConnector EA at ilagay ang License ID at Secret Key.'
      },
      {
        title: 'Awtomatikong trading',
        desc: 'Kapag na-trigger ng strategy ang Alert, awtomatikong ipapadala ang signal sa MT terminal para i-execute.'
      }
    ],

    loginTip: 'Pagkatapos mag-login, makikita mo ang iyong eksklusibong key at certificate',
    loginBtn: 'Mag-login na',

    navConn: 'Pamamahala ng koneksyon',
    navLog: 'Signal log',
    navGen: 'Code generator',
    navParams: 'Mabilisang sanggunian ng parameter',
    navDl: 'I-download',
    navDoc: 'Gabay sa paggamit',
    navFaq: 'Mga madalas itanong',

    keyLabel: 'Secret Key',
    keyTip1: 'Huwag ibahagi kaninuman',
    keyTip2: 'Ginagamit para sa EA authentication',
    keyTip3: 'Pagkatapos i-reset, agad na magiging invalid ang lumang key',

    connSubtitle: 'Nasa ibaba ang iyong mga License at ang katumbas nilang Webhook URL',
    noLicense: 'Walang License. Mangyaring makipag-ugnayan sa customer service',
    needHelp: 'Kailangan ng tulong?',
    viewDoc: 'Tingnan ang gabay sa paggamit',

    allLicense: 'Lahat ng License',
    allStatus: 'Lahat ng katayuan',
    refresh: 'I-refresh',
    signalId: 'Signal ID',
    total: 'Kabuuan',
    records: 'record',

    genIntro: 'Punan ang mga sumusunod na parameter para awtomatikong makabuo ng JSON signal at Pine Script code na magagamit sa TradingView Alert.',
    genAuth: 'Impormasyon ng authentication',
    required: 'Kinakailangan',
    optional: 'Opsyonal',
    genLicPlaceholder: 'Ilagay ang iyong License ID',
    genLicHint: 'Makikita sa page ng pamamahala ng koneksyon',
    genKeyPlaceholder: 'Ilagay ang iyong Secret Key',
    genKeyHint: 'Makikita sa page ng pamamahala ng koneksyon',
    genTrade: 'Trade order',
    genCmd: 'Uri ng order',
    genMarket: 'Market order',
    genPending: 'Pending order',
    genClose: 'Isara',
    cmdBuy: 'Bumili sa market',
    cmdSell: 'Magbenta sa market',
    cmdBuyLimit: 'Limitadong pagbili',
    cmdSellLimit: 'Limitadong pagbenta',
    cmdBuyStop: 'Breakout na pagbili',
    cmdSellStop: 'Breakout na pagbenta',
    cmdCloseBuy: 'Isara ang long positions',
    cmdCloseSell: 'Isara ang short positions',
    cmdCloseAll: 'Isara ang simbolo',
    cmdCloseAllOrders: 'Isara lahat',
    genSlTpHint: 'Pumili ng isa sa tatlo · Priyoridad: Presyo > Puntos > Porsyento',
    genTsHint: 'Oras ng pagpapadala ng signal',
    genTsBtn: 'Kasalukuyang oras',
    presetSimple: '📝 Simpleng pagbili',
    presetSltp: '🛡 May stop loss at take profit',
    presetFull: '📋 Kumpletong parameter',
    presetClose: '❌ Signal ng pagsasara',
    presetPending: '📌 Pending order',
    presetReverse: '🔄 Baliktad (isara + buksan)',
    genAlertTab: '🔔 Paliwanag ng setting ng Alert',
    toastIncomplete: 'Hindi kumpleto ang impormasyon. Pakiusap punan ang mga kinakailangang field',
    toastRegen: 'Nagenerate na ang bagong key. Kopyahin ito agad at i-update ang lahat ng naka-configure na EA',
    toastKeyCopied: 'Nakopya na ang key',
    toastCopied: 'Nakopya na',
    toastCodeCopied: 'Nakopya na ang code',
    copyTitle: 'Kopyahin',
    genSymbol: 'Simbolo ng trading',
    genPrice: 'Presyo ng pending order',
    genParams: 'Mga parameter ng trading',
    genLots: 'Laki ng lot',
    genLotsHint: 'Iwanang blangko para gamitin ang default ng EA',
    genMagic: 'Magic Number',
    genMagicHint: "Ginagamit para pag-ibahin ang orders ng iba't ibang strategy",
    genComment: 'Komento ng order',
    genCommentHint: 'Halimbawa: Strategy A',
    genSL: 'Setting ng stop loss',
    genPoints: 'Puntos',
    genPrice2: 'Fixed na presyo',
    genPct: 'Porsyento %',
    genTP: 'Setting ng take profit',
    genAdvanced: 'Mga advanced na parameter',
    genSigIdHint: 'Iwanang blangko para awtomatikong mabuo, ginagamit para sa deduplication',
    genGenId: 'Awtomatikong buuin',
    genBtn: 'Bumuo ng code',
    genFormat: 'Format ng signal',
    genGuideTitle: 'Paano gamitin sa TradingView',
    genGuideSteps: [
      'Gumawa ng <strong>Alert</strong> sa iyong TradingView chart',
      'Sa <strong>Alert trigger condition</strong>, piliin ang iyong strategy o indicator',
      'Palawakin ang <strong>Notifications</strong> → lagyan ng check ang <strong>Webhook URL</strong>',
      'Ilagay ang Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'I-paste ang nabuong JSON sa <strong>Message</strong> box',
      'I-click ang <strong>Create</strong> para i-save ang Alert'
    ],
    genGuideNote: '<strong>Tip:</strong> Kung gumagamit ka ng Pine Script, idagdag ang nabuong code sa iyong script at gamitin ang <code>alert_message</code> parameter sa <code>strategy.entry()</code> o <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Awtorisasyon) — Dapat baguhin',
        rows: [
          ['License', '—', 'Authorization ID, dapat eksaktong tumugma sa license field sa signal JSON', 'req'],
          ['SecretKey', '—', 'Security key (nagsisimula sa wc_sk_), dapat eksaktong tumugma sa key field sa signal JSON', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Default na parameter ng trading)',
        rows: [
          ['InpLots', '0.1', 'Default na laki ng lot, ginagamit kapag walang lots ang signal JSON', ''],
          ['InpMagic', '888', "Default na magic number, para pag-ibahin ang orders ng iba't ibang strategy", ''],
          ['InpComment', 'TV Signal', 'Default na komento ng order', ''],
          ['InpDeviation', '30', 'Maximum slippage (puntos), para sa Forex 10–30, para sa Gold/Index 30–50 inirerekomenda', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Priyoridad: sl_price (fixed na presyo) > sl_points (puntos) > sl_pct (porsyento). Kung zero ang tatlo, walang stop loss na itinatakda, pareho para sa take profit',
        rows: [
          ['InpSLPoints', '0', 'Default na stop loss puntos (0 = hindi pinagana)', ''],
          ['InpSLPrice', '0', 'Default na stop loss fixed na presyo (0 = hindi pinagana, pinakamataas na priyoridad)', ''],
          ['InpSLPct', '0', 'Default na stop loss porsyento (0 = hindi pinagana)', ''],
          ['InpTPPoints', '0', 'Default na take profit puntos (0 = hindi pinagana)', ''],
          ['InpTPPrice', '0', 'Default na take profit fixed na presyo (0 = hindi pinagana)', ''],
          ['InpTPPct', '0', 'Default na take profit porsyento (0 = hindi pinagana)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Pagma-map ng pangalan ng simbolo)',
        note: 'Maaaring magkaiba ang pangalan ng simbolo sa bawat broker (hal: TradingView tawag XAUUSD, broker mo tawag GOLD). Gamit ang mapping, awtomatikong magko-convert',
        rows: [
          ['InpPrefix', '(blangko)', 'Prefix ng pangalan ng simbolo, kung ang simbolo ng broker ay m.EURUSD ilagay ang m.', ''],
          ['InpSuffix', '(blangko)', 'Suffix ng pangalan ng simbolo, kung ang simbolo ng broker ay EURUSD.pro ilagay ang .pro', ''],
          ['InpEnableMap1~5', 'false', 'Itakda sa true para i-activate ang kaukulang mapping rule', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Mapping rule, format: PangalanSaTradingView|PangalanSaMT5, sumusuporta hanggang 5 rules', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Pareho sa itaas', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Pareho sa itaas', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Pareho sa itaas', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Pareho sa itaas', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Filter ng oras / Display at log)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Kapag pinagana, pinoproseso lamang ang signal sa pagitan ng StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Pinapayagang oras ng pagsisimula ng trading (oras ng MT5 server, format HH:MM)', ''],
          ['InpEndTime', '23:59', 'Pinapayagang oras ng pagtatapos ng trading', ''],
          ['InpShowPanel', 'true', 'Ipakita ang information panel ng status ng koneksyon at statistics ng signal sa chart', ''],
          ['InpUpdateInterval', '1000', 'Interval ng pag-update ng panel (ms), inirerekomenda 1000~3000', ''],
          ['InpLogLevel', '1', 'Level ng log: 0=sara 1=basic 2=detalyado 3=debug (gumamit ng 2 o 3 para sa troubleshooting)', ''],
          ['InpLogToFile', 'true', 'Sumulat ng log file sa MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Output sa "Experts" tab sa ilalim ng MT5', ''],
          ['InpMaxLogMB', '5', 'Maximum na laki ng log file (MB), awtomatikong rotation kapag nalampasan', '']
        ]
      }
    ],

    paramsEATitle: 'Paliwanag ng parameter ng EA',
    paramsEADesc: 'Ang mga sumusunod na parameter ay maaaring itakda kapag binubuksan ang EA sa MT5, at maaari ring ma-override sa pamamagitan ng kaukulang field sa signal JSON.',
    paramName: 'Pangalan ng parameter',
    paramDefault: 'Default na halaga',
    paramDesc: 'Paliwanag',
    paramOverride: 'JSON override field',
    eaParams: [
      ['DefaultLots', '0.1', 'Default na laki ng lot (ginagamit kapag hindi tinukoy ng JSON)', 'lots'],
      ['DefaultMagic', '0', 'Default na Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Default na komento ng order', 'comment'],
      ['SlippagePoints', '3', 'Maximum slippage (puntos)', '—'],
      ['OfflineBuffer', 'false', 'I-activate ang offline buffer', '—'],
      ['ReconnectSeconds', '5', 'Interval ng WebSocket reconnection (segundo)', '—']
    ],
    cmdTableTitle: 'Paliwanag ng uri ng order',
    cmdCol: 'Order (cmd)',
    typeCol: 'Uri',
    actionCol: 'Aksyon',
    extraCol: 'Karagdagang parameter',
    cmdTable: [
      ['buy', 'Market order', 'Bumili agad', 'lots, sl_*, tp_*'],
      ['sell', 'Market order', 'Magbenta agad', 'lots, sl_*, tp_*'],
      ['buylimit', 'Pending order', 'Bumili kapag naabot ang presyo', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Pending order', 'Magbenta kapag naabot ang presyo', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Pending order', 'Bumili sa breakout', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Pending order', 'Magbenta sa breakout', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Isara', 'Isara lahat ng long positions', 'magic (opsyonal)'],
      ['closesell', 'Isara', 'Isara lahat ng short positions', 'magic (opsyonal)'],
      ['closeall', 'Isara', 'Isara lahat ng open positions', '—'],
      ['closeallorders', 'Isara', 'Tanggalin lahat ng pending orders', '—']
    ],
    jsonFieldTitle: 'Paliwanag ng JSON field',
    fieldCol: 'Pangalan ng field',
    requiredCol: 'Kinakailangan',
    descCol: 'Paliwanag',
    jsonFields: [
      ['license', 'string', 'Kinakailangan', 'License ID'],
      ['key', 'string', 'Kinakailangan', 'Secret Key'],
      ['cmd', 'string', 'Kinakailangan', 'Trade order, tingnan ang talahanayan sa itaas'],
      ['symbol', 'string', 'Kinakailangan', 'Simbolo ng trading, hal. EURUSD'],
      ['lots', 'number', 'Opsyonal', 'Laki ng lot, iwanang blangko para gamitin ang default ng EA'],
      ['price', 'number', 'Kinakailangan para sa pending order', 'Presyo ng pending order'],
      ['sl_points', 'number', 'Opsyonal', 'Stop loss puntos'],
      ['sl_price', 'number', 'Opsyonal', 'Stop loss fixed na presyo'],
      ['sl_pct', 'number', 'Opsyonal', 'Stop loss porsyento (0-100)'],
      ['tp_points', 'number', 'Opsyonal', 'Take profit puntos'],
      ['tp_price', 'number', 'Opsyonal', 'Take profit fixed na presyo'],
      ['tp_pct', 'number', 'Opsyonal', 'Take profit porsyento (0-100)'],
      ['magic', 'number', 'Opsyonal', 'Magic Number'],
      ['comment', 'string', 'Opsyonal', 'Komento ng order'],
      ['signalid', 'string', 'Opsyonal', 'Natatanging signal ID, ginagamit para sa deduplication'],
      ['expiryseconds', 'number', 'Opsyonal', 'Bisa ng signal (segundo), default 60']
    ],

    dlMt5Desc: 'MT5 version ng EA, sumusuporta sa lahat ng order, inirerekomenda',
    dlMt5Btn: 'I-download ang MT5 EA',
    dlMt4Desc: 'MT4 version ng EA, kasalukuyang ginagawa, abangan',
    dlMt4Dev: 'Ginagawa pa',
    dlInstallDoc: `<h4>Gabay sa pag-install</h4>
<ol>
<li>I-download ang file na <code>WikiConnector_MT5.ex5</code></li>
<li>Buksan ang MT5, menu bar → <strong>File → Buksan ang data folder</strong></li>
<li>Kopyahin ang <code>.ex5</code> file sa direktoryong <code>MQL5/Experts/</code></li>
<li>Pindutin ang <strong>F5</strong> sa MT5 para i-refresh ang navigator, hanapin ang WikiConnector EA</li>
<li>I-drag ang EA sa kahit anong chart, ilagay ang <strong>License ID</strong> at <strong>Secret Key</strong></li>
<li>Sa EA options, lagyan ng check ang <strong>Payagan ang WebRequest</strong>, at idagdag ang <code>api-gw.interface003.com</code> sa listahan ng mga pinapayagang URL</li>
</ol>`,

    disclaimerTitle: 'Disclaimer sa panganib',
    disclaimerContent: `<p>Bago i-download at gamitin ang WikiConnector EA, pakiusap basahin nang mabuti ang sumusunod na disclaimer:</p>
<p><strong>1. Panganib sa trading</strong><br/>Ang trading ng Forex at CFD ay may malaking panganib na maaaring magresulta sa pagkawala ng lahat o bahagi ng pondo. Ang WikiConnector ay isang tool lamang sa pagpapadala ng signal at hindi mananagot sa anumang resulta ng trading.</p>
<p><strong>2. Panganib sa strategy</strong><br/>Ang nakaraang performance ng automated trading strategies ay hindi garantiya ng mga resulta sa hinaharap. Subukan nang husto bago gamitin sa totoong account.</p>
<p><strong>3. Teknikal na panganib</strong><br/>Ang network latency, server failures, at API limitations ay maaaring magdulot ng pagkawala ng signal o pagkaantala sa execution. Huwag gamitin ang tool na ito para sa high-frequency strategies na sensitibo sa latency.</p>
<p><strong>4. Responsibilidad ng user</strong><br/>Ang user ay may buong responsibilidad sa lahat ng resulta ng trading na nagmumula sa paggamit ng WikiConnector EA. Ang WikiFX ay hindi nagbibigay ng investment advice at hindi mananagot sa kita o lugi sa trading.</p>`,
    disclaimerAgree: 'Nabasa ko at sumasang-ayon ako sa disclaimer sa itaas at nauunawaan ko ang mga panganib sa trading',
    disclaimerDownload: 'Sumang-ayon at i-download',

    regenTitle: 'Kumpirmahin ang pag-reset ng key?',
    regenSubtitle: 'Ang pagkilos na ito ay hindi na maaaring bawiin. Pakiusap kumpirmahin na nauunawaan mo ang mga sumusunod na epekto:',
    regenWarnings: ['Lahat ng EA na naka-configure gamit ang key na ito ay <strong>agad na madidiskonekta</strong>', 'Ang lumang key ay <strong>permanenteng magiging invalid</strong> at hindi na maibabalik', 'Kailangan mong manu-manong i-update ang Secret Key configuration sa lahat ng EA', 'Maaaring may <strong>pagkawala ng signal</strong> sa panahon ng pag-reset'],

    dashTitle: 'Aking WikiConnector',
    myKey: 'Aking Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Kopyahin',
    regenBtn: 'Muling buuin',
    regenConfirm: 'Pagkatapos muling buuin ang key, lahat ng konektadong EA ay madidiskonekta at kailangang i-reconfigure. Magpatuloy?',
    regenConfirmBtn: 'Kumpirmahin ang pag-reset',
    cancelBtn: 'Kanselahin',
    copiedTip: 'Nakopya na',

    licenseTitle: 'Aking mga Certificate (License)',
    licenseId: 'ID ng Certificate',
    maxConn: 'Maximum na koneksyon',
    activeConn: 'Kasalukuyang koneksyon',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Statistics ng signal',
    statTotal: 'Kabuuang signal',
    statDelivered: 'Na-deliver',
    statFailed: 'Nabigo',
    statConnections: 'Kasalukuyang koneksyon',

    signalTitle: 'Kamakailang record ng signal',
    signalTime: 'Oras',
    signalCmd: 'Order',
    signalSymbol: 'Simbolo',
    signalLots: 'Laki ng lot',
    signalStatus: 'Katayuan',
    signalLicense: 'Certificate',
    statusDelivered: 'Na-deliver',
    statusPending: 'Nakabinbin',
    statusFailed: 'Nabigo',
    statusExpired: 'Nag-expire',
    noSignal: 'Wala pang record ng signal',
    loadMore: 'Mag-load pa',

    offlineBuffer: 'Offline buffer',
    offlineBufferDesc: 'Kapag pinagana, ang mga signal na naipon habang offline ay ide-deliver kapag nag-reconnect ang EA (default na hindi pinagana para maiwasan ang pagkalugi)',

    docTitle: 'Gabay sa paggamit',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Paano gumagana ang WikiConnector</p>
  <p>Ang WikiConnector ay tumatanggap ng mga signal ng TradingView sa real time sa pamamagitan ng <strong>WebSocket persistent connection</strong> at awtomatikong nag-e-execute ng trades sa trading software.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① I-install ang EA sa trading software</p>
  <ol class="doc-steps">
    <li><strong>Buksan ang data folder</strong>: Menu ng trading software → File → Buksan ang data folder</li>
    <li><strong>Kopyahin ang EA file</strong>: Kopyahin ang EA file sa direktoryong <code>Experts/</code></li>
    <li><strong>I-refresh ang navigator</strong>: Buksan ang navigator → right-click sa "Expert Advisors" → Refresh. Dapat lumabas ang <strong>SignalReceiver</strong> sa listahan</li>
    <li><strong>I-activate ang automated trading</strong>: Ang "Automated trading" button sa toolbar ay dapat 🟢 berde</li>
    <li><strong>Ilapat sa chart</strong>: I-drag ang SignalReceiver sa kahit anong chart. Kapag lumabas ang window ng setting, i-configure ang mga parameter</li>
  </ol>
  <div class="doc-tip"><strong>Tip:</strong> Kailangan lang ilapat ang EA sa isang chart para maproseso ang signal ng lahat ng simbolo. Hindi kailangan ilapat ito sa bawat chart nang paisa-isa.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② I-configure ang mga parameter ng EA</p>
  <p>May dalawang uri ng parameter: <strong>kinakailangan</strong> (License / SecretKey) at <strong>default na parameter</strong> (ginagamit kapag walang specific field ang signal JSON; ang halaga sa signal ay laging nauuna kaysa sa default ng EA).</p>
  <div class="doc-warn"><strong>Babala sa seguridad:</strong> Ang License at SecretKey ay ang tanging hadlang para protektahan ang iyong account. Kung tumagas ang mga ito, kahit sino ay maaaring magpadala ng trade orders sa iyong trading software. Huwag mag-screenshot o ibahagi ang mga ito sa iba. Inirerekomenda na regular na palitan ang SecretKey.</div>
  <p>Pagkatapos makumpleto ang setup, lalabas ang pangalan ng EA + <strong>😊</strong> sa kanang itaas na sulok ng chart, na nagpapahiwatig na konektado ito sa server. Kung 😞 ang lumabas, suriin kung berde ang "Automated trading" button.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Sumulat ng Pine Script signal code</p>
  <p>Gumagamit ang WikiConnector ng <code>alert()</code> function para mag-trigger ng signal, hindi ang <code>strategy.entry(alert_message=)</code> method. Magkaiba ang mekanismo ng dalawa, huwag paghaluin.</p>
  <div class="doc-danger"><strong>Mahalaga: alert.freq_all</strong> — Bilang default, sa Pine Script, ang unang <code>alert()</code> lang sa loob ng parehong candle ang nagti-trigger, at ang mga sumusunod ay tahimik na itinatapon. Kung kailangan mong magpadala ng maraming sunod-sunod na signal (halimbawa: sa reversal, isara muna ang short saka buksan ang long), dapat magdagdag ng <code>alert.freq_all</code> sa bawat <code>alert()</code>, kung hindi, hindi makakarating ang pangalawang signal sa server.</div>
<pre>//@version=6
strategy("WikiConnector Strategy", overlay=true)

// Tukuyin ang signal messages (palitan ang YOUR_LICENSE at YOUR_KEY ng sarili mong halaga)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Halimbawa ng strategy conditions (3/13 moving average cross)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Gamitin ang alert.freq_all para masiguradong maraming signal ang maipapadala sa loob ng parehong candle
if longCondition
    alert(closesellMessage, alert.freq_all)  // Isara muna ang short positions
    alert(buyMessage,       alert.freq_all)  // Saka buksan ang long position

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Isara muna ang long positions
    alert(sellMessage,     alert.freq_all)   // Saka buksan ang short position</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Gumawa ng Alert sa TradingView</p>
  <p>Webhook URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Right-click sa chart → "<strong>Magdagdag ng Alert...</strong>" o <strong>Alt+A</strong></li>
    <li>Sa trigger condition, piliin ang <strong>"alert() function calls lang"</strong> (mahalaga!)</li>
    <li>Pumili ng expiration date na hangga't maaari, o "Open-ended"</li>
    <li>Ang Message box ay <strong>iwanang default, huwag maglagay ng kahit ano</strong> (ang nilalaman ng signal ay tinutukoy ng alert() sa code)</li>
    <li>Notification settings: lagyan ng check ang <strong>Webhook URL</strong> at ilagay ang address sa itaas; <strong>i-uncheck ang "Send plain text"</strong></li>
    <li>I-click ang "Create" para i-save ang Alert</li>
  </ol>
  <div class="doc-tip"><strong>Tip:</strong> Ang Webhook function ay nangangailangan ng TradingView Pro subscription o mas mataas.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Paliwanag ng format ng signal JSON</p>
  <p><strong>Mga kinakailangang field:</strong><code>license</code> (authorization ID), <code>key</code> (key), <code>cmd</code> (order), <code>symbol</code> (pangalan ng simbolo)</p>
  <p><strong>Mga opsyonal na field:</strong><code>lots</code> (laki ng lot), <code>price</code> (presyo ng pending order), <code>sl_points / sl_price / sl_pct</code> (stop loss tatlong pagpipilian), <code>tp_points / tp_price / tp_pct</code> (take profit tatlong pagpipilian), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (default 300 segundo)</p>
  <p><strong>Mga supported cmd:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Priyoridad ng stop loss/take profit:</strong><code>sl_price</code> (fixed na presyo)&gt; <code>sl_points</code> (puntos)&gt; <code>sl_pct</code> (porsyento). Kung zero ang tatlo, walang stop loss na itinatakda, pareho para sa take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Checklist bago mag-operate</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Automated trading button ng trading software ay 🟢 berde</li>
    <li class="ok">✅ EA sa kanang itaas na sulok ng chart ay nagpapakita ng 😊 (konektado sa server)</li>
    <li class="ok">✅ License / SecretKey ay eksaktong tumutugma sa mga halaga sa TradingView JSON</li>
    <li class="ok">✅ Alert trigger condition ay "<strong>alert() function calls lang</strong>"</li>
    <li class="ok">✅ Bawat <code>alert()</code> ay may <code>alert.freq_all</code> na idinagdag</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Message box iniwang default, walang laman</li>
    <li class="no">❌ Na-uncheck ang "Send plain text"</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Mga babala sa seguridad at panganib</p>
  <div class="doc-warn">
    <strong>Seguridad ng account:</strong><br>
    · Huwag mag-screenshot ng License at SecretKey o ibahagi ang mga ito kaninuman<br>
    · Kung pinaghihinalaan mong tumagas ang key, i-reset agad ang SecretKey sa console<br>
    · Inirerekomenda na regular na palitan ang SecretKey
  </div>
  <div class="doc-warn">
    <strong>Pamamahala ng panganib sa trading:</strong><br>
    · Palaging magtakda ng stop loss, huwag patakbuhin ang automated strategy nang walang proteksyon<br>
    · Inirerekomenda na ang panganib bawat trade ay nasa loob ng 1-2% ng balanse ng account<br>
    · Bago ang mahahalagang economic data (NFP, CPI, FOMC), inirerekomenda na i-pause ang automated trading
  </div>
  <div class="doc-tip">
    <strong>Best practices:</strong><br>
    · Subukan muna sa demo account nang hindi bababa sa 1-2 linggo para kumpirmahing normal ang link bago lumipat sa totoong account<br>
    · Sa totoong account, magsimula sa pinakamaliit na lot (0.01 lot)<br>
    · Gumamit ng VPS (tulad ng Tianyun Cloud VPS) para panatilihing online ang trading software at EA 24/7
  </div>
</div>`,
    docSections: [
      {
        title: '1. Format ng Webhook signal',
        content: `Sa Message box ng TradingView Alert, ilagay ang sumusunod na JSON:
<pre>{
  "license": "{{iyongLicenseID}}",
  "key": "{{iyongSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Mga supported <strong>cmd</strong> order: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook address',
        content: `<p>Sa TradingView Alert settings, itakda ang Webhook URL bilang:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Sa Message box, ilagay ang format ng signal JSON sa itaas at palitan ang license at key ng sarili mong halaga.</p>`
      },
      {
        title: '3. I-install ang WikiConnector EA',
        content: `<p>1. I-download ang WikiConnector EA (.ex5 file)</p>
<p>2. Kopyahin ang EA sa direktoryong <code>MQL5/Experts</code> ng MT5</p>
<p>3. Buksan ang EA sa MT5 at ilagay ang <strong>License ID</strong> at <strong>Secret Key</strong></p>
<p>4. Payagan ang EA na gumawa ng WebSocket connections (sa MT5 Options → EA, i-activate ang network connection permission)</p>`
      },
      {
        title: '4. Rate limits',
        content: `<p>Maximum <strong>30 requests / 60 segundo</strong> bawat License. Ang paglampas sa limit ay magbabalik ng 429 error.</p>
<p>Kung kailangan mo ng mas mataas na frequency, makipag-ugnayan sa customer service para i-upgrade ang iyong plan.</p>`
      }
    ],

    faqTitle: 'Mga madalas itanong',
    faqs: [
      {
        q: 'Ano ang gagawin kung tumagas ang key?',
        a: 'I-click ang "Muling buuin" sa console. Agad na magiging invalid ang lumang key at lahat ng EA connection ay madidiskonekta. I-reconfigure ang EA gamit ang bagong key.'
      },
      {
        q: 'Muling ipapadala ba ang signal pagkatapos mag-reconnect ang EA?',
        a: 'Bilang default hindi (para maiwasan ang pagkalugi). Kung kailangan mo ng resend, i-activate ang "Offline buffer" sa console. Kapag nag-reconnect ang EA, matatanggap nito ang mga signal na naipon habang offline.'
      },
      {
        q: 'Ilang MT account ang kayang ikonekta ng isang License?',
        a: 'Bawat License ay sumusuporta ng hanggang 10 concurrent WebSocket connections, kaya hanggang 10 MT terminals ang maaaring sabay na makatanggap ng parehong signal.'
      },
      {
        q: 'Sinusuportahan ba ang MT4?',
        a: 'Ang kasalukuyang bersyon ay pangunahing sumusuporta sa MT5. Ang MT4 version ng EA ay ginagawa pa. Abangan!'
      },
      {
        q: 'Gaano katagal ang latency ng signal?',
        a: 'Ang average latency ay <100ms. Gamit ang Tianyun Cloud VPS, maaaring kasing-baba ng 1ms.'
      },
      {
        q: 'Paano ko susuriin kung gumagana nang tama ang Webhook?',
        a: 'Sa listahan ng certificates, suriin ang "Kasalukuyang bilang ng koneksyon". Kung mas malaki sa 0, online ang EA. Pagkatapos magpadala ng test signal, suriin ang "Kamakailang record ng signal" para makita ang status na "Na-deliver".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script at pagpapadala ng signal',
        items: [
          {
            q: 'Gumagamit ako ng dalawang alert() para magsara at magbukas, pero isang signal lang ang natatanggap ng trading software.',
            a: 'Ito ang default na limitasyon ng Pine Script: sa loob ng parehong candle, ang unang alert() lang ang nagti-trigger. Ang solusyon ay <strong>magdagdag ng <code>alert.freq_all</code> parameter sa bawat alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Anong trigger condition ang dapat kong piliin para sa Alert?',
            a: 'Kapag gumagamit ng <code>alert()</code> function, dapat mong piliin ang <strong>"alert() function calls lang"</strong>. Kung gumagamit ka ng <code>strategy.entry(..., alert_message=xxx)</code> method, piliin ang "Order fills only". Hindi maaaring paghaluin ang dalawang method.'
          },
          {
            q: 'Ano ang dapat kong ilagay sa Message box?',
            a: 'Kapag gumagamit ng <code>alert()</code> method, <strong>iwanang default ang Message box, huwag maglagay ng kahit ano</strong>. Ang nilalaman ng signal ay tinutukoy ng string sa loob ng <code>alert(xxx)</code> sa code, at matatanggap ng Webhook ang JSON na iyon.'
          }
        ]
      },
      {
        title: '🔌 Koneksyon at pagtanggap ng signal',
        items: [
          {
            q: 'Ang icon ng EA ay nagpapakita ng pulang umiiyak na mukha 😞. Ano ang gagawin ko?',
            a: 'Suriin kung ang "Automated trading" button sa toolbar ng trading software ay berde. Kung pula, i-click ito para maging berde. Awtomatikong babalik sa normal ang EA.'
          },
          {
            q: 'Nagpadala ako ng signal mula sa TradingView pero hindi tumugon ang trading software.',
            a: 'Suriin sa ganitong pagkakasunud-sunod:<br>1. Berde ba ang automated trading ng trading software?<br>2. Nagpapakita ba ng "Connected" ang EA panel?<br>3. Ang Webhook URL ba ay <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. Ang Alert trigger condition ba ay "alert() function calls lang"?<br>5. May <code>alert.freq_all</code> ba ang bawat alert()?<br>6. Tumutugma ba nang eksakto ang license at key sa JSON sa EA settings?'
          }
        ]
      },
      {
        title: '💰 Pagpapatupad ng trading',
        items: [
          {
            q: 'Nabigo ang order. Ano ang dahilan?',
            a: 'Mga karaniwang dahilan: Hindi sapat ang balanse / Hindi tugma ang pangalan ng simbolo (kailangan i-configure ang Symbol Mapping) / Lumampas sa laki ng lot / Masyadong malaki ang slippage (dagdagan ang InpDeviation) / Sarado ang merkado. Suriin ang "Experts" log sa ilalim ng trading software para sa tiyak na impormasyon ng error.'
          },
          {
            q: 'Ang order ay walang stop loss o take profit.',
            a: 'Suriin: ① Kasama ba sa signal JSON ang mga field tulad ng <code>sl_points</code> / <code>tp_points</code> atbp.; ② Ang default bang stop loss/take profit parameters ng EA ay 0? Kung walang nakatakda sa alinman, ang order ay walang stop loss o take profit.'
          },
          {
            q: 'Hindi tugma ang pangalan ng simbolo. Ano ang gagawin ko?',
            a: 'I-activate ang Symbol Mapping sa mga parameter ng EA:<br>Itakda ang <code>InpEnableMap1 = true</code><br>Itakda ang <code>InpMapping1 = XAUUSD|GOLD</code> (PangalanSaTradingView|PangalanSaTradingSoftware)'
          },
          {
            q: 'Maaari ba akong mag-test muna sa demo account?',
            a: '<strong>Lubos na inirerekomenda!</strong> Sa unang paggamit, dapat kang mag-test sa demo account nang hindi bababa sa 1-2 linggo upang kumpirmahin na normal ang link at tama ang pagpapatupad ng order bago lumipat sa totoong account. Magsimula sa pinakamaliit na lot na 0.01.'
          }
        ]
      }
    ]
  },

  // === fr Français ===
  fr: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Connectez automatiquement les signaux TradingView à MetaTrader pour exécuter vos transactions',
    heroBtn: 'Commencez gratuitement',

    stat1Label: 'Latence moyenne',
    stat2Label: 'Disponibilité du service',
    stat3Label: 'Fonctionnement 24h/24',
    stat4Label: 'Distribution multi-comptes',

    flowSub1: 'Stratégie / Alerte',
    flowSub2: 'Routage des signaux',
    flowSub3: 'Exécution automatique',

    featTitle: 'Pourquoi choisir WikiConnector',
    featSubtitle: 'Avantages clés',
    features: [
      {
        icon: '⚡',
        title: 'Exécution en millisecondes',
        desc: "Latence moyenne du signal <100 ms, jusqu'à 1 ms avec WikiFX VPS."
      },
      {
        icon: '🔗',
        title: 'Distribution multi-comptes',
        desc: 'Un seul certificat connecte plusieurs terminaux MT et distribue le même signal de stratégie simultanément.'
      },
      {
        icon: '🔒',
        title: 'Chiffrement sécurisé',
        desc: 'Système de clés indépendant par utilisateur, transmission des données chiffrée de bout en bout.'
      },
      {
        icon: '📊',
        title: 'Surveillance en temps réel',
        desc: "État de réception du signal, latence d'exécution et taux de succès visibles en temps réel."
      },
      {
        icon: '<>',
        title: 'Générateur de code',
        desc: 'Générez visuellement des signaux JSON et du code Pine Script, sans programmation nécessaire.'
      },
      {
        icon: '🖥',
        title: 'Intégration approfondie avec VPS',
        desc: 'Système de comptes partagé avec Tianyun Cloud VPS, fonctionnement 24h/24 à faible latence.'
      }
    ],

    stepsTitle: 'Quatre étapes pour commencer le trading automatisé',
    stepsSubtitle: 'Démarrage rapide',
    steps: [
      {
        title: 'Connectez-vous',
        desc: 'Connectez-vous avec votre compte WikiFX et obtenez automatiquement votre clé et licence exclusives.'
      },
      {
        title: 'Configurez le Webhook',
        desc: "Copiez l'URL du Webhook dans les paramètres d'alerte de TradingView."
      },
      {
        title: "Installez l'EA",
        desc: "Téléchargez l'EA WikiConnector et saisissez votre License ID et Secret Key."
      },
      {
        title: 'Trading automatisé',
        desc: 'Lorsque votre stratégie déclenche une alerte, le signal est automatiquement envoyé au terminal MT pour exécution.'
      }
    ],

    loginTip: 'Après connexion, vous pouvez voir votre clé et certificat exclusifs',
    loginBtn: 'Connectez-vous maintenant',

    navConn: 'Gestion des connexions',
    navLog: 'Journal des signaux',
    navGen: 'Générateur de code',
    navParams: 'Référence rapide des paramètres',
    navDl: 'Téléchargements',
    navDoc: "Tutoriel d'utilisation",
    navFaq: 'Questions fréquentes',

    keyLabel: 'Secret Key',
    keyTip1: 'Ne le partagez avec personne',
    keyTip2: "Utilisé pour l'authentification de l'EA",
    keyTip3: "Après réinitialisation, l'ancienne clé devient immédiatement invalide",

    connSubtitle: 'Voici vos licences et leurs URLs Webhook correspondantes',
    noLicense: 'Aucune licence disponible. Veuillez contacter le service client',
    needHelp: "Besoin d'aide ?",
    viewDoc: "Voir le tutoriel d'utilisation",

    allLicense: 'Toutes les licences',
    allStatus: 'Tous les statuts',
    refresh: 'Actualiser',
    signalId: 'ID du signal',
    total: 'Total',
    records: 'enregistrements',

    genIntro: 'Remplissez les paramètres suivants pour générer automatiquement des signaux JSON et du code Pine Script utilisables dans les alertes TradingView.',
    genAuth: "Informations d'authentification",
    required: 'Obligatoire',
    optional: 'Optionnel',
    genLicPlaceholder: 'Entrez votre License ID',
    genLicHint: 'Consultable sur la page de gestion des connexions',
    genKeyPlaceholder: 'Entrez votre Secret Key',
    genKeyHint: 'Consultable sur la page de gestion des connexions',
    genTrade: 'Ordre de transaction',
    genCmd: "Type d'ordre",
    genMarket: 'Ordre au marché',
    genPending: 'Ordre en attente',
    genClose: 'Fermeture',
    cmdBuy: 'Achat au marché',
    cmdSell: 'Vente au marché',
    cmdBuyLimit: 'Achat limité',
    cmdSellLimit: 'Vente limitée',
    cmdBuyStop: 'Achat par rupture',
    cmdSellStop: 'Vente par rupture',
    cmdCloseBuy: 'Fermer les positions longues',
    cmdCloseSell: 'Fermer les positions courtes',
    cmdCloseAll: 'Fermer ce symbole',
    cmdCloseAllOrders: 'Tout fermer',
    genSlTpHint: 'Choisissez un parmi trois · Priorité : Prix > Points > Pourcentage',
    genTsHint: "Heure d'envoi du signal",
    genTsBtn: 'Heure actuelle',
    presetSimple: '📝 Achat simple',
    presetSltp: '🛡 Avec stop loss et take profit',
    presetFull: '📋 Paramètres complets',
    presetClose: '❌ Signal de fermeture',
    presetPending: '📌 Ordre en attente',
    presetReverse: '🔄 Inversion (fermeture + ouverture)',
    genAlertTab: "🔔 Explication des paramètres d'alerte",
    toastIncomplete: 'Informations incomplètes. Veuillez remplir les champs obligatoires',
    toastRegen: 'Une nouvelle clé a été générée. Copiez-la immédiatement et mettez à jour tous les EA configurés',
    toastKeyCopied: 'Clé copiée',
    toastCopied: 'Copié',
    toastCodeCopied: 'Code copié',
    copyTitle: 'Copier',
    genSymbol: 'Symbole de trading',
    genPrice: "Prix de l'ordre en attente",
    genParams: 'Paramètres de trading',
    genLots: 'Volume (lots)',
    genLotsHint: "Laissez vide pour utiliser la valeur par défaut de l'EA",
    genMagic: 'Magic Number',
    genMagicHint: 'Utilisé pour distinguer les ordres de différentes stratégies',
    genComment: "Commentaire de l'ordre",
    genCommentHint: 'Exemple : Strategy A',
    genSL: 'Configuration du stop loss',
    genPoints: 'Points',
    genPrice2: 'Prix fixe',
    genPct: 'Pourcentage %',
    genTP: 'Configuration du take profit',
    genAdvanced: 'Paramètres avancés',
    genSigIdHint: 'Laissez vide pour génération automatique, utilisé pour la déduplication',
    genGenId: 'Générer automatiquement',
    genBtn: 'Générer le code',
    genFormat: 'Format du signal',
    genGuideTitle: "Comment l'utiliser dans TradingView",
    genGuideSteps: [
      'Créez une <strong>alerte (Alert)</strong> sur votre graphique TradingView',
      "Dans <strong>Condition de déclenchement de l'alerte</strong>, sélectionnez votre stratégie ou indicateur",
      'Développez <strong>Notifications</strong> → cochez <strong>Webhook URL</strong>',
      "Entrez l'URL du Webhook : <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>",
      'Collez le JSON généré ci-dessus dans la zone <strong>Message</strong>',
      "Cliquez sur <strong>Créer (Create)</strong> pour enregistrer l'alerte"
    ],
    genGuideNote: '<strong>Astuce :</strong> Si vous utilisez Pine Script, ajoutez le code généré à votre script et utilisez le paramètre <code>alert_message</code> dans <code>strategy.entry()</code> ou <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Autorisation) — Doit être modifié',
        rows: [
          ['License', '—', "ID d'autorisation, doit correspondre exactement au champ license dans le JSON du signal", 'req'],
          ['SecretKey', '—', 'Clé de sécurité (commence par wc_sk_), doit correspondre exactement au champ key dans le JSON du signal', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Paramètres de trading par défaut)',
        rows: [
          ['InpLots', '0.1', 'Volume par défaut, utilisé lorsque le JSON du signal ne contient pas lots', ''],
          ['InpMagic', '888', 'Magic Number par défaut, pour distinguer les ordres de différentes stratégies', ''],
          ['InpComment', 'TV Signal', "Commentaire d'ordre par défaut", ''],
          ['InpDeviation', '30', "Glissement maximum (points), pour le Forex 10–30, pour l'Or/les Indices 30–50 recommandé", '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: "Priorité : sl_price (prix fixe) > sl_points (points) > sl_pct (pourcentage). Si les trois sont à 0, aucun stop loss n'est défini, idem pour le take profit",
        rows: [
          ['InpSLPoints', '0', 'Points de stop loss par défaut (0 = désactivé)', ''],
          ['InpSLPrice', '0', 'Prix fixe de stop loss par défaut (0 = désactivé, priorité maximale)', ''],
          ['InpSLPct', '0', 'Pourcentage de stop loss par défaut (0 = désactivé)', ''],
          ['InpTPPoints', '0', 'Points de take profit par défaut (0 = désactivé)', ''],
          ['InpTPPrice', '0', 'Prix fixe de take profit par défaut (0 = désactivé)', ''],
          ['InpTPPct', '0', 'Pourcentage de take profit par défaut (0 = désactivé)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Correspondance des noms de symboles)',
        note: "Les brokers peuvent utiliser des noms de symboles différents (ex : TradingView appelle XAUUSD, votre broker l'appelle GOLD). La correspondance permet une conversion automatique",
        rows: [
          ['InpPrefix', '(vide)', 'Préfixe du nom du symbole, si le symbole du broker est m.EURUSD, entrez m.', ''],
          ['InpSuffix', '(vide)', 'Suffixe du nom du symbole, si le symbole du broker est EURUSD.pro, entrez .pro', ''],
          ['InpEnableMap1~5', 'false', 'Définissez sur true pour activer la règle de correspondance correspondante', ''],
          ['InpMapping1', 'XAUUSD|GOLD', "Règle de correspondance, format : NomTradingView|NomMT5, supporte jusqu'à 5 règles", ''],
          ['InpMapping2', 'EURUSD|EUR', 'Idem ci-dessus', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Idem ci-dessus', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Idem ci-dessus', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Idem ci-dessus', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Filtre temporel / Affichage et journal)',
        rows: [
          ['InpUseTimeFilter', 'false', "Lorsqu'activé, traite uniquement les signaux entre StartTime~EndTime", ''],
          ['InpStartTime', '00:00', 'Heure de début autorisée pour le trading (heure du serveur MT5, format HH:MM)', ''],
          ['InpEndTime', '23:59', 'Heure de fin autorisée pour le trading', ''],
          ['InpShowPanel', 'true', "Affiche un panneau d'informations sur l'état de la connexion et les statistiques des signaux sur le graphique", ''],
          ['InpUpdateInterval', '1000', 'Intervalle de mise à jour du panneau (ms), recommandé 1000~3000', ''],
          ['InpLogLevel', '1', 'Niveau de journal : 0=désactivé 1=basique 2=détaillé 3=débogage (utilisez 2 ou 3 pour le dépannage)', ''],
          ['InpLogToFile', 'true', 'Écrire le fichier journal dans MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Sortie dans l\'onglet "Experts" en bas de MT5', ''],
          ['InpMaxLogMB', '5', 'Taille maximale du fichier journal (Mo), rotation automatique au dépassement', '']
        ]
      }
    ],

    paramsEATitle: "Explication des paramètres de l'EA",
    paramsEADesc: "Les paramètres suivants peuvent être configurés lors de l'ouverture de l'EA dans MT5, et peuvent également être remplacés via les champs correspondants dans le JSON du signal.",
    paramName: 'Nom du paramètre',
    paramDefault: 'Valeur par défaut',
    paramDesc: 'Description',
    paramOverride: 'Champ de remplacement JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'Volume par défaut (utilisé lorsque le JSON ne le spécifie pas)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number par défaut', 'magic'],
      ['DefaultComment', 'WikiConnector', "Commentaire d'ordre par défaut", 'comment'],
      ['SlippagePoints', '3', 'Glissement maximum (points)', '—'],
      ['OfflineBuffer', 'false', 'Activer le tampon hors ligne', '—'],
      ['ReconnectSeconds', '5', 'Intervalle de reconnexion WebSocket (secondes)', '—']
    ],
    cmdTableTitle: "Explication des types d'ordres",
    cmdCol: 'Ordre (cmd)',
    typeCol: 'Type',
    actionCol: 'Action',
    extraCol: 'Paramètres supplémentaires',
    cmdTable: [
      ['buy', 'Ordre au marché', 'Acheter immédiatement', 'lots, sl_*, tp_*'],
      ['sell', 'Ordre au marché', 'Vendre immédiatement', 'lots, sl_*, tp_*'],
      ['buylimit', 'Ordre en attente', "Acheter à l'atteinte du prix", 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Ordre en attente', "Vendre à l'atteinte du prix", 'price, lots, sl_*, tp_*'],
      ['buystop', 'Ordre en attente', 'Acheter sur rupture', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Ordre en attente', 'Vendre sur rupture', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Fermeture', 'Fermer toutes les positions longues', 'magic (optionnel)'],
      ['closesell', 'Fermeture', 'Fermer toutes les positions courtes', 'magic (optionnel)'],
      ['closeall', 'Fermeture', 'Fermer toutes les positions ouvertes', '—'],
      ['closeallorders', 'Fermeture', 'Supprimer tous les ordres en attente', '—']
    ],
    jsonFieldTitle: 'Explication des champs JSON',
    fieldCol: 'Nom du champ',
    requiredCol: 'Obligatoire',
    descCol: 'Description',
    jsonFields: [
      ['license', 'string', 'Obligatoire', 'License ID'],
      ['key', 'string', 'Obligatoire', 'Secret Key'],
      ['cmd', 'string', 'Obligatoire', 'Ordre de trading, voir tableau ci-dessus'],
      ['symbol', 'string', 'Obligatoire', 'Symbole de trading, ex. EURUSD'],
      ['lots', 'number', 'Optionnel', "Volume, laisser vide pour utiliser la valeur par défaut de l'EA"],
      ['price', 'number', 'Obligatoire pour ordre en attente', "Prix de l'ordre en attente"],
      ['sl_points', 'number', 'Optionnel', 'Points de stop loss'],
      ['sl_price', 'number', 'Optionnel', 'Prix fixe de stop loss'],
      ['sl_pct', 'number', 'Optionnel', 'Pourcentage de stop loss (0-100)'],
      ['tp_points', 'number', 'Optionnel', 'Points de take profit'],
      ['tp_price', 'number', 'Optionnel', 'Prix fixe de take profit'],
      ['tp_pct', 'number', 'Optionnel', 'Pourcentage de take profit (0-100)'],
      ['magic', 'number', 'Optionnel', 'Magic Number'],
      ['comment', 'string', 'Optionnel', "Commentaire de l'ordre"],
      ['signalid', 'string', 'Optionnel', 'ID unique du signal, utilisé pour la déduplication'],
      ['expiryseconds', 'number', 'Optionnel', 'Durée de validité du signal (secondes), par défaut 60']
    ],

    dlMt5Desc: "Version MT5 de l'EA, prend en charge tous les ordres, recommandée",
    dlMt5Btn: "Télécharger l'EA MT5",
    dlMt4Desc: "Version MT4 de l'EA, en développement, restez à l'écoute",
    dlMt4Dev: 'En développement',
    dlInstallDoc: `<h4>Instructions d'installation</h4>
<ol>
<li>Téléchargez le fichier <code>WikiConnector_MT5.ex5</code></li>
<li>Ouvrez MT5, barre de menu → <strong>Fichier → Ouvrir le dossier de données</strong></li>
<li>Copiez le fichier <code>.ex5</code> dans le répertoire <code>MQL5/Experts/</code></li>
<li>Appuyez sur <strong>F5</strong> dans MT5 pour actualiser le navigateur et trouver l'EA WikiConnector</li>
<li>Faites glisser l'EA sur n'importe quel graphique, saisissez <strong>License ID</strong> et <strong>Secret Key</strong></li>
<li>Dans les options de l'EA, cochez <strong>Autoriser WebRequest</strong> et ajoutez <code>api-gw.interface003.com</code> à la liste des URLs autorisées</li>
</ol>`,

    disclaimerTitle: 'Clause de non-responsabilité concernant les risques',
    disclaimerContent: `<p>Avant de télécharger et d'utiliser WikiConnector EA, veuillez lire attentivement la clause de non-responsabilité suivante :</p>
<p><strong>1. Risque de trading</strong><br/>Le trading de devises et de CFD comporte des risques importants pouvant entraîner la perte totale ou partielle du capital. WikiConnector est simplement un outil de transmission de signaux et n'assume aucune responsabilité quant aux résultats des transactions.</p>
<p><strong>2. Risque de stratégie</strong><br/>Les performances passées des stratégies de trading automatisé ne garantissent pas les résultats futurs. Effectuez des tests approfondis avant de les utiliser sur des comptes réels.</p>
<p><strong>3. Risque technique</strong><br/>La latence réseau, les pannes de serveur et les limitations d'API peuvent entraîner une perte de signaux ou des retards d'exécution. N'utilisez pas cet outil pour des stratégies haute fréquence sensibles à la latence.</p>
<p><strong>4. Responsabilité de l'utilisateur</strong><br/>L'utilisateur assume l'entière responsabilité de tous les résultats de trading découlant de l'utilisation de WikiConnector EA. WikiFX ne fournit pas de conseils en investissement et n'assume aucune responsabilité quant aux gains ou pertes de trading.</p>`,
    disclaimerAgree: "J'ai lu et j'accepte la clause de non-responsabilité ci-dessus et je comprends les risques du trading",
    disclaimerDownload: 'Accepter et télécharger',

    regenTitle: 'Confirmer la réinitialisation de la clé ?',
    regenSubtitle: 'Cette action est irréversible. Veuillez confirmer que vous comprenez les conséquences suivantes :',
    regenWarnings: ['Tous les EA configurés avec cette clé seront <strong>immédiatement déconnectés</strong>', "L'ancienne clé sera <strong>définitivement invalide</strong> et ne pourra pas être récupérée", 'Vous devez mettre à jour manuellement la configuration de Secret Key dans tous les EA', 'Il existe un risque de <strong>perte de signaux</strong> pendant la réinitialisation'],

    dashTitle: 'Mon WikiConnector',
    myKey: 'Ma Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Copier',
    regenBtn: 'Régénérer',
    regenConfirm: 'Après la régénération de la clé, tous les EA connectés seront déconnectés et devront être reconfigurés. Continuer ?',
    regenConfirmBtn: 'Confirmer la réinitialisation',
    cancelBtn: 'Annuler',
    copiedTip: 'Copié',

    licenseTitle: 'Mes certificats (License)',
    licenseId: 'ID du certificat',
    maxConn: 'Connexions maximales',
    activeConn: 'Connexion actuelle',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Statistiques des signaux',
    statTotal: 'Total des signaux',
    statDelivered: 'Livrés',
    statFailed: 'Échoués',
    statConnections: 'Connexions actuelles',

    signalTitle: 'Enregistrements récents des signaux',
    signalTime: 'Heure',
    signalCmd: 'Ordre',
    signalSymbol: 'Symbole',
    signalLots: 'Volume',
    signalStatus: 'Statut',
    signalLicense: 'Certificat',
    statusDelivered: 'Livré',
    statusPending: 'En attente',
    statusFailed: 'Échoué',
    statusExpired: 'Expiré',
    noSignal: 'Aucun enregistrement de signal pour le moment',
    loadMore: 'Charger plus',

    offlineBuffer: 'Tampon hors ligne',
    offlineBufferDesc: "Lorsqu'activé, les signaux accumulés pendant la période hors ligne seront livrés lors de la reconnexion de l'EA (désactivé par défaut pour éviter les pertes)",

    docTitle: "Tutoriel d'utilisation",
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Comment fonctionne WikiConnector</p>
  <p>WikiConnector reçoit les signaux TradingView en temps réel via une <strong>connexion persistante WebSocket</strong> et exécute automatiquement les transactions dans le logiciel de trading.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Installer l'EA dans le logiciel de trading</p>
  <ol class="doc-steps">
    <li><strong>Ouvrir le dossier de données</strong> : Menu du logiciel de trading → Fichier → Ouvrir le dossier de données</li>
    <li><strong>Copier le fichier EA</strong> : Copiez le fichier EA dans le répertoire <code>Experts/</code></li>
    <li><strong>Actualiser le navigateur</strong> : Ouvrez le navigateur → clic droit sur "Experts Conseillers" → Actualiser. <strong>SignalReceiver</strong> devrait apparaître dans la liste</li>
    <li><strong>Activer le trading automatisé</strong> : Le bouton "Trading automatisé" dans la barre d'outils supérieure doit être 🟢 vert</li>
    <li><strong>Appliquer au graphique</strong> : Faites glisser SignalReceiver sur n'importe quel graphique. Lorsque la fenêtre de configuration apparaît, ajustez les paramètres</li>
  </ol>
  <div class="doc-tip"><strong>Astuce :</strong> Il suffit d'appliquer l'EA sur un seul graphique pour traiter les signaux de tous les symboles. Il n'est pas nécessaire de l'appliquer individuellement sur chaque graphique.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Configurer les paramètres de l'EA</p>
  <p>Il existe deux types de paramètres : <strong>obligatoires</strong> (License / SecretKey) et <strong>paramètres par défaut</strong> (utilisés lorsque le JSON du signal ne contient pas un champ spécifique ; les valeurs du signal ont toujours priorité sur les valeurs par défaut de l'EA).</p>
  <div class="doc-warn"><strong>Avertissement de sécurité :</strong> License et SecretKey sont la seule barrière protégeant votre compte. En cas de fuite, n'importe qui pourrait envoyer des ordres de trading à votre logiciel de trading. Ne faites pas de captures d'écran et ne les partagez pas avec d'autres personnes. Il est recommandé de changer régulièrement le SecretKey.</div>
  <p>Une fois la configuration terminée, le nom de l'EA + <strong>😊</strong> apparaît dans le coin supérieur droit du graphique, indiquant qu'il est connecté au serveur. Si 😞 apparaît, vérifiez que le bouton "Trading automatisé" est vert.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Écrire le code Pine Script pour le signal</p>
  <p>WikiConnector utilise la fonction <code>alert()</code> pour déclencher les signaux, et non la méthode <code>strategy.entry(alert_message=)</code>. Ce sont deux mécanismes différents, ne les mélangez pas.</p>
  <div class="doc-danger"><strong>Important : alert.freq_all</strong> — Par défaut, dans Pine Script, seul le premier <code>alert()</code> est déclenché dans la même bougie, les suivants sont ignorés silencieusement. Si vous devez envoyer plusieurs signaux consécutifs (par exemple, lors d'une inversion : d'abord fermer la position courte puis ouvrir une position longue), vous devez ajouter <code>alert.freq_all</code> à chaque <code>alert()</code>, sinon le deuxième signal n'atteindra jamais le serveur.</div>
<pre>//@version=6
strategy("Stratégie WikiConnector", overlay=true)

// Définir les messages de signal (remplacez YOUR_LICENSE et YOUR_KEY par vos propres valeurs)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Exemple de conditions de stratégie (croisement de moyennes mobiles 3/13)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Utiliser alert.freq_all pour garantir l'envoi de multiples signaux dans la même bougie
if longCondition
    alert(closesellMessage, alert.freq_all)  // D'abord fermer les positions courtes
    alert(buyMessage,       alert.freq_all)  // Ensuite ouvrir une position longue

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // D'abord fermer les positions longues
    alert(sellMessage,     alert.freq_all)   // Ensuite ouvrir une position courte</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Créer une alerte dans TradingView</p>
  <p>URL du Webhook :</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Clic droit sur le graphique → "<strong>Ajouter une alerte...</strong>" ou <strong>Alt+A</strong></li>
    <li>Comme condition de déclenchement, sélectionnez <strong>"Uniquement les appels de fonction alert()"</strong> (important !)</li>
    <li>Choisissez une date d'expiration aussi longue que possible, ou "Sans expiration"</li>
    <li>La zone Message <strong>laissez-la par défaut, n'y inscrivez rien</strong> (le contenu du signal est déterminé par alert() dans le code)</li>
    <li>Paramètres de notification : cochez <strong>Webhook URL</strong> et entrez l'adresse ci-dessus ; <strong>décochez "Envoyer en texte brut"</strong></li>
    <li>Cliquez sur "Créer" pour enregistrer l'alerte</li>
  </ol>
  <div class="doc-tip"><strong>Astuce :</strong> La fonction Webhook nécessite un abonnement TradingView Pro ou supérieur.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Explication du format JSON du signal</p>
  <p><strong>Champs obligatoires :</strong><code>license</code> (ID d'autorisation), <code>key</code> (clé), <code>cmd</code> (ordre), <code>symbol</code> (nom du symbole)</p>
  <p><strong>Champs optionnels :</strong><code>lots</code> (volume), <code>price</code> (prix de l'ordre en attente), <code>sl_points / sl_price / sl_pct</code> (stop loss triple choix), <code>tp_points / tp_price / tp_pct</code> (take profit triple choix), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (par défaut 300 secondes)</p>
  <p><strong>Ordres pris en charge :</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Priorité stop loss/take profit :</strong><code>sl_price</code> (prix fixe) &gt; <code>sl_points</code> (points) &gt; <code>sl_pct</code> (pourcentage). Si les trois sont à 0, aucun stop loss n'est défini, idem pour le take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Liste de vérification avant exploitation</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Bouton de trading automatisé du logiciel de trading 🟢 vert</li>
    <li class="ok">✅ EA dans le coin supérieur droit du graphique affiche 😊 (connecté au serveur)</li>
    <li class="ok">✅ License / SecretKey correspondent exactement aux valeurs dans le JSON TradingView</li>
    <li class="ok">✅ Condition de déclenchement de l'alerte "<strong>Uniquement les appels de fonction alert()</strong>"</li>
    <li class="ok">✅ Chaque <code>alert()</code> a <code>alert.freq_all</code> ajouté</li>
    <li class="ok">✅ Webhook URL : <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Zone Message laissée par défaut, vide</li>
    <li class="no">❌ "Envoyer en texte brut" décoché</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Conseils de sécurité et de risque</p>
  <div class="doc-warn">
    <strong>Sécurité du compte :</strong><br>
    · Ne faites pas de captures d'écran de License et SecretKey et ne les partagez avec personne<br>
    · Si vous soupçonnez une fuite de la clé, réinitialisez immédiatement le SecretKey dans la console<br>
    · Il est recommandé de changer régulièrement le SecretKey
  </div>
  <div class="doc-warn">
    <strong>Gestion des risques de trading :</strong><br>
    · Définissez toujours un stop loss, n'exploitez jamais de stratégies automatisées sans protection<br>
    · Il est recommandé que le risque par transaction soit inférieur à 1-2 % du solde du compte<br>
    · Avant les publications économiques importantes (NFP, IPC, FOMC), il est recommandé de mettre en pause le trading automatisé
  </div>
  <div class="doc-tip">
    <strong>Bonnes pratiques :</strong><br>
    · Testez d'abord sur un compte démo pendant au moins 1 à 2 semaines pour confirmer que le lien fonctionne correctement avant de passer à un compte réel<br>
    · Sur le compte réel, commencez avec le volume minimum (0,01 lot)<br>
    · Utilisez un VPS (comme Tianyun Cloud VPS) pour maintenir le logiciel de trading et l'EA en ligne 24h/24
  </div>
</div>`,
    docSections: [
      {
        title: '1. Format du signal Webhook',
        content: `Dans la zone Message de l'alerte TradingView, saisissez le JSON suivant :
<pre>{
  "license": "{{votreLicenseID}}",
  "key": "{{votreSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Ordres <strong>cmd</strong> pris en charge : buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. Adresse Webhook TradingView',
        content: `<p>Dans les paramètres de l'alerte TradingView, définissez l'URL du Webhook comme suit :</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Dans la zone Message, saisissez le format JSON du signal ci-dessus et remplacez license et key par vos propres valeurs.</p>`
      },
      {
        title: '3. Installer WikiConnector EA',
        content: `<p>1. Téléchargez WikiConnector EA (fichier .ex5)</p>
<p>2. Copiez l'EA dans le répertoire <code>MQL5/Experts</code> de MT5</p>
<p>3. Ouvrez l'EA dans MT5 et saisissez <strong>License ID</strong> et <strong>Secret Key</strong></p>
<p>4. Autorisez l'EA à effectuer des connexions WebSocket (dans Options MT5 → EA, activez l'autorisation de connexion réseau)</p>`
      },
      {
        title: '4. Limites de débit',
        content: `<p>Maximum <strong>30 requêtes / 60 secondes</strong> par licence. Le dépassement de la limite renvoie une erreur 429.</p>
<p>Si vous avez besoin d'une fréquence plus élevée, contactez le service client pour améliorer votre forfait.</p>`
      }
    ],

    faqTitle: 'Questions fréquentes',
    faqs: [
      {
        q: 'Que faire si ma clé a fui ?',
        a: 'Cliquez sur "Régénérer" dans la console. L\'ancienne clé deviendra immédiatement invalide et toutes les connexions EA seront interrompues. Reconfigurez l\'EA avec la nouvelle clé.'
      },
      {
        q: "Les signaux seront-ils renvoyés après la reconnexion de l'EA ?",
        a: 'Par défaut non (pour éviter les pertes). Si vous avez besoin d\'un renvoi, activez le "Tampon hors ligne" dans la console. Lors de la reconnexion de l\'EA, il recevra les signaux accumulés pendant la période hors ligne.'
      },
      {
        q: 'Combien de comptes MT une licence peut-elle connecter ?',
        a: "Chaque licence prend en charge jusqu'à 10 connexions WebSocket simultanées, permettant à jusqu'à 10 terminaux MT de recevoir le même signal en même temps."
      },
      {
        q: 'MT4 est-il pris en charge ?',
        a: "La version actuelle prend principalement en charge MT5. La version MT4 de l'EA est en développement. Restez à l'écoute !"
      },
      {
        q: 'Quelle est la latence du signal ?',
        a: 'La latence moyenne est <100 ms. Avec Tianyun Cloud VPS, elle peut être aussi faible que 1 ms.'
      },
      {
        q: 'Comment tester si le Webhook fonctionne correctement ?',
        a: 'Dans la liste des certificats, vérifiez le "Nombre de connexions actuelles". S\'il est supérieur à 0, l\'EA est en ligne. Après avoir envoyé un signal de test, vérifiez les "Enregistrements récents des signaux" pour voir le statut "Livré".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script et envoi de signaux',
        items: [
          {
            q: "J'utilise deux alert() pour fermer et ouvrir, mais le logiciel de trading ne reçoit qu'un seul signal.",
            a: "C'est la limitation par défaut de Pine Script : dans la même bougie, seul le premier alert() est déclenché. La solution est d'<strong>ajouter le paramètre <code>alert.freq_all</code> à chaque alert()</strong> :<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>"
          },
          {
            q: "Quelle condition de déclenchement dois-je choisir pour l'alerte ?",
            a: 'Lorsque vous utilisez la fonction <code>alert()</code>, vous devez sélectionner <strong>"Uniquement les appels de fonction alert()"</strong>. Si vous utilisez la méthode <code>strategy.entry(..., alert_message=xxx)</code>, sélectionnez "Order fills only". Les deux méthodes ne peuvent pas être mélangées.'
          },
          {
            q: 'Que dois-je mettre dans la zone Message ?',
            a: "Lorsque vous utilisez la méthode <code>alert()</code>, <strong>laissez la zone Message par défaut, n'y inscrivez rien</strong>. Le contenu du signal est déterminé par la chaîne dans <code>alert(xxx)</code> dans le code, et le Webhook recevra ce JSON."
          }
        ]
      },
      {
        title: '🔌 Connexion et réception des signaux',
        items: [
          {
            q: "L'icône de l'EA affiche un visage rouge pleurant 😞. Que faire ?",
            a: "Vérifiez si le bouton \"Trading automatisé\" dans la barre d'outils du logiciel de trading est vert. S'il est rouge, cliquez dessus pour le passer au vert. L'EA reviendra automatiquement à l'état normal."
          },
          {
            q: "J'ai envoyé un signal depuis TradingView mais le logiciel de trading ne répond pas.",
            a: 'Vérifiez dans cet ordre :<br>1. Le trading automatisé du logiciel de trading est-il vert ?<br>2. Le panneau de l\'EA affiche-t-il "Connected" ?<br>3. L\'URL du Webhook est-elle <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code> ?<br>4. La condition de déclenchement de l\'alerte est-elle "Uniquement les appels de fonction alert()" ?<br>5. Chaque alert() a-t-il <code>alert.freq_all</code> ajouté ?<br>6. License et key dans le JSON correspondent-ils exactement aux paramètres de l\'EA ?'
          }
        ]
      },
      {
        title: '💰 Exécution des transactions',
        items: [
          {
            q: "L'ordre a échoué. Quelle est la cause ?",
            a: 'Causes courantes : Solde insuffisant / Le nom du symbole ne correspond pas (nécessite la configuration de Symbol Mapping) / Volume dépassé / Glissement trop important (augmenter InpDeviation) / Marché fermé. Consultez le journal "Experts" en bas du logiciel de trading pour obtenir des informations d\'erreur spécifiques.'
          },
          {
            q: "L'ordre n'a pas de stop loss ou de take profit.",
            a: "Vérifiez : ① Le JSON du signal inclut-il des champs comme <code>sl_points</code> / <code>tp_points</code> etc. ?; ② Les paramètres de stop loss/take profit par défaut de l'EA sont-ils à 0 ? Si aucun des deux n'est configuré, l'ordre n'aura ni stop loss ni take profit."
          },
          {
            q: 'Le nom du symbole ne correspond pas. Que faire ?',
            a: "Activez Symbol Mapping dans les paramètres de l'EA :<br>Définissez <code>InpEnableMap1 = true</code><br>Définissez <code>InpMapping1 = XAUUSD|GOLD</code> (NomTradingView|NomLogicielTrading)"
          },
          {
            q: "Puis-je d'abord tester sur un compte démo ?",
            a: "<strong>Fortement recommandé !</strong> Lors de la première utilisation, vous devez tester sur un compte démo pendant au moins 1 à 2 semaines pour confirmer que le lien fonctionne correctement et que l'exécution des ordres est correcte avant de passer à un compte réel. Commencez avec le volume minimum de 0,01 lot."
          }
        ]
      }
    ]
  },

  // === id Bahasa Indonesia ===
  id: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Hubungkan sinyal TradingView secara otomatis ke MetaTrader untuk mengeksekusi trading',
    heroBtn: 'Mulai gratis',

    stat1Label: 'Latensi rata-rata',
    stat2Label: 'Ketersediaan layanan',
    stat3Label: 'Operasi 24/7',
    stat4Label: 'Distribusi multi-akun',

    flowSub1: 'Strategi / Alert',
    flowSub2: 'Routing sinyal',
    flowSub3: 'Eksekusi otomatis',

    featTitle: 'Mengapa memilih WikiConnector',
    featSubtitle: 'Keunggulan inti',
    features: [
      {
        icon: '⚡',
        title: 'Eksekusi dalam milidetik',
        desc: 'Latensi sinyal rata-rata <100 md, bisa serendah 1 md dengan WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Distribusi multi-akun',
        desc: 'Satu sertifikat menghubungkan banyak terminal MT, mendistribusikan sinyal strategi yang sama secara bersamaan.'
      },
      {
        icon: '🔒',
        title: 'Enkripsi aman',
        desc: 'Sistem kunci independen per pengguna, transmisi data terenkripsi penuh.'
      },
      {
        icon: '📊',
        title: 'Pemantauan real-time',
        desc: 'Status penerimaan sinyal, latensi eksekusi, dan tingkat keberhasilan terlihat secara real-time.'
      },
      {
        icon: '<>',
        title: 'Generator kode',
        desc: 'Hasilkan sinyal JSON dan kode Pine Script secara visual, tanpa perlu pemrograman.'
      },
      {
        icon: '🖥',
        title: 'Integrasi mendalam dengan VPS',
        desc: 'Berbagi sistem akun dengan Tianyun Cloud VPS, operasi latensi rendah 24/7.'
      }
    ],

    stepsTitle: 'Empat langkah memulai trading otomatis',
    stepsSubtitle: 'Mulai cepat',
    steps: [
      {
        title: 'Masuk',
        desc: 'Masuk dengan akun WikiFX Anda, dapatkan kunci dan Lisensi eksklusif Anda secara otomatis.'
      },
      {
        title: 'Konfigurasi Webhook',
        desc: 'Salin URL Webhook ke pengaturan Alert TradingView.'
      },
      {
        title: 'Instal EA',
        desc: 'Unduh EA WikiConnector dan masukkan License ID dan Secret Key.'
      },
      {
        title: 'Trading otomatis',
        desc: 'Ketika strategi Anda memicu Alert, sinyal akan otomatis dikirim ke terminal MT untuk dieksekusi.'
      }
    ],

    loginTip: 'Setelah masuk, Anda dapat melihat kunci dan sertifikat eksklusif Anda',
    loginBtn: 'Masuk sekarang',

    navConn: 'Manajemen koneksi',
    navLog: 'Log sinyal',
    navGen: 'Generator kode',
    navParams: 'Referensi cepat parameter',
    navDl: 'Unduhan',
    navDoc: 'Panduan penggunaan',
    navFaq: 'Pertanyaan umum',

    keyLabel: 'Secret Key',
    keyTip1: 'Jangan bagikan kepada siapa pun',
    keyTip2: 'Digunakan untuk autentikasi EA',
    keyTip3: 'Setelah direset, kunci lama langsung menjadi tidak berlaku',

    connSubtitle: 'Berikut adalah Lisensi Anda dan URL Webhook yang sesuai',
    noLicense: 'Tidak ada Lisensi. Silakan hubungi layanan pelanggan',
    needHelp: 'Butuh bantuan?',
    viewDoc: 'Lihat panduan penggunaan',

    allLicense: 'Semua Lisensi',
    allStatus: 'Semua status',
    refresh: 'Segarkan',
    signalId: 'ID sinyal',
    total: 'Total',
    records: 'catatan',

    genIntro: 'Isi parameter berikut untuk menghasilkan secara otomatis sinyal JSON dan kode Pine Script yang dapat digunakan di Alert TradingView.',
    genAuth: 'Informasi autentikasi',
    required: 'Wajib',
    optional: 'Opsional',
    genLicPlaceholder: 'Masukkan License ID Anda',
    genLicHint: 'Dapat dilihat di halaman manajemen koneksi',
    genKeyPlaceholder: 'Masukkan Secret Key Anda',
    genKeyHint: 'Dapat dilihat di halaman manajemen koneksi',
    genTrade: 'Perintah trading',
    genCmd: 'Jenis perintah',
    genMarket: 'Perintah pasar',
    genPending: 'Perintah tertunda',
    genClose: 'Tutup',
    cmdBuy: 'Beli pasar',
    cmdSell: 'Jual pasar',
    cmdBuyLimit: 'Beli terbatas',
    cmdSellLimit: 'Jual terbatas',
    cmdBuyStop: 'Beli breakout',
    cmdSellStop: 'Jual breakout',
    cmdCloseBuy: 'Tutup posisi long',
    cmdCloseSell: 'Tutup posisi short',
    cmdCloseAll: 'Tutup simbol ini',
    cmdCloseAllOrders: 'Tutup semua',
    genSlTpHint: 'Pilih satu dari tiga · Prioritas: Harga > Poin > Persentase',
    genTsHint: 'Waktu pengiriman sinyal',
    genTsBtn: 'Waktu saat ini',
    presetSimple: '📝 Beli sederhana',
    presetSltp: '🛡 Dengan stop loss dan take profit',
    presetFull: '📋 Parameter lengkap',
    presetClose: '❌ Sinyal penutupan',
    presetPending: '📌 Perintah tertunda',
    presetReverse: '🔄 Pembalikan (tutup + buka)',
    genAlertTab: '🔔 Penjelasan pengaturan Alert',
    toastIncomplete: 'Informasi tidak lengkap. Silakan isi bidang wajib',
    toastRegen: 'Kunci baru telah dibuat. Segera salin dan perbarui semua EA yang dikonfigurasi',
    toastKeyCopied: 'Kunci disalin',
    toastCopied: 'Disalin',
    toastCodeCopied: 'Kode disalin',
    copyTitle: 'Salin',
    genSymbol: 'Simbol trading',
    genPrice: 'Harga perintah tertunda',
    genParams: 'Parameter trading',
    genLots: 'Ukuran lot',
    genLotsHint: 'Biarkan kosong untuk menggunakan nilai default EA',
    genMagic: 'Magic Number',
    genMagicHint: 'Digunakan untuk membedakan pesanan dari strategi yang berbeda',
    genComment: 'Komentar pesanan',
    genCommentHint: 'Contoh: Strategy A',
    genSL: 'Pengaturan stop loss',
    genPoints: 'Poin',
    genPrice2: 'Harga tetap',
    genPct: 'Persentase %',
    genTP: 'Pengaturan take profit',
    genAdvanced: 'Parameter lanjutan',
    genSigIdHint: 'Biarkan kosong untuk pembuatan otomatis, digunakan untuk deduplikasi',
    genGenId: 'Hasilkan otomatis',
    genBtn: 'Hasilkan kode',
    genFormat: 'Format sinyal',
    genGuideTitle: 'Cara menggunakannya di TradingView',
    genGuideSteps: [
      'Buat <strong>Alert</strong> di grafik TradingView Anda',
      'Di <strong>Kondisi pemicu Alert</strong>, pilih strategi atau indikator Anda',
      'Perluas <strong>Notifikasi</strong> → centang <strong>Webhook URL</strong>',
      'Masukkan URL Webhook: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Tempel JSON yang dihasilkan di atas ke kotak <strong>Pesan (Message)</strong>',
      'Klik <strong>Buat (Create)</strong> untuk menyimpan Alert'
    ],
    genGuideNote: '<strong>Tips:</strong> Jika Anda menggunakan Pine Script, tambahkan kode yang dihasilkan ke skrip Anda dan gunakan parameter <code>alert_message</code> di <code>strategy.entry()</code> atau <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Otorisasi) — Harus diubah',
        rows: [
          ['License', '—', 'ID otorisasi, harus cocok persis dengan bidang license di JSON sinyal', 'req'],
          ['SecretKey', '—', 'Kunci keamanan (dimulai dengan wc_sk_), harus cocok persis dengan bidang key di JSON sinyal', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Parameter trading default)',
        rows: [
          ['InpLots', '0.1', 'Ukuran lot default, digunakan ketika JSON sinyal tidak menyertakan lots', ''],
          ['InpMagic', '888', 'Magic Number default, untuk membedakan pesanan dari strategi yang berbeda', ''],
          ['InpComment', 'TV Signal', 'Komentar pesanan default', ''],
          ['InpDeviation', '30', 'Selip maksimum (poin), untuk Forex 10–30, untuk Emas/Indeks 30–50 direkomendasikan', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Prioritas: sl_price (harga tetap) > sl_points (poin) > sl_pct (persentase). Jika ketiganya 0, stop loss tidak ditetapkan, sama untuk take profit',
        rows: [
          ['InpSLPoints', '0', 'Poin stop loss default (0 = dinonaktifkan)', ''],
          ['InpSLPrice', '0', 'Harga tetap stop loss default (0 = dinonaktifkan, prioritas tertinggi)', ''],
          ['InpSLPct', '0', 'Persentase stop loss default (0 = dinonaktifkan)', ''],
          ['InpTPPoints', '0', 'Poin take profit default (0 = dinonaktifkan)', ''],
          ['InpTPPrice', '0', 'Harga tetap take profit default (0 = dinonaktifkan)', ''],
          ['InpTPPct', '0', 'Persentase take profit default (0 = dinonaktifkan)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Pemetaan nama simbol)',
        note: 'Broker mungkin menggunakan nama simbol yang berbeda (mis: TradingView menyebut XAUUSD, broker Anda menyebut GOLD). Pemetaan memungkinkan konversi otomatis',
        rows: [
          ['InpPrefix', '(kosong)', 'Awalan nama simbol, jika simbol broker adalah m.EURUSD masukkan m.', ''],
          ['InpSuffix', '(kosong)', 'Akhiran nama simbol, jika simbol broker adalah EURUSD.pro masukkan .pro', ''],
          ['InpEnableMap1~5', 'false', 'Atur ke true untuk mengaktifkan aturan pemetaan yang sesuai', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Aturan pemetaan, format: NamaTradingView|NamaMT5, mendukung hingga 5 aturan', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Sama seperti di atas', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Sama seperti di atas', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Sama seperti di atas', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Sama seperti di atas', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Filter waktu / Tampilan & log)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Jika diaktifkan, hanya memproses sinyal antara StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Waktu mulai trading yang diizinkan (waktu server MT5, format HH:MM)', ''],
          ['InpEndTime', '23:59', 'Waktu selesai trading yang diizinkan', ''],
          ['InpShowPanel', 'true', 'Tampilkan panel informasi status koneksi dan statistik sinyal di grafik', ''],
          ['InpUpdateInterval', '1000', 'Interval pembaruan panel (ms), direkomendasikan 1000~3000', ''],
          ['InpLogLevel', '1', 'Level log: 0=mati 1=dasar 2=detail 3=debug (gunakan 2 atau 3 untuk pemecahan masalah)', ''],
          ['InpLogToFile', 'true', 'Tulis file log ke MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Keluaran di tab "Pakar" di bagian bawah MT5', ''],
          ['InpMaxLogMB', '5', 'Ukuran maksimum file log (MB), rotasi otomatis saat terlampaui', '']
        ]
      }
    ],

    paramsEATitle: 'Penjelasan parameter EA',
    paramsEADesc: 'Parameter berikut dapat diatur saat membuka EA di MT5, dan juga dapat ditimpa melalui bidang yang sesuai di JSON sinyal.',
    paramName: 'Nama parameter',
    paramDefault: 'Nilai default',
    paramDesc: 'Deskripsi',
    paramOverride: 'Bidang timpa JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'Ukuran lot default (digunakan ketika JSON tidak menentukannya)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number default', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Komentar pesanan default', 'comment'],
      ['SlippagePoints', '3', 'Selip maksimum (poin)', '—'],
      ['OfflineBuffer', 'false', 'Aktifkan buffer offline', '—'],
      ['ReconnectSeconds', '5', 'Interval koneksi ulang WebSocket (detik)', '—']
    ],
    cmdTableTitle: 'Penjelasan jenis perintah',
    cmdCol: 'Perintah (cmd)',
    typeCol: 'Jenis',
    actionCol: 'Tindakan',
    extraCol: 'Parameter tambahan',
    cmdTable: [
      ['buy', 'Perintah pasar', 'Beli segera', 'lots, sl_*, tp_*'],
      ['sell', 'Perintah pasar', 'Jual segera', 'lots, sl_*, tp_*'],
      ['buylimit', 'Perintah tertunda', 'Beli saat harga tercapai', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Perintah tertunda', 'Jual saat harga tercapai', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Perintah tertunda', 'Beli pada breakout', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Perintah tertunda', 'Jual pada breakout', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Tutup', 'Tutup semua posisi long', 'magic (opsional)'],
      ['closesell', 'Tutup', 'Tutup semua posisi short', 'magic (opsional)'],
      ['closeall', 'Tutup', 'Tutup semua posisi terbuka', '—'],
      ['closeallorders', 'Tutup', 'Hapus semua perintah tertunda', '—']
    ],
    jsonFieldTitle: 'Penjelasan bidang JSON',
    fieldCol: 'Nama bidang',
    requiredCol: 'Wajib',
    descCol: 'Deskripsi',
    jsonFields: [
      ['license', 'string', 'Wajib', 'License ID'],
      ['key', 'string', 'Wajib', 'Secret Key'],
      ['cmd', 'string', 'Wajib', 'Perintah trading, lihat tabel di atas'],
      ['symbol', 'string', 'Wajib', 'Simbol trading, mis. EURUSD'],
      ['lots', 'number', 'Opsional', 'Ukuran lot, biarkan kosong untuk menggunakan nilai default EA'],
      ['price', 'number', 'Wajib untuk perintah tertunda', 'Harga perintah tertunda'],
      ['sl_points', 'number', 'Opsional', 'Poin stop loss'],
      ['sl_price', 'number', 'Opsional', 'Harga tetap stop loss'],
      ['sl_pct', 'number', 'Opsional', 'Persentase stop loss (0-100)'],
      ['tp_points', 'number', 'Opsional', 'Poin take profit'],
      ['tp_price', 'number', 'Opsional', 'Harga tetap take profit'],
      ['tp_pct', 'number', 'Opsional', 'Persentase take profit (0-100)'],
      ['magic', 'number', 'Opsional', 'Magic Number'],
      ['comment', 'string', 'Opsional', 'Komentar pesanan'],
      ['signalid', 'string', 'Opsional', 'ID unik sinyal, digunakan untuk deduplikasi'],
      ['expiryseconds', 'number', 'Opsional', 'Masa berlaku sinyal (detik), default 60']
    ],

    dlMt5Desc: 'Versi MT5 dari EA, mendukung semua perintah, direkomendasikan',
    dlMt5Btn: 'Unduh EA MT5',
    dlMt4Desc: 'Versi MT4 dari EA, sedang dalam pengembangan, nantikan',
    dlMt4Dev: 'Dalam pengembangan',
    dlInstallDoc: `<h4>Petunjuk instalasi</h4>
<ol>
<li>Unduh file <code>WikiConnector_MT5.ex5</code></li>
<li>Buka MT5, bilah menu → <strong>File → Buka folder data</strong></li>
<li>Salin file <code>.ex5</code> ke direktori <code>MQL5/Experts/</code></li>
<li>Tekan <strong>F5</strong> di MT5 untuk menyegarkan navigator, temukan EA WikiConnector</li>
<li>Seret EA ke grafik mana pun, masukkan <strong>License ID</strong> dan <strong>Secret Key</strong></li>
<li>Di opsi EA, centang <strong>Izinkan WebRequest</strong>, dan tambahkan <code>api-gw.interface003.com</code> ke daftar URL yang diizinkan</li>
</ol>`,

    disclaimerTitle: 'Penyangkalan risiko',
    disclaimerContent: `<p>Sebelum mengunduh dan menggunakan WikiConnector EA, harap baca penyangkalan berikut dengan saksama:</p>
<p><strong>1. Risiko trading</strong><br/>Trading Forex dan CFD mengandung risiko signifikan yang dapat mengakibatkan hilangnya seluruh atau sebagian modal. WikiConnector hanyalah alat transmisi sinyal dan tidak bertanggung jawab atas hasil trading apa pun.</p>
<p><strong>2. Risiko strategi</strong><br/>Kinerja masa lalu dari strategi trading otomatis tidak menjamin hasil di masa depan. Uji secara menyeluruh sebelum digunakan di akun nyata.</p>
<p><strong>3. Risiko teknis</strong><br/>Latensi jaringan, kegagalan server, dan batasan API dapat menyebabkan hilangnya sinyal atau keterlambatan eksekusi. Jangan gunakan alat ini untuk strategi frekuensi tinggi yang sensitif terhadap latensi.</p>
<p><strong>4. Tanggung jawab pengguna</strong><br/>Pengguna menanggung semua tanggung jawab atas semua hasil trading yang timbul dari penggunaan WikiConnector EA. WikiFX tidak memberikan nasihat investasi dan tidak bertanggung jawab atas keuntungan atau kerugian trading.</p>`,
    disclaimerAgree: 'Saya telah membaca dan menyetujui penyangkalan di atas dan memahami risiko trading',
    disclaimerDownload: 'Setuju dan unduh',

    regenTitle: 'Konfirmasi pengaturan ulang kunci?',
    regenSubtitle: 'Tindakan ini tidak dapat dibatalkan. Harap konfirmasi bahwa Anda memahami dampak berikut:',
    regenWarnings: ['Semua EA yang dikonfigurasi dengan kunci ini akan <strong>segera terputus</strong>', 'Kunci lama akan <strong>menjadi tidak berlaku secara permanen</strong> dan tidak dapat dipulihkan', 'Anda harus memperbarui konfigurasi Secret Key secara manual di semua EA', 'Ada risiko <strong>kehilangan sinyal</strong> selama pengaturan ulang'],

    dashTitle: 'WikiConnector Saya',
    myKey: 'Secret Key Saya',
    keyPrefix: 'Secret Key',
    copyBtn: 'Salin',
    regenBtn: 'Hasilkan ulang',
    regenConfirm: 'Setelah menghasilkan ulang kunci, semua EA yang terhubung akan terputus dan perlu dikonfigurasi ulang. Lanjutkan?',
    regenConfirmBtn: 'Konfirmasi pengaturan ulang',
    cancelBtn: 'Batal',
    copiedTip: 'Disalin',

    licenseTitle: 'Sertifikat Saya (License)',
    licenseId: 'ID Sertifikat',
    maxConn: 'Koneksi maksimum',
    activeConn: 'Koneksi saat ini',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Statistik sinyal',
    statTotal: 'Total sinyal',
    statDelivered: 'Terkirim',
    statFailed: 'Gagal',
    statConnections: 'Koneksi saat ini',

    signalTitle: 'Catatan sinyal terbaru',
    signalTime: 'Waktu',
    signalCmd: 'Perintah',
    signalSymbol: 'Simbol',
    signalLots: 'Ukuran lot',
    signalStatus: 'Status',
    signalLicense: 'Sertifikat',
    statusDelivered: 'Terkirim',
    statusPending: 'Menunggu',
    statusFailed: 'Gagal',
    statusExpired: 'Kedaluwarsa',
    noSignal: 'Belum ada catatan sinyal',
    loadMore: 'Muat lebih banyak',

    offlineBuffer: 'Buffer offline',
    offlineBufferDesc: 'Jika diaktifkan, sinyal yang terkumpul selama periode offline akan dikirim saat EA terhubung kembali (dinonaktifkan secara default untuk mencegah kerugian)',

    docTitle: 'Panduan penggunaan',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Cara kerja WikiConnector</p>
  <p>WikiConnector menerima sinyal TradingView secara real-time melalui <strong>koneksi WebSocket persisten</strong> dan secara otomatis mengeksekusi trading di perangkat lunak trading.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Instal EA di perangkat lunak trading</p>
  <ol class="doc-steps">
    <li><strong>Buka folder data</strong>: Menu perangkat lunak trading → File → Buka folder data</li>
    <li><strong>Salin file EA</strong>: Salin file EA ke direktori <code>Experts/</code></li>
    <li><strong>Segarkan navigator</strong>: Buka navigator → klik kanan "Expert Advisors" → Segarkan. <strong>SignalReceiver</strong> akan muncul di daftar</li>
    <li><strong>Aktifkan trading otomatis</strong>: Tombol "Trading otomatis" di bilah alat atas harus 🟢 hijau</li>
    <li><strong>Terapkan ke grafik</strong>: Seret SignalReceiver ke grafik mana pun. Setelah jendela pengaturan muncul, konfigurasikan parameter</li>
  </ol>
  <div class="doc-tip"><strong>Tips:</strong> EA hanya perlu diterapkan pada satu grafik untuk memproses sinyal semua simbol. Tidak perlu menerapkannya secara individual pada setiap grafik.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Konfigurasi parameter EA</p>
  <p>Ada dua jenis parameter: <strong>wajib</strong> (License / SecretKey) dan <strong>parameter default</strong> (digunakan ketika JSON sinyal tidak menyertakan bidang tertentu; nilai dalam sinyal selalu didahulukan daripada nilai default EA).</p>
  <div class="doc-warn"><strong>Peringatan keamanan:</strong> License dan SecretKey adalah satu-satunya penghalang yang melindungi akun Anda. Jika bocor, siapa pun dapat mengirim perintah trading ke perangkat lunak trading Anda. Jangan mengambil tangkapan layar atau membaginya dengan orang lain. Disarankan untuk mengganti SecretKey secara berkala.</div>
  <p>Setelah pengaturan selesai, nama EA + <strong>😊</strong> akan muncul di sudut kanan atas grafik, menunjukkan bahwa EA terhubung ke server. Jika 😞 muncul, periksa apakah tombol "Trading otomatis" berwarna hijau.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Menulis kode Pine Script untuk sinyal</p>
  <p>WikiConnector menggunakan fungsi <code>alert()</code> untuk memicu sinyal, bukan metode <code>strategy.entry(alert_message=)</code>. Keduanya adalah mekanisme yang berbeda, jangan dicampur.</p>
  <div class="doc-danger"><strong>Penting: alert.freq_all</strong> — Secara default, di Pine Script, hanya <code>alert()</code> pertama dalam lilin yang sama yang dipicu, sisanya diam-diam dibuang. Jika Anda perlu mengirim beberapa sinyal berturut-turut (misalnya: dalam pembalikan, tutup short dulu lalu buka long), Anda harus menambahkan <code>alert.freq_all</code> ke setiap <code>alert()</code>, jika tidak, sinyal kedua tidak akan pernah mencapai server.</div>
<pre>//@version=6
strategy("Strategi WikiConnector", overlay=true)

// Tentukan pesan sinyal (ganti YOUR_LICENSE dan YOUR_KEY dengan nilai Anda sendiri)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Contoh kondisi strategi (persilangan rata-rata bergerak 3/13)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Gunakan alert.freq_all untuk memastikan beberapa sinyal terkirim dalam lilin yang sama
if longCondition
    alert(closesellMessage, alert.freq_all)  // Tutup posisi short dulu
    alert(buyMessage,       alert.freq_all)  // Lalu buka posisi long

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Tutup posisi long dulu
    alert(sellMessage,     alert.freq_all)   // Lalu buka posisi short</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Buat Alert di TradingView</p>
  <p>URL Webhook:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Klik kanan pada grafik → "<strong>Tambahkan Alert...</strong>" atau <strong>Alt+A</strong></li>
    <li>Sebagai kondisi pemicu, pilih <strong>"Hanya panggilan fungsi alert()"</strong> (penting!)</li>
    <li>Pilih tanggal kedaluwarsa selama mungkin, atau "Tanpa batas waktu"</li>
    <li>Kotak Pesan <strong>biarkan default, jangan isi apa pun</strong> (konten sinyal ditentukan oleh alert() dalam kode)</li>
    <li>Pengaturan notifikasi: centang <strong>Webhook URL</strong> dan masukkan alamat di atas; <strong>hapus centang "Kirim teks biasa"</strong></li>
    <li>Klik "Buat" untuk menyimpan Alert</li>
  </ol>
  <div class="doc-tip"><strong>Tips:</strong> Fungsi Webhook memerlukan langganan TradingView Pro atau lebih tinggi.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Penjelasan format JSON sinyal</p>
  <p><strong>Bidang wajib:</strong><code>license</code> (ID otorisasi), <code>key</code> (kunci), <code>cmd</code> (perintah), <code>symbol</code> (nama simbol)</p>
  <p><strong>Bidang opsional:</strong><code>lots</code> (ukuran lot), <code>price</code> (harga perintah tertunda), <code>sl_points / sl_price / sl_pct</code> (stop loss tiga pilihan), <code>tp_points / tp_price / tp_pct</code> (take profit tiga pilihan), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (default 300 detik)</p>
  <p><strong>Perintah yang didukung:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Prioritas stop loss/take profit:</strong><code>sl_price</code> (harga tetap)&gt; <code>sl_points</code> (poin)&gt; <code>sl_pct</code> (persentase). Jika ketiganya 0, stop loss tidak ditetapkan, sama untuk take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Daftar periksa sebelum beroperasi</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Tombol trading otomatis perangkat lunak trading 🟢 hijau</li>
    <li class="ok">✅ EA di sudut kanan atas grafik menampilkan 😊 (terhubung ke server)</li>
    <li class="ok">✅ License / SecretKey cocok persis dengan nilai di JSON TradingView</li>
    <li class="ok">✅ Kondisi pemicu Alert "<strong>Hanya panggilan fungsi alert()</strong>"</li>
    <li class="ok">✅ Setiap <code>alert()</code> telah ditambahkan <code>alert.freq_all</code></li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Kotak Pesan dibiarkan default, kosong</li>
    <li class="no">❌ "Kirim teks biasa" tidak dicentang</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Tips keamanan dan risiko</p>
  <div class="doc-warn">
    <strong>Keamanan akun:</strong><br>
    · Jangan mengambil tangkapan layar License dan SecretKey atau membaginya dengan siapa pun<br>
    · Jika Anda mencurigai kunci bocor, segera atur ulang SecretKey di konsol<br>
    · Disarankan untuk mengganti SecretKey secara berkala
  </div>
  <div class="doc-warn">
    <strong>Manajemen risiko trading:</strong><br>
    · Selalu tetapkan stop loss, jangan menjalankan strategi otomatis tanpa perlindungan<br>
    · Disarankan agar risiko per trading berada dalam 1-2% dari saldo akun<br>
    · Sebelum data ekonomi penting (NFP, CPI, FOMC), disarankan untuk menjeda trading otomatis
  </div>
  <div class="doc-tip">
    <strong>Praktik terbaik:</strong><br>
    · Uji coba dulu di akun demo setidaknya 1-2 minggu untuk memastikan tautan berfungsi normal sebelum beralih ke akun nyata<br>
    · Di akun nyata, mulailah dengan ukuran lot minimum (0,01 lot)<br>
    · Gunakan VPS (seperti Tianyun Cloud VPS) untuk menjaga perangkat lunak trading dan EA tetap online 24/7
  </div>
</div>`,
    docSections: [
      {
        title: '1. Format sinyal Webhook',
        content: `Di kotak Pesan Alert TradingView, masukkan JSON berikut:
<pre>{
  "license": "{{LicenseID Anda}}",
  "key": "{{SecretKey Anda}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Perintah <strong>cmd</strong> yang didukung: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. Alamat Webhook TradingView',
        content: `<p>Di pengaturan Alert TradingView, atur URL Webhook sebagai berikut:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Di kotak Pesan, masukkan format JSON sinyal di atas dan ganti license dan key dengan nilai Anda sendiri.</p>`
      },
      {
        title: '3. Instal WikiConnector EA',
        content: `<p>1. Unduh WikiConnector EA (file .ex5)</p>
<p>2. Salin EA ke direktori <code>MQL5/Experts</code> MT5</p>
<p>3. Buka EA di MT5 dan masukkan <strong>License ID</strong> dan <strong>Secret Key</strong></p>
<p>4. Izinkan EA melakukan koneksi WebSocket (di Opsi MT5 → EA, aktifkan izin koneksi jaringan)</p>`
      },
      {
        title: '4. Batas kecepatan',
        content: `<p>Maksimum <strong>30 permintaan / 60 detik</strong> per Lisensi. Melebihi batas akan mengembalikan kesalahan 429.</p>
<p>Jika Anda membutuhkan frekuensi yang lebih tinggi, hubungi layanan pelanggan untuk meningkatkan paket Anda.</p>`
      }
    ],

    faqTitle: 'Pertanyaan umum',
    faqs: [
      {
        q: 'Apa yang harus dilakukan jika kunci bocor?',
        a: 'Klik "Hasilkan ulang" di konsol. Kunci lama akan segera menjadi tidak berlaku dan semua koneksi EA akan terputus. Konfigurasi ulang EA dengan kunci baru.'
      },
      {
        q: 'Apakah sinyal akan dikirim ulang setelah EA terhubung kembali?',
        a: 'Secara default tidak (untuk mencegah kerugian). Jika Anda memerlukan pengiriman ulang, aktifkan "Buffer offline" di konsol. Saat EA terhubung kembali, ia akan menerima sinyal yang terkumpul selama periode offline.'
      },
      {
        q: 'Berapa banyak akun MT yang dapat dihubungkan oleh satu Lisensi?',
        a: 'Setiap Lisensi mendukung hingga 10 koneksi WebSocket bersamaan, sehingga hingga 10 terminal MT dapat menerima sinyal yang sama secara bersamaan.'
      },
      {
        q: 'Apakah MT4 didukung?',
        a: 'Versi saat ini terutama mendukung MT5. Versi MT4 dari EA sedang dalam pengembangan. Nantikan!'
      },
      {
        q: 'Berapa latensi sinyal?',
        a: 'Latensi rata-rata <100 md. Dengan Tianyun Cloud VPS, dapat serendah 1 md.'
      },
      {
        q: 'Bagaimana cara menguji apakah Webhook berfungsi dengan benar?',
        a: 'Di daftar sertifikat, periksa "Jumlah koneksi saat ini". Jika lebih besar dari 0, EA online. Setelah mengirim sinyal uji, periksa "Catatan sinyal terbaru" untuk melihat status "Terkirim".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script dan pengiriman sinyal',
        items: [
          {
            q: 'Saya menggunakan dua alert() untuk menutup dan membuka, tetapi perangkat lunak trading hanya menerima satu sinyal.',
            a: 'Ini adalah batasan default Pine Script: dalam lilin yang sama, hanya alert() pertama yang dipicu. Solusinya adalah <strong>menambahkan parameter <code>alert.freq_all</code> ke setiap alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Kondisi pemicu Alert apa yang harus saya pilih?',
            a: 'Saat menggunakan fungsi <code>alert()</code>, Anda harus memilih <strong>"Hanya panggilan fungsi alert()"</strong>. Jika Anda menggunakan metode <code>strategy.entry(..., alert_message=xxx)</code>, pilih "Order fills only". Kedua metode tidak boleh dicampur.'
          },
          {
            q: 'Apa yang harus saya isi di kotak Pesan?',
            a: 'Saat menggunakan metode <code>alert()</code>, <strong>biarkan kotak Pesan default, jangan isi apa pun</strong>. Konten sinyal ditentukan oleh string di dalam <code>alert(xxx)</code> dalam kode, dan Webhook akan menerima JSON tersebut.'
          }
        ]
      },
      {
        title: '🔌 Koneksi dan penerimaan sinyal',
        items: [
          {
            q: 'Ikon EA menampilkan wajah merah menangis 😞. Apa yang harus saya lakukan?',
            a: 'Periksa apakah tombol "Trading otomatis" di bilah alat perangkat lunak trading berwarna hijau. Jika merah, klik untuk mengubahnya menjadi hijau. EA akan otomatis kembali ke keadaan normal.'
          },
          {
            q: 'Saya mengirim sinyal dari TradingView tetapi perangkat lunak trading tidak merespons.',
            a: 'Periksa dalam urutan ini:<br>1. Apakah trading otomatis perangkat lunak trading hijau?<br>2. Apakah panel EA menampilkan "Connected"?<br>3. Apakah URL Webhook adalah <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. Apakah kondisi pemicu Alert adalah "Hanya panggilan fungsi alert()"?<br>5. Apakah setiap alert() memiliki <code>alert.freq_all</code>?<br>6. Apakah license dan key di JSON cocok persis dengan pengaturan EA?'
          }
        ]
      },
      {
        title: '💰 Eksekusi trading',
        items: [
          {
            q: 'Perintah gagal. Apa penyebabnya?',
            a: 'Penyebab umum: Saldo tidak mencukupi / Nama simbol tidak cocok (perlu konfigurasi Symbol Mapping) / Ukuran lot terlampaui / Selip terlalu besar (tingkatkan InpDeviation) / Pasar tutup. Periksa log "Pakar" di bagian bawah perangkat lunak trading untuk informasi kesalahan spesifik.'
          },
          {
            q: 'Perintah tidak memiliki stop loss atau take profit.',
            a: 'Periksa: ① Apakah JSON sinyal menyertakan bidang seperti <code>sl_points</code> / <code>tp_points</code> dll.?; ② Apakah parameter stop loss/take profit default EA adalah 0? Jika keduanya tidak diatur, perintah tidak akan memiliki stop loss atau take profit.'
          },
          {
            q: 'Nama simbol tidak cocok. Apa yang harus dilakukan?',
            a: 'Aktifkan Symbol Mapping di parameter EA:<br>Atur <code>InpEnableMap1 = true</code><br>Atur <code>InpMapping1 = XAUUSD|GOLD</code> (NamaTradingView|NamaPerangkatLunakTrading)'
          },
          {
            q: 'Bisakah saya menguji dulu di akun demo?',
            a: '<strong>Sangat disarankan!</strong> Pada penggunaan pertama, Anda harus menguji di akun demo setidaknya 1-2 minggu untuk memastikan tautan berfungsi normal dan eksekusi perintah benar sebelum beralih ke akun nyata. Mulailah dengan ukuran lot minimum 0,01.'
          }
        ]
      }
    ]
  },

  // === hi हिन्दी ===
  hi: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'TradingView सिग्नल को स्वचालित रूप से MetaTrader से कनेक्ट करें और ट्रेड निष्पादित करें',
    heroBtn: 'मुफ्त शुरू करें',

    stat1Label: 'औसत विलंबता',
    stat2Label: 'सेवा उपलब्धता',
    stat3Label: '24/7 संचालन',
    stat4Label: 'मल्टी-अकाउंट वितरण',

    flowSub1: 'रणनीति / अलर्ट',
    flowSub2: 'सिग्नल रूटिंग',
    flowSub3: 'स्वचालित निष्पादन',

    featTitle: 'WikiConnector क्यों चुनें',
    featSubtitle: 'मुख्य लाभ',
    features: [
      {
        icon: '⚡',
        title: 'मिलीसेकंड में निष्पादन',
        desc: 'औसत सिग्नल विलंबता <100ms, WikiFX VPS के साथ 1ms तक कम हो सकती है।'
      },
      {
        icon: '🔗',
        title: 'मल्टी-अकाउंट वितरण',
        desc: 'एक प्रमाणपत्र कई MT टर्मिनलों को जोड़ता है, एक ही रणनीति सिग्नल को एक साथ वितरित करता है।'
      },
      {
        icon: '🔒',
        title: 'सुरक्षित एन्क्रिप्शन',
        desc: 'प्रति उपयोगकर्ता स्वतंत्र कुंजी प्रणाली, पूर्ण-श्रृंखला एन्क्रिप्टेड डेटा ट्रांसमिशन।'
      },
      {
        icon: '📊',
        title: 'रीयल-टाइम मॉनिटरिंग',
        desc: 'सिग्नल प्राप्ति स्थिति, निष्पादन विलंबता और सफलता दर रीयल-टाइम में देखी जा सकती है।'
      },
      {
        icon: '<>',
        title: 'कोड जनरेटर',
        desc: 'दृश्य रूप से JSON सिग्नल और Pine Script कोड उत्पन्न करें, प्रोग्रामिंग की आवश्यकता नहीं।'
      },
      {
        icon: '🖥',
        title: 'VPS के साथ गहन एकीकरण',
        desc: 'Tianyun Cloud VPS के साथ खाता प्रणाली साझा करें, 24/7 कम-विलंबता संचालन।'
      }
    ],

    stepsTitle: 'स्वचालित ट्रेडिंग शुरू करने के चार कदम',
    stepsSubtitle: 'त्वरित शुरुआत',
    steps: [
      {
        title: 'लॉग इन करें',
        desc: 'अपने WikiFX खाते से लॉग इन करें, स्वचालित रूप से अपनी विशेष कुंजी और लाइसेंस प्राप्त करें।'
      },
      {
        title: 'Webhook कॉन्फ़िगर करें',
        desc: 'Webhook URL को TradingView अलर्ट सेटिंग्स में कॉपी करें।'
      },
      {
        title: 'EA इंस्टॉल करें',
        desc: 'WikiConnector EA डाउनलोड करें और License ID और Secret Key दर्ज करें।'
      },
      {
        title: 'स्वचालित ट्रेडिंग',
        desc: 'जब आपकी रणनीति अलर्ट ट्रिगर करती है, सिग्नल स्वचालित रूप से निष्पादन के लिए MT टर्मिनल पर भेज दिया जाता है।'
      }
    ],

    loginTip: 'लॉग इन करने के बाद, आप अपनी विशेष कुंजी और प्रमाणपत्र देख सकते हैं',
    loginBtn: 'अभी लॉग इन करें',

    navConn: 'कनेक्शन प्रबंधन',
    navLog: 'सिग्नल लॉग',
    navGen: 'कोड जनरेटर',
    navParams: 'पैरामीटर त्वरित संदर्भ',
    navDl: 'डाउनलोड',
    navDoc: 'उपयोग ट्यूटोरियल',
    navFaq: 'सामान्य प्रश्न',

    keyLabel: 'Secret Key',
    keyTip1: 'इसे किसी के साथ साझा न करें',
    keyTip2: 'EA प्रमाणीकरण के लिए उपयोग किया जाता है',
    keyTip3: 'रीसेट करने के बाद, पुरानी कुंजी तुरंत अमान्य हो जाती है',

    connSubtitle: 'नीचे आपके लाइसेंस और उनके संबंधित Webhook URL दिए गए हैं',
    noLicense: 'कोई लाइसेंस उपलब्ध नहीं है। कृपया ग्राहक सेवा से संपर्क करें',
    needHelp: 'मदद चाहिए?',
    viewDoc: 'उपयोग ट्यूटोरियल देखें',

    allLicense: 'सभी लाइसेंस',
    allStatus: 'सभी स्थितियाँ',
    refresh: 'ताज़ा करें',
    signalId: 'सिग्नल ID',
    total: 'कुल',
    records: 'रिकॉर्ड',

    genIntro: 'निम्नलिखित पैरामीटर भरें, TradingView अलर्ट में उपयोग के लिए स्वचालित रूप से JSON सिग्नल और Pine Script कोड उत्पन्न होगा।',
    genAuth: 'प्रमाणीकरण जानकारी',
    required: 'आवश्यक',
    optional: 'वैकल्पिक',
    genLicPlaceholder: 'अपना License ID दर्ज करें',
    genLicHint: 'कनेक्शन प्रबंधन पृष्ठ पर देखा जा सकता है',
    genKeyPlaceholder: 'अपना Secret Key दर्ज करें',
    genKeyHint: 'कनेक्शन प्रबंधन पृष्ठ पर देखा जा सकता है',
    genTrade: 'ट्रेड ऑर्डर',
    genCmd: 'ऑर्डर प्रकार',
    genMarket: 'मार्केट ऑर्डर',
    genPending: 'लंबित ऑर्डर',
    genClose: 'बंद करें',
    cmdBuy: 'मार्केट खरीद',
    cmdSell: 'मार्केट बेच',
    cmdBuyLimit: 'सीमित खरीद',
    cmdSellLimit: 'सीमित बेच',
    cmdBuyStop: 'ब्रेकआउट खरीद',
    cmdSellStop: 'ब्रेकआउट बेच',
    cmdCloseBuy: 'लॉन्ग पोजीशन बंद करें',
    cmdCloseSell: 'शॉर्ट पोजीशन बंद करें',
    cmdCloseAll: 'इस सिंबल को बंद करें',
    cmdCloseAllOrders: 'सब बंद करें',
    genSlTpHint: 'तीन में से एक चुनें · प्राथमिकता: मूल्य > अंक > प्रतिशत',
    genTsHint: 'सिग्नल भेजने का समय',
    genTsBtn: 'वर्तमान समय',
    presetSimple: '📝 सरल खरीद',
    presetSltp: '🛡 स्टॉप लॉस और टेक प्रॉफिट के साथ',
    presetFull: '📋 पूर्ण पैरामीटर',
    presetClose: '❌ बंद करने का सिग्नल',
    presetPending: '📌 लंबित ऑर्डर',
    presetReverse: '🔄 उलट (बंद + खोलें)',
    genAlertTab: '🔔 अलर्ट सेटिंग स्पष्टीकरण',
    toastIncomplete: 'जानकारी अधूरी है। कृपया आवश्यक फ़ील्ड भरें',
    toastRegen: 'नई कुंजी उत्पन्न हो गई है। इसे तुरंत कॉपी करें और सभी कॉन्फ़िगर किए गए EA को अपडेट करें',
    toastKeyCopied: 'कुंजी कॉपी हो गई',
    toastCopied: 'कॉपी हो गया',
    toastCodeCopied: 'कोड कॉपी हो गया',
    copyTitle: 'कॉपी करें',
    genSymbol: 'ट्रेडिंग सिंबल',
    genPrice: 'लंबित ऑर्डर मूल्य',
    genParams: 'ट्रेडिंग पैरामीटर',
    genLots: 'लॉट आकार',
    genLotsHint: 'खाली छोड़ने पर EA डिफ़ॉल्ट मान का उपयोग होगा',
    genMagic: 'Magic Number',
    genMagicHint: 'विभिन्न रणनीतियों के ऑर्डर को अलग करने के लिए उपयोग किया जाता है',
    genComment: 'ऑर्डर टिप्पणी',
    genCommentHint: 'उदाहरण: Strategy A',
    genSL: 'स्टॉप लॉस सेटिंग',
    genPoints: 'अंक',
    genPrice2: 'निश्चित मूल्य',
    genPct: 'प्रतिशत %',
    genTP: 'टेक प्रॉफिट सेटिंग',
    genAdvanced: 'उन्नत पैरामीटर',
    genSigIdHint: 'खाली छोड़ने पर स्वचालित रूप से उत्पन्न होगा, डुप्लिकेशन रोकने के लिए उपयोग किया जाता है',
    genGenId: 'स्वचालित रूप से उत्पन्न करें',
    genBtn: 'कोड उत्पन्न करें',
    genFormat: 'सिग्नल प्रारूप',
    genGuideTitle: 'TradingView में इसका उपयोग कैसे करें',
    genGuideSteps: [
      'अपने TradingView चार्ट पर एक <strong>अलर्ट (Alert)</strong> बनाएं',
      '<strong>अलर्ट ट्रिगर स्थिति</strong> में अपनी रणनीति या संकेतक चुनें',
      '<strong>सूचनाएं (Notifications)</strong> का विस्तार करें → <strong>Webhook URL</strong> चेक करें',
      'Webhook URL दर्ज करें: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'ऊपर उत्पन्न JSON को <strong>संदेश (Message)</strong> बॉक्स में पेस्ट करें',
      'अलर्ट सहेजने के लिए <strong>बनाएं (Create)</strong> पर क्लिक करें'
    ],
    genGuideNote: '<strong>सुझाव:</strong> यदि आप Pine Script का उपयोग कर रहे हैं, तो उत्पन्न कोड को अपनी स्क्रिप्ट में जोड़ें और <code>strategy.entry()</code> या <code>strategy.close()</code> में <code>alert_message</code> पैरामीटर का उपयोग करें।',

    paramsGroups: [
      {
        title: '🔐 Authorization (प्राधिकरण) — बदलना आवश्यक',
        rows: [
          ['License', '—', 'प्राधिकरण ID, सिग्नल JSON के license फ़ील्ड से बिल्कुल मेल खाना चाहिए', 'req'],
          ['SecretKey', '—', 'सुरक्षा कुंजी (wc_sk_ से शुरू होती है), सिग्नल JSON के key फ़ील्ड से बिल्कुल मेल खाना चाहिए', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (डिफ़ॉल्ट ट्रेडिंग पैरामीटर)',
        rows: [
          ['InpLots', '0.1', 'डिफ़ॉल्ट लॉट आकार, जब सिग्नल JSON में lots न हो तब उपयोग किया जाता है', ''],
          ['InpMagic', '888', 'डिफ़ॉल्ट मैजिक नंबर, विभिन्न रणनीतियों के ऑर्डर को अलग करने के लिए', ''],
          ['InpComment', 'TV Signal', 'डिफ़ॉल्ट ऑर्डर टिप्पणी', ''],
          ['InpDeviation', '30', 'अधिकतम स्लिपेज (अंक), फॉरेक्स के लिए 10–30, सोना/सूचकांक के लिए 30–50 अनुशंसित', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'प्राथमिकता: sl_price (निश्चित मूल्य) > sl_points (अंक) > sl_pct (प्रतिशत)। यदि तीनों 0 हैं, तो कोई स्टॉप लॉस सेट नहीं होगा, टेक प्रॉफिट के लिए भी यही',
        rows: [
          ['InpSLPoints', '0', 'डिफ़ॉल्ट स्टॉप लॉस अंक (0 = निष्क्रिय)', ''],
          ['InpSLPrice', '0', 'डिफ़ॉल्ट स्टॉप लॉस निश्चित मूल्य (0 = निष्क्रिय, उच्चतम प्राथमिकता)', ''],
          ['InpSLPct', '0', 'डिफ़ॉल्ट स्टॉप लॉस प्रतिशत (0 = निष्क्रिय)', ''],
          ['InpTPPoints', '0', 'डिफ़ॉल्ट टेक प्रॉफिट अंक (0 = निष्क्रिय)', ''],
          ['InpTPPrice', '0', 'डिफ़ॉल्ट टेक प्रॉफिट निश्चित मूल्य (0 = निष्क्रिय)', ''],
          ['InpTPPct', '0', 'डिफ़ॉल्ट टेक प्रॉफिट प्रतिशत (0 = निष्क्रिय)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (सिंबल नाम मैपिंग)',
        note: 'ब्रोकर अलग-अलग सिंबल नामों का उपयोग कर सकते हैं (जैसे: TradingView XAUUSD कहता है, आपका ब्रोकर GOLD कहता है)। मैपिंग स्वचालित रूपांतरण की अनुमति देती है',
        rows: [
          ['InpPrefix', '(खाली)', 'सिंबल नाम का उपसर्ग, यदि ब्रोकर का सिंबल m.EURUSD है तो m. दर्ज करें', ''],
          ['InpSuffix', '(खाली)', 'सिंबल नाम का प्रत्यय, यदि ब्रोकर का सिंबल EURUSD.pro है तो .pro दर्ज करें', ''],
          ['InpEnableMap1~5', 'false', 'संबंधित मैपिंग नियम को सक्रिय करने के लिए true पर सेट करें', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'मैपिंग नियम, प्रारूप: TradingViewनाम|MT5नाम, अधिकतम 5 नियमों का समर्थन', ''],
          ['InpMapping2', 'EURUSD|EUR', 'ऊपर जैसा ही', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'ऊपर जैसा ही', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'ऊपर जैसा ही', ''],
          ['InpMapping5', 'USOUSD|WTI', 'ऊपर जैसा ही', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (समय फ़िल्टर / प्रदर्शन और लॉग)',
        rows: [
          ['InpUseTimeFilter', 'false', 'सक्रिय होने पर, केवल StartTime~EndTime के बीच सिग्नल प्रोसेस करता है', ''],
          ['InpStartTime', '00:00', 'ट्रेडिंग के लिए अनुमत प्रारंभ समय (MT5 सर्वर समय, प्रारूप HH:MM)', ''],
          ['InpEndTime', '23:59', 'ट्रेडिंग के लिए अनुमत समाप्ति समय', ''],
          ['InpShowPanel', 'true', 'चार्ट पर कनेक्शन स्थिति और सिग्नल आँकड़ों की सूचना पैनल प्रदर्शित करें', ''],
          ['InpUpdateInterval', '1000', 'पैनल अद्यतन अंतराल (ms), 1000~3000 अनुशंसित', ''],
          ['InpLogLevel', '1', 'लॉग स्तर: 0=बंद 1=बुनियादी 2=विस्तृत 3=डीबग (समस्या निवारण के लिए 2 या 3 का उपयोग करें)', ''],
          ['InpLogToFile', 'true', 'लॉग फ़ाइल MQL5/Logs/ में लिखें', ''],
          ['InpLogToConsole', 'true', 'MT5 के निचले भाग में "विशेषज्ञ" टैब में आउटपुट', ''],
          ['InpMaxLogMB', '5', 'लॉग फ़ाइल का अधिकतम आकार (MB), अधिक होने पर स्वचालित रोटेशन', '']
        ]
      }
    ],

    paramsEATitle: 'EA पैरामीटर स्पष्टीकरण',
    paramsEADesc: 'निम्नलिखित पैरामीटर MT5 में EA खोलते समय सेट किए जा सकते हैं, और सिग्नल JSON में संबंधित फ़ील्ड द्वारा ओवरराइड भी किए जा सकते हैं।',
    paramName: 'पैरामीटर नाम',
    paramDefault: 'डिफ़ॉल्ट मान',
    paramDesc: 'विवरण',
    paramOverride: 'JSON ओवरराइड फ़ील्ड',
    eaParams: [
      ['DefaultLots', '0.1', 'डिफ़ॉल्ट लॉट आकार (जब JSON निर्दिष्ट न करे तब उपयोग किया जाता है)', 'lots'],
      ['DefaultMagic', '0', 'डिफ़ॉल्ट Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', 'डिफ़ॉल्ट ऑर्डर टिप्पणी', 'comment'],
      ['SlippagePoints', '3', 'अधिकतम स्लिपेज (अंक)', '—'],
      ['OfflineBuffer', 'false', 'ऑफ़लाइन बफर सक्रिय करें', '—'],
      ['ReconnectSeconds', '5', 'WebSocket पुनः कनेक्शन अंतराल (सेकंड)', '—']
    ],
    cmdTableTitle: 'ऑर्डर प्रकार स्पष्टीकरण',
    cmdCol: 'ऑर्डर (cmd)',
    typeCol: 'प्रकार',
    actionCol: 'क्रिया',
    extraCol: 'अतिरिक्त पैरामीटर',
    cmdTable: [
      ['buy', 'मार्केट ऑर्डर', 'तुरंत खरीदें', 'lots, sl_*, tp_*'],
      ['sell', 'मार्केट ऑर्डर', 'तुरंत बेचें', 'lots, sl_*, tp_*'],
      ['buylimit', 'लंबित ऑर्डर', 'मूल्य पर पहुँचने पर खरीदें', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'लंबित ऑर्डर', 'मूल्य पर पहुँचने पर बेचें', 'price, lots, sl_*, tp_*'],
      ['buystop', 'लंबित ऑर्डर', 'ब्रेकआउट पर खरीदें', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'लंबित ऑर्डर', 'ब्रेकआउट पर बेचें', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'बंद करें', 'सभी लॉन्ग पोजीशन बंद करें', 'magic (वैकल्पिक)'],
      ['closesell', 'बंद करें', 'सभी शॉर्ट पोजीशन बंद करें', 'magic (वैकल्पिक)'],
      ['closeall', 'बंद करें', 'सभी खुली पोजीशन बंद करें', '—'],
      ['closeallorders', 'बंद करें', 'सभी लंबित ऑर्डर हटाएं', '—']
    ],
    jsonFieldTitle: 'JSON फ़ील्ड स्पष्टीकरण',
    fieldCol: 'फ़ील्ड नाम',
    requiredCol: 'आवश्यक',
    descCol: 'विवरण',
    jsonFields: [
      ['license', 'string', 'आवश्यक', 'License ID'],
      ['key', 'string', 'आवश्यक', 'Secret Key'],
      ['cmd', 'string', 'आवश्यक', 'ट्रेड ऑर्डर, ऊपर तालिका देखें'],
      ['symbol', 'string', 'आवश्यक', 'ट्रेडिंग सिंबल, जैसे EURUSD'],
      ['lots', 'number', 'वैकल्पिक', 'लॉट आकार, खाली छोड़ने पर EA डिफ़ॉल्ट का उपयोग होगा'],
      ['price', 'number', 'लंबित ऑर्डर के लिए आवश्यक', 'लंबित ऑर्डर मूल्य'],
      ['sl_points', 'number', 'वैकल्पिक', 'स्टॉप लॉस अंक'],
      ['sl_price', 'number', 'वैकल्पिक', 'स्टॉप लॉस निश्चित मूल्य'],
      ['sl_pct', 'number', 'वैकल्पिक', 'स्टॉप लॉस प्रतिशत (0-100)'],
      ['tp_points', 'number', 'वैकल्पिक', 'टेक प्रॉफिट अंक'],
      ['tp_price', 'number', 'वैकल्पिक', 'टेक प्रॉफिट निश्चित मूल्य'],
      ['tp_pct', 'number', 'वैकल्पिक', 'टेक प्रॉफिट प्रतिशत (0-100)'],
      ['magic', 'number', 'वैकल्पिक', 'Magic Number'],
      ['comment', 'string', 'वैकल्पिक', 'ऑर्डर टिप्पणी'],
      ['signalid', 'string', 'वैकल्पिक', 'अद्वितीय सिग्नल ID, डुप्लिकेशन रोकने के लिए उपयोग किया जाता है'],
      ['expiryseconds', 'number', 'वैकल्पिक', 'सिग्नल की वैधता अवधि (सेकंड), डिफ़ॉल्ट 60']
    ],

    dlMt5Desc: 'MT5 संस्करण EA, सभी ऑर्डर का समर्थन करता है, अनुशंसित',
    dlMt5Btn: 'MT5 EA डाउनलोड करें',
    dlMt4Desc: 'MT4 संस्करण EA, विकासाधीन है, प्रतीक्षा करें',
    dlMt4Dev: 'विकासाधीन',
    dlInstallDoc: `<h4>स्थापना निर्देश</h4>
<ol>
<li><code>WikiConnector_MT5.ex5</code> फ़ाइल डाउनलोड करें</li>
<li>MT5 खोलें, मेनू बार → <strong>फ़ाइल → डेटा फ़ोल्डर खोलें</strong></li>
<li><code>.ex5</code> फ़ाइल को <code>MQL5/Experts/</code> निर्देशिका में कॉपी करें</li>
<li>MT5 में <strong>F5</strong> दबाकर नेविगेटर को ताज़ा करें, WikiConnector EA ढूंढें</li>
<li>EA को किसी भी चार्ट पर खींचें, <strong>License ID</strong> और <strong>Secret Key</strong> दर्ज करें</li>
<li>EA विकल्पों में, <strong>WebRequest की अनुमति दें</strong> चेक करें, और अनुमत URL सूची में <code>api-gw.interface003.com</code> जोड़ें</li>
</ol>`,

    disclaimerTitle: 'जोखिम अस्वीकरण',
    disclaimerContent: `<p>WikiConnector EA डाउनलोड और उपयोग करने से पहले, कृपया निम्नलिखित अस्वीकरण को ध्यान से पढ़ें:</p>
<p><strong>1. ट्रेडिंग जोखिम</strong><br/>विदेशी मुद्रा और CFD ट्रेडिंग में महत्वपूर्ण जोखिम शामिल हैं जो पूंजी के पूर्ण या आंशिक नुकसान का कारण बन सकते हैं। WikiConnector केवल एक सिग्नल ट्रांसमिशन उपकरण है और किसी भी ट्रेडिंग परिणाम के लिए जिम्मेदार नहीं है।</p>
<p><strong>2. रणनीति जोखिम</strong><br/>स्वचालित ट्रेडिंग रणनीतियों का पिछला प्रदर्शन भविष्य के परिणामों की गारंटी नहीं देता है। वास्तविक खातों पर उपयोग करने से पहले पूरी तरह से परीक्षण करें।</p>
<p><strong>3. तकनीकी जोखिम</strong><br/>नेटवर्क विलंबता, सर्वर विफलता और API सीमाएं सिग्नल हानि या निष्पादन में देरी का कारण बन सकती हैं। विलंबता के प्रति संवेदनशील उच्च-आवृत्ति रणनीतियों के लिए इस उपकरण का उपयोग न करें।</p>
<p><strong>4. उपयोगकर्ता की जिम्मेदारी</strong><br/>उपयोगकर्ता WikiConnector EA के उपयोग से उत्पन्न सभी ट्रेडिंग परिणामों की पूरी जिम्मेदारी वहन करता है। WikiFX निवेश सलाह प्रदान नहीं करता है और ट्रेडिंग लाभ या हानि के लिए जिम्मेदार नहीं है।</p>`,
    disclaimerAgree: 'मैंने उपरोक्त अस्वीकरण पढ़ लिया है और सहमत हूं, और ट्रेडिंग जोखिमों को समझता हूं',
    disclaimerDownload: 'सहमत हूं और डाउनलोड करें',

    regenTitle: 'कुंजी रीसेट की पुष्टि करें?',
    regenSubtitle: 'यह क्रिया पूर्ववत नहीं की जा सकती। कृपया पुष्टि करें कि आप निम्नलिखित प्रभावों को समझते हैं:',
    regenWarnings: ['इस कुंजी से कॉन्फ़िगर किए गए सभी EA <strong>तुरंत डिस्कनेक्ट हो जाएंगे</strong>', 'पुरानी कुंजी <strong>स्थायी रूप से अमान्य</strong> हो जाएगी और पुनर्प्राप्त नहीं की जा सकती', 'आपको सभी EA में Secret Key कॉन्फ़िगरेशन मैन्युअल रूप से अपडेट करना होगा', 'रीसेट के दौरान <strong>सिग्नल हानि</strong> का जोखिम है'],

    dashTitle: 'मेरा WikiConnector',
    myKey: 'मेरी Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'कॉपी करें',
    regenBtn: 'पुनः उत्पन्न करें',
    regenConfirm: 'कुंजी पुनः उत्पन्न करने के बाद, सभी जुड़े EA डिस्कनेक्ट हो जाएंगे और पुनः कॉन्फ़िगर करने की आवश्यकता होगी। जारी रखें?',
    regenConfirmBtn: 'रीसेट की पुष्टि करें',
    cancelBtn: 'रद्द करें',
    copiedTip: 'कॉपी हो गया',

    licenseTitle: 'मेरे प्रमाणपत्र (License)',
    licenseId: 'प्रमाणपत्र ID',
    maxConn: 'अधिकतम कनेक्शन',
    activeConn: 'वर्तमान कनेक्शन',
    webhookUrl: 'Webhook URL',

    statsTitle: 'सिग्नल आँकड़े',
    statTotal: 'कुल सिग्नल',
    statDelivered: 'वितरित',
    statFailed: 'विफल',
    statConnections: 'वर्तमान कनेक्शन',

    signalTitle: 'हाल के सिग्नल रिकॉर्ड',
    signalTime: 'समय',
    signalCmd: 'ऑर्डर',
    signalSymbol: 'सिंबल',
    signalLots: 'लॉट आकार',
    signalStatus: 'स्थिति',
    signalLicense: 'प्रमाणपत्र',
    statusDelivered: 'वितरित',
    statusPending: 'लंबित',
    statusFailed: 'विफल',
    statusExpired: 'समाप्त',
    noSignal: 'अभी तक कोई सिग्नल रिकॉर्ड नहीं है',
    loadMore: 'और लोड करें',

    offlineBuffer: 'ऑफ़लाइन बफर',
    offlineBufferDesc: 'सक्रिय होने पर, EA के पुनः कनेक्ट होने पर ऑफ़लाइन अवधि के दौरान संचित सिग्नल वितरित किए जाएंगे (डिफ़ॉल्ट रूप से निष्क्रिय, नुकसान को रोकने के लिए)',

    docTitle: 'उपयोग ट्यूटोरियल',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 WikiConnector कैसे काम करता है</p>
  <p>WikiConnector <strong>WebSocket स्थायी कनेक्शन</strong> के माध्यम से TradingView सिग्नल को रीयल-टाइम में प्राप्त करता है और ट्रेडिंग सॉफ़्टवेयर में स्वचालित रूप से ट्रेड निष्पादित करता है।</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① ट्रेडिंग सॉफ़्टवेयर में EA स्थापित करें</p>
  <ol class="doc-steps">
    <li><strong>डेटा फ़ोल्डर खोलें</strong>: ट्रेडिंग सॉफ़्टवेयर मेनू → फ़ाइल → डेटा फ़ोल्डर खोलें</li>
    <li><strong>EA फ़ाइल कॉपी करें</strong>: EA फ़ाइल को <code>Experts/</code> निर्देशिका में कॉपी करें</li>
    <li><strong>नेविगेटर ताज़ा करें</strong>: नेविगेटर खोलें → "विशेषज्ञ सलाहकार" पर राइट-क्लिक करें → ताज़ा करें। सूची में <strong>SignalReceiver</strong> दिखाई देना चाहिए</li>
    <li><strong>स्वचालित ट्रेडिंग सक्रिय करें</strong>: शीर्ष टूलबार में "स्वचालित ट्रेडिंग" बटन 🟢 हरा होना चाहिए</li>
    <li><strong>चार्ट पर लागू करें</strong>: SignalReceiver को किसी भी चार्ट पर खींचें। सेटिंग विंडो दिखाई देने पर पैरामीटर कॉन्फ़िगर करें</li>
  </ol>
  <div class="doc-tip"><strong>सुझाव:</strong> EA को केवल एक चार्ट पर लागू करना पर्याप्त है, यह सभी सिंबल के सिग्नल प्रोसेस करेगा। प्रत्येक चार्ट पर अलग-अलग लागू करने की आवश्यकता नहीं है।</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② EA पैरामीटर कॉन्फ़िगर करें</p>
  <p>दो प्रकार के पैरामीटर हैं: <strong>आवश्यक</strong> (License / SecretKey) और <strong>डिफ़ॉल्ट पैरामीटर</strong> (जब सिग्नल JSON में कोई विशिष्ट फ़ील्ड न हो तब उपयोग किए जाते हैं; सिग्नल में मान हमेशा EA डिफ़ॉल्ट से पहले आते हैं)।</p>
  <div class="doc-warn"><strong>सुरक्षा चेतावनी:</strong> License और SecretKey आपके खाते की रक्षा करने वाली एकमात्र बाधा हैं। यदि ये लीक हो जाते हैं, तो कोई भी आपके ट्रेडिंग सॉफ़्टवेयर को ट्रेड ऑर्डर भेज सकता है। इनका स्क्रीनशॉट न लें या दूसरों के साथ साझा न करें। नियमित रूप से SecretKey बदलने की अनुशंसा की जाती है।</div>
  <p>सेटअप पूरा होने के बाद, चार्ट के ऊपरी दाएं कोने में EA का नाम + <strong>😊</strong> दिखाई देगा, जो सर्वर से कनेक्ट होने का संकेत देता है। यदि 😞 दिखाई देता है, तो जांचें कि "स्वचालित ट्रेडिंग" बटन हरा है या नहीं।</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ सिग्नल के लिए Pine Script कोड लिखें</p>
  <p>WikiConnector सिग्नल ट्रिगर करने के लिए <code>alert()</code> फ़ंक्शन का उपयोग करता है, <code>strategy.entry(alert_message=)</code> विधि का नहीं। दोनों अलग-अलग तंत्र हैं, इन्हें मिश्रित न करें।</p>
  <div class="doc-danger"><strong>महत्वपूर्ण: alert.freq_all</strong> — डिफ़ॉल्ट रूप से, Pine Script में, एक ही कैंडल के भीतर केवल पहला <code>alert()</code> ट्रिगर होता है, बाकी चुपचाप त्याग दिए जाते हैं। यदि आपको लगातार कई सिग्नल भेजने की आवश्यकता है (जैसे: उलट में पहले शॉर्ट बंद करें फिर लॉंग खोलें), तो आपको प्रत्येक <code>alert()</code> में <code>alert.freq_all</code> जोड़ना होगा, अन्यथा दूसरा सिग्नल कभी सर्वर तक नहीं पहुंचेगा।</div>
<pre>//@version=6
strategy("WikiConnector रणनीति", overlay=true)

// सिग्नल संदेश परिभाषित करें (YOUR_LICENSE और YOUR_KEY को अपने मानों से बदलें)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// रणनीति स्थितियों का उदाहरण (3/13 मूविंग एवरेज क्रॉस)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// एक ही कैंडल में कई सिग्नल सुनिश्चित करने के लिए alert.freq_all का उपयोग करें
if longCondition
    alert(closesellMessage, alert.freq_all)  // पहले शॉर्ट पोजीशन बंद करें
    alert(buyMessage,       alert.freq_all)  // फिर लॉंग पोजीशन खोलें

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // पहले लॉंग पोजीशन बंद करें
    alert(sellMessage,     alert.freq_all)   // फिर शॉर्ट पोजीशन खोलें</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ TradingView में अलर्ट बनाएं</p>
  <p>Webhook URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>चार्ट पर राइट-क्लिक करें → "<strong>अलर्ट जोड़ें...</strong>" या <strong>Alt+A</strong></li>
    <li>ट्रिगर स्थिति के रूप में <strong>"केवल alert() फ़ंक्शन कॉल"</strong> चुनें (महत्वपूर्ण!)</li>
    <li>समाप्ति तिथि यथासंभव लंबी चुनें, या "कोई समाप्ति नहीं" चुनें</li>
    <li>संदेश बॉक्स को <strong>डिफ़ॉल्ट रूप से छोड़ दें, इसमें कुछ भी न भरें</strong> (सिग्नल की सामग्री कोड में alert() द्वारा निर्धारित की जाती है)</li>
    <li>सूचना सेटिंग्स: <strong>Webhook URL</strong> चेक करें और उपरोक्त पता दर्ज करें; <strong>"सादा टेक्स्ट भेजें" को अनचेक करें</strong></li>
    <li>अलर्ट सहेजने के लिए "बनाएं" पर क्लिक करें</li>
  </ol>
  <div class="doc-tip"><strong>सुझाव:</strong> Webhook सुविधा के लिए TradingView Pro या उच्च सदस्यता आवश्यक है।</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ सिग्नल JSON प्रारूप स्पष्टीकरण</p>
  <p><strong>आवश्यक फ़ील्ड:</strong><code>license</code> (प्राधिकरण ID), <code>key</code> (कुंजी), <code>cmd</code> (आदेश), <code>symbol</code> (सिंबल नाम)</p>
  <p><strong>वैकल्पिक फ़ील्ड:</strong><code>lots</code> (लॉट आकार), <code>price</code> (लंबित आदेश मूल्य), <code>sl_points / sl_price / sl_pct</code> (स्टॉप लॉस तीन विकल्प), <code>tp_points / tp_price / tp_pct</code> (टेक प्रॉफिट तीन विकल्प), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (डिफ़ॉल्ट 300 सेकंड)</p>
  <p><strong>समर्थित cmd:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>स्टॉप लॉस/टेक प्रॉफिट प्राथमिकता:</strong><code>sl_price</code> (निश्चित मूल्य)&gt; <code>sl_points</code> (अंक)&gt; <code>sl_pct</code> (प्रतिशत)। यदि तीनों 0 हैं, तो कोई स्टॉप लॉस सेट नहीं होगा, टेक प्रॉफिट के लिए भी यही।</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ संचालन से पहले जाँच सूची</p>
  <ul class="doc-checklist">
    <li class="ok">✅ ट्रेडिंग सॉफ़्टवेयर का स्वचालित ट्रेडिंग बटन 🟢 हरा है</li>
    <li class="ok">✅ चार्ट के ऊपरी दाएं कोने में EA 😊 दिखाता है (सर्वर से जुड़ा है)</li>
    <li class="ok">✅ License / SecretKey TradingView JSON में मानों से बिल्कुल मेल खाते हैं</li>
    <li class="ok">✅ अलर्ट ट्रिगर स्थिति "<strong>केवल alert() फ़ंक्शन कॉल</strong>" है</li>
    <li class="ok">✅ प्रत्येक <code>alert()</code> में <code>alert.freq_all</code> जोड़ा गया है</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ संदेश बॉक्स डिफ़ॉल्ट रूप से छोड़ा गया, खाली है</li>
    <li class="no">❌ "सादा टेक्स्ट भेजें" अनचेक किया गया है</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ सुरक्षा और जोखिम सुझाव</p>
  <div class="doc-warn">
    <strong>खाता सुरक्षा:</strong><br>
    · License और SecretKey का स्क्रीनशॉट न लें या किसी के साथ साझा न करें<br>
    · यदि आपको कुंजी लीक होने का संदेह है, तो तुरंत कंसोल में SecretKey रीसेट करें<br>
    · नियमित रूप से SecretKey बदलने की अनुशंसा की जाती है
  </div>
  <div class="doc-warn">
    <strong>ट्रेडिंग जोखिम प्रबंधन:</strong><br>
    · हमेशा स्टॉप लॉस सेट करें, बिना सुरक्षा के स्वचालित रणनीति न चलाएं<br>
    · अनुशंसा है कि प्रति ट्रेड जोखिम खाता शेष के 1-2% के भीतर हो<br>
    · महत्वपूर्ण आर्थिक डेटा (NFP, CPI, FOMC) से पहले, स्वचालित ट्रेडिंग को रोकने की अनुशंसा की जाती है
  </div>
  <div class="doc-tip">
    <strong>सर्वोत्तम अभ्यास:</strong><br>
    · वास्तविक खाते पर स्विच करने से पहले कम से कम 1-2 सप्ताह तक डेमो खाते पर परीक्षण करें ताकि लिंक सामान्य रूप से काम कर रहा हो<br>
    · वास्तविक खाते पर, न्यूनतम लॉट (0.01 लॉट) से शुरू करें<br>
    · ट्रेडिंग सॉफ़्टवेयर और EA को 24/7 ऑनलाइन रखने के लिए VPS (जैसे Tianyun Cloud VPS) का उपयोग करें
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook सिग्नल प्रारूप',
        content: `TradingView अलर्ट के संदेश बॉक्स में निम्नलिखित JSON भरें:
<pre>{
  "license": "{{आपकाLicenseID}}",
  "key": "{{आपकाSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>समर्थित <strong>cmd</strong> आदेश: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook पता',
        content: `<p>TradingView अलर्ट सेटिंग्स में, Webhook URL को इस प्रकार सेट करें:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>संदेश बॉक्स में, उपरोक्त सिग्नल JSON प्रारूप भरें और license और key को अपने मानों से बदलें।</p>`
      },
      {
        title: '3. WikiConnector EA स्थापित करें',
        content: `<p>1. WikiConnector EA (.ex5 फ़ाइल) डाउनलोड करें</p>
<p>2. EA को MT5 के <code>MQL5/Experts</code> निर्देशिका में कॉपी करें</p>
<p>3. MT5 में EA खोलें और <strong>License ID</strong> और <strong>Secret Key</strong> दर्ज करें</p>
<p>4. EA को WebSocket कनेक्शन बनाने की अनुमति दें (MT5 विकल्प → EA में, नेटवर्क कनेक्शन अनुमति सक्रिय करें)</p>`
      },
      {
        title: '4. दर सीमाएँ',
        content: `<p>प्रति लाइसेंस अधिकतम <strong>30 अनुरोध / 60 सेकंड</strong>। सीमा पार करने पर 429 त्रुटि वापस आती है।</p>
<p>यदि आपको उच्च आवृत्ति की आवश्यकता है, तो अपनी योजना को अपग्रेड करने के लिए ग्राहक सेवा से संपर्क करें।</p>`
      }
    ],

    faqTitle: 'सामान्य प्रश्न',
    faqs: [
      {
        q: 'यदि मेरी कुंजी लीक हो जाए तो क्या करूं?',
        a: 'कंसोल में "पुनः उत्पन्न करें" पर क्लिक करें। पुरानी कुंजी तुरंत अमान्य हो जाएगी और सभी EA कनेक्शन टूट जाएंगे। नई कुंजी के साथ EA को पुनः कॉन्फ़िगर करें।'
      },
      {
        q: 'क्या EA के पुनः कनेक्ट होने पर सिग्नल फिर से भेजे जाएंगे?',
        a: 'डिफ़ॉल्ट रूप से नहीं (नुकसान को रोकने के लिए)। यदि आपको पुनः भेजने की आवश्यकता है, तो कंसोल में "ऑफ़लाइन बफर" सक्रिय करें। EA के पुनः कनेक्ट होने पर, यह ऑफ़लाइन अवधि के दौरान संचित सिग्नल प्राप्त करेगा।'
      },
      {
        q: 'एक लाइसेंस कितने MT खातों को कनेक्ट कर सकता है?',
        a: 'प्रत्येक लाइसेंस अधिकतम 10 समवर्ती WebSocket कनेक्शन का समर्थन करता है, जिससे 10 MT टर्मिनल एक साथ एक ही सिग्नल प्राप्त कर सकते हैं।'
      },
      {
        q: 'क्या MT4 समर्थित है?',
        a: 'वर्तमान संस्करण मुख्य रूप से MT5 का समर्थन करता है। EA का MT4 संस्करण विकासाधीन है। प्रतीक्षा करें!'
      },
      {
        q: 'सिग्नल विलंबता कितनी है?',
        a: 'औसत विलंबता <100ms है। Tianyun Cloud VPS के साथ, यह 1ms तक कम हो सकती है।'
      },
      {
        q: 'मैं कैसे परीक्षण करूं कि Webhook सही ढंग से काम कर रहा है?',
        a: 'प्रमाणपत्र सूची में, "वर्तमान कनेक्शन संख्या" जांचें। यदि यह 0 से अधिक है, तो EA ऑनलाइन है। परीक्षण सिग्नल भेजने के बाद, "हाल के सिग्नल रिकॉर्ड" में "वितरित" स्थिति देखें।'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script और सिग्नल भेजना',
        items: [
          {
            q: 'मैं बंद करने और खोलने के लिए दो alert() का उपयोग कर रहा हूं, लेकिन ट्रेडिंग सॉफ़्टवेयर केवल एक सिग्नल प्राप्त करता है।',
            a: 'यह Pine Script की डिफ़ॉल्ट सीमा है: एक ही कैंडल के भीतर, केवल पहला alert() ट्रिगर होता है। समाधान है <strong>प्रत्येक alert() में <code>alert.freq_all</code> पैरामीटर जोड़ना</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'मुझे अलर्ट के लिए कौन सी ट्रिगर स्थिति चुननी चाहिए?',
            a: '<code>alert()</code> फ़ंक्शन का उपयोग करते समय, आपको <strong>"केवल alert() फ़ंक्शन कॉल"</strong> चुनना होगा। यदि आप <code>strategy.entry(..., alert_message=xxx)</code> विधि का उपयोग कर रहे हैं, तो "Order fills only" चुनें। दोनों विधियों को मिश्रित नहीं किया जा सकता।'
          },
          {
            q: 'मुझे संदेश बॉक्स में क्या भरना चाहिए?',
            a: '<code>alert()</code> विधि का उपयोग करते समय, <strong>संदेश बॉक्स को डिफ़ॉल्ट रूप से छोड़ दें, इसमें कुछ भी न भरें</strong>। सिग्नल की सामग्री कोड में <code>alert(xxx)</code> के अंदर स्ट्रिंग द्वारा निर्धारित की जाती है, और Webhook उस JSON को प्राप्त करेगा।'
          }
        ]
      },
      {
        title: '🔌 कनेक्शन और सिग्नल प्राप्त करना',
        items: [
          {
            q: 'EA आइकन लाल रोता हुआ चेहरा 😞 दिखाता है। मुझे क्या करना चाहिए?',
            a: 'जांचें कि ट्रेडिंग सॉफ़्टवेयर के टूलबार में "स्वचालित ट्रेडिंग" बटन हरा है या नहीं। यदि लाल है, तो इसे हरा करने के लिए क्लिक करें। EA स्वचालित रूप से सामान्य स्थिति में वापस आ जाएगा।'
          },
          {
            q: 'मैंने TradingView से सिग्नल भेजा लेकिन ट्रेडिंग सॉफ़्टवेयर ने प्रतिक्रिया नहीं दी।',
            a: 'इस क्रम में जांचें:<br>1. क्या ट्रेडिंग सॉफ़्टवेयर का स्वचालित ट्रेडिंग हरा है?<br>2. क्या EA पैनल "Connected" दिखाता है?<br>3. क्या Webhook URL <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code> है?<br>4. क्या अलर्ट ट्रिगर स्थिति "केवल alert() फ़ंक्शन कॉल" है?<br>5. क्या प्रत्येक alert() में <code>alert.freq_all</code> जोड़ा गया है?<br>6. क्या JSON में license और key EA सेटिंग्स से बिल्कुल मेल खाते हैं?'
          }
        ]
      },
      {
        title: '💰 ट्रेडिंग निष्पादन',
        items: [
          {
            q: 'ऑर्डर विफल रहा। इसका कारण क्या है?',
            a: 'सामान्य कारण: अपर्याप्त शेष / सिंबल नाम मेल नहीं खाता (Symbol Mapping कॉन्फ़िगर करने की आवश्यकता) / लॉट आकार पार हो गया / स्लिपेज बहुत अधिक (InpDeviation बढ़ाएं) / बाजार बंद है। विशिष्ट त्रुटि जानकारी के लिए ट्रेडिंग सॉफ़्टवेयर के निचले भाग में "विशेषज्ञ" लॉग देखें।'
          },
          {
            q: 'ऑर्डर में स्टॉप लॉस या टेक प्रॉफिट नहीं है।',
            a: 'जांचें: ① क्या सिग्नल JSON में <code>sl_points</code> / <code>tp_points</code> आदि फ़ील्ड शामिल हैं?; ② क्या EA के डिफ़ॉल्ट स्टॉप लॉस/टेक प्रॉफिट पैरामीटर 0 हैं? यदि दोनों में से कोई भी सेट नहीं है, तो ऑर्डर में स्टॉप लॉस या टेक प्रॉफिट नहीं होगा।'
          },
          {
            q: 'सिंबल नाम मेल नहीं खाता। मुझे क्या करना चाहिए?',
            a: 'EA पैरामीटर में Symbol Mapping सक्रिय करें:<br><code>InpEnableMap1 = true</code> सेट करें<br><code>InpMapping1 = XAUUSD|GOLD</code> सेट करें (TradingViewनाम|ट्रेडिंगसॉफ़्टवेयरनाम)'
          },
          {
            q: 'क्या मैं पहले डेमो खाते पर परीक्षण कर सकता हूं?',
            a: '<strong>अत्यधिक अनुशंसित!</strong> पहली बार उपयोग में, वास्तविक खाते पर स्विच करने से पहले कम से कम 1-2 सप्ताह तक डेमो खाते पर परीक्षण करें ताकि लिंक सामान्य है और ऑर्डर निष्पादन सही है। न्यूनतम लॉट 0.01 से शुरू करें।'
          }
        ]
      }
    ]
  },

  // === pt Português ===
  pt: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Conecte sinais do TradingView automaticamente ao MetaTrader para executar negociações',
    heroBtn: 'Comece grátis',

    stat1Label: 'Latência média',
    stat2Label: 'Disponibilidade do serviço',
    stat3Label: 'Operação 24/7',
    stat4Label: 'Distribuição multi-contas',

    flowSub1: 'Estratégia / Alerta',
    flowSub2: 'Roteamento de sinais',
    flowSub3: 'Execução automática',

    featTitle: 'Por que escolher o WikiConnector',
    featSubtitle: 'Principais vantagens',
    features: [
      {
        icon: '⚡',
        title: 'Execução em milissegundos',
        desc: 'Latência média do sinal <100 ms, tão baixa quanto 1 ms com WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Distribuição multi-contas',
        desc: 'Um certificado conecta vários terminais MT e distribui o mesmo sinal de estratégia simultaneamente.'
      },
      {
        icon: '🔒',
        title: 'Criptografia segura',
        desc: 'Sistema de chaves independente por usuário, transmissão de dados criptografada de ponta a ponta.'
      },
      {
        icon: '📊',
        title: 'Monitoramento em tempo real',
        desc: 'Status de recebimento de sinal, latência de execução e taxa de sucesso visíveis em tempo real.'
      },
      {
        icon: '<>',
        title: 'Gerador de código',
        desc: 'Gere visualmente sinais JSON e código Pine Script, sem necessidade de programação.'
      },
      {
        icon: '🖥',
        title: 'Integração profunda com VPS',
        desc: 'Sistema de contas compartilhado com Tianyun Cloud VPS, operação 24/7 com baixa latência.'
      }
    ],

    stepsTitle: 'Quatro passos para começar o trading automatizado',
    stepsSubtitle: 'Início rápido',
    steps: [
      {
        title: 'Faça login',
        desc: 'Faça login com sua conta WikiFX e obtenha automaticamente sua chave e licença exclusivas.'
      },
      {
        title: 'Configure o Webhook',
        desc: 'Copie a URL do Webhook para as configurações de Alerta do TradingView.'
      },
      {
        title: 'Instale o EA',
        desc: 'Baixe o WikiConnector EA e insira seu License ID e Secret Key.'
      },
      {
        title: 'Trading automatizado',
        desc: 'Quando sua estratégia disparar um Alerta, o sinal será automaticamente enviado ao terminal MT para execução.'
      }
    ],

    loginTip: 'Após o login, você pode ver sua chave e certificado exclusivos',
    loginBtn: 'Entre agora',

    navConn: 'Gerenciamento de conexões',
    navLog: 'Registro de sinais',
    navGen: 'Gerador de código',
    navParams: 'Referência rápida de parâmetros',
    navDl: 'Downloads',
    navDoc: 'Tutorial de uso',
    navFaq: 'Perguntas frequentes',

    keyLabel: 'Secret Key',
    keyTip1: 'Não compartilhe com ninguém',
    keyTip2: 'Usado para autenticação do EA',
    keyTip3: 'Após redefinir, a chave antiga torna-se imediatamente inválida',

    connSubtitle: 'Abaixo estão suas Licenças e suas URLs de Webhook correspondentes',
    noLicense: 'Nenhuma Licença disponível. Entre em contato com o atendimento ao cliente',
    needHelp: 'Precisa de ajuda?',
    viewDoc: 'Ver tutorial de uso',

    allLicense: 'Todas as Licenças',
    allStatus: 'Todos os status',
    refresh: 'Atualizar',
    signalId: 'ID do sinal',
    total: 'Total',
    records: 'registros',

    genIntro: 'Preencha os seguintes parâmetros para gerar automaticamente sinais JSON e código Pine Script utilizáveis em Alertas do TradingView.',
    genAuth: 'Informações de autenticação',
    required: 'Obrigatório',
    optional: 'Opcional',
    genLicPlaceholder: 'Insira seu License ID',
    genLicHint: 'Pode ser consultado na página de gerenciamento de conexões',
    genKeyPlaceholder: 'Insira seu Secret Key',
    genKeyHint: 'Pode ser consultado na página de gerenciamento de conexões',
    genTrade: 'Ordem de negociação',
    genCmd: 'Tipo de ordem',
    genMarket: 'Ordem a mercado',
    genPending: 'Ordem pendente',
    genClose: 'Fechar',
    cmdBuy: 'Compra a mercado',
    cmdSell: 'Venda a mercado',
    cmdBuyLimit: 'Compra limitada',
    cmdSellLimit: 'Venda limitada',
    cmdBuyStop: 'Compra por ruptura',
    cmdSellStop: 'Venda por ruptura',
    cmdCloseBuy: 'Fechar posições longas',
    cmdCloseSell: 'Fechar posições curtas',
    cmdCloseAll: 'Fechar este símbolo',
    cmdCloseAllOrders: 'Fechar tudo',
    genSlTpHint: 'Escolha um de três · Prioridade: Preço > Pontos > Percentual',
    genTsHint: 'Horário de envio do sinal',
    genTsBtn: 'Horário atual',
    presetSimple: '📝 Compra simples',
    presetSltp: '🛡 Com stop loss e take profit',
    presetFull: '📋 Parâmetros completos',
    presetClose: '❌ Sinal de fechamento',
    presetPending: '📌 Ordem pendente',
    presetReverse: '🔄 Inversão (fechar + abrir)',
    genAlertTab: '🔔 Explicação das configurações de Alerta',
    toastIncomplete: 'Informações incompletas. Preencha os campos obrigatórios',
    toastRegen: 'Nova chave foi gerada. Copie-a imediatamente e atualize todos os EAs configurados',
    toastKeyCopied: 'Chave copiada',
    toastCopied: 'Copiado',
    toastCodeCopied: 'Código copiado',
    copyTitle: 'Copiar',
    genSymbol: 'Símbolo de negociação',
    genPrice: 'Preço da ordem pendente',
    genParams: 'Parâmetros de negociação',
    genLots: 'Volume (lotes)',
    genLotsHint: 'Deixe vazio para usar o valor padrão do EA',
    genMagic: 'Magic Number',
    genMagicHint: 'Usado para distinguir ordens de diferentes estratégias',
    genComment: 'Comentário da ordem',
    genCommentHint: 'Exemplo: Strategy A',
    genSL: 'Configuração de stop loss',
    genPoints: 'Pontos',
    genPrice2: 'Preço fixo',
    genPct: 'Percentual %',
    genTP: 'Configuração de take profit',
    genAdvanced: 'Parâmetros avançados',
    genSigIdHint: 'Deixe vazio para geração automática, usado para desduplicação',
    genGenId: 'Gerar automaticamente',
    genBtn: 'Gerar código',
    genFormat: 'Formato do sinal',
    genGuideTitle: 'Como usar no TradingView',
    genGuideSteps: [
      'Crie um <strong>Alerta (Alert)</strong> no seu gráfico do TradingView',
      'Em <strong>Condição de disparo do Alerta</strong>, selecione sua estratégia ou indicador',
      'Expanda <strong>Notificações (Notifications)</strong> → marque <strong>Webhook URL</strong>',
      'Insira a URL do Webhook: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Cole o JSON gerado acima na caixa <strong>Mensagem (Message)</strong>',
      'Clique em <strong>Criar (Create)</strong> para salvar o Alerta'
    ],
    genGuideNote: '<strong>Dica:</strong> Se você usa Pine Script, adicione o código gerado ao seu script e use o parâmetro <code>alert_message</code> em <code>strategy.entry()</code> ou <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Autorização) — Deve ser modificado',
        rows: [
          ['License', '—', 'ID de autorização, deve corresponder exatamente ao campo license no JSON do sinal', 'req'],
          ['SecretKey', '—', 'Chave de segurança (começa com wc_sk_), deve corresponder exatamente ao campo key no JSON do sinal', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Parâmetros de negociação padrão)',
        rows: [
          ['InpLots', '0.1', 'Volume padrão, usado quando o JSON do sinal não contém lots', ''],
          ['InpMagic', '888', 'Magic Number padrão, para distinguir ordens de diferentes estratégias', ''],
          ['InpComment', 'TV Signal', 'Comentário de ordem padrão', ''],
          ['InpDeviation', '30', 'Deslizamento máximo (pontos), para Forex 10–30, para Ouro/Índices 30–50 recomendado', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Prioridade: sl_price (preço fixo) > sl_points (pontos) > sl_pct (percentual). Se todos os três forem 0, nenhum stop loss é definido, o mesmo para take profit',
        rows: [
          ['InpSLPoints', '0', 'Pontos de stop loss padrão (0 = desativado)', ''],
          ['InpSLPrice', '0', 'Preço fixo de stop loss padrão (0 = desativado, prioridade máxima)', ''],
          ['InpSLPct', '0', 'Percentual de stop loss padrão (0 = desativado)', ''],
          ['InpTPPoints', '0', 'Pontos de take profit padrão (0 = desativado)', ''],
          ['InpTPPrice', '0', 'Preço fixo de take profit padrão (0 = desativado)', ''],
          ['InpTPPct', '0', 'Percentual de take profit padrão (0 = desativado)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Mapeamento de nomes de símbolos)',
        note: 'Corretoras podem usar nomes de símbolos diferentes (ex: TradingView chama XAUUSD, sua corretora chama GOLD). O mapeamento permite conversão automática',
        rows: [
          ['InpPrefix', '(vazio)', 'Prefixo do nome do símbolo, se o símbolo da corretora for m.EURUSD, insira m.', ''],
          ['InpSuffix', '(vazio)', 'Sufixo do nome do símbolo, se o símbolo da corretora for EURUSD.pro, insira .pro', ''],
          ['InpEnableMap1~5', 'false', 'Defina como true para ativar a regra de mapeamento correspondente', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Regra de mapeamento, formato: NomeTradingView|NomeMT5, suporta até 5 regras', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Mesmo que acima', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Mesmo que acima', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Mesmo que acima', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Mesmo que acima', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Filtro de tempo / Exibição e registro)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Quando ativado, processa apenas sinais entre StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Horário de início permitido para negociação (horário do servidor MT5, formato HH:MM)', ''],
          ['InpEndTime', '23:59', 'Horário de término permitido para negociação', ''],
          ['InpShowPanel', 'true', 'Exibir painel informativo com status da conexão e estatísticas de sinais no gráfico', ''],
          ['InpUpdateInterval', '1000', 'Intervalo de atualização do painel (ms), recomendado 1000~3000', ''],
          ['InpLogLevel', '1', 'Nível de registro: 0=desligado 1=básico 2=detalhado 3=depuração (use 2 ou 3 para solução de problemas)', ''],
          ['InpLogToFile', 'true', 'Gravar arquivo de registro em MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Saída na aba "Especialistas" na parte inferior do MT5', ''],
          ['InpMaxLogMB', '5', 'Tamanho máximo do arquivo de registro (MB), rotação automática ao exceder', '']
        ]
      }
    ],

    paramsEATitle: 'Explicação dos parâmetros do EA',
    paramsEADesc: 'Os seguintes parâmetros podem ser configurados ao abrir o EA no MT5, e também podem ser substituídos pelos campos correspondentes no JSON do sinal.',
    paramName: 'Nome do parâmetro',
    paramDefault: 'Valor padrão',
    paramDesc: 'Descrição',
    paramOverride: 'Campo de substituição JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'Volume padrão (usado quando o JSON não especifica)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number padrão', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Comentário de ordem padrão', 'comment'],
      ['SlippagePoints', '3', 'Deslizamento máximo (pontos)', '—'],
      ['OfflineBuffer', 'false', 'Ativar buffer offline', '—'],
      ['ReconnectSeconds', '5', 'Intervalo de reconexão WebSocket (segundos)', '—']
    ],
    cmdTableTitle: 'Explicação dos tipos de ordem',
    cmdCol: 'Ordem (cmd)',
    typeCol: 'Tipo',
    actionCol: 'Ação',
    extraCol: 'Parâmetros adicionais',
    cmdTable: [
      ['buy', 'Ordem a mercado', 'Comprar imediatamente', 'lots, sl_*, tp_*'],
      ['sell', 'Ordem a mercado', 'Vender imediatamente', 'lots, sl_*, tp_*'],
      ['buylimit', 'Ordem pendente', 'Comprar ao atingir o preço', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Ordem pendente', 'Vender ao atingir o preço', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Ordem pendente', 'Comprar na ruptura', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Ordem pendente', 'Vender na ruptura', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Fechamento', 'Fechar todas as posições longas', 'magic (opcional)'],
      ['closesell', 'Fechamento', 'Fechar todas as posições curtas', 'magic (opcional)'],
      ['closeall', 'Fechamento', 'Fechar todas as posições abertas', '—'],
      ['closeallorders', 'Fechamento', 'Remover todas as ordens pendentes', '—']
    ],
    jsonFieldTitle: 'Explicação dos campos JSON',
    fieldCol: 'Nome do campo',
    requiredCol: 'Obrigatório',
    descCol: 'Descrição',
    jsonFields: [
      ['license', 'string', 'Obrigatório', 'License ID'],
      ['key', 'string', 'Obrigatório', 'Secret Key'],
      ['cmd', 'string', 'Obrigatório', 'Ordem de negociação, veja tabela acima'],
      ['symbol', 'string', 'Obrigatório', 'Símbolo de negociação, ex. EURUSD'],
      ['lots', 'number', 'Opcional', 'Volume, deixe vazio para usar valor padrão do EA'],
      ['price', 'number', 'Obrigatório para ordem pendente', 'Preço da ordem pendente'],
      ['sl_points', 'number', 'Opcional', 'Pontos de stop loss'],
      ['sl_price', 'number', 'Opcional', 'Preço fixo de stop loss'],
      ['sl_pct', 'number', 'Opcional', 'Percentual de stop loss (0-100)'],
      ['tp_points', 'number', 'Opcional', 'Pontos de take profit'],
      ['tp_price', 'number', 'Opcional', 'Preço fixo de take profit'],
      ['tp_pct', 'number', 'Opcional', 'Percentual de take profit (0-100)'],
      ['magic', 'number', 'Opcional', 'Magic Number'],
      ['comment', 'string', 'Opcional', 'Comentário da ordem'],
      ['signalid', 'string', 'Opcional', 'ID único do sinal, usado para desduplicação'],
      ['expiryseconds', 'number', 'Opcional', 'Prazo de validade do sinal (segundos), padrão 60']
    ],

    dlMt5Desc: 'Versão MT5 do EA, suporta todas as ordens, recomendada',
    dlMt5Btn: 'Baixar EA MT5',
    dlMt4Desc: 'Versão MT4 do EA, em desenvolvimento, aguarde',
    dlMt4Dev: 'Em desenvolvimento',
    dlInstallDoc: `<h4>Instruções de instalação</h4>
<ol>
<li>Baixe o arquivo <code>WikiConnector_MT5.ex5</code></li>
<li>Abra o MT5, barra de menu → <strong>Arquivo → Abrir pasta de dados</strong></li>
<li>Copie o arquivo <code>.ex5</code> para o diretório <code>MQL5/Experts/</code></li>
<li>Pressione <strong>F5</strong> no MT5 para atualizar o navegador e encontrar o EA WikiConnector</li>
<li>Arraste o EA para qualquer gráfico, insira <strong>License ID</strong> e <strong>Secret Key</strong></li>
<li>Nas opções do EA, marque <strong>Permitir WebRequest</strong> e adicione <code>api-gw.interface003.com</code> à lista de URLs permitidas</li>
</ol>`,

    disclaimerTitle: 'Isenção de responsabilidade sobre riscos',
    disclaimerContent: `<p>Antes de baixar e usar o WikiConnector EA, leia atentamente a seguinte isenção de responsabilidade:</p>
<p><strong>1. Risco de negociação</strong><br/>A negociação de Forex e CFD envolve riscos significativos que podem resultar na perda total ou parcial do capital. O WikiConnector é apenas uma ferramenta de transmissão de sinais e não assume nenhuma responsabilidade pelos resultados das negociações.</p>
<p><strong>2. Risco de estratégia</strong><br/>O desempenho passado de estratégias de negociação automatizada não garante resultados futuros. Teste exaustivamente antes de usar em contas reais.</p>
<p><strong>3. Risco técnico</strong><br/>Latência de rede, falhas de servidor e limitações de API podem causar perda de sinais ou atrasos na execução. Não use esta ferramenta para estratégias de alta frequência sensíveis à latência.</p>
<p><strong>4. Responsabilidade do usuário</strong><br/>O usuário assume total responsabilidade por todos os resultados de negociação decorrentes do uso do WikiConnector EA. A WikiFX não fornece aconselhamento de investimento e não assume responsabilidade por lucros ou perdas de negociação.</p>`,
    disclaimerAgree: 'Li e aceito a isenção de responsabilidade acima e entendo os riscos da negociação',
    disclaimerDownload: 'Aceitar e baixar',

    regenTitle: 'Confirmar redefinição da chave?',
    regenSubtitle: 'Esta ação é irreversível. Confirme que você entende os seguintes impactos:',
    regenWarnings: ['Todos os EAs configurados com esta chave serão <strong>desconectados imediatamente</strong>', 'A chave antiga se tornará <strong>permanentemente inválida</strong> e não poderá ser recuperada', 'Você precisa atualizar manualmente a configuração de Secret Key em todos os EAs', 'Há risco de <strong>perda de sinais</strong> durante a redefinição'],

    dashTitle: 'Meu WikiConnector',
    myKey: 'Minha Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Copiar',
    regenBtn: 'Regenerar',
    regenConfirm: 'Após regenerar a chave, todos os EAs conectados serão desconectados e precisarão ser reconfigurados. Continuar?',
    regenConfirmBtn: 'Confirmar redefinição',
    cancelBtn: 'Cancelar',
    copiedTip: 'Copiado',

    licenseTitle: 'Meus Certificados (License)',
    licenseId: 'ID do Certificado',
    maxConn: 'Conexões máximas',
    activeConn: 'Conexão atual',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Estatísticas de sinais',
    statTotal: 'Total de sinais',
    statDelivered: 'Entregues',
    statFailed: 'Falhos',
    statConnections: 'Conexões atuais',

    signalTitle: 'Registros recentes de sinais',
    signalTime: 'Horário',
    signalCmd: 'Ordem',
    signalSymbol: 'Símbolo',
    signalLots: 'Volume',
    signalStatus: 'Status',
    signalLicense: 'Certificado',
    statusDelivered: 'Entregue',
    statusPending: 'Pendente',
    statusFailed: 'Falho',
    statusExpired: 'Expirado',
    noSignal: 'Ainda não há registros de sinais',
    loadMore: 'Carregar mais',

    offlineBuffer: 'Buffer offline',
    offlineBufferDesc: 'Quando ativado, os sinais acumulados durante o período offline serão entregues quando o EA reconectar (desativado por padrão para evitar perdas)',

    docTitle: 'Tutorial de uso',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Como o WikiConnector funciona</p>
  <p>O WikiConnector recebe sinais do TradingView em tempo real através de uma <strong>conexão persistente WebSocket</strong> e executa negociações automaticamente no software de trading.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Instalar o EA no software de trading</p>
  <ol class="doc-steps">
    <li><strong>Abrir pasta de dados</strong>: Menu do software de trading → Arquivo → Abrir pasta de dados</li>
    <li><strong>Copiar arquivo EA</strong>: Copie o arquivo EA para o diretório <code>Experts/</code></li>
    <li><strong>Atualizar o navegador</strong>: Abra o navegador → clique direito em "Expert Advisors" → Atualizar. <strong>SignalReceiver</strong> deve aparecer na lista</li>
    <li><strong>Ativar trading automatizado</strong>: O botão "Trading automatizado" na barra de ferramentas superior deve estar 🟢 verde</li>
    <li><strong>Aplicar ao gráfico</strong>: Arraste o SignalReceiver para qualquer gráfico. Quando a janela de configuração aparecer, ajuste os parâmetros</li>
  </ol>
  <div class="doc-tip"><strong>Dica:</strong> Basta aplicar o EA em um gráfico para processar sinais de todos os símbolos. Não é necessário aplicá-lo individualmente em cada gráfico.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Configurar os parâmetros do EA</p>
  <p>Existem dois tipos de parâmetros: <strong>obrigatórios</strong> (License / SecretKey) e <strong>parâmetros padrão</strong> (usados quando o JSON do sinal não contém um campo específico; os valores no sinal sempre têm prioridade sobre os valores padrão do EA).</p>
  <div class="doc-warn"><strong>Aviso de segurança:</strong> License e SecretKey são a única barreira protegendo sua conta. Se vazarem, qualquer pessoa pode enviar ordens de negociação para seu software de trading. Não tire screenshots nem compartilhe com outras pessoas. Recomenda-se alterar o SecretKey regularmente.</div>
  <p>Após a conclusão da configuração, o nome do EA + <strong>😊</strong> aparecerá no canto superior direito do gráfico, indicando que está conectado ao servidor. Se 😞 aparecer, verifique se o botão "Trading automatizado" está verde.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Escrever código Pine Script para o sinal</p>
  <p>O WikiConnector usa a função <code>alert()</code> para disparar sinais, não o método <code>strategy.entry(alert_message=)</code>. São mecanismos diferentes, não os misture.</p>
  <div class="doc-danger"><strong>Importante: alert.freq_all</strong> — Por padrão, no Pine Script, apenas o primeiro <code>alert()</code> é disparado dentro do mesmo candle, os seguintes são silenciosamente descartados. Se você precisar enviar vários sinais consecutivos (por exemplo, em uma inversão: primeiro fechar posição curta e depois abrir posição longa), você deve adicionar <code>alert.freq_all</code> a cada <code>alert()</code>, caso contrário, o segundo sinal nunca chegará ao servidor.</div>
<pre>//@version=6
strategy("Estratégia WikiConnector", overlay=true)

// Definir mensagens de sinal (substitua YOUR_LICENSE e YOUR_KEY pelos seus próprios valores)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Exemplo de condições de estratégia (cruzamento de médias móveis 3/13)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Usar alert.freq_all para garantir que múltiplos sinais sejam enviados no mesmo candle
if longCondition
    alert(closesellMessage, alert.freq_all)  // Primeiro fechar posições curtas
    alert(buyMessage,       alert.freq_all)  // Depois abrir posição longa

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Primeiro fechar posições longas
    alert(sellMessage,     alert.freq_all)   // Depois abrir posição curta</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Criar um Alerta no TradingView</p>
  <p>URL do Webhook:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Clique direito no gráfico → "<strong>Adicionar Alerta...</strong>" ou <strong>Alt+A</strong></li>
    <li>Como condição de disparo, selecione <strong>"Apenas chamadas de função alert()"</strong> (importante!)</li>
    <li>Escolha uma data de expiração o mais longa possível, ou "Sem expiração"</li>
    <li>A caixa de Mensagem <strong>deixe como padrão, não insira nada</strong> (o conteúdo do sinal é determinado pelo alert() no código)</li>
    <li>Configurações de notificação: marque <strong>Webhook URL</strong> e insira o endereço acima; <strong>desmarque "Enviar texto simples"</strong></li>
    <li>Clique em "Criar" para salvar o Alerta</li>
  </ol>
  <div class="doc-tip"><strong>Dica:</strong> A função Webhook requer uma assinatura TradingView Pro ou superior.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Explicação do formato JSON do sinal</p>
  <p><strong>Campos obrigatórios:</strong><code>license</code> (ID de autorização), <code>key</code> (chave), <code>cmd</code> (ordem), <code>symbol</code> (nome do símbolo)</p>
  <p><strong>Campos opcionais:</strong><code>lots</code> (volume), <code>price</code> (preço da ordem pendente), <code>sl_points / sl_price / sl_pct</code> (stop loss tripla opção), <code>tp_points / tp_price / tp_pct</code> (take profit tripla opção), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (padrão 300 segundos)</p>
  <p><strong>Ordens suportadas:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Prioridade stop loss/take profit:</strong><code>sl_price</code> (preço fixo)&gt; <code>sl_points</code> (pontos)&gt; <code>sl_pct</code> (percentual). Se todos os três forem 0, nenhum stop loss é definido, o mesmo para take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Lista de verificação antes de operar</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Botão de trading automatizado do software de trading 🟢 verde</li>
    <li class="ok">✅ EA no canto superior direito do gráfico mostra 😊 (conectado ao servidor)</li>
    <li class="ok">✅ License / SecretKey correspondem exatamente aos valores no JSON do TradingView</li>
    <li class="ok">✅ Condição de disparo do Alerta "<strong>Apenas chamadas de função alert()</strong>"</li>
    <li class="ok">✅ Cada <code>alert()</code> tem <code>alert.freq_all</code> adicionado</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Caixa de Mensagem deixada como padrão, vazia</li>
    <li class="no">❌ "Enviar texto simples" desmarcado</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Dicas de segurança e risco</p>
  <div class="doc-warn">
    <strong>Segurança da conta:</strong><br>
    · Não tire screenshots de License e SecretKey nem compartilhe com ninguém<br>
    · Se suspeitar que a chave vazou, redefina imediatamente o SecretKey no console<br>
    · Recomenda-se alterar o SecretKey regularmente
  </div>
  <div class="doc-warn">
    <strong>Gerenciamento de risco de negociação:</strong><br>
    · Sempre defina um stop loss, nunca execute estratégias automatizadas sem proteção<br>
    · Recomenda-se que o risco por negociação esteja dentro de 1-2% do saldo da conta<br>
    · Antes de dados econômicos importantes (NFP, CPI, FOMC), recomenda-se pausar o trading automatizado
  </div>
  <div class="doc-tip">
    <strong>Melhores práticas:</strong><br>
    · Teste primeiro em uma conta demo por pelo menos 1-2 semanas para confirmar que o link está funcionando normalmente antes de mudar para uma conta real<br>
    · Na conta real, comece com o volume mínimo (0,01 lote)<br>
    · Use um VPS (como Tianyun Cloud VPS) para manter o software de trading e o EA online 24/7
  </div>
</div>`,
    docSections: [
      {
        title: '1. Formato do sinal Webhook',
        content: `Na caixa de Mensagem do Alerta do TradingView, insira o seguinte JSON:
<pre>{
  "license": "{{seuLicenseID}}",
  "key": "{{suaSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Ordens <strong>cmd</strong> suportadas: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. Endereço Webhook do TradingView',
        content: `<p>Nas configurações do Alerta do TradingView, defina a URL do Webhook como:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Na caixa de Mensagem, insira o formato JSON do sinal acima e substitua license e key pelos seus próprios valores.</p>`
      },
      {
        title: '3. Instalar o WikiConnector EA',
        content: `<p>1. Baixe o WikiConnector EA (arquivo .ex5)</p>
<p>2. Copie o EA para o diretório <code>MQL5/Experts</code> do MT5</p>
<p>3. Abra o EA no MT5 e insira <strong>License ID</strong> e <strong>Secret Key</strong></p>
<p>4. Permita que o EA faça conexões WebSocket (em Opções MT5 → EA, ative a permissão de conexão de rede)</p>`
      },
      {
        title: '4. Limites de taxa',
        content: `<p>Máximo <strong>30 requisições / 60 segundos</strong> por Licença. Exceder o limite retorna um erro 429.</p>
<p>Se precisar de uma frequência maior, entre em contato com o atendimento ao cliente para fazer upgrade do seu plano.</p>`
      }
    ],

    faqTitle: 'Perguntas frequentes',
    faqs: [
      {
        q: 'O que fazer se minha chave vazar?',
        a: 'Clique em "Regenerar" no console. A chave antiga se tornará imediatamente inválida e todas as conexões EA serão interrompidas. Reconfigure o EA com a nova chave.'
      },
      {
        q: 'Os sinais serão reenviados após o EA reconectar?',
        a: 'Por padrão não (para evitar perdas). Se precisar de reenvio, ative o "Buffer offline" no console. Quando o EA reconectar, ele receberá os sinais acumulados durante o período offline.'
      },
      {
        q: 'Quantas contas MT uma Licença pode conectar?',
        a: 'Cada Licença suporta até 10 conexões WebSocket simultâneas, permitindo que até 10 terminais MT recebam o mesmo sinal ao mesmo tempo.'
      },
      {
        q: 'O MT4 é suportado?',
        a: 'A versão atual suporta principalmente MT5. A versão MT4 do EA está em desenvolvimento. Aguarde!'
      },
      {
        q: 'Qual é a latência do sinal?',
        a: 'A latência média é <100 ms. Com Tianyun Cloud VPS, pode ser tão baixa quanto 1 ms.'
      },
      {
        q: 'Como testar se o Webhook está funcionando corretamente?',
        a: 'Na lista de certificados, verifique o "Número de conexões atuais". Se for maior que 0, o EA está online. Após enviar um sinal de teste, verifique os "Registros recentes de sinais" para ver o status "Entregue".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script e envio de sinais',
        items: [
          {
            q: 'Uso dois alert() para fechar e abrir, mas o software de trading só recebe um sinal.',
            a: 'Esta é a limitação padrão do Pine Script: dentro do mesmo candle, apenas o primeiro alert() é disparado. A solução é <strong>adicionar o parâmetro <code>alert.freq_all</code> a cada alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Qual condição de disparo devo escolher para o Alerta?',
            a: 'Ao usar a função <code>alert()</code>, você deve selecionar <strong>"Apenas chamadas de função alert()"</strong>. Se estiver usando o método <code>strategy.entry(..., alert_message=xxx)</code>, selecione "Order fills only". Os dois métodos não podem ser misturados.'
          },
          {
            q: 'O que devo colocar na caixa de Mensagem?',
            a: 'Ao usar o método <code>alert()</code>, <strong>deixe a caixa de Mensagem como padrão, não insira nada</strong>. O conteúdo do sinal é determinado pela string dentro de <code>alert(xxx)</code> no código, e o Webhook receberá esse JSON.'
          }
        ]
      },
      {
        title: '🔌 Conexão e recepção de sinais',
        items: [
          {
            q: 'O ícone do EA mostra um rosto vermelho chorando 😞. O que fazer?',
            a: 'Verifique se o botão "Trading automatizado" na barra de ferramentas do software de trading está verde. Se estiver vermelho, clique para torná-lo verde. O EA retornará automaticamente ao estado normal.'
          },
          {
            q: 'Enviei um sinal do TradingView mas o software de trading não respondeu.',
            a: 'Verifique nesta ordem:<br>1. O trading automatizado do software de trading está verde?<br>2. O painel do EA mostra "Connected"?<br>3. A URL do Webhook é <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. A condição de disparo do Alerta é "Apenas chamadas de função alert()"?<br>5. Cada alert() tem <code>alert.freq_all</code> adicionado?<br>6. License e key no JSON correspondem exatamente às configurações do EA?'
          }
        ]
      },
      {
        title: '💰 Execução de negociações',
        items: [
          {
            q: 'A ordem falhou. Qual é a causa?',
            a: 'Causas comuns: Saldo insuficiente / O nome do símbolo não corresponde (necessário configurar Symbol Mapping) / Volume excedido / Deslizamento muito grande (aumentar InpDeviation) / Mercado fechado. Verifique o registro "Especialistas" na parte inferior do software de trading para obter informações específicas do erro.'
          },
          {
            q: 'A ordem não tem stop loss ou take profit.',
            a: 'Verifique: ① O JSON do sinal inclui campos como <code>sl_points</code> / <code>tp_points</code> etc.?; ② Os parâmetros padrão de stop loss/take profit do EA são 0? Se nenhum dos dois estiver configurado, a ordem não terá stop loss nem take profit.'
          },
          {
            q: 'O nome do símbolo não corresponde. O que fazer?',
            a: 'Ative Symbol Mapping nos parâmetros do EA:<br>Defina <code>InpEnableMap1 = true</code><br>Defina <code>InpMapping1 = XAUUSD|GOLD</code> (NomeTradingView|NomeSoftwareTrading)'
          },
          {
            q: 'Posso testar primeiro em uma conta demo?',
            a: '<strong>Altamente recomendado!</strong> No primeiro uso, você deve testar em uma conta demo por pelo menos 1-2 semanas para confirmar que o link está funcionando e a execução da ordem está correta antes de mudar para uma conta real. Comece com o volume mínimo de 0,01 lote.'
          }
        ]
      }
    ]
  },

  // === ru Русский ===
  ru: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Автоматически подключайте сигналы TradingView к MetaTrader для исполнения сделок',
    heroBtn: 'Начать бесплатно',

    stat1Label: 'Средняя задержка',
    stat2Label: 'Доступность сервиса',
    stat3Label: 'Работа 24/7',
    stat4Label: 'Мульти-аккаунт распределение',

    flowSub1: 'Стратегия / Оповещение',
    flowSub2: 'Маршрутизация сигналов',
    flowSub3: 'Автоматическое исполнение',

    featTitle: 'Почему стоит выбрать WikiConnector',
    featSubtitle: 'Ключевые преимущества',
    features: [
      {
        icon: '⚡',
        title: 'Исполнение в миллисекундах',
        desc: 'Средняя задержка сигнала <100 мс, до 1 мс с WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Мульти-аккаунт распределение',
        desc: 'Один сертификат подключает несколько терминалов MT и одновременно распространяет один и тот же сигнал стратегии.'
      },
      {
        icon: '🔒',
        title: 'Безопасное шифрование',
        desc: 'Независимая система ключей для каждого пользователя, сквозное шифрование передачи данных.'
      },
      {
        icon: '📊',
        title: 'Мониторинг в реальном времени',
        desc: 'Статус получения сигнала, задержка исполнения и уровень успеха видны в реальном времени.'
      },
      {
        icon: '<>',
        title: 'Генератор кода',
        desc: 'Визуально генерируйте JSON-сигналы и код Pine Script без необходимости программирования.'
      },
      {
        icon: '🖥',
        title: 'Глубокая интеграция с VPS',
        desc: 'Общая система аккаунтов с Tianyun Cloud VPS, круглосуточная работа с низкой задержкой.'
      }
    ],

    stepsTitle: 'Четыре шага для начала автоматической торговли',
    stepsSubtitle: 'Быстрый старт',
    steps: [
      {
        title: 'Войдите',
        desc: 'Войдите в свою учетную запись WikiFX и автоматически получите свой эксклюзивный ключ и лицензию.'
      },
      {
        title: 'Настройте Webhook',
        desc: 'Скопируйте URL вебхука в настройки оповещений TradingView.'
      },
      {
        title: 'Установите EA',
        desc: 'Загрузите WikiConnector EA и введите License ID и Secret Key.'
      },
      {
        title: 'Автоматическая торговля',
        desc: 'Когда ваша стратегия запустит оповещение, сигнал будет автоматически отправлен в терминал MT для исполнения.'
      }
    ],

    loginTip: 'После входа вы сможете увидеть свой эксклюзивный ключ и сертификат',
    loginBtn: 'Войти сейчас',

    navConn: 'Управление подключениями',
    navLog: 'Журнал сигналов',
    navGen: 'Генератор кода',
    navParams: 'Быстрая справка по параметрам',
    navDl: 'Загрузки',
    navDoc: 'Руководство по использованию',
    navFaq: 'Часто задаваемые вопросы',

    keyLabel: 'Secret Key',
    keyTip1: 'Не делитесь им ни с кем',
    keyTip2: 'Используется для аутентификации EA',
    keyTip3: 'После сброса старый ключ становится немедленно недействительным',

    connSubtitle: 'Ниже представлены ваши лицензии и соответствующие им URL вебхуков',
    noLicense: 'Нет доступных лицензий. Пожалуйста, свяжитесь со службой поддержки',
    needHelp: 'Нужна помощь?',
    viewDoc: 'Посмотреть руководство по использованию',

    allLicense: 'Все лицензии',
    allStatus: 'Все статусы',
    refresh: 'Обновить',
    signalId: 'ID сигнала',
    total: 'Всего',
    records: 'записей',

    genIntro: 'Заполните следующие параметры для автоматической генерации JSON-сигналов и кода Pine Script, используемых в оповещениях TradingView.',
    genAuth: 'Информация для аутентификации',
    required: 'Обязательно',
    optional: 'Опционально',
    genLicPlaceholder: 'Введите ваш License ID',
    genLicHint: 'Можно посмотреть на странице управления подключениями',
    genKeyPlaceholder: 'Введите ваш Secret Key',
    genKeyHint: 'Можно посмотреть на странице управления подключениями',
    genTrade: 'Торговый ордер',
    genCmd: 'Тип ордера',
    genMarket: 'Рыночный ордер',
    genPending: 'Отложенный ордер',
    genClose: 'Закрыть',
    cmdBuy: 'Купить по рынку',
    cmdSell: 'Продать по рынку',
    cmdBuyLimit: 'Лимитная покупка',
    cmdSellLimit: 'Лимитная продажа',
    cmdBuyStop: 'Стоп-покупка',
    cmdSellStop: 'Стоп-продажа',
    cmdCloseBuy: 'Закрыть длинные позиции',
    cmdCloseSell: 'Закрыть короткие позиции',
    cmdCloseAll: 'Закрыть этот символ',
    cmdCloseAllOrders: 'Закрыть все',
    genSlTpHint: 'Выберите один из трех · Приоритет: Цена > Пункты > Процент',
    genTsHint: 'Время отправки сигнала',
    genTsBtn: 'Текущее время',
    presetSimple: '📝 Простая покупка',
    presetSltp: '🛡 Со стоп-лоссом и тейк-профитом',
    presetFull: '📋 Полные параметры',
    presetClose: '❌ Сигнал закрытия',
    presetPending: '📌 Отложенный ордер',
    presetReverse: '🔄 Разворот (закрытие + открытие)',
    genAlertTab: '🔔 Объяснение настроек оповещения',
    toastIncomplete: 'Информация неполная. Пожалуйста, заполните обязательные поля',
    toastRegen: 'Новый ключ был сгенерирован. Немедленно скопируйте его и обновите все настроенные EA',
    toastKeyCopied: 'Ключ скопирован',
    toastCopied: 'Скопировано',
    toastCodeCopied: 'Код скопирован',
    copyTitle: 'Копировать',
    genSymbol: 'Торговый символ',
    genPrice: 'Цена отложенного ордера',
    genParams: 'Торговые параметры',
    genLots: 'Объем (лоты)',
    genLotsHint: 'Оставьте пустым для использования значения по умолчанию EA',
    genMagic: 'Magic Number',
    genMagicHint: 'Используется для различения ордеров разных стратегий',
    genComment: 'Комментарий к ордеру',
    genCommentHint: 'Пример: Strategy A',
    genSL: 'Настройка стоп-лосса',
    genPoints: 'Пункты',
    genPrice2: 'Фиксированная цена',
    genPct: 'Процент %',
    genTP: 'Настройка тейк-профита',
    genAdvanced: 'Расширенные параметры',
    genSigIdHint: 'Оставьте пустым для автоматической генерации, используется для дедупликации',
    genGenId: 'Сгенерировать автоматически',
    genBtn: 'Сгенерировать код',
    genFormat: 'Формат сигнала',
    genGuideTitle: 'Как использовать это в TradingView',
    genGuideSteps: [
      'Создайте <strong>оповещение (Alert)</strong> на вашем графике TradingView',
      'В <strong>условии запуска оповещения</strong> выберите вашу стратегию или индикатор',
      'Разверните <strong>Уведомления (Notifications)</strong> → отметьте <strong>Webhook URL</strong>',
      'Введите URL вебхука: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Вставьте сгенерированный выше JSON в поле <strong>Сообщение (Message)</strong>',
      'Нажмите <strong>Создать (Create)</strong> для сохранения оповещения'
    ],
    genGuideNote: '<strong>Совет:</strong> Если вы используете Pine Script, добавьте сгенерированный код в ваш скрипт и используйте параметр <code>alert_message</code> в <code>strategy.entry()</code> или <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Авторизация) — Должен быть изменен',
        rows: [
          ['License', '—', 'ID авторизации, должен точно совпадать с полем license в JSON сигнала', 'req'],
          ['SecretKey', '—', 'Ключ безопасности (начинается с wc_sk_), должен точно совпадать с полем key в JSON сигнала', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Параметры торговли по умолчанию)',
        rows: [
          ['InpLots', '0.1', 'Объем лота по умолчанию, используется когда JSON сигнала не содержит lots', ''],
          ['InpMagic', '888', 'Magic Number по умолчанию, для различения ордеров разных стратегий', ''],
          ['InpComment', 'TV Signal', 'Комментарий к ордеру по умолчанию', ''],
          ['InpDeviation', '30', 'Максимальное проскальзывание (пункты), для Форекс 10–30, для Золота/Индексов 30–50 рекомендуется', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Приоритет: sl_price (фиксированная цена) > sl_points (пункты) > sl_pct (процент). Если все три равны 0, стоп-лосс не устанавливается, то же самое для тейк-профита',
        rows: [
          ['InpSLPoints', '0', 'Пункты стоп-лосса по умолчанию (0 = отключено)', ''],
          ['InpSLPrice', '0', 'Фиксированная цена стоп-лосса по умолчанию (0 = отключено, наивысший приоритет)', ''],
          ['InpSLPct', '0', 'Процент стоп-лосса по умолчанию (0 = отключено)', ''],
          ['InpTPPoints', '0', 'Пункты тейк-профита по умолчанию (0 = отключено)', ''],
          ['InpTPPrice', '0', 'Фиксированная цена тейк-профита по умолчанию (0 = отключено)', ''],
          ['InpTPPct', '0', 'Процент тейк-профита по умолчанию (0 = отключено)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Сопоставление имен символов)',
        note: 'Брокеры могут использовать разные имена символов (например: TradingView называет XAUUSD, ваш брокер называет GOLD). Сопоставление позволяет автоматическую конвертацию',
        rows: [
          ['InpPrefix', '(пусто)', 'Префикс имени символа, если символ брокера m.EURUSD, введите m.', ''],
          ['InpSuffix', '(пусто)', 'Суффикс имени символа, если символ брокера EURUSD.pro, введите .pro', ''],
          ['InpEnableMap1~5', 'false', 'Установите true для активации соответствующего правила сопоставления', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Правило сопоставления, формат: ИмяTradingView|ИмяMT5, поддерживает до 5 правил', ''],
          ['InpMapping2', 'EURUSD|EUR', 'То же, что выше', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'То же, что выше', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'То же, что выше', ''],
          ['InpMapping5', 'USOUSD|WTI', 'То же, что выше', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Временной фильтр / Отображение и журнал)',
        rows: [
          ['InpUseTimeFilter', 'false', 'При активации обрабатывает только сигналы между StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Разрешенное время начала торговли (время сервера MT5, формат ЧЧ:ММ)', ''],
          ['InpEndTime', '23:59', 'Разрешенное время окончания торговли', ''],
          ['InpShowPanel', 'true', 'Отображать информационную панель со статусом подключения и статистикой сигналов на графике', ''],
          ['InpUpdateInterval', '1000', 'Интервал обновления панели (мс), рекомендуется 1000~3000', ''],
          ['InpLogLevel', '1', 'Уровень журнала: 0=выкл 1=базовый 2=подробный 3=отладка (используйте 2 или 3 для устранения неполадок)', ''],
          ['InpLogToFile', 'true', 'Записывать файл журнала в MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Вывод на вкладку "Эксперты" в нижней части MT5', ''],
          ['InpMaxLogMB', '5', 'Максимальный размер файла журнала (МБ), автоматическая ротация при превышении', '']
        ]
      }
    ],

    paramsEATitle: 'Пояснение параметров EA',
    paramsEADesc: 'Следующие параметры можно настроить при открытии EA в MT5, а также переопределить через соответствующие поля в JSON сигнала.',
    paramName: 'Имя параметра',
    paramDefault: 'Значение по умолчанию',
    paramDesc: 'Описание',
    paramOverride: 'Поле переопределения JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'Объем лота по умолчанию (используется, когда JSON не указывает)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number по умолчанию', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Комментарий к ордеру по умолчанию', 'comment'],
      ['SlippagePoints', '3', 'Максимальное проскальзывание (пункты)', '—'],
      ['OfflineBuffer', 'false', 'Активировать офлайн-буфер', '—'],
      ['ReconnectSeconds', '5', 'Интервал переподключения WebSocket (секунды)', '—']
    ],
    cmdTableTitle: 'Пояснение типов ордеров',
    cmdCol: 'Ордер (cmd)',
    typeCol: 'Тип',
    actionCol: 'Действие',
    extraCol: 'Дополнительные параметры',
    cmdTable: [
      ['buy', 'Рыночный ордер', 'Немедленно купить', 'lots, sl_*, tp_*'],
      ['sell', 'Рыночный ордер', 'Немедленно продать', 'lots, sl_*, tp_*'],
      ['buylimit', 'Отложенный ордер', 'Купить при достижении цены', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Отложенный ордер', 'Продать при достижении цены', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Отложенный ордер', 'Купить при пробое', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Отложенный ордер', 'Продать при пробое', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Закрытие', 'Закрыть все длинные позиции', 'magic (опционально)'],
      ['closesell', 'Закрытие', 'Закрыть все короткие позиции', 'magic (опционально)'],
      ['closeall', 'Закрытие', 'Закрыть все открытые позиции', '—'],
      ['closeallorders', 'Закрытие', 'Удалить все отложенные ордера', '—']
    ],
    jsonFieldTitle: 'Пояснение полей JSON',
    fieldCol: 'Имя поля',
    requiredCol: 'Обязательно',
    descCol: 'Описание',
    jsonFields: [
      ['license', 'string', 'Обязательно', 'License ID'],
      ['key', 'string', 'Обязательно', 'Secret Key'],
      ['cmd', 'string', 'Обязательно', 'Торговый ордер, см. таблицу выше'],
      ['symbol', 'string', 'Обязательно', 'Торговый символ, например EURUSD'],
      ['lots', 'number', 'Опционально', 'Объем лота, оставьте пустым для использования значения по умолчанию EA'],
      ['price', 'number', 'Обязательно для отложенного ордера', 'Цена отложенного ордера'],
      ['sl_points', 'number', 'Опционально', 'Пункты стоп-лосса'],
      ['sl_price', 'number', 'Опционально', 'Фиксированная цена стоп-лосса'],
      ['sl_pct', 'number', 'Опционально', 'Процент стоп-лосса (0-100)'],
      ['tp_points', 'number', 'Опционально', 'Пункты тейк-профита'],
      ['tp_price', 'number', 'Опционально', 'Фиксированная цена тейк-профита'],
      ['tp_pct', 'number', 'Опционально', 'Процент тейк-профита (0-100)'],
      ['magic', 'number', 'Опционально', 'Magic Number'],
      ['comment', 'string', 'Опционально', 'Комментарий к ордеру'],
      ['signalid', 'string', 'Опционально', 'Уникальный ID сигнала, используется для дедупликации'],
      ['expiryseconds', 'number', 'Опционально', 'Срок действия сигнала (секунды), по умолчанию 60']
    ],

    dlMt5Desc: 'Версия EA для MT5, поддерживает все ордера, рекомендуется',
    dlMt5Btn: 'Скачать EA для MT5',
    dlMt4Desc: 'Версия EA для MT4, в разработке, следите за обновлениями',
    dlMt4Dev: 'В разработке',
    dlInstallDoc: `<h4>Инструкции по установке</h4>
<ol>
<li>Загрузите файл <code>WikiConnector_MT5.ex5</code></li>
<li>Откройте MT5, строка меню → <strong>Файл → Открыть папку данных</strong></li>
<li>Скопируйте файл <code>.ex5</code> в каталог <code>MQL5/Experts/</code></li>
<li>Нажмите <strong>F5</strong> в MT5 для обновления навигатора, найдите WikiConnector EA</li>
<li>Перетащите EA на любой график, введите <strong>License ID</strong> и <strong>Secret Key</strong></li>
<li>В опциях EA отметьте <strong>Разрешить WebRequest</strong> и добавьте <code>api-gw.interface003.com</code> в список разрешенных URL</li>
</ol>`,

    disclaimerTitle: 'Отказ от ответственности за риски',
    disclaimerContent: `<p>Перед загрузкой и использованием WikiConnector EA внимательно прочитайте следующий отказ от ответственности:</p>
<p><strong>1. Торговый риск</strong><br/>Торговля на Форекс и CFD сопряжена со значительными рисками, которые могут привести к полной или частичной потере капитала. WikiConnector является лишь инструментом передачи сигналов и не несет ответственности за результаты торговли.</p>
<p><strong>2. Риск стратегии</strong><br/>Прошлые показатели автоматических торговых стратегий не гарантируют будущих результатов. Проведите тщательное тестирование перед использованием на реальных счетах.</p>
<p><strong>3. Технический риск</strong><br/>Сетевая задержка, сбои сервера и ограничения API могут привести к потере сигналов или задержкам исполнения. Не используйте этот инструмент для высокочастотных стратегий, чувствительных к задержке.</p>
<p><strong>4. Ответственность пользователя</strong><br/>Пользователь несет полную ответственность за все результаты торговли, возникающие в результате использования WikiConnector EA. WikiFX не предоставляет инвестиционных советов и не несет ответственности за торговую прибыль или убытки.</p>`,
    disclaimerAgree: 'Я прочитал и принимаю вышеуказанный отказ от ответственности и понимаю риски торговли',
    disclaimerDownload: 'Принять и скачать',

    regenTitle: 'Подтвердить сброс ключа?',
    regenSubtitle: 'Это действие необратимо. Пожалуйста, подтвердите, что вы понимаете следующие последствия:',
    regenWarnings: ['Все EA, настроенные с этим ключом, будут <strong>немедленно отключены</strong>', 'Старый ключ станет <strong>навсегда недействительным</strong> и не может быть восстановлен', 'Вам необходимо вручную обновить конфигурацию Secret Key во всех EA', 'Существует риск <strong>потери сигналов</strong> во время сброса'],

    dashTitle: 'Мой WikiConnector',
    myKey: 'Мой Secret Key',
    keyPrefix: 'Secret Key',
    copyBtn: 'Копировать',
    regenBtn: 'Перегенерировать',
    regenConfirm: 'После перегенерации ключа все подключенные EA будут отключены и потребуют перенастройки. Продолжить?',
    regenConfirmBtn: 'Подтвердить сброс',
    cancelBtn: 'Отмена',
    copiedTip: 'Скопировано',

    licenseTitle: 'Мои сертификаты (License)',
    licenseId: 'ID сертификата',
    maxConn: 'Максимум подключений',
    activeConn: 'Текущее подключение',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Статистика сигналов',
    statTotal: 'Всего сигналов',
    statDelivered: 'Доставлено',
    statFailed: 'Ошибок',
    statConnections: 'Текущие подключения',

    signalTitle: 'Последние записи сигналов',
    signalTime: 'Время',
    signalCmd: 'Ордер',
    signalSymbol: 'Символ',
    signalLots: 'Объем',
    signalStatus: 'Статус',
    signalLicense: 'Сертификат',
    statusDelivered: 'Доставлено',
    statusPending: 'В ожидании',
    statusFailed: 'Ошибка',
    statusExpired: 'Истек',
    noSignal: 'Пока нет записей сигналов',
    loadMore: 'Загрузить еще',

    offlineBuffer: 'Офлайн-буфер',
    offlineBufferDesc: 'При активации сигналы, накопленные за время офлайн-периода, будут доставлены при переподключении EA (по умолчанию отключено для предотвращения потерь)',

    docTitle: 'Руководство по использованию',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Как работает WikiConnector</p>
  <p>WikiConnector получает сигналы TradingView в реальном времени через <strong>постоянное WebSocket-соединение</strong> и автоматически исполняет сделки в торговом программном обеспечении.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Установка EA в торговое ПО</p>
  <ol class="doc-steps">
    <li><strong>Открыть папку данных</strong>: Меню торгового ПО → Файл → Открыть папку данных</li>
    <li><strong>Скопировать файл EA</strong>: Скопируйте файл EA в каталог <code>Experts/</code></li>
    <li><strong>Обновить навигатор</strong>: Откройте навигатор → правый клик на "Советники" → Обновить. В списке должен появиться <strong>SignalReceiver</strong></li>
    <li><strong>Активировать автоторговлю</strong>: Кнопка "Автоторговля" на верхней панели инструментов должна быть 🟢 зеленой</li>
    <li><strong>Применить на график</strong>: Перетащите SignalReceiver на любой график. Когда появится окно настроек, настройте параметры</li>
  </ol>
  <div class="doc-tip"><strong>Совет:</strong> Достаточно применить EA на одном графике для обработки сигналов всех символов. Нет необходимости применять его отдельно на каждом графике.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Настройка параметров EA</p>
  <p>Существует два типа параметров: <strong>обязательные</strong> (License / SecretKey) и <strong>параметры по умолчанию</strong> (используются, когда JSON сигнала не содержит определенного поля; значения в сигнале всегда имеют приоритет над значениями по умолчанию EA).</p>
  <div class="doc-warn"><strong>Предупреждение безопасности:</strong> License и SecretKey — единственный барьер, защищающий вашу учетную запись. При утечке кто угодно может отправлять торговые ордера в ваше торговое ПО. Не делайте скриншоты и не делитесь ими с другими. Рекомендуется регулярно менять SecretKey.</div>
  <p>После завершения настройки в правом верхнем углу графика появится имя EA + <strong>😊</strong>, указывающее на подключение к серверу. Если отображается 😞, проверьте, зеленая ли кнопка "Автоторговля".</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Написание кода Pine Script для сигнала</p>
  <p>WikiConnector использует функцию <code>alert()</code> для запуска сигналов, а не метод <code>strategy.entry(alert_message=)</code>. Это разные механизмы, не смешивайте их.</p>
  <div class="doc-danger"><strong>Важно: alert.freq_all</strong> — По умолчанию в Pine Script в пределах одной свечи запускается только первый <code>alert()</code>, остальные молча игнорируются. Если вам нужно отправить несколько последовательных сигналов (например, при развороте: сначала закрыть шорт, затем открыть лонг), вы должны добавить <code>alert.freq_all</code> к каждому <code>alert()</code>, иначе второй сигнал никогда не достигнет сервера.</div>
<pre>//@version=6
strategy("Стратегия WikiConnector", overlay=true)

// Определение сообщений сигнала (замените YOUR_LICENSE и YOUR_KEY своими значениями)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Пример условий стратегии (пересечение скользящих средних 3/13)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Используйте alert.freq_all для гарантии отправки нескольких сигналов в одной свече
if longCondition
    alert(closesellMessage, alert.freq_all)  // Сначала закрыть короткие позиции
    alert(buyMessage,       alert.freq_all)  // Затем открыть длинную позицию

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Сначала закрыть длинные позиции
    alert(sellMessage,     alert.freq_all)   // Затем открыть короткую позицию</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Создание оповещения в TradingView</p>
  <p>URL вебхука:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Кликните правой кнопкой мыши по графику → "<strong>Добавить оповещение...</strong>" или <strong>Alt+A</strong></li>
    <li>В качестве условия запуска выберите <strong>"Только вызовы функции alert()"</strong> (важно!)</li>
    <li>Выберите дату истечения как можно более длительную или "Без срока"</li>
    <li>Поле Сообщения <strong>оставьте по умолчанию, ничего не вводите</strong> (содержимое сигнала определяется alert() в коде)</li>
    <li>Настройки уведомлений: отметьте <strong>Webhook URL</strong> и введите указанный выше адрес; <strong>снимите отметку "Отправлять обычный текст"</strong></li>
    <li>Нажмите "Создать" для сохранения оповещения</li>
  </ol>
  <div class="doc-tip"><strong>Совет:</strong> Функция вебхука требует подписки TradingView Pro или выше.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Пояснение формата JSON сигнала</p>
  <p><strong>Обязательные поля:</strong><code>license</code> (ID авторизации), <code>key</code> (ключ), <code>cmd</code> (команда), <code>symbol</code> (имя символа)</p>
  <p><strong>Опциональные поля:</strong><code>lots</code> (объем лота), <code>price</code> (цена отложенного ордера), <code>sl_points / sl_price / sl_pct</code> (стоп-лосс тройной выбор), <code>tp_points / tp_price / tp_pct</code> (тейк-профит тройной выбор), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (по умолчанию 300 секунд)</p>
  <p><strong>Поддерживаемые команды:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Приоритет стоп-лосса/тейк-профита:</strong><code>sl_price</code> (фиксированная цена)&gt; <code>sl_points</code> (пункты)&gt; <code>sl_pct</code> (процент). Если все три равны 0, стоп-лосс не устанавливается, то же самое для тейк-профита.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Контрольный список перед эксплуатацией</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Кнопка автоторговли торгового ПО 🟢 зеленая</li>
    <li class="ok">✅ EA в правом верхнем углу графика показывает 😊 (подключен к серверу)</li>
    <li class="ok">✅ License / SecretKey точно соответствуют значениям в JSON TradingView</li>
    <li class="ok">✅ Условие запуска оповещения "<strong>Только вызовы функции alert()</strong>"</li>
    <li class="ok">✅ К каждому <code>alert()</code> добавлен <code>alert.freq_all</code></li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Поле Сообщения оставлено по умолчанию, пусто</li>
    <li class="no">❌ "Отправлять обычный текст" снято</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Советы по безопасности и рискам</p>
  <div class="doc-warn">
    <strong>Безопасность учетной записи:</strong><br>
    · Не делайте скриншоты License и SecretKey и не делитесь ими ни с кем<br>
    · Если вы подозреваете утечку ключа, немедленно сбросьте SecretKey в консоли<br>
    · Рекомендуется регулярно менять SecretKey
  </div>
  <div class="doc-warn">
    <strong>Управление торговыми рисками:</strong><br>
    · Всегда устанавливайте стоп-лосс, не запускайте автоматические стратегии без защиты<br>
    · Рекомендуется, чтобы риск на одну сделку составлял не более 1-2% от баланса счета<br>
    · Перед важными экономическими данными (NFP, CPI, FOMC) рекомендуется приостанавливать автоматическую торговлю
  </div>
  <div class="doc-tip">
    <strong>Лучшие практики:</strong><br>
    · Сначала протестируйте на демо-счете не менее 1-2 недель, чтобы убедиться, что связь работает нормально, прежде чем переходить на реальный счет<br>
    · На реальном счете начинайте с минимального объема (0,01 лота)<br>
    · Используйте VPS (например, Tianyun Cloud VPS) для поддержания торгового ПО и EA онлайн 24/7
  </div>
</div>`,
    docSections: [
      {
        title: '1. Формат сигнала Webhook',
        content: `В поле Сообщения оповещения TradingView введите следующий JSON:
<pre>{
  "license": "{{вашLicenseID}}",
  "key": "{{вашSecretKey}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Поддерживаемые команды <strong>cmd</strong>: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. Адрес вебхука TradingView',
        content: `<p>В настройках оповещения TradingView установите URL вебхука следующим образом:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>В поле Сообщения введите формат JSON сигнала выше и замените license и key своими значениями.</p>`
      },
      {
        title: '3. Установка WikiConnector EA',
        content: `<p>1. Загрузите WikiConnector EA (файл .ex5)</p>
<p>2. Скопируйте EA в каталог <code>MQL5/Experts</code> MT5</p>
<p>3. Откройте EA в MT5 и введите <strong>License ID</strong> и <strong>Secret Key</strong></p>
<p>4. Разрешите EA устанавливать WebSocket-соединения (в Опциях MT5 → EA, активируйте разрешение сетевого подключения)</p>`
      },
      {
        title: '4. Лимиты частоты',
        content: `<p>Максимум <strong>30 запросов / 60 секунд</strong> на лицензию. Превышение лимита возвращает ошибку 429.</p>
<p>Если вам нужна более высокая частота, обратитесь в службу поддержки для обновления вашего тарифа.</p>`
      }
    ],

    faqTitle: 'Часто задаваемые вопросы',
    faqs: [
      {
        q: 'Что делать, если мой ключ утек?',
        a: 'Нажмите "Перегенерировать" в консоли. Старый ключ станет немедленно недействительным, и все соединения EA будут прерваны. Перенастройте EA с новым ключом.'
      },
      {
        q: 'Будут ли сигналы повторно отправлены после переподключения EA?',
        a: 'По умолчанию нет (для предотвращения потерь). Если вам нужна повторная отправка, активируйте "Офлайн-буфер" в консоли. При переподключении EA получит сигналы, накопленные за время офлайн-периода.'
      },
      {
        q: 'Сколько MT-аккаунтов может подключить одна лицензия?',
        a: 'Каждая лицензия поддерживает до 10 одновременных WebSocket-соединений, что позволяет до 10 терминалам MT одновременно получать один и тот же сигнал.'
      },
      {
        q: 'Поддерживается ли MT4?',
        a: 'Текущая версия в основном поддерживает MT5. Версия EA для MT4 находится в разработке. Следите за обновлениями!'
      },
      {
        q: 'Какова задержка сигнала?',
        a: 'Средняя задержка составляет <100 мс. С Tianyun Cloud VPS она может быть всего 1 мс.'
      },
      {
        q: 'Как проверить, правильно ли работает вебхук?',
        a: 'В списке сертификатов проверьте "Текущее количество подключений". Если оно больше 0, EA онлайн. После отправки тестового сигнала проверьте "Последние записи сигналов" на статус "Доставлено".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script и отправка сигналов',
        items: [
          {
            q: 'Я использую два alert() для закрытия и открытия, но торговое ПО получает только один сигнал.',
            a: 'Это ограничение Pine Script по умолчанию: в пределах одной свечи запускается только первый alert(). Решение — <strong>добавить параметр <code>alert.freq_all</code> к каждому alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Какое условие запуска мне выбрать для оповещения?',
            a: 'При использовании функции <code>alert()</code> вы должны выбрать <strong>"Только вызовы функции alert()"</strong>. Если вы используете метод <code>strategy.entry(..., alert_message=xxx)</code>, выберите "Order fills only". Эти два метода нельзя смешивать.'
          },
          {
            q: 'Что мне ввести в поле Сообщения?',
            a: 'При использовании метода <code>alert()</code> <strong>оставьте поле Сообщения по умолчанию, ничего не вводите</strong>. Содержимое сигнала определяется строкой внутри <code>alert(xxx)</code> в коде, и вебхук получит этот JSON.'
          }
        ]
      },
      {
        title: '🔌 Подключение и получение сигналов',
        items: [
          {
            q: 'Значок EA показывает красное плачущее лицо 😞. Что делать?',
            a: 'Проверьте, зеленая ли кнопка "Автоторговля" на панели инструментов торгового ПО. Если красная, нажмите на нее, чтобы сделать зеленой. EA автоматически вернется в нормальное состояние.'
          },
          {
            q: 'Я отправил сигнал из TradingView, но торговое ПО не отвечает.',
            a: 'Проверьте в таком порядке:<br>1. Зеленая ли автоторговля торгового ПО?<br>2. Показывает ли панель EA "Connected"?<br>3. Правильный ли URL вебхука <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>?<br>4. Является ли условие запуска оповещения "Только вызовы функции alert()"?<br>5. Добавлен ли к каждому alert() <code>alert.freq_all</code>?<br>6. Совпадают ли license и key в JSON точно с настройками EA?'
          }
        ]
      },
      {
        title: '💰 Исполнение сделок',
        items: [
          {
            q: 'Ордер не исполнился. В чем причина?',
            a: 'Распространенные причины: Недостаточно средств / Имя символа не совпадает (требуется настройка Symbol Mapping) / Превышен объем лота / Слишком большое проскальзывание (увеличьте InpDeviation) / Рынок закрыт. Проверьте журнал "Эксперты" в нижней части торгового ПО для получения конкретной информации об ошибке.'
          },
          {
            q: 'У ордера нет стоп-лосса или тейк-профита?',
            a: 'Проверьте: ① Содержит ли JSON сигнала такие поля, как <code>sl_points</code> / <code>tp_points</code> и т.д.?; ② Равны ли нулю параметры стоп-лосса и тейк-профита по умолчанию в EA? Если ни то, ни другое не установлено, у ордера не будет стоп-лосса или тейк-профита.'
          },
          {
            q: 'Имя символа не совпадает. Что делать?',
            a: 'Активируйте Symbol Mapping в параметрах EA:<br>Установите <code>InpEnableMap1 = true</code><br>Установите <code>InpMapping1 = XAUUSD|GOLD</code> (ИмяTradingView|ИмяТорговогоПО)'
          },
          {
            q: 'Могу ли я сначала протестировать на демо-счете?',
            a: '<strong>Настоятельно рекомендуется!</strong> При первом использовании вы должны протестировать на демо-счете не менее 1-2 недель, чтобы убедиться, что связь работает нормально и исполнение ордеров корректно, прежде чем переходить на реальный счет. Начинайте с минимального объема 0,01 лота.'
          }
        ]
      }
    ]
  },

  // === th ภาษาไทย ===
  th: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'เชื่อมต่อสัญญาณ TradingView ไปยัง MetaTrader โดยอัตโนมัติเพื่อดำเนินการเทรด',
    heroBtn: 'เริ่มต้นฟรี',

    stat1Label: 'ความหน่วงเฉลี่ย',
    stat2Label: 'ความพร้อมใช้งานของบริการ',
    stat3Label: 'ทำงาน 24/7',
    stat4Label: 'กระจายหลายบัญชี',

    flowSub1: 'กลยุทธ์ / การแจ้งเตือน',
    flowSub2: 'การกำหนดเส้นทางสัญญาณ',
    flowSub3: 'การดำเนินการอัตโนมัติ',

    featTitle: 'ทำไมต้องเลือก WikiConnector',
    featSubtitle: 'ข้อได้เปรียบหลัก',
    features: [
      {
        icon: '⚡',
        title: 'ดำเนินการในมิลลิวินาที',
        desc: 'ความหน่วงสัญญาณเฉลี่ย <100 มิลลิวินาที ต่ำถึง 1 มิลลิวินาทีด้วย WikiFX VPS'
      },
      {
        icon: '🔗',
        title: 'กระจายหลายบัญชี',
        desc: 'ใบรับรองหนึ่งใบเชื่อมต่อเทอร์มินัล MT หลายเครื่อง และกระจายสัญญาณกลยุทธ์เดียวกันพร้อมกัน'
      },
      {
        icon: '🔒',
        title: 'การเข้ารหัสที่ปลอดภัย',
        desc: 'ระบบคีย์อิสระต่อผู้ใช้ การส่งข้อมูลเข้ารหัสแบบครบวงจร'
      },
      {
        icon: '📊',
        title: 'ตรวจสอบแบบเรียลไทม์',
        desc: 'สถานะการรับสัญญาณ ความหน่วงในการดำเนินการ และอัตราความสำเร็จสามารถดูได้แบบเรียลไทม์'
      },
      {
        icon: '<>',
        title: 'ตัวสร้างโค้ด',
        desc: 'สร้างสัญญาณ JSON และโค้ด Pine Script ด้วยภาพ ไม่จำเป็นต้องเขียนโปรแกรม'
      },
      {
        icon: '🖥',
        title: 'บูรณาการเชิงลึกกับ VPS',
        desc: 'แบ่งปันระบบบัญชีกับ Tianyun Cloud VPS ทำงานตลอด 24 ชั่วโมงด้วยความหน่วงต่ำ'
      }
    ],

    stepsTitle: 'สี่ขั้นตอนในการเริ่มต้นเทรดอัตโนมัติ',
    stepsSubtitle: 'เริ่มต้นอย่างรวดเร็ว',
    steps: [
      {
        title: 'เข้าสู่ระบบ',
        desc: 'เข้าสู่ระบบด้วยบัญชี WikiFX ของคุณ และรับคีย์และใบอนุญาตพิเศษของคุณโดยอัตโนมัติ'
      },
      {
        title: 'กำหนดค่า Webhook',
        desc: 'คัดลอก URL Webhook ไปยังการตั้งค่าการแจ้งเตือนของ TradingView'
      },
      {
        title: 'ติดตั้ง EA',
        desc: 'ดาวน์โหลด WikiConnector EA และป้อน License ID และ Secret Key'
      },
      {
        title: 'เทรดอัตโนมัติ',
        desc: 'เมื่อกลยุทธ์ของคุณกระตุ้นการแจ้งเตือน สัญญาณจะถูกส่งไปยังเทอร์มินัล MT โดยอัตโนมัติเพื่อดำเนินการ'
      }
    ],

    loginTip: 'หลังจากเข้าสู่ระบบ คุณจะเห็นคีย์และใบรับรองพิเศษของคุณ',
    loginBtn: 'เข้าสู่ระบบเลย',

    navConn: 'การจัดการการเชื่อมต่อ',
    navLog: 'บันทึกสัญญาณ',
    navGen: 'ตัวสร้างโค้ด',
    navParams: 'การอ้างอิงพารามิเตอร์ด่วน',
    navDl: 'ดาวน์โหลด',
    navDoc: 'คู่มือการใช้งาน',
    navFaq: 'คำถามที่พบบ่อย',

    keyLabel: 'Secret Key',
    keyTip1: 'อย่าแชร์ให้ใคร',
    keyTip2: 'ใช้สำหรับการตรวจสอบสิทธิ์ EA',
    keyTip3: 'หลังจากรีเซ็ต คีย์เก่าจะกลายเป็นไม่ถูกต้องทันที',

    connSubtitle: 'ด้านล่างนี้คือใบอนุญาตของคุณและ URL Webhook ที่เกี่ยวข้อง',
    noLicense: 'ไม่มีใบอนุญาต โปรดติดต่อฝ่ายบริการลูกค้า',
    needHelp: 'ต้องการความช่วยเหลือ?',
    viewDoc: 'ดูคู่มือการใช้งาน',

    allLicense: 'ใบอนุญาตทั้งหมด',
    allStatus: 'สถานะทั้งหมด',
    refresh: 'รีเฟรช',
    signalId: 'ID สัญญาณ',
    total: 'รวม',
    records: 'รายการ',

    genIntro: 'กรอกพารามิเตอร์ต่อไปนี้เพื่อสร้างสัญญาณ JSON และโค้ด Pine Script โดยอัตโนมัติที่สามารถใช้ในการแจ้งเตือนของ TradingView',
    genAuth: 'ข้อมูลการตรวจสอบสิทธิ์',
    required: 'จำเป็น',
    optional: 'ไม่บังคับ',
    genLicPlaceholder: 'ป้อน License ID ของคุณ',
    genLicHint: 'สามารถดูได้ในหน้าจัดการการเชื่อมต่อ',
    genKeyPlaceholder: 'ป้อน Secret Key ของคุณ',
    genKeyHint: 'สามารถดูได้ในหน้าจัดการการเชื่อมต่อ',
    genTrade: 'คำสั่งเทรด',
    genCmd: 'ประเภทคำสั่ง',
    genMarket: 'คำสั่งตลาด',
    genPending: 'คำสั่งรอ',
    genClose: 'ปิด',
    cmdBuy: 'ซื้อตามตลาด',
    cmdSell: 'ขายตามตลาด',
    cmdBuyLimit: 'ซื้อแบบจำกัด',
    cmdSellLimit: 'ขายแบบจำกัด',
    cmdBuyStop: 'ซื้อแบบเบรกเอาท์',
    cmdSellStop: 'ขายแบบเบรกเอาท์',
    cmdCloseBuy: 'ปิดสถานะซื้อทั้งหมด',
    cmdCloseSell: 'ปิดสถานะขายทั้งหมด',
    cmdCloseAll: 'ปิดสัญลักษณ์นี้',
    cmdCloseAllOrders: 'ปิดทั้งหมด',
    genSlTpHint: 'เลือกหนึ่งในสาม · ลำดับความสำคัญ: ราคา > จุด > เปอร์เซ็นต์',
    genTsHint: 'เวลาที่ส่งสัญญาณ',
    genTsBtn: 'เวลาปัจจุบัน',
    presetSimple: '📝 ซื้อแบบง่าย',
    presetSltp: '🛡 พร้อม stop loss และ take profit',
    presetFull: '📋 พารามิเตอร์ครบถ้วน',
    presetClose: '❌ สัญญาณปิด',
    presetPending: '📌 คำสั่งรอ',
    presetReverse: '🔄 กลับด้าน (ปิด + เปิด)',
    genAlertTab: '🔔 คำอธิบายการตั้งค่าการแจ้งเตือน',
    toastIncomplete: 'ข้อมูลไม่สมบูรณ์ กรุณากรอกฟิลด์ที่จำเป็น',
    toastRegen: 'สร้างคีย์ใหม่แล้ว กรุณาคัดลอกทันทีและอัปเดต EA ที่กำหนดค่าทั้งหมด',
    toastKeyCopied: 'คัดลอกคีย์แล้ว',
    toastCopied: 'คัดลอกแล้ว',
    toastCodeCopied: 'คัดลอกโค้ดแล้ว',
    copyTitle: 'คัดลอก',
    genSymbol: 'สัญลักษณ์การเทรด',
    genPrice: 'ราคาคำสั่งรอ',
    genParams: 'พารามิเตอร์การเทรด',
    genLots: 'ขนาดล็อต',
    genLotsHint: 'ปล่อยว่างเพื่อใช้ค่าเริ่มต้นของ EA',
    genMagic: 'Magic Number',
    genMagicHint: 'ใช้เพื่อแยกความแตกต่างของคำสั่งจากกลยุทธ์ต่างๆ',
    genComment: 'ความคิดเห็นคำสั่ง',
    genCommentHint: 'ตัวอย่าง: Strategy A',
    genSL: 'การตั้งค่า stop loss',
    genPoints: 'จุด',
    genPrice2: 'ราคาคงที่',
    genPct: 'เปอร์เซ็นต์ %',
    genTP: 'การตั้งค่า take profit',
    genAdvanced: 'พารามิเตอร์ขั้นสูง',
    genSigIdHint: 'ปล่อยว่างเพื่อสร้างอัตโนมัติ ใช้สำหรับป้องกันรายการซ้ำ',
    genGenId: 'สร้างอัตโนมัติ',
    genBtn: 'สร้างโค้ด',
    genFormat: 'รูปแบบสัญญาณ',
    genGuideTitle: 'วิธีใช้งานใน TradingView',
    genGuideSteps: [
      'สร้าง<strong>การแจ้งเตือน (Alert)</strong>บนแผนภูมิ TradingView ของคุณ',
      'ใน<strong>เงื่อนไขการกระตุ้นการแจ้งเตือน</strong> เลือกกลยุทธ์หรืออินดิเคเตอร์ของคุณ',
      'ขยาย<strong>การแจ้งเตือน (Notifications)</strong> → ทำเครื่องหมาย<strong>Webhook URL</strong>',
      'ป้อน URL Webhook: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'วาง JSON ที่สร้างไว้ด้านบนลงในกล่อง<strong>ข้อความ (Message)</strong>',
      'คลิก<strong>สร้าง (Create)</strong>เพื่อบันทึกการแจ้งเตือน'
    ],
    genGuideNote: '<strong>เคล็ดลับ:</strong> หากคุณใช้ Pine Script ให้เพิ่มโค้ดที่สร้างขึ้นไปยังสคริปต์ของคุณ และใช้พารามิเตอร์ <code>alert_message</code> ใน <code>strategy.entry()</code> หรือ <code>strategy.close()</code>',

    paramsGroups: [
      {
        title: '🔐 Authorization (การอนุญาต) — ต้องแก้ไข',
        rows: [
          ['License', '—', 'ID การอนุญาต ต้องตรงกับฟิลด์ license ใน JSON สัญญาณทุกประการ', 'req'],
          ['SecretKey', '—', 'คีย์ความปลอดภัย (ขึ้นต้นด้วย wc_sk_) ต้องตรงกับฟิลด์ key ใน JSON สัญญาณทุกประการ', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (พารามิเตอร์การเทรดเริ่มต้น)',
        rows: [
          ['InpLots', '0.1', 'ขนาดล็อตเริ่มต้น ใช้เมื่อ JSON สัญญาณไม่มี lots', ''],
          ['InpMagic', '888', 'Magic Number เริ่มต้น สำหรับแยกคำสั่งจากกลยุทธ์ต่างๆ', ''],
          ['InpComment', 'TV Signal', 'ความคิดเห็นคำสั่งเริ่มต้น', ''],
          ['InpDeviation', '30', 'ค่า slippage สูงสุด (จุด) สำหรับ Forex 10–30 สำหรับทองคำ/ดัชนี แนะนำ 30–50', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'ลำดับความสำคัญ: sl_price (ราคาคงที่) > sl_points (จุด) > sl_pct (เปอร์เซ็นต์) หากทั้งสามเป็น 0 จะไม่ตั้ง stop loss เช่นเดียวกับ take profit',
        rows: [
          ['InpSLPoints', '0', 'จุด stop loss เริ่มต้น (0 = ปิดใช้งาน)', ''],
          ['InpSLPrice', '0', 'ราคาคงที่ stop loss เริ่มต้น (0 = ปิดใช้งาน, ลำดับความสำคัญสูงสุด)', ''],
          ['InpSLPct', '0', 'เปอร์เซ็นต์ stop loss เริ่มต้น (0 = ปิดใช้งาน)', ''],
          ['InpTPPoints', '0', 'จุด take profit เริ่มต้น (0 = ปิดใช้งาน)', ''],
          ['InpTPPrice', '0', 'ราคาคงที่ take profit เริ่มต้น (0 = ปิดใช้งาน)', ''],
          ['InpTPPct', '0', 'เปอร์เซ็นต์ take profit เริ่มต้น (0 = ปิดใช้งาน)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (การแมปชื่อสัญลักษณ์)',
        note: 'โบรกเกอร์อาจใช้ชื่อสัญลักษณ์ต่างกัน (เช่น TradingView เรียก XAUUSD โบรกเกอร์ของคุณเรียก GOLD) การแมปช่วยให้แปลงอัตโนมัติ',
        rows: [
          ['InpPrefix', '(ว่าง)', 'คำนำหน้าชื่อสัญลักษณ์ ถ้าสัญลักษณ์โบรกเกอร์คือ m.EURUSD ให้ป้อน m.', ''],
          ['InpSuffix', '(ว่าง)', 'คำต่อท้ายชื่อสัญลักษณ์ ถ้าสัญลักษณ์โบรกเกอร์คือ EURUSD.pro ให้ป้อน .pro', ''],
          ['InpEnableMap1~5', 'false', 'ตั้งเป็น true เพื่อเปิดใช้งานกฎการแมปที่เกี่ยวข้อง', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'กฎการแมป รูปแบบ: ชื่อTradingView|ชื่อMT5 รองรับสูงสุด 5 กฎ', ''],
          ['InpMapping2', 'EURUSD|EUR', 'เหมือนข้างบน', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'เหมือนข้างบน', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'เหมือนข้างบน', ''],
          ['InpMapping5', 'USOUSD|WTI', 'เหมือนข้างบน', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (ตัวกรองเวลา / การแสดงผลและบันทึก)',
        rows: [
          ['InpUseTimeFilter', 'false', 'เมื่อเปิดใช้งาน จะประมวลผลเฉพาะสัญญาณระหว่าง StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'เวลาเริ่มต้นที่อนุญาตให้เทรด (เวลาเซิร์ฟเวอร์ MT5 รูปแบบ HH:MM)', ''],
          ['InpEndTime', '23:59', 'เวลาสิ้นสุดที่อนุญาตให้เทรด', ''],
          ['InpShowPanel', 'true', 'แสดงแผงข้อมูลสถานะการเชื่อมต่อและสถิติสัญญาณบนแผนภูมิ', ''],
          ['InpUpdateInterval', '1000', 'ช่วงเวลาอัปเดตแผง (ms) แนะนำ 1000~3000', ''],
          ['InpLogLevel', '1', 'ระดับบันทึก: 0=ปิด 1=พื้นฐาน 2=ละเอียด 3=ดีบัก (ใช้ 2 หรือ 3 สำหรับการแก้ปัญหา)', ''],
          ['InpLogToFile', 'true', 'เขียนไฟล์บันทึกไปยัง MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'แสดงผลในแท็บ "ผู้เชี่ยวชาญ" ที่ด้านล่างของ MT5', ''],
          ['InpMaxLogMB', '5', 'ขนาดไฟล์บันทึกสูงสุด (MB) หมุนเวียนอัตโนมัติเมื่อเกิน', '']
        ]
      }
    ],

    paramsEATitle: 'คำอธิบายพารามิเตอร์ EA',
    paramsEADesc: 'พารามิเตอร์ต่อไปนี้สามารถตั้งค่าได้เมื่อเปิด EA ใน MT5 และยังสามารถแทนที่ได้ผ่านฟิลด์ที่เกี่ยวข้องใน JSON สัญญาณ',
    paramName: 'ชื่อพารามิเตอร์',
    paramDefault: 'ค่าเริ่มต้น',
    paramDesc: 'คำอธิบาย',
    paramOverride: 'ฟิลด์แทนที่ JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'ขนาดล็อตเริ่มต้น (ใช้เมื่อ JSON ไม่ระบุ)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number เริ่มต้น', 'magic'],
      ['DefaultComment', 'WikiConnector', 'ความคิดเห็นคำสั่งเริ่มต้น', 'comment'],
      ['SlippagePoints', '3', 'ค่า slippage สูงสุด (จุด)', '—'],
      ['OfflineBuffer', 'false', 'เปิดใช้งานบัฟเฟอร์ออฟไลน์', '—'],
      ['ReconnectSeconds', '5', 'ช่วงเวลาเชื่อมต่อ WebSocket ใหม่ (วินาที)', '—']
    ],
    cmdTableTitle: 'คำอธิบายประเภทคำสั่ง',
    cmdCol: 'คำสั่ง (cmd)',
    typeCol: 'ประเภท',
    actionCol: 'การดำเนินการ',
    extraCol: 'พารามิเตอร์เพิ่มเติม',
    cmdTable: [
      ['buy', 'คำสั่งตลาด', 'ซื้อทันที', 'lots, sl_*, tp_*'],
      ['sell', 'คำสั่งตลาด', 'ขายทันที', 'lots, sl_*, tp_*'],
      ['buylimit', 'คำสั่งรอ', 'ซื้อเมื่อถึงราคา', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'คำสั่งรอ', 'ขายเมื่อถึงราคา', 'price, lots, sl_*, tp_*'],
      ['buystop', 'คำสั่งรอ', 'ซื้อเมื่อทะลุ', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'คำสั่งรอ', 'ขายเมื่อทะลุ', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'ปิด', 'ปิดสถานะซื้อทั้งหมด', 'magic (ไม่บังคับ)'],
      ['closesell', 'ปิด', 'ปิดสถานะขายทั้งหมด', 'magic (ไม่บังคับ)'],
      ['closeall', 'ปิด', 'ปิดสถานะที่เปิดอยู่ทั้งหมด', '—'],
      ['closeallorders', 'ปิด', 'ลบคำสั่งรอทั้งหมด', '—']
    ],
    jsonFieldTitle: 'คำอธิบายฟิลด์ JSON',
    fieldCol: 'ชื่อฟิลด์',
    requiredCol: 'จำเป็น',
    descCol: 'คำอธิบาย',
    jsonFields: [
      ['license', 'string', 'จำเป็น', 'License ID'],
      ['key', 'string', 'จำเป็น', 'Secret Key'],
      ['cmd', 'string', 'จำเป็น', 'คำสั่งเทรด ดูตารางด้านบน'],
      ['symbol', 'string', 'จำเป็น', 'สัญลักษณ์การเทรด เช่น EURUSD'],
      ['lots', 'number', 'ไม่บังคับ', 'ขนาดล็อต ปล่อยว่างเพื่อใช้ค่าเริ่มต้นของ EA'],
      ['price', 'number', 'จำเป็นสำหรับคำสั่งรอ', 'ราคาคำสั่งรอ'],
      ['sl_points', 'number', 'ไม่บังคับ', 'จุด stop loss'],
      ['sl_price', 'number', 'ไม่บังคับ', 'ราคาคงที่ stop loss'],
      ['sl_pct', 'number', 'ไม่บังคับ', 'เปอร์เซ็นต์ stop loss (0-100)'],
      ['tp_points', 'number', 'ไม่บังคับ', 'จุด take profit'],
      ['tp_price', 'number', 'ไม่บังคับ', 'ราคาคงที่ take profit'],
      ['tp_pct', 'number', 'ไม่บังคับ', 'เปอร์เซ็นต์ take profit (0-100)'],
      ['magic', 'number', 'ไม่บังคับ', 'Magic Number'],
      ['comment', 'string', 'ไม่บังคับ', 'ความคิดเห็นคำสั่ง'],
      ['signalid', 'string', 'ไม่บังคับ', 'ID เฉพาะของสัญญาณ ใช้สำหรับป้องกันรายการซ้ำ'],
      ['expiryseconds', 'number', 'ไม่บังคับ', 'อายุของสัญญาณ (วินาที) ค่าเริ่มต้น 60']
    ],

    dlMt5Desc: 'เวอร์ชัน MT5 ของ EA รองรับคำสั่งทั้งหมด แนะนำ',
    dlMt5Btn: 'ดาวน์โหลด EA MT5',
    dlMt4Desc: 'เวอร์ชัน MT4 ของ EA กำลังพัฒนา โปรดรอติดตาม',
    dlMt4Dev: 'กำลังพัฒนา',
    dlInstallDoc: `<h4>คำแนะนำการติดตั้ง</h4>
<ol>
<li>ดาวน์โหลดไฟล์ <code>WikiConnector_MT5.ex5</code></li>
<li>เปิด MT5 แถบเมนู → <strong>ไฟล์ → เปิดโฟลเดอร์ข้อมูล</strong></li>
<li>คัดลอกไฟล์ <code>.ex5</code> ไปยังไดเรกทอรี <code>MQL5/Experts/</code></li>
<li>กด <strong>F5</strong> ใน MT5 เพื่อรีเฟรชเนวิเกเตอร์ ค้นหา WikiConnector EA</li>
<li>ลาก EA ไปยังแผนภูมิใดก็ได้ ป้อน <strong>License ID</strong> และ <strong>Secret Key</strong></li>
<li>ในตัวเลือก EA ให้ทำเครื่องหมาย <strong>อนุญาต WebRequest</strong> และเพิ่ม <code>api-gw.interface003.com</code> ลงในรายการ URL ที่อนุญาต</li>
</ol>`,

    disclaimerTitle: 'ข้อจำกัดความรับผิดชอบเกี่ยวกับความเสี่ยง',
    disclaimerContent: `<p>ก่อนดาวน์โหลดและใช้ WikiConnector EA โปรดอ่านข้อจำกัดความรับผิดชอบต่อไปนี้อย่างละเอียด:</p>
<p><strong>1. ความเสี่ยงในการเทรด</strong><br/>การเทรด Forex และ CFD มีความเสี่ยงอย่างมีนัยสำคัญซึ่งอาจส่งผลให้สูญเสียเงินทุนทั้งหมดหรือบางส่วน WikiConnector เป็นเพียงเครื่องมือส่งสัญญาณเท่านั้น และไม่รับผิดชอบต่อผลลัพธ์การเทรดใดๆ</p>
<p><strong>2. ความเสี่ยงด้านกลยุทธ์</strong><br/>ผลการดำเนินงานในอดีตของกลยุทธ์การเทรดอัตโนมัติไม่ได้รับประกันผลลัพธ์ในอนาคต ทดสอบอย่างละเอียดก่อนใช้ในบัญชีจริง</p>
<p><strong>3. ความเสี่ยงทางเทคนิค</strong><br/>ความหน่วงของเครือข่าย ความล้มเหลวของเซิร์ฟเวอร์ และข้อจำกัดของ API อาจทำให้สัญญาณสูญหายหรือการดำเนินการล่าช้า ห้ามใช้เครื่องมือนี้สำหรับกลยุทธ์ความถี่สูงที่ไวต่อความหน่วง</p>
<p><strong>4. ความรับผิดชอบของผู้ใช้</strong><br/>ผู้ใช้รับผิดชอบทั้งหมดต่อผลลัพธ์การเทรดทั้งหมดที่เกิดจากการใช้ WikiConnector EA WikiFX ไม่ให้คำแนะนำการลงทุนและไม่รับผิดชอบต่อกำไรหรือขาดทุนจากการเทรด</p>`,
    disclaimerAgree: 'ฉันได้อ่านและยอมรับข้อจำกัดความรับผิดชอบข้างต้น และเข้าใจความเสี่ยงในการเทรด',
    disclaimerDownload: 'ยอมรับและดาวน์โหลด',

    regenTitle: 'ยืนยันการรีเซ็ตคีย์?',
    regenSubtitle: 'การกระทำนี้ไม่สามารถยกเลิกได้ กรุณายืนยันว่าคุณเข้าใจผลกระทบต่อไปนี้:',
    regenWarnings: ['EA ทั้งหมดที่กำหนดค่าด้วยคีย์นี้จะ<strong>ตัดการเชื่อมต่อทันที</strong>', 'คีย์เก่าจะ<strong>ไม่ถูกต้องอย่างถาวร</strong>และไม่สามารถกู้คืนได้', 'คุณต้องอัปเดตการกำหนดค่า Secret Key ใน EA ทั้งหมดด้วยตนเอง', 'มีความเสี่ยง<strong>สูญเสียสัญญาณ</strong>ระหว่างการรีเซ็ต'],

    dashTitle: 'WikiConnector ของฉัน',
    myKey: 'Secret Key ของฉัน',
    keyPrefix: 'Secret Key',
    copyBtn: 'คัดลอก',
    regenBtn: 'สร้างใหม่',
    regenConfirm: 'หลังจากสร้างคีย์ใหม่ EA ที่เชื่อมต่อทั้งหมดจะถูกตัดการเชื่อมต่อและต้องกำหนดค่าใหม่ ดำเนินการต่อ?',
    regenConfirmBtn: 'ยืนยันการรีเซ็ต',
    cancelBtn: 'ยกเลิก',
    copiedTip: 'คัดลอกแล้ว',

    licenseTitle: 'ใบรับรองของฉัน (License)',
    licenseId: 'ID ใบรับรอง',
    maxConn: 'การเชื่อมต่อสูงสุด',
    activeConn: 'การเชื่อมต่อปัจจุบัน',
    webhookUrl: 'Webhook URL',

    statsTitle: 'สถิติสัญญาณ',
    statTotal: 'สัญญาณทั้งหมด',
    statDelivered: 'จัดส่งแล้ว',
    statFailed: 'ล้มเหลว',
    statConnections: 'การเชื่อมต่อปัจจุบัน',

    signalTitle: 'บันทึกสัญญาณล่าสุด',
    signalTime: 'เวลา',
    signalCmd: 'คำสั่ง',
    signalSymbol: 'สัญลักษณ์',
    signalLots: 'ขนาดล็อต',
    signalStatus: 'สถานะ',
    signalLicense: 'ใบรับรอง',
    statusDelivered: 'จัดส่งแล้ว',
    statusPending: 'รอดำเนินการ',
    statusFailed: 'ล้มเหลว',
    statusExpired: 'หมดอายุ',
    noSignal: 'ยังไม่มีบันทึกสัญญาณ',
    loadMore: 'โหลดเพิ่มเติม',

    offlineBuffer: 'บัฟเฟอร์ออฟไลน์',
    offlineBufferDesc: 'เมื่อเปิดใช้งาน สัญญาณที่สะสมในช่วงออฟไลน์จะถูกจัดส่งเมื่อ EA เชื่อมต่อใหม่ (ปิดใช้งานโดยค่าเริ่มต้นเพื่อป้องกันการสูญเสีย)',

    docTitle: 'คู่มือการใช้งาน',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 วิธีการทำงานของ WikiConnector</p>
  <p>WikiConnector รับสัญญาณ TradingView แบบเรียลไทม์ผ่าน<strong>การเชื่อมต่อ WebSocket แบบถาวร</strong> และดำเนินการเทรดโดยอัตโนมัติในซอฟต์แวร์เทรด</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① ติดตั้ง EA ในซอฟต์แวร์เทรด</p>
  <ol class="doc-steps">
    <li><strong>เปิดโฟลเดอร์ข้อมูล</strong>: เมนูซอฟต์แวร์เทรด → ไฟล์ → เปิดโฟลเดอร์ข้อมูล</li>
    <li><strong>คัดลอกไฟล์ EA</strong>: คัดลอกไฟล์ EA ไปยังไดเรกทอรี <code>Experts/</code></li>
    <li><strong>รีเฟรชเนวิเกเตอร์</strong>: เปิดเนวิเกเตอร์ → คลิกขวาที่ "ผู้เชี่ยวชาญ" → รีเฟรช <strong>SignalReceiver</strong> ควรปรากฏในรายการ</li>
    <li><strong>เปิดใช้งานการเทรดอัตโนมัติ</strong>: ปุ่ม "การเทรดอัตโนมัติ" บนแถบเครื่องมือด้านบนต้องเป็นสี🟢 เขียว</li>
    <li><strong>นำไปใช้กับแผนภูมิ</strong>: ลาก SignalReceiver ไปยังแผนภูมิใดก็ได้ เมื่อหน้าต่างการตั้งค่าปรากฏขึ้น ให้กำหนดค่าพารามิเตอร์</li>
  </ol>
  <div class="doc-tip"><strong>เคล็ดลับ:</strong> เพียงนำ EA ไปใช้กับแผนภูมิเดียวก็เพียงพอที่จะประมวลผลสัญญาณของสัญลักษณ์ทั้งหมด ไม่จำเป็นต้องนำไปใช้กับแต่ละแผนภูมิแยกกัน</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② กำหนดค่าพารามิเตอร์ EA</p>
  <p>มีพารามิเตอร์สองประเภท: <strong>จำเป็น</strong> (License / SecretKey) และ <strong>พารามิเตอร์เริ่มต้น</strong> (ใช้เมื่อ JSON สัญญาณไม่มีฟิลด์เฉพาะ ค่าในสัญญาณจะมีลำดับความสำคัญเหนือกว่าค่าเริ่มต้นของ EA เสมอ)</p>
  <div class="doc-warn"><strong>คำเตือนด้านความปลอดภัย:</strong> License และ SecretKey เป็นสิ่งกีดขวางเพียงอย่างเดียวที่ปกป้องบัญชีของคุณ หากรั่วไหล ใครก็ตามสามารถส่งคำสั่งเทรดไปยังซอฟต์แวร์เทรดของคุณได้ อย่าถ่ายภาพหน้าจอหรือแชร์ให้ผู้อื่น ขอแนะนำให้เปลี่ยน SecretKey เป็นประจำ</div>
  <p>หลังจากตั้งค่าเสร็จสิ้น ชื่อ EA + <strong>😊</strong> จะปรากฏที่มุมขวาบนของแผนภูมิ ซึ่งบ่งบอกว่าเชื่อมต่อกับเซิร์ฟเวอร์แล้ว หากแสดง 😞 ให้ตรวจสอบว่าปุ่ม "การเทรดอัตโนมัติ" เป็นสีเขียวหรือไม่</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ เขียนโค้ด Pine Script สำหรับสัญญาณ</p>
  <p>WikiConnector ใช้ฟังก์ชัน <code>alert()</code> เพื่อกระตุ้นสัญญาณ ไม่ใช่วิธี <code>strategy.entry(alert_message=)</code> ทั้งสองเป็นกลไกที่แตกต่างกัน อย่าผสมกัน</p>
  <div class="doc-danger"><strong>สำคัญ: alert.freq_all</strong> — โดยค่าเริ่มต้น ใน Pine Script ภายในแท่งเทียนเดียวกัน เฉพาะ <code>alert()</code> แรกเท่านั้นที่ถูกกระตุ้น ส่วนที่เหลือจะถูกทิ้งอย่างเงียบ ๆ หากคุณต้องการส่งสัญญาณหลายรายการติดต่อกัน (เช่น ในการกลับด้าน: ปิดสถานะขายก่อนแล้วจึงเปิดสถานะซื้อ) คุณต้องเพิ่ม <code>alert.freq_all</code> ให้กับทุก <code>alert()</code> มิฉะนั้นสัญญาณที่สองจะไปไม่ถึงเซิร์ฟเวอร์</div>
<pre>//@version=6
strategy("กลยุทธ์ WikiConnector", overlay=true)

// กำหนดข้อความสัญญาณ (แทนที่ YOUR_LICENSE และ YOUR_KEY ด้วยค่าของคุณเอง)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// ตัวอย่างเงื่อนไขกลยุทธ์ (เส้นค่าเฉลี่ยเคลื่อนที่ 3/13 ตัดกัน)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// ใช้ alert.freq_all เพื่อให้แน่ใจว่าสามารถส่งสัญญาณหลายรายการในแท่งเทียนเดียวกัน
if longCondition
    alert(closesellMessage, alert.freq_all)  // ปิดสถานะขายก่อน
    alert(buyMessage,       alert.freq_all)  // จากนั้นเปิดสถานะซื้อ

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // ปิดสถานะซื้อก่อน
    alert(sellMessage,     alert.freq_all)   // จากนั้นเปิดสถานะขาย</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ สร้างการแจ้งเตือนใน TradingView</p>
  <p>URL Webhook:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>คลิกขวาบนแผนภูมิ → "<strong>เพิ่มการแจ้งเตือน...</strong>" หรือ <strong>Alt+A</strong></li>
    <li>เป็นเงื่อนไขการกระตุ้น ให้เลือก <strong>"เฉพาะการเรียกใช้ฟังก์ชัน alert()"</strong> (สำคัญ!)</li>
    <li>เลือกวันที่หมดอายุให้นานที่สุด หรือ "ไม่มีกำหนด"</li>
    <li>กล่องข้อความ <strong>ปล่อยเป็นค่าเริ่มต้น อย่ากรอกอะไร</strong> (เนื้อหาสัญญาณถูกกำหนดโดย alert() ในโค้ด)</li>
    <li>การตั้งค่าการแจ้งเตือน: ทำเครื่องหมาย <strong>Webhook URL</strong> และป้อนที่อยู่ด้านบน <strong>ยกเลิกการเลือก "ส่งข้อความธรรมดา"</strong></li>
    <li>คลิก "สร้าง" เพื่อบันทึกการแจ้งเตือน</li>
  </ol>
  <div class="doc-tip"><strong>เคล็ดลับ:</strong> ฟังก์ชัน Webhook ต้องมีการสมัครสมาชิก TradingView Pro หรือสูงกว่า</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ คำอธิบายรูปแบบ JSON สัญญาณ</p>
  <p><strong>ฟิลด์ที่จำเป็น:</strong><code>license</code> (ID การอนุญาต), <code>key</code> (คีย์), <code>cmd</code> (คำสั่ง), <code>symbol</code> (ชื่อสัญลักษณ์)</p>
  <p><strong>ฟิลด์ที่ไม่บังคับ:</strong><code>lots</code> (ขนาดล็อต), <code>price</code> (ราคาคำสั่งรอ), <code>sl_points / sl_price / sl_pct</code> (stop loss สามตัวเลือก), <code>tp_points / tp_price / tp_pct</code> (take profit สามตัวเลือก), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (ค่าเริ่มต้น 300 วินาที)</p>
  <p><strong>คำสั่งที่รองรับ:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>ลำดับความสำคัญของ stop loss/take profit:</strong><code>sl_price</code> (ราคาคงที่)&gt; <code>sl_points</code> (จุด)&gt; <code>sl_pct</code> (เปอร์เซ็นต์) หากทั้งสามเป็น 0 จะไม่ตั้ง stop loss เช่นเดียวกับ take profit</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ รายการตรวจสอบก่อนดำเนินการ</p>
  <ul class="doc-checklist">
    <li class="ok">✅ ปุ่มการเทรดอัตโนมัติของซอฟต์แวร์เทรดเป็นสี🟢 เขียว</li>
    <li class="ok">✅ EA ที่มุมขวาบนของแผนภูมิแสดง 😊 (เชื่อมต่อกับเซิร์ฟเวอร์)</li>
    <li class="ok">✅ License / SecretKey ตรงกับค่าใน JSON TradingView ทุกประการ</li>
    <li class="ok">✅ เงื่อนไขการกระตุ้นการแจ้งเตือนคือ "<strong>เฉพาะการเรียกใช้ฟังก์ชัน alert()</strong>"</li>
    <li class="ok">✅ แต่ละ <code>alert()</code> มี <code>alert.freq_all</code> เพิ่มแล้ว</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ กล่องข้อความปล่อยเป็นค่าเริ่มต้น ว่างเปล่า</li>
    <li class="no">❌ ยกเลิกการเลือก "ส่งข้อความธรรมดา" แล้ว</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ เคล็ดลับด้านความปลอดภัยและความเสี่ยง</p>
  <div class="doc-warn">
    <strong>ความปลอดภัยของบัญชี:</strong><br>
    · อย่าถ่ายภาพหน้าจอ License และ SecretKey หรือแชร์ให้ผู้อื่น<br>
    · หากคุณสงสัยว่าคีย์รั่วไหล ให้รีเซ็ต SecretKey ทันทีในคอนโซล<br>
    · ขอแนะนำให้เปลี่ยน SecretKey เป็นประจำ
  </div>
  <div class="doc-warn">
    <strong>การจัดการความเสี่ยงในการเทรด:</strong><br>
    · ตั้ง stop loss เสมอ อย่าเรียกใช้กลยุทธ์อัตโนมัติโดยไม่มีการป้องกัน<br>
    · ขอแนะนำให้ความเสี่ยงต่อการเทรดอยู่ในช่วง 1-2% ของยอดคงเหลือในบัญชี<br>
    · ก่อนข้อมูลเศรษฐกิจสำคัญ (NFP, CPI, FOMC) ขอแนะนำให้หยุดการเทรดอัตโนมัติชั่วคราว
  </div>
  <div class="doc-tip">
    <strong>แนวปฏิบัติที่ดีที่สุด:</strong><br>
    · ทดสอบในบัญชีเดโมก่อนอย่างน้อย 1-2 สัปดาห์เพื่อยืนยันว่าลิงก์ทำงานปกติก่อนเปลี่ยนไปใช้บัญชีจริง<br>
    · ในบัญชีจริง ให้เริ่มต้นด้วยขนาดล็อตขั้นต่ำ (0.01 ล็อต)<br>
    · ใช้ VPS (เช่น Tianyun Cloud VPS) เพื่อให้ซอฟต์แวร์เทรดและ EA ออนไลน์ตลอด 24 ชั่วโมง
  </div>
</div>`,
    docSections: [
      {
        title: '1. รูปแบบสัญญาณ Webhook',
        content: `ในกล่องข้อความของการแจ้งเตือน TradingView ให้ป้อน JSON ต่อไปนี้:
<pre>{
  "license": "{{LicenseIDของคุณ}}",
  "key": "{{SecretKeyของคุณ}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>คำสั่ง <strong>cmd</strong> ที่รองรับ: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. ที่อยู่ Webhook ของ TradingView',
        content: `<p>ในการตั้งค่าการแจ้งเตือน TradingView ให้ตั้งค่า URL Webhook ดังนี้:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>ในกล่องข้อความ ให้ป้อนรูปแบบ JSON สัญญาณด้านบนและแทนที่ license และ key ด้วยค่าของคุณเอง</p>`
      },
      {
        title: '3. ติดตั้ง WikiConnector EA',
        content: `<p>1. ดาวน์โหลด WikiConnector EA (ไฟล์ .ex5)</p>
<p>2. คัดลอก EA ไปยังไดเรกทอรี <code>MQL5/Experts</code> ของ MT5</p>
<p>3. เปิด EA ใน MT5 และป้อน <strong>License ID</strong> และ <strong>Secret Key</strong></p>
<p>4. อนุญาตให้ EA ทำการเชื่อมต่อ WebSocket (ในตัวเลือก MT5 → EA เปิดใช้งานสิทธิ์การเชื่อมต่อเครือข่าย)</p>`
      },
      {
        title: '4. ขีดจำกัดอัตรา',
        content: `<p>สูงสุด <strong>30 คำขอ / 60 วินาที</strong> ต่อใบอนุญาต การเกินขีดจำกัดจะส่งคืนข้อผิดพลาด 429</p>
<p>หากคุณต้องการความถี่ที่สูงขึ้น โปรดติดต่อฝ่ายบริการลูกค้าเพื่ออัปเกรดแผนของคุณ</p>`
      }
    ],

    faqTitle: 'คำถามที่พบบ่อย',
    faqs: [
      {
        q: 'จะทำอย่างไรถ้าคีย์ของฉันรั่วไหล?',
        a: 'คลิก "สร้างใหม่" ในคอนโซล คีย์เก่าจะไม่ถูกต้องทันทีและการเชื่อมต่อ EA ทั้งหมดจะถูกตัดการเชื่อมต่อ กำหนดค่า EA ใหม่ด้วยคีย์ใหม่'
      },
      {
        q: 'สัญญาณจะถูกส่งอีกครั้งหลังจาก EA เชื่อมต่อใหม่หรือไม่?',
        a: 'โดยค่าเริ่มต้นไม่ใช่ (เพื่อป้องกันการสูญเสีย) หากคุณต้องการส่งซ้ำ ให้เปิดใช้งาน "บัฟเฟอร์ออฟไลน์" ในคอนโซล เมื่อ EA เชื่อมต่อใหม่ มันจะรับสัญญาณที่สะสมในช่วงออฟไลน์'
      },
      {
        q: 'หนึ่งใบอนุญาตสามารถเชื่อมต่อบัญชี MT ได้กี่บัญชี?',
        a: 'แต่ละใบอนุญาตรองรับการเชื่อมต่อ WebSocket พร้อมกันสูงสุด 10 รายการ ดังนั้นเทอร์มินัล MT สูงสุด 10 เครื่องสามารถรับสัญญาณเดียวกันพร้อมกันได้'
      },
      {
        q: 'รองรับ MT4 หรือไม่?',
        a: 'เวอร์ชันปัจจุบันรองรับ MT5 เป็นหลัก เวอร์ชัน MT4 ของ EA กำลังพัฒนา โปรดรอติดตาม!'
      },
      {
        q: 'ความหน่วงของสัญญาณเท่าไหร่?',
        a: 'ความหน่วงเฉลี่ย <100 มิลลิวินาที ด้วย Tianyun Cloud VPS สามารถต่ำถึง 1 มิลลิวินาที'
      },
      {
        q: 'จะทดสอบว่า Webhook ทำงานถูกต้องหรือไม่?',
        a: 'ในรายการใบรับรอง ให้ตรวจสอบ "จำนวนการเชื่อมต่อปัจจุบัน" หากมากกว่า 0 แสดงว่า EA ออนไลน์ หลังจากส่งสัญญาณทดสอบ ให้ตรวจสอบ "บันทึกสัญญาณล่าสุด" เพื่อดูสถานะ "จัดส่งแล้ว"'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script และการส่งสัญญาณ',
        items: [
          {
            q: 'ฉันใช้สอง alert() เพื่อปิดและเปิด แต่ซอฟต์แวร์เทรดได้รับสัญญาณเดียวเท่านั้น',
            a: 'นี่คือข้อจำกัดเริ่มต้นของ Pine Script: ภายในแท่งเทียนเดียวกัน เฉพาะ alert() แรกเท่านั้นที่ถูกกระตุ้น วิธีแก้ไขคือ <strong>เพิ่มพารามิเตอร์ <code>alert.freq_all</code> ให้กับทุก alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'ฉันควรเลือกเงื่อนไขการกระตุ้นใดสำหรับการแจ้งเตือน?',
            a: 'เมื่อใช้ฟังก์ชัน <code>alert()</code> คุณต้องเลือก <strong>"เฉพาะการเรียกใช้ฟังก์ชัน alert()"</strong> หากคุณใช้วิธี <code>strategy.entry(..., alert_message=xxx)</code> ให้เลือก "Order fills only" ทั้งสองวิธีไม่สามารถผสมกันได้'
          },
          {
            q: 'ฉันควรใส่อะไรในกล่องข้อความ?',
            a: 'เมื่อใช้วิธี <code>alert()</code> <strong>ปล่อยกล่องข้อความเป็นค่าเริ่มต้น อย่ากรอกอะไร</strong> เนื้อหาสัญญาณถูกกำหนดโดยสตริงภายใน <code>alert(xxx)</code> ในโค้ด และ Webhook จะได้รับ JSON นั้น'
          }
        ]
      },
      {
        title: '🔌 การเชื่อมต่อและการรับสัญญาณ',
        items: [
          {
            q: 'ไอคอน EA แสดงใบหน้าสีแดงร้องไห้ 😞 ฉันควรทำอย่างไร?',
            a: 'ตรวจสอบว่าปุ่ม "การเทรดอัตโนมัติ" บนแถบเครื่องมือของซอฟต์แวร์เทรดเป็นสีเขียวหรือไม่ หากเป็นสีแดง ให้คลิกเพื่อเปลี่ยนเป็นสีเขียว EA จะกลับสู่สถานะปกติโดยอัตโนมัติ'
          },
          {
            q: 'ฉันส่งสัญญาณจาก TradingView แต่ซอฟต์แวร์เทรดไม่ตอบสนอง',
            a: 'ตรวจสอบตามลำดับนี้:<br>1. การเทรดอัตโนมัติของซอฟต์แวร์เทรดเป็นสีเขียวหรือไม่?<br>2. แผง EA แสดง "Connected" หรือไม่?<br>3. URL Webhook คือ <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code> หรือไม่?<br>4. เงื่อนไขการกระตุ้นการแจ้งเตือนคือ "เฉพาะการเรียกใช้ฟังก์ชัน alert()" หรือไม่?<br>5. แต่ละ alert() มี <code>alert.freq_all</code> เพิ่มหรือไม่?<br>6. license และ key ใน JSON ตรงกับการตั้งค่า EA ทุกประการหรือไม่?'
          }
        ]
      },
      {
        title: '💰 การดำเนินการเทรด',
        items: [
          {
            q: 'คำสั่งล้มเหลว สาเหตุคืออะไร?',
            a: 'สาเหตุทั่วไป: ยอดเงินไม่เพียงพอ / ชื่อสัญลักษณ์ไม่ตรงกัน (ต้องกำหนดค่า Symbol Mapping) / ขนาดล็อตเกิน / ค่า slippage มากเกินไป (เพิ่ม InpDeviation) / ตลาดปิด ตรวจสอบบันทึก "ผู้เชี่ยวชาญ" ที่ด้านล่างของซอฟต์แวร์เทรดสำหรับข้อมูลข้อผิดพลาดเฉพาะ'
          },
          {
            q: 'คำสั่งไม่มี stop loss หรือ take profit?',
            a: 'ตรวจสอบ: ① JSON สัญญาณมีฟิลด์เช่น <code>sl_points</code> / <code>tp_points</code> ฯลฯ หรือไม่?; ② พารามิเตอร์ stop loss/take profit เริ่มต้นของ EA เป็น 0 หรือไม่? หากไม่ได้ตั้งค่าทั้งสองอย่าง คำสั่งจะไม่มี stop loss หรือ take profit'
          },
          {
            q: 'ชื่อสัญลักษณ์ไม่ตรงกัน ฉันควรทำอย่างไร?',
            a: 'เปิดใช้งาน Symbol Mapping ในพารามิเตอร์ EA:<br>ตั้งค่า <code>InpEnableMap1 = true</code><br>ตั้งค่า <code>InpMapping1 = XAUUSD|GOLD</code> (ชื่อTradingView|ชื่อซอฟต์แวร์เทรด)'
          },
          {
            q: 'ฉันสามารถทดสอบในบัญชีเดโมก่อนได้หรือไม่?',
            a: '<strong>แนะนำอย่างยิ่ง!</strong> ในการใช้งานครั้งแรก คุณควรทดสอบในบัญชีเดโมอย่างน้อย 1-2 สัปดาห์เพื่อยืนยันว่าลิงก์ทำงานปกติและการดำเนินการคำสั่งถูกต้องก่อนเปลี่ยนไปใช้บัญชีจริง เริ่มต้นด้วยขนาดล็อตขั้นต่ำ 0.01'
          }
        ]
      }
    ]
  },

  // === tr Türkçe ===
  tr: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: "TradingView sinyallerini otomatik olarak MetaTrader'a bağlayın ve işlemleri gerçekleştirin",
    heroBtn: 'Ücretsiz başla',

    stat1Label: 'Ortalama gecikme',
    stat2Label: 'Hizmet kullanılabilirliği',
    stat3Label: '7/24 çalışma',
    stat4Label: 'Çoklu hesap dağıtımı',

    flowSub1: 'Strateji / Uyarı',
    flowSub2: 'Sinyal yönlendirme',
    flowSub3: 'Otomatik yürütme',

    featTitle: "Neden WikiConnector'ı seçmelisiniz",
    featSubtitle: 'Temel avantajlar',
    features: [
      {
        icon: '⚡',
        title: 'Milisaniyede yürütme',
        desc: 'Ortalama sinyal gecikmesi <100 ms, WikiFX VPS ile 1 ms kadar düşük.'
      },
      {
        icon: '🔗',
        title: 'Çoklu hesap dağıtımı',
        desc: 'Tek bir sertifika birden fazla MT terminalini bağlar ve aynı strateji sinyalini aynı anda dağıtır.'
      },
      {
        icon: '🔒',
        title: 'Güvenli şifreleme',
        desc: 'Her kullanıcı için bağımsız anahtar sistemi, uçtan uca şifrelenmiş veri iletimi.'
      },
      {
        icon: '📊',
        title: 'Gerçek zamanlı izleme',
        desc: 'Sinyal alma durumu, yürütme gecikmesi ve başarı oranı gerçek zamanlı olarak görülebilir.'
      },
      {
        icon: '<>',
        title: 'Kod üretici',
        desc: 'Görsel olarak JSON sinyalleri ve Pine Script kodu oluşturun, programlama gerektirmez.'
      },
      {
        icon: '🖥',
        title: 'VPS ile derin entegrasyon',
        desc: 'Tianyun Cloud VPS ile paylaşılan hesap sistemi, 7/24 düşük gecikmeli çalışma.'
      }
    ],

    stepsTitle: 'Otomatik işlemlere başlamak için dört adım',
    stepsSubtitle: 'Hızlı başlangıç',
    steps: [
      {
        title: 'Giriş yapın',
        desc: 'WikiFX hesabınızla giriş yapın, otomatik olarak özel anahtarınızı ve lisansınızı alın.'
      },
      {
        title: "Webhook'u yapılandırın",
        desc: "Webhook URL'sini TradingView Uyarı ayarlarına kopyalayın."
      },
      {
        title: "EA'yı kurun",
        desc: "WikiConnector EA'yı indirin ve License ID ile Secret Key'i girin."
      },
      {
        title: 'Otomatik işlemler',
        desc: 'Stratejiniz bir Uyarı tetiklediğinde, sinyal otomatik olarak yürütülmek üzere MT terminaline gönderilir.'
      }
    ],

    loginTip: 'Giriş yaptıktan sonra özel anahtarınızı ve sertifikanızı görebilirsiniz',
    loginBtn: 'Şimdi giriş yap',

    navConn: 'Bağlantı yönetimi',
    navLog: 'Sinyal günlüğü',
    navGen: 'Kod üretici',
    navParams: 'Hızlı parametre referansı',
    navDl: 'İndirmeler',
    navDoc: 'Kullanım kılavuzu',
    navFaq: 'Sık sorulan sorular',

    keyLabel: 'Secret Key',
    keyTip1: 'Kimseyle paylaşmayın',
    keyTip2: 'EA kimlik doğrulaması için kullanılır',
    keyTip3: 'Sıfırladıktan sonra eski anahtar hemen geçersiz olur',

    connSubtitle: "Aşağıda lisanslarınız ve bunlara karşılık gelen Webhook URL'leri bulunmaktadır",
    noLicense: 'Kullanılabilir lisans yok. Lütfen müşteri hizmetleriyle iletişime geçin',
    needHelp: 'Yardıma mı ihtiyacınız var?',
    viewDoc: 'Kullanım kılavuzunu görüntüleyin',

    allLicense: 'Tüm Lisanslar',
    allStatus: 'Tüm durumlar',
    refresh: 'Yenile',
    signalId: 'Sinyal ID',
    total: 'Toplam',
    records: 'kayıt',

    genIntro: 'TradingView Uyarılarında kullanılabilen JSON sinyalleri ve Pine Script kodunu otomatik olarak oluşturmak için aşağıdaki parametreleri doldurun.',
    genAuth: 'Kimlik doğrulama bilgileri',
    required: 'Zorunlu',
    optional: 'İsteğe bağlı',
    genLicPlaceholder: "License ID'nizi girin",
    genLicHint: 'Bağlantı yönetimi sayfasında görülebilir',
    genKeyPlaceholder: "Secret Key'inizi girin",
    genKeyHint: 'Bağlantı yönetimi sayfasında görülebilir',
    genTrade: 'İşlem emri',
    genCmd: 'Emir türü',
    genMarket: 'Piyasa emri',
    genPending: 'Bekleyen emir',
    genClose: 'Kapat',
    cmdBuy: 'Piyasadan al',
    cmdSell: 'Piyasadan sat',
    cmdBuyLimit: 'Limitli al',
    cmdSellLimit: 'Limitli sat',
    cmdBuyStop: 'Kırılma ile al',
    cmdSellStop: 'Kırılma ile sat',
    cmdCloseBuy: 'Uzun pozisyonları kapat',
    cmdCloseSell: 'Kısa pozisyonları kapat',
    cmdCloseAll: 'Bu sembolü kapat',
    cmdCloseAllOrders: 'Hepsini kapat',
    genSlTpHint: 'Üçten birini seçin · Öncelik: Fiyat > Puan > Yüzde',
    genTsHint: 'Sinyal gönderme zamanı',
    genTsBtn: 'Geçerli zaman',
    presetSimple: '📝 Basit alım',
    presetSltp: '🛡 Stop loss ve take profit ile',
    presetFull: '📋 Tam parametreler',
    presetClose: '❌ Kapatma sinyali',
    presetPending: '📌 Bekleyen emir',
    presetReverse: '🔄 Ters çevir (kapat + aç)',
    genAlertTab: '🔔 Uyarı ayarları açıklaması',
    toastIncomplete: 'Bilgiler eksik. Lütfen zorunlu alanları doldurun',
    toastRegen: "Yeni anahtar oluşturuldu. Hemen kopyalayın ve yapılandırılmış tüm EA'ları güncelleyin",
    toastKeyCopied: 'Anahtar kopyalandı',
    toastCopied: 'Kopyalandı',
    toastCodeCopied: 'Kod kopyalandı',
    copyTitle: 'Kopyala',
    genSymbol: 'İşlem sembolü',
    genPrice: 'Bekleyen emir fiyatı',
    genParams: 'İşlem parametreleri',
    genLots: 'Lot büyüklüğü',
    genLotsHint: 'EA varsayılanını kullanmak için boş bırakın',
    genMagic: 'Magic Number',
    genMagicHint: 'Farklı stratejilerin emirlerini ayırt etmek için kullanılır',
    genComment: 'Emir yorumu',
    genCommentHint: 'Örnek: Strategy A',
    genSL: 'Stop loss ayarı',
    genPoints: 'Puan',
    genPrice2: 'Sabit fiyat',
    genPct: 'Yüzde %',
    genTP: 'Take profit ayarı',
    genAdvanced: 'Gelişmiş parametreler',
    genSigIdHint: 'Otomatik oluşturma için boş bırakın, yinelenmeyi önlemek için kullanılır',
    genGenId: 'Otomatik oluştur',
    genBtn: 'Kodu oluştur',
    genFormat: 'Sinyal formatı',
    genGuideTitle: "TradingView'de nasıl kullanılır",
    genGuideSteps: [
      'TradingView grafiğinizde bir <strong>Uyarı (Alert)</strong> oluşturun',
      '<strong>Uyarı tetikleme koşulunda</strong> stratejinizi veya göstergenizi seçin',
      '<strong>Bildirimler (Notifications)</strong> bölümünü genişletin → <strong>Webhook URL</strong> işaretleyin',
      "Webhook URL'sini girin: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>",
      "Yukarıda oluşturulan JSON'u <strong>Mesaj (Message)</strong> kutusuna yapıştırın",
      'Uyarıyı kaydetmek için <strong>Oluştur (Create)</strong> düğmesine tıklayın'
    ],
    genGuideNote: '<strong>İpucu:</strong> Pine Script kullanıyorsanız, oluşturulan kodu betiğinize ekleyin ve <code>strategy.entry()</code> veya <code>strategy.close()</code> içinde <code>alert_message</code> parametresini kullanın.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Yetkilendirme) — Değiştirilmelidir',
        rows: [
          ['License', '—', "Yetkilendirme ID'si, sinyal JSON'undaki license alanıyla tam olarak eşleşmelidir", 'req'],
          ['SecretKey', '—', "Güvenlik anahtarı (wc_sk_ ile başlar), sinyal JSON'undaki key alanıyla tam olarak eşleşmelidir", 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Varsayılan işlem parametreleri)',
        rows: [
          ['InpLots', '0.1', "Varsayılan lot büyüklüğü, sinyal JSON'unda lots olmadığında kullanılır", ''],
          ['InpMagic', '888', 'Varsayılan Magic Number, farklı stratejilerin emirlerini ayırt etmek için', ''],
          ['InpComment', 'TV Signal', 'Varsayılan emir yorumu', ''],
          ['InpDeviation', '30', 'Maksimum kayma (puan), Forex için 10–30, Altın/Endeksler için 30–50 önerilir', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Öncelik: sl_price (sabit fiyat) > sl_points (puan) > sl_pct (yüzde). Üçü de 0 ise stop loss ayarlanmaz, take profit için de aynısı geçerlidir',
        rows: [
          ['InpSLPoints', '0', 'Varsayılan stop loss puanı (0 = devre dışı)', ''],
          ['InpSLPrice', '0', 'Varsayılan stop loss sabit fiyatı (0 = devre dışı, en yüksek öncelik)', ''],
          ['InpSLPct', '0', 'Varsayılan stop loss yüzdesi (0 = devre dışı)', ''],
          ['InpTPPoints', '0', 'Varsayılan take profit puanı (0 = devre dışı)', ''],
          ['InpTPPrice', '0', 'Varsayılan take profit sabit fiyatı (0 = devre dışı)', ''],
          ['InpTPPct', '0', 'Varsayılan take profit yüzdesi (0 = devre dışı)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Sembol adı eşleme)',
        note: 'Brokerler farklı sembol adları kullanabilir (örn: TradingView XAUUSD der, brokeriniz GOLD der). Eşleme otomatik dönüştürmeye izin verir',
        rows: [
          ['InpPrefix', '(boş)', 'Sembol adı öneki, broker sembolü m.EURUSD ise m. girin', ''],
          ['InpSuffix', '(boş)', 'Sembol adı soneki, broker sembolü EURUSD.pro ise .pro girin', ''],
          ['InpEnableMap1~5', 'false', 'İlgili eşleme kuralını etkinleştirmek için true olarak ayarlayın', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Eşleme kuralı, format: TradingViewAdı|MT5Adı, en fazla 5 kural destekler', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Yukarıdakiyle aynı', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Yukarıdakiyle aynı', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Yukarıdakiyle aynı', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Yukarıdakiyle aynı', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Zaman filtresi / Görüntüleme ve günlük)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Etkinleştirildiğinde, yalnızca StartTime~EndTime arasındaki sinyalleri işler', ''],
          ['InpStartTime', '00:00', 'İşlem için izin verilen başlangıç saati (MT5 sunucu saati, HH:SS formatı)', ''],
          ['InpEndTime', '23:59', 'İşlem için izin verilen bitiş saati', ''],
          ['InpShowPanel', 'true', 'Grafikte bağlantı durumu ve sinyal istatistikleri içeren bir bilgi paneli göster', ''],
          ['InpUpdateInterval', '1000', 'Panel güncelleme aralığı (ms), 1000~3000 önerilir', ''],
          ['InpLogLevel', '1', 'Günlük seviyesi: 0=kapalı 1=temel 2=ayrıntılı 3=hata ayıklama (sorun giderme için 2 veya 3 kullanın)', ''],
          ['InpLogToFile', 'true', 'Günlük dosyasını MQL5/Logs/ dizinine yaz', ''],
          ['InpLogToConsole', 'true', 'MT5\'in altındaki "Uzmanlar" sekmesinde çıktı', ''],
          ['InpMaxLogMB', '5', 'Maksimum günlük dosyası boyutu (MB), aşıldığında otomatik döndürme', '']
        ]
      }
    ],

    paramsEATitle: 'EA parametre açıklaması',
    paramsEADesc: "Aşağıdaki parametreler MT5'te EA açılırken yapılandırılabilir ve ayrıca sinyal JSON'undaki ilgili alanlar aracılığıyla geçersiz kılınabilir.",
    paramName: 'Parametre adı',
    paramDefault: 'Varsayılan değer',
    paramDesc: 'Açıklama',
    paramOverride: 'JSON geçersiz kılma alanı',
    eaParams: [
      ['DefaultLots', '0.1', 'Varsayılan lot büyüklüğü (JSON belirtmediğinde kullanılır)', 'lots'],
      ['DefaultMagic', '0', 'Varsayılan Magic Number', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Varsayılan emir yorumu', 'comment'],
      ['SlippagePoints', '3', 'Maksimum kayma (puan)', '—'],
      ['OfflineBuffer', 'false', 'Çevrimdışı arabelleği etkinleştir', '—'],
      ['ReconnectSeconds', '5', 'WebSocket yeniden bağlanma aralığı (saniye)', '—']
    ],
    cmdTableTitle: 'Emir türleri açıklaması',
    cmdCol: 'Emir (cmd)',
    typeCol: 'Tür',
    actionCol: 'Eylem',
    extraCol: 'Ek parametreler',
    cmdTable: [
      ['buy', 'Piyasa emri', 'Hemen satın al', 'lots, sl_*, tp_*'],
      ['sell', 'Piyasa emri', 'Hemen sat', 'lots, sl_*, tp_*'],
      ['buylimit', 'Bekleyen emir', 'Fiyata ulaşıldığında satın al', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Bekleyen emir', 'Fiyata ulaşıldığında sat', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Bekleyen emir', 'Kırılmada satın al', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Bekleyen emir', 'Kırılmada sat', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Kapat', 'Tüm uzun pozisyonları kapat', 'magic (isteğe bağlı)'],
      ['closesell', 'Kapat', 'Tüm kısa pozisyonları kapat', 'magic (isteğe bağlı)'],
      ['closeall', 'Kapat', 'Tüm açık pozisyonları kapat', '—'],
      ['closeallorders', 'Kapat', 'Tüm bekleyen emirleri sil', '—']
    ],
    jsonFieldTitle: 'JSON alan açıklaması',
    fieldCol: 'Alan adı',
    requiredCol: 'Zorunlu',
    descCol: 'Açıklama',
    jsonFields: [
      ['license', 'string', 'Zorunlu', 'License ID'],
      ['key', 'string', 'Zorunlu', 'Secret Key'],
      ['cmd', 'string', 'Zorunlu', 'İşlem emri, yukarıdaki tabloya bakın'],
      ['symbol', 'string', 'Zorunlu', 'İşlem sembolü, örn. EURUSD'],
      ['lots', 'number', 'İsteğe bağlı', 'Lot büyüklüğü, EA varsayılanını kullanmak için boş bırakın'],
      ['price', 'number', 'Bekleyen emir için zorunlu', 'Bekleyen emir fiyatı'],
      ['sl_points', 'number', 'İsteğe bağlı', 'Stop loss puanı'],
      ['sl_price', 'number', 'İsteğe bağlı', 'Stop loss sabit fiyatı'],
      ['sl_pct', 'number', 'İsteğe bağlı', 'Stop loss yüzdesi (0-100)'],
      ['tp_points', 'number', 'İsteğe bağlı', 'Take profit puanı'],
      ['tp_price', 'number', 'İsteğe bağlı', 'Take profit sabit fiyatı'],
      ['tp_pct', 'number', 'İsteğe bağlı', 'Take profit yüzdesi (0-100)'],
      ['magic', 'number', 'İsteğe bağlı', 'Magic Number'],
      ['comment', 'string', 'İsteğe bağlı', 'Emir yorumu'],
      ['signalid', 'string', 'İsteğe bağlı', "Benzersiz sinyal ID'si, yinelenmeyi önlemek için kullanılır"],
      ['expiryseconds', 'number', 'İsteğe bağlı', 'Sinyal geçerlilik süresi (saniye), varsayılan 60']
    ],

    dlMt5Desc: "EA'nın MT5 sürümü, tüm emirleri destekler, önerilir",
    dlMt5Btn: "MT5 EA'yı indir",
    dlMt4Desc: "EA'nın MT4 sürümü, geliştirme aşamasında, takipte kalın",
    dlMt4Dev: 'Geliştirme aşamasında',
    dlInstallDoc: `<h4>Kurulum talimatları</h4>
<ol>
<li><code>WikiConnector_MT5.ex5</code> dosyasını indirin</li>
<li>MT5'i açın, menü çubuğu → <strong>Dosya → Veri klasörünü aç</strong></li>
<li><code>.ex5</code> dosyasını <code>MQL5/Experts/</code> dizinine kopyalayın</li>
<li>MT5'te <strong>F5</strong> tuşuna basarak gezgini yenileyin, WikiConnector EA'yı bulun</li>
<li>EA'yı herhangi bir grafiğe sürükleyin, <strong>License ID</strong> ve <strong>Secret Key</strong> girin</li>
<li>EA seçeneklerinde <strong>WebRequest'e İzin Ver</strong> işaretleyin ve izin verilen URL listesine <code>api-gw.interface003.com</code> ekleyin</li>
</ol>`,

    disclaimerTitle: 'Risk bildirimi',
    disclaimerContent: `<p>WikiConnector EA'yı indirmeden ve kullanmadan önce aşağıdaki bildirimi dikkatlice okuyun:</p>
<p><strong>1. İşlem riski</strong><br/>Forex ve CFD işlemleri, sermayenin tamamen veya kısmen kaybedilmesine yol açabilecek önemli riskler içerir. WikiConnector yalnızca bir sinyal iletim aracıdır ve herhangi bir işlem sonucundan sorumlu değildir.</p>
<p><strong>2. Strateji riski</strong><br/>Otomatik işlem stratejilerinin geçmiş performansı gelecekteki sonuçları garanti etmez. Gerçek hesaplarda kullanmadan önce kapsamlı testler yapın.</p>
<p><strong>3. Teknik risk</strong><br/>Ağ gecikmesi, sunucu arızaları ve API sınırlamaları sinyal kaybına veya yürütme gecikmelerine neden olabilir. Bu aracı gecikmeye duyarlı yüksek frekanslı stratejiler için kullanmayın.</p>
<p><strong>4. Kullanıcı sorumluluğu</strong><br/>Kullanıcı, WikiConnector EA kullanımından kaynaklanan tüm işlem sonuçlarının tam sorumluluğunu üstlenir. WikiFX yatırım tavsiyesi sağlamaz ve işlem kar veya zararlarından sorumlu değildir.</p>`,
    disclaimerAgree: 'Yukarıdaki bildirimi okudum ve kabul ediyorum, işlem risklerini anlıyorum',
    disclaimerDownload: 'Kabul et ve indir',

    regenTitle: 'Anahtar sıfırlamayı onaylıyor musunuz?',
    regenSubtitle: 'Bu işlem geri alınamaz. Lütfen aşağıdaki etkileri anladığınızı onaylayın:',
    regenWarnings: ["Bu anahtarla yapılandırılmış tüm EA'lar <strong>hemen bağlantıyı kesecek</strong>", 'Eski anahtar <strong>kalıcı olarak geçersiz</strong> olacak ve kurtarılamayacak', "Tüm EA'larda Secret Key yapılandırmasını manuel olarak güncellemelisiniz", 'Sıfırlama sırasında <strong>sinyal kaybı</strong> riski vardır'],

    dashTitle: "WikiConnector'ım",
    myKey: "Secret Key'im",
    keyPrefix: 'Secret Key',
    copyBtn: 'Kopyala',
    regenBtn: 'Yeniden oluştur',
    regenConfirm: "Anahtarı yeniden oluşturduktan sonra, bağlı tüm EA'lar bağlantıyı kesecek ve yeniden yapılandırılması gerekecek. Devam edilsin mi?",
    regenConfirmBtn: 'Sıfırlamayı onayla',
    cancelBtn: 'İptal',
    copiedTip: 'Kopyalandı',

    licenseTitle: 'Sertifikalarım (License)',
    licenseId: 'Sertifika ID',
    maxConn: 'Maksimum bağlantı',
    activeConn: 'Mevcut bağlantı',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Sinyal istatistikleri',
    statTotal: 'Toplam sinyal',
    statDelivered: 'Teslim edildi',
    statFailed: 'Başarısız',
    statConnections: 'Mevcut bağlantılar',

    signalTitle: 'Son sinyal kayıtları',
    signalTime: 'Zaman',
    signalCmd: 'Emir',
    signalSymbol: 'Sembol',
    signalLots: 'Lot büyüklüğü',
    signalStatus: 'Durum',
    signalLicense: 'Sertifika',
    statusDelivered: 'Teslim edildi',
    statusPending: 'Bekliyor',
    statusFailed: 'Başarısız',
    statusExpired: 'Süresi doldu',
    noSignal: 'Henüz sinyal kaydı yok',
    loadMore: 'Daha fazla yükle',

    offlineBuffer: 'Çevrimdışı arabellek',
    offlineBufferDesc: 'Etkinleştirildiğinde, çevrimdışı dönemde biriken sinyaller EA yeniden bağlandığında teslim edilir (kayıpları önlemek için varsayılan olarak devre dışı)',

    docTitle: 'Kullanım kılavuzu',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 WikiConnector nasıl çalışır</p>
  <p>WikiConnector, <strong>WebSocket kalıcı bağlantısı</strong> aracılığıyla TradingView sinyallerini gerçek zamanlı olarak alır ve işlem yazılımında otomatik olarak işlemleri gerçekleştirir.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① EA'yı işlem yazılımına kurun</p>
  <ol class="doc-steps">
    <li><strong>Veri klasörünü açın</strong>: İşlem yazılımı menüsü → Dosya → Veri klasörünü aç</li>
    <li><strong>EA dosyasını kopyalayın</strong>: EA dosyasını <code>Experts/</code> dizinine kopyalayın</li>
    <li><strong>Gezgini yenileyin</strong>: Gezgini açın → "Uzman Danışmanlar"a sağ tıklayın → Yenileyin. Listede <strong>SignalReceiver</strong> görünmelidir</li>
    <li><strong>Otomatik işlemleri etkinleştirin</strong>: Üst araç çubuğundaki "Otomatik işlemler" düğmesi 🟢 yeşil olmalıdır</li>
    <li><strong>Grafiğe uygulayın</strong>: SignalReceiver'ı herhangi bir grafiğe sürükleyin. Ayarlar penceresi göründüğünde parametreleri yapılandırın</li>
  </ol>
  <div class="doc-tip"><strong>İpucu:</strong> Tüm sembollerin sinyallerini işlemek için EA'yı yalnızca bir grafiğe uygulamak yeterlidir. Her grafiğe ayrı ayrı uygulamaya gerek yoktur.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② EA parametrelerini yapılandırın</p>
  <p>İki tür parametre vardır: <strong>zorunlu</strong> (License / SecretKey) ve <strong>varsayılan parametreler</strong> (sinyal JSON'unda belirli bir alan olmadığında kullanılır; sinyaldeki değerler her zaman EA varsayılanlarına göre önceliklidir).</p>
  <div class="doc-warn"><strong>Güvenlik uyarısı:</strong> License ve SecretKey, hesabınızı koruyan tek engeldir. Sızdırılırsa, herkes işlem yazılımınıza işlem emirleri gönderebilir. Bunların ekran görüntüsünü almayın veya başkalarıyla paylaşmayın. Secret Key'in düzenli olarak değiştirilmesi önerilir.</div>
  <p>Kurulum tamamlandıktan sonra, grafiğin sağ üst köşesinde EA adı + <strong>😊</strong> görünecek ve sunucuya bağlı olduğunu gösterecektir. 😞 görünüyorsa, "Otomatik işlemler" düğmesinin yeşil olup olmadığını kontrol edin.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Sinyal için Pine Script kodu yazın</p>
  <p>WikiConnector, sinyalleri tetiklemek için <code>alert()</code> işlevini kullanır, <code>strategy.entry(alert_message=)</code> yöntemini değil. Bunlar farklı mekanizmalardır, karıştırmayın.</p>
  <div class="doc-danger"><strong>Önemli: alert.freq_all</strong> — Varsayılan olarak Pine Script'te aynı mum içinde yalnızca ilk <code>alert()</code> tetiklenir, sonrakiler sessizce atılır. Birden fazla ardışık sinyal göndermeniz gerekiyorsa (örneğin ters çevirmede: önce kısayı kapatın, sonra uzunu açın), her <code>alert()</code>'e <code>alert.freq_all</code> eklemelisiniz, aksi takdirde ikinci sinyal sunucuya asla ulaşmaz.</div>
<pre>//@version=6
strategy("WikiConnector Stratejisi", overlay=true)

// Sinyal mesajlarını tanımlayın (YOUR_LICENSE ve YOUR_KEY'i kendi değerlerinizle değiştirin)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Strateji koşulları örneği (3/13 hareketli ortalama kesişimi)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Aynı mum içinde birden fazla sinyalin gönderilmesini sağlamak için alert.freq_all kullanın
if longCondition
    alert(closesellMessage, alert.freq_all)  // Önce kısa pozisyonları kapat
    alert(buyMessage,       alert.freq_all)  // Sonra uzun pozisyon aç

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Önce uzun pozisyonları kapat
    alert(sellMessage,     alert.freq_all)   // Sonra kısa pozisyon aç</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ TradingView'de bir Uyarı oluşturun</p>
  <p>Webhook URL:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Grafiğe sağ tıklayın → "<strong>Uyarı Ekle...</strong>" veya <strong>Alt+A</strong></li>
    <li>Tetikleme koşulu olarak <strong>"Yalnızca alert() işlev çağrıları"</strong> seçin (önemli!)</li>
    <li>Mümkün olduğunca uzun bir son kullanma tarihi veya "Süresiz" seçin</li>
    <li>Mesaj kutusunu <strong>varsayılan olarak bırakın, hiçbir şey girmeyin</strong> (sinyal içeriği kod içindeki alert() tarafından belirlenir)</li>
    <li>Bildirim ayarları: <strong>Webhook URL</strong> işaretleyin ve yukarıdaki adresi girin; <strong>"Düz metin gönder" seçeneğinin işaretini kaldırın</strong></li>
    <li>Uyarıyı kaydetmek için "Oluştur" düğmesine tıklayın</li>
  </ol>
  <div class="doc-tip"><strong>İpucu:</strong> Webhook işlevi, TradingView Pro veya üzeri bir abonelik gerektirir.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Sinyal JSON formatı açıklaması</p>
  <p><strong>Zorunlu alanlar:</strong><code>license</code> (yetkilendirme ID'si), <code>key</code> (anahtar), <code>cmd</code> (emir), <code>symbol</code> (sembol adı)</p>
  <p><strong>İsteğe bağlı alanlar:</strong><code>lots</code> (lot büyüklüğü), <code>price</code> (bekleyen emir fiyatı), <code>sl_points / sl_price / sl_pct</code> (stop loss üç seçenek), <code>tp_points / tp_price / tp_pct</code> (take profit üç seçenek), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (varsayılan 300 saniye)</p>
  <p><strong>Desteklenen cmd:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Stop loss/take profit önceliği:</strong><code>sl_price</code> (sabit fiyat)&gt; <code>sl_points</code> (puan)&gt; <code>sl_pct</code> (yüzde). Üçü de 0 ise stop loss ayarlanmaz, take profit için de aynısı geçerlidir.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Çalıştırmadan önce kontrol listesi</p>
  <ul class="doc-checklist">
    <li class="ok">✅ İşlem yazılımının otomatik işlemler düğmesi 🟢 yeşil</li>
    <li class="ok">✅ Grafiğin sağ üst köşesindeki EA 😊 gösteriyor (sunucuya bağlı)</li>
    <li class="ok">✅ License / SecretKey, TradingView JSON'undaki değerlerle tam olarak eşleşiyor</li>
    <li class="ok">✅ Uyarı tetikleme koşulu "<strong>Yalnızca alert() işlev çağrıları</strong>"</li>
    <li class="ok">✅ Her <code>alert()</code>'e <code>alert.freq_all</code> eklendi</li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Mesaj kutusu varsayılan olarak bırakıldı, boş</li>
    <li class="no">❌ "Düz metin gönder" işareti kaldırıldı</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Güvenlik ve risk ipuçları</p>
  <div class="doc-warn">
    <strong>Hesap güvenliği:</strong><br>
    · License ve Secret Key'in ekran görüntüsünü almayın veya kimseyle paylaşmayın<br>
    · Anahtarın sızdığından şüpheleniyorsanız, konsolda Secret Key'i hemen sıfırlayın<br>
    · Secret Key'in düzenli olarak değiştirilmesi önerilir
  </div>
  <div class="doc-warn">
    <strong>İşlem risk yönetimi:</strong><br>
    · Her zaman stop loss belirleyin, korumasız otomatik stratejiler çalıştırmayın<br>
    · İşlem başına riskin hesap bakiyesinin %1-2'si arasında olması önerilir<br>
    · Önemli ekonomik verilerden (NFP, CPI, FOMC) önce otomatik işlemlerin duraklatılması önerilir
  </div>
  <div class="doc-tip">
    <strong>En iyi uygulamalar:</strong><br>
    · Gerçek hesaba geçmeden önce en az 1-2 hafta demo hesapta test ederek bağlantının normal çalıştığını doğrulayın<br>
    · Gerçek hesapta minimum lot (0,01 lot) ile başlayın<br>
    · İşlem yazılımını ve EA'yı 7/24 çevrimiçi tutmak için bir VPS (Tianyun Cloud VPS gibi) kullanın
  </div>
</div>`,
    docSections: [
      {
        title: '1. Webhook sinyal formatı',
        content: `TradingView Uyarısının Mesaj kutusuna aşağıdaki JSON'u girin:
<pre>{
  "license": "{{LicenseIDniz}}",
  "key": "{{SecretKeyiniz}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Desteklenen <strong>cmd</strong> emirleri: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. TradingView Webhook adresi',
        content: `<p>TradingView Uyarı ayarlarında Webhook URL'sini şu şekilde ayarlayın:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Mesaj kutusuna yukarıdaki sinyal JSON formatını girin ve license ile key'i kendi değerlerinizle değiştirin.</p>`
      },
      {
        title: "3. WikiConnector EA'yı kurun",
        content: `<p>1. WikiConnector EA'yı (.ex5 dosyası) indirin</p>
<p>2. EA'yı MT5'in <code>MQL5/Experts</code> dizinine kopyalayın</p>
<p>3. MT5'te EA'yı açın ve <strong>License ID</strong> ile <strong>Secret Key</strong> girin</p>
<p>4. EA'nın WebSocket bağlantıları yapmasına izin verin (MT5 Seçenekleri → EA'da, ağ bağlantısı iznini etkinleştirin)</p>`
      },
      {
        title: '4. Hız sınırları',
        content: `<p>Lisans başına maksimum <strong>30 istek / 60 saniye</strong>. Sınırın aşılması 429 hatası döndürür.</p>
<p>Daha yüksek frekansa ihtiyacınız varsa, planınızı yükseltmek için müşteri hizmetleriyle iletişime geçin.</p>`
      }
    ],

    faqTitle: 'Sık sorulan sorular',
    faqs: [
      {
        q: 'Anahtarım sızdırılırsa ne yapmalıyım?',
        a: 'Konsolda "Yeniden oluştur" düğmesine tıklayın. Eski anahtar hemen geçersiz olur ve tüm EA bağlantıları kesilir. EA\'yı yeni anahtarla yeniden yapılandırın.'
      },
      {
        q: 'EA yeniden bağlandıktan sonra sinyaller yeniden gönderilecek mi?',
        a: 'Varsayılan olarak hayır (kayıpları önlemek için). Yeniden göndermeye ihtiyacınız varsa, konsolda "Çevrimdışı arabellek" seçeneğini etkinleştirin. EA yeniden bağlandığında, çevrimdışı dönemde biriken sinyalleri alacaktır.'
      },
      {
        q: 'Bir lisans kaç MT hesabını bağlayabilir?',
        a: 'Her lisans, en fazla 10 eşzamanlı WebSocket bağlantısını destekler, böylece en fazla 10 MT terminali aynı anda aynı sinyali alabilir.'
      },
      {
        q: 'MT4 destekleniyor mu?',
        a: "Mevcut sürüm esas olarak MT5'i desteklemektedir. EA'nın MT4 sürümü geliştirme aşamasındadır. Takipte kalın!"
      },
      {
        q: 'Sinyal gecikmesi nedir?',
        a: "Ortalama gecikme <100 ms'dir. Tianyun Cloud VPS ile 1 ms kadar düşük olabilir."
      },
      {
        q: "Webhook'un doğru çalışıp çalışmadığını nasıl test edebilirim?",
        a: 'Sertifika listesinde "Mevcut bağlantı sayısını" kontrol edin. 0\'dan büyükse EA çevrimiçidir. Bir test sinyali gönderdikten sonra "Son sinyal kayıtları"nda "Teslim edildi" durumunu kontrol edin.'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script ve sinyal gönderme',
        items: [
          {
            q: 'Kapatmak ve açmak için iki alert() kullanıyorum ancak işlem yazılımı yalnızca bir sinyal alıyor.',
            a: "Bu, Pine Script'in varsayılan sınırlamasıdır: aynı mum içinde yalnızca ilk alert() tetiklenir. Çözüm, <strong>her alert()'e <code>alert.freq_all</code> parametresini eklemektir</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>"
          },
          {
            q: 'Uyarı için hangi tetikleme koşulunu seçmeliyim?',
            a: '<code>alert()</code> işlevini kullanırken <strong>"Yalnızca alert() işlev çağrıları"</strong> seçmelisiniz. <code>strategy.entry(..., alert_message=xxx)</code> yöntemini kullanıyorsanız, "Order fills only" seçeneğini seçin. İki yöntem karıştırılamaz.'
          },
          {
            q: 'Mesaj kutusuna ne koymalıyım?',
            a: "<code>alert()</code> yöntemini kullanırken <strong>Mesaj kutusunu varsayılan olarak bırakın, hiçbir şey girmeyin</strong>. Sinyal içeriği, kod içindeki <code>alert(xxx)</code> içindeki dize tarafından belirlenir ve Webhook bu JSON'u alacaktır."
          }
        ]
      },
      {
        title: '🔌 Bağlantı ve sinyal alma',
        items: [
          {
            q: 'EA simgesi kırmızı ağlayan bir yüz gösteriyor 😞. Ne yapmalıyım?',
            a: 'İşlem yazılımının araç çubuğundaki "Otomatik işlemler" düğmesinin yeşil olup olmadığını kontrol edin. Kırmızıysa, yeşil yapmak için tıklayın. EA otomatik olarak normal duruma dönecektir.'
          },
          {
            q: "TradingView'den sinyal gönderdim ancak işlem yazılımı yanıt vermedi.",
            a: 'Bu sırayla kontrol edin:<br>1. İşlem yazılımının otomatik işlemleri yeşil mi?<br>2. EA paneli "Connected" gösteriyor mu?<br>3. Webhook URL\'si <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code> mi?<br>4. Uyarı tetikleme koşulu "Yalnızca alert() işlev çağrıları" mı?<br>5. Her alert()\'e <code>alert.freq_all</code> eklendi mi?<br>6. JSON\'daki license ve key, EA ayarlarıyla tam olarak eşleşiyor mu?'
          }
        ]
      },
      {
        title: '💰 İşlem yürütme',
        items: [
          {
            q: 'Emir başarısız oldu. Nedeni nedir?',
            a: 'Yaygın nedenler: Yetersiz bakiye / Sembol adı eşleşmiyor (Symbol Mapping yapılandırması gerekli) / Lot boyutu aşıldı / Kayma çok büyük (InpDeviation\'ı artırın) / Piyasa kapalı. Spesifik hata bilgisi için işlem yazılımının altındaki "Uzmanlar" günlüğünü kontrol edin.'
          },
          {
            q: "Emrin stop loss veya take profit'i yok.",
            a: "Kontrol edin: ① Sinyal JSON'u <code>sl_points</code> / <code>tp_points</code> vb. alanlar içeriyor mu?; ② EA'nın varsayılan stop loss/take profit parametreleri 0 mı? Hiçbiri ayarlanmamışsa, emrin stop loss veya take profit'i olmayacaktır."
          },
          {
            q: 'Sembol adı eşleşmiyor. Ne yapmalıyım?',
            a: "EA parametrelerinde Symbol Mapping'i etkinleştirin:<br><code>InpEnableMap1 = true</code> ayarlayın<br><code>InpMapping1 = XAUUSD|GOLD</code> ayarlayın (TradingViewAdı|İşlemYazılımıAdı)"
          },
          {
            q: 'Önce demo hesapta test edebilir miyim?',
            a: '<strong>Şiddetle tavsiye edilir!</strong> İlk kullanımda, gerçek hesaba geçmeden önce bağlantının normal çalıştığını ve emir yürütmenin doğru olduğunu onaylamak için en az 1-2 hafta demo hesapta test etmelisiniz. Minimum lot olan 0,01 ile başlayın.'
          }
        ]
      }
    ]
  },

  // === vi Tiếng Việt ===
  vi: {
    nav: 'WikiConnector',

    heroTitle: 'TradingView → MT4/MT5',
    heroSubtitle: 'Kết nối tín hiệu TradingView tự động đến MetaTrader để thực hiện giao dịch',
    heroBtn: 'Bắt đầu miễn phí',

    stat1Label: 'Độ trễ trung bình',
    stat2Label: 'Khả dụng dịch vụ',
    stat3Label: 'Hoạt động 24/7',
    stat4Label: 'Phân phối đa tài khoản',

    flowSub1: 'Chiến lược / Cảnh báo',
    flowSub2: 'Định tuyến tín hiệu',
    flowSub3: 'Thực thi tự động',

    featTitle: 'Tại sao chọn WikiConnector',
    featSubtitle: 'Lợi thế chính',
    features: [
      {
        icon: '⚡',
        title: 'Thực thi trong mili giây',
        desc: 'Độ trễ tín hiệu trung bình <100ms, có thể thấp tới 1ms với WikiFX VPS.'
      },
      {
        icon: '🔗',
        title: 'Phân phối đa tài khoản',
        desc: 'Một chứng chỉ kết nối nhiều terminal MT và phân phối cùng một tín hiệu chiến lược đồng thời.'
      },
      {
        icon: '🔒',
        title: 'Mã hóa an toàn',
        desc: 'Hệ thống khóa độc lập cho mỗi người dùng, truyền dữ liệu được mã hóa toàn bộ.'
      },
      {
        icon: '📊',
        title: 'Giám sát thời gian thực',
        desc: 'Trạng thái nhận tín hiệu, độ trễ thực thi và tỷ lệ thành công có thể xem theo thời gian thực.'
      },
      {
        icon: '<>',
        title: 'Trình tạo mã',
        desc: 'Tạo trực quan tín hiệu JSON và mã Pine Script, không cần lập trình.'
      },
      {
        icon: '🖥',
        title: 'Tích hợp sâu với VPS',
        desc: 'Chia sẻ hệ thống tài khoản với Tianyun Cloud VPS, hoạt động 24/7 với độ trễ thấp.'
      }
    ],

    stepsTitle: 'Bốn bước để bắt đầu giao dịch tự động',
    stepsSubtitle: 'Bắt đầu nhanh',
    steps: [
      {
        title: 'Đăng nhập',
        desc: 'Đăng nhập bằng tài khoản WikiFX của bạn và tự động nhận khóa và giấy phép độc quyền.'
      },
      {
        title: 'Cấu hình Webhook',
        desc: 'Sao chép URL Webhook vào cài đặt Cảnh báo của TradingView.'
      },
      {
        title: 'Cài đặt EA',
        desc: 'Tải xuống WikiConnector EA và nhập License ID và Secret Key.'
      },
      {
        title: 'Giao dịch tự động',
        desc: 'Khi chiến lược của bạn kích hoạt Cảnh báo, tín hiệu sẽ tự động được gửi đến terminal MT để thực thi.'
      }
    ],

    loginTip: 'Sau khi đăng nhập, bạn có thể thấy khóa và chứng chỉ độc quyền của mình',
    loginBtn: 'Đăng nhập ngay',

    navConn: 'Quản lý kết nối',
    navLog: 'Nhật ký tín hiệu',
    navGen: 'Trình tạo mã',
    navParams: 'Tham khảo nhanh tham số',
    navDl: 'Tải xuống',
    navDoc: 'Hướng dẫn sử dụng',
    navFaq: 'Câu hỏi thường gặp',

    keyLabel: 'Secret Key',
    keyTip1: 'Không chia sẻ với bất kỳ ai',
    keyTip2: 'Được sử dụng để xác thực EA',
    keyTip3: 'Sau khi đặt lại, khóa cũ sẽ ngay lập tức không còn hiệu lực',

    connSubtitle: 'Dưới đây là các Giấy phép của bạn và URL Webhook tương ứng',
    noLicense: 'Không có Giấy phép nào khả dụng. Vui lòng liên hệ dịch vụ khách hàng',
    needHelp: 'Cần trợ giúp?',
    viewDoc: 'Xem hướng dẫn sử dụng',

    allLicense: 'Tất cả Giấy phép',
    allStatus: 'Tất cả trạng thái',
    refresh: 'Làm mới',
    signalId: 'ID tín hiệu',
    total: 'Tổng',
    records: 'bản ghi',

    genIntro: 'Điền các tham số sau để tự động tạo tín hiệu JSON và mã Pine Script có thể sử dụng trong Cảnh báo TradingView.',
    genAuth: 'Thông tin xác thực',
    required: 'Bắt buộc',
    optional: 'Tùy chọn',
    genLicPlaceholder: 'Nhập License ID của bạn',
    genLicHint: 'Có thể xem trên trang quản lý kết nối',
    genKeyPlaceholder: 'Nhập Secret Key của bạn',
    genKeyHint: 'Có thể xem trên trang quản lý kết nối',
    genTrade: 'Lệnh giao dịch',
    genCmd: 'Loại lệnh',
    genMarket: 'Lệnh thị trường',
    genPending: 'Lệnh chờ',
    genClose: 'Đóng',
    cmdBuy: 'Mua theo thị trường',
    cmdSell: 'Bán theo thị trường',
    cmdBuyLimit: 'Mua giới hạn',
    cmdSellLimit: 'Bán giới hạn',
    cmdBuyStop: 'Mua phá vỡ',
    cmdSellStop: 'Bán phá vỡ',
    cmdCloseBuy: 'Đóng vị thế mua',
    cmdCloseSell: 'Đóng vị thế bán',
    cmdCloseAll: 'Đóng biểu tượng này',
    cmdCloseAllOrders: 'Đóng tất cả',
    genSlTpHint: 'Chọn một trong ba · Ưu tiên: Giá > Điểm > Phần trăm',
    genTsHint: 'Thời gian gửi tín hiệu',
    genTsBtn: 'Thời gian hiện tại',
    presetSimple: '📝 Mua đơn giản',
    presetSltp: '🛡 Có stop loss và take profit',
    presetFull: '📋 Tham số đầy đủ',
    presetClose: '❌ Tín hiệu đóng',
    presetPending: '📌 Lệnh chờ',
    presetReverse: '🔄 Đảo ngược (đóng + mở)',
    genAlertTab: '🔔 Giải thích cài đặt Cảnh báo',
    toastIncomplete: 'Thông tin không đầy đủ. Vui lòng điền các trường bắt buộc',
    toastRegen: 'Khóa mới đã được tạo. Sao chép ngay và cập nhật tất cả EA đã cấu hình',
    toastKeyCopied: 'Đã sao chép khóa',
    toastCopied: 'Đã sao chép',
    toastCodeCopied: 'Đã sao chép mã',
    copyTitle: 'Sao chép',
    genSymbol: 'Biểu tượng giao dịch',
    genPrice: 'Giá lệnh chờ',
    genParams: 'Tham số giao dịch',
    genLots: 'Kích thước lot',
    genLotsHint: 'Để trống để sử dụng giá trị mặc định của EA',
    genMagic: 'Magic Number',
    genMagicHint: 'Được sử dụng để phân biệt lệnh của các chiến lược khác nhau',
    genComment: 'Nhận xét lệnh',
    genCommentHint: 'Ví dụ: Strategy A',
    genSL: 'Cài đặt stop loss',
    genPoints: 'Điểm',
    genPrice2: 'Giá cố định',
    genPct: 'Phần trăm %',
    genTP: 'Cài đặt take profit',
    genAdvanced: 'Tham số nâng cao',
    genSigIdHint: 'Để trống để tự động tạo, được sử dụng để chống trùng lặp',
    genGenId: 'Tự động tạo',
    genBtn: 'Tạo mã',
    genFormat: 'Định dạng tín hiệu',
    genGuideTitle: 'Cách sử dụng trong TradingView',
    genGuideSteps: [
      'Tạo một <strong>Cảnh báo (Alert)</strong> trên biểu đồ TradingView của bạn',
      'Trong <strong>Điều kiện kích hoạt Cảnh báo</strong>, chọn chiến lược hoặc chỉ báo của bạn',
      'Mở rộng <strong>Thông báo (Notifications)</strong> → đánh dấu <strong>Webhook URL</strong>',
      'Nhập URL Webhook: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code>',
      'Dán JSON đã tạo ở trên vào hộp <strong>Tin nhắn (Message)</strong>',
      'Nhấp <strong>Tạo (Create)</strong> để lưu Cảnh báo'
    ],
    genGuideNote: '<strong>Mẹo:</strong> Nếu bạn sử dụng Pine Script, hãy thêm mã đã tạo vào tập lệnh của bạn và sử dụng tham số <code>alert_message</code> trong <code>strategy.entry()</code> hoặc <code>strategy.close()</code>.',

    paramsGroups: [
      {
        title: '🔐 Authorization (Ủy quyền) — Phải thay đổi',
        rows: [
          ['License', '—', 'ID ủy quyền, phải khớp chính xác với trường license trong JSON tín hiệu', 'req'],
          ['SecretKey', '—', 'Khóa bảo mật (bắt đầu bằng wc_sk_), phải khớp chính xác với trường key trong JSON tín hiệu', 'req']
        ]
      },
      {
        title: '💰 Default Trading Parameters (Tham số giao dịch mặc định)',
        rows: [
          ['InpLots', '0.1', 'Kích thước lot mặc định, được sử dụng khi JSON tín hiệu không có lots', ''],
          ['InpMagic', '888', 'Magic Number mặc định, để phân biệt lệnh của các chiến lược khác nhau', ''],
          ['InpComment', 'TV Signal', 'Nhận xét lệnh mặc định', ''],
          ['InpDeviation', '30', 'Độ trượt tối đa (điểm), cho Forex 10–30, cho Vàng/Chỉ số 30–50 được khuyến nghị', '']
        ]
      },
      {
        title: '🛡️ Stop Loss / Take Profit',
        note: 'Ưu tiên: sl_price (giá cố định) > sl_points (điểm) > sl_pct (phần trăm). Nếu cả ba đều là 0, không có stop loss nào được đặt, tương tự cho take profit',
        rows: [
          ['InpSLPoints', '0', 'Điểm stop loss mặc định (0 = tắt)', ''],
          ['InpSLPrice', '0', 'Giá cố định stop loss mặc định (0 = tắt, ưu tiên cao nhất)', ''],
          ['InpSLPct', '0', 'Phần trăm stop loss mặc định (0 = tắt)', ''],
          ['InpTPPoints', '0', 'Điểm take profit mặc định (0 = tắt)', ''],
          ['InpTPPrice', '0', 'Giá cố định take profit mặc định (0 = tắt)', ''],
          ['InpTPPct', '0', 'Phần trăm take profit mặc định (0 = tắt)', '']
        ]
      },
      {
        title: '🔄 Symbol Mapping (Ánh xạ tên biểu tượng)',
        note: 'Các nhà môi giới có thể sử dụng tên biểu tượng khác nhau (ví dụ: TradingView gọi XAUUSD, nhà môi giới của bạn gọi GOLD). Ánh xạ cho phép chuyển đổi tự động',
        rows: [
          ['InpPrefix', '(trống)', 'Tiền tố tên biểu tượng, nếu biểu tượng của nhà môi giới là m.EURUSD, nhập m.', ''],
          ['InpSuffix', '(trống)', 'Hậu tố tên biểu tượng, nếu biểu tượng của nhà môi giới là EURUSD.pro, nhập .pro', ''],
          ['InpEnableMap1~5', 'false', 'Đặt thành true để kích hoạt quy tắc ánh xạ tương ứng', ''],
          ['InpMapping1', 'XAUUSD|GOLD', 'Quy tắc ánh xạ, định dạng: TênTradingView|TênMT5, hỗ trợ tối đa 5 quy tắc', ''],
          ['InpMapping2', 'EURUSD|EUR', 'Giống như trên', ''],
          ['InpMapping3', 'GBPUSD|GBP', 'Giống như trên', ''],
          ['InpMapping4', 'BTCUSD|BTC', 'Giống như trên', ''],
          ['InpMapping5', 'USOUSD|WTI', 'Giống như trên', '']
        ]
      },
      {
        title: '⏰ Time Filter / Display & Log (Bộ lọc thời gian / Hiển thị & Nhật ký)',
        rows: [
          ['InpUseTimeFilter', 'false', 'Khi được kích hoạt, chỉ xử lý tín hiệu giữa StartTime~EndTime', ''],
          ['InpStartTime', '00:00', 'Thời gian bắt đầu được phép giao dịch (thời gian máy chủ MT5, định dạng HH:MM)', ''],
          ['InpEndTime', '23:59', 'Thời gian kết thúc được phép giao dịch', ''],
          ['InpShowPanel', 'true', 'Hiển thị bảng thông tin về trạng thái kết nối và thống kê tín hiệu trên biểu đồ', ''],
          ['InpUpdateInterval', '1000', 'Khoảng thời gian cập nhật bảng (ms), khuyến nghị 1000~3000', ''],
          ['InpLogLevel', '1', 'Cấp độ nhật ký: 0=tắt 1=cơ bản 2=chi tiết 3=gỡ lỗi (sử dụng 2 hoặc 3 để khắc phục sự cố)', ''],
          ['InpLogToFile', 'true', 'Ghi tệp nhật ký vào MQL5/Logs/', ''],
          ['InpLogToConsole', 'true', 'Đầu ra trong tab "Chuyên gia" ở cuối MT5', ''],
          ['InpMaxLogMB', '5', 'Kích thước tệp nhật ký tối đa (MB), tự động xoay khi vượt quá', '']
        ]
      }
    ],

    paramsEATitle: 'Giải thích tham số EA',
    paramsEADesc: 'Các tham số sau có thể được cấu hình khi mở EA trong MT5 và cũng có thể được ghi đè thông qua các trường tương ứng trong JSON tín hiệu.',
    paramName: 'Tên tham số',
    paramDefault: 'Giá trị mặc định',
    paramDesc: 'Mô tả',
    paramOverride: 'Trường ghi đè JSON',
    eaParams: [
      ['DefaultLots', '0.1', 'Kích thước lot mặc định (được sử dụng khi JSON không chỉ định)', 'lots'],
      ['DefaultMagic', '0', 'Magic Number mặc định', 'magic'],
      ['DefaultComment', 'WikiConnector', 'Nhận xét lệnh mặc định', 'comment'],
      ['SlippagePoints', '3', 'Độ trượt tối đa (điểm)', '—'],
      ['OfflineBuffer', 'false', 'Kích hoạt bộ đệm ngoại tuyến', '—'],
      ['ReconnectSeconds', '5', 'Khoảng thời gian kết nối lại WebSocket (giây)', '—']
    ],
    cmdTableTitle: 'Giải thích loại lệnh',
    cmdCol: 'Lệnh (cmd)',
    typeCol: 'Loại',
    actionCol: 'Hành động',
    extraCol: 'Tham số bổ sung',
    cmdTable: [
      ['buy', 'Lệnh thị trường', 'Mua ngay lập tức', 'lots, sl_*, tp_*'],
      ['sell', 'Lệnh thị trường', 'Bán ngay lập tức', 'lots, sl_*, tp_*'],
      ['buylimit', 'Lệnh chờ', 'Mua khi đạt giá', 'price, lots, sl_*, tp_*'],
      ['selllimit', 'Lệnh chờ', 'Bán khi đạt giá', 'price, lots, sl_*, tp_*'],
      ['buystop', 'Lệnh chờ', 'Mua khi phá vỡ', 'price, lots, sl_*, tp_*'],
      ['sellstop', 'Lệnh chờ', 'Bán khi phá vỡ', 'price, lots, sl_*, tp_*'],
      ['closebuy', 'Đóng', 'Đóng tất cả vị thế mua', 'magic (tùy chọn)'],
      ['closesell', 'Đóng', 'Đóng tất cả vị thế bán', 'magic (tùy chọn)'],
      ['closeall', 'Đóng', 'Đóng tất cả vị thế đang mở', '—'],
      ['closeallorders', 'Đóng', 'Xóa tất cả lệnh chờ', '—']
    ],
    jsonFieldTitle: 'Giải thích trường JSON',
    fieldCol: 'Tên trường',
    requiredCol: 'Bắt buộc',
    descCol: 'Mô tả',
    jsonFields: [
      ['license', 'string', 'Bắt buộc', 'License ID'],
      ['key', 'string', 'Bắt buộc', 'Secret Key'],
      ['cmd', 'string', 'Bắt buộc', 'Lệnh giao dịch, xem bảng trên'],
      ['symbol', 'string', 'Bắt buộc', 'Biểu tượng giao dịch, ví dụ EURUSD'],
      ['lots', 'number', 'Tùy chọn', 'Kích thước lot, để trống để sử dụng giá trị mặc định của EA'],
      ['price', 'number', 'Bắt buộc cho lệnh chờ', 'Giá lệnh chờ'],
      ['sl_points', 'number', 'Tùy chọn', 'Điểm stop loss'],
      ['sl_price', 'number', 'Tùy chọn', 'Giá cố định stop loss'],
      ['sl_pct', 'number', 'Tùy chọn', 'Phần trăm stop loss (0-100)'],
      ['tp_points', 'number', 'Tùy chọn', 'Điểm take profit'],
      ['tp_price', 'number', 'Tùy chọn', 'Giá cố định take profit'],
      ['tp_pct', 'number', 'Tùy chọn', 'Phần trăm take profit (0-100)'],
      ['magic', 'number', 'Tùy chọn', 'Magic Number'],
      ['comment', 'string', 'Tùy chọn', 'Nhận xét lệnh'],
      ['signalid', 'string', 'Tùy chọn', 'ID duy nhất của tín hiệu, được sử dụng để chống trùng lặp'],
      ['expiryseconds', 'number', 'Tùy chọn', 'Thời hạn hiệu lực của tín hiệu (giây), mặc định 60']
    ],

    dlMt5Desc: 'Phiên bản MT5 của EA, hỗ trợ tất cả lệnh, được khuyến nghị',
    dlMt5Btn: 'Tải xuống EA MT5',
    dlMt4Desc: 'Phiên bản MT4 của EA, đang phát triển, hãy chờ đón',
    dlMt4Dev: 'Đang phát triển',
    dlInstallDoc: `<h4>Hướng dẫn cài đặt</h4>
<ol>
<li>Tải xuống tệp <code>WikiConnector_MT5.ex5</code></li>
<li>Mở MT5, thanh menu → <strong>Tệp → Mở thư mục dữ liệu</strong></li>
<li>Sao chép tệp <code>.ex5</code> vào thư mục <code>MQL5/Experts/</code></li>
<li>Nhấn <strong>F5</strong> trong MT5 để làm mới trình duyệt, tìm WikiConnector EA</li>
<li>Kéo EA vào bất kỳ biểu đồ nào, nhập <strong>License ID</strong> và <strong>Secret Key</strong></li>
<li>Trong tùy chọn EA, đánh dấu <strong>Cho phép WebRequest</strong> và thêm <code>api-gw.interface003.com</code> vào danh sách URL được phép</li>
</ol>`,

    disclaimerTitle: 'Tuyên bố từ chối trách nhiệm về rủi ro',
    disclaimerContent: `<p>Trước khi tải xuống và sử dụng WikiConnector EA, vui lòng đọc kỹ tuyên bố từ chối trách nhiệm sau:</p>
<p><strong>1. Rủi ro giao dịch</strong><br/>Giao dịch Forex và CFD có rủi ro đáng kể có thể dẫn đến mất toàn bộ hoặc một phần vốn. WikiConnector chỉ là công cụ truyền tín hiệu và không chịu trách nhiệm về bất kỳ kết quả giao dịch nào.</p>
<p><strong>2. Rủi ro chiến lược</strong><br/>Hiệu suất trong quá khứ của các chiến lược giao dịch tự động không đảm bảo kết quả trong tương lai. Hãy kiểm tra kỹ lưỡng trước khi sử dụng trên tài khoản thực.</p>
<p><strong>3. Rủi ro kỹ thuật</strong><br/>Độ trễ mạng, lỗi máy chủ và giới hạn API có thể gây mất tín hiệu hoặc chậm trễ thực thi. Không sử dụng công cụ này cho các chiến lược tần suất cao nhạy cảm với độ trễ.</p>
<p><strong>4. Trách nhiệm của người dùng</strong><br/>Người dùng chịu hoàn toàn trách nhiệm về mọi kết quả giao dịch phát sinh từ việc sử dụng WikiConnector EA. WikiFX không cung cấp lời khuyên đầu tư và không chịu trách nhiệm về lợi nhuận hoặc thua lỗ giao dịch.</p>`,
    disclaimerAgree: 'Tôi đã đọc và chấp nhận tuyên bố từ chối trách nhiệm trên và hiểu rõ rủi ro giao dịch',
    disclaimerDownload: 'Chấp nhận và tải xuống',

    regenTitle: 'Xác nhận đặt lại khóa?',
    regenSubtitle: 'Hành động này không thể hoàn tác. Vui lòng xác nhận rằng bạn hiểu các tác động sau:',
    regenWarnings: ['Tất cả EA được cấu hình với khóa này sẽ <strong>bị ngắt kết nối ngay lập tức</strong>', 'Khóa cũ sẽ <strong>bị vô hiệu vĩnh viễn</strong> và không thể khôi phục', 'Bạn phải cập nhật thủ công cấu hình Secret Key trong tất cả EA', 'Có nguy cơ <strong>mất tín hiệu</strong> trong quá trình đặt lại'],

    dashTitle: 'WikiConnector của tôi',
    myKey: 'Secret Key của tôi',
    keyPrefix: 'Secret Key',
    copyBtn: 'Sao chép',
    regenBtn: 'Tạo lại',
    regenConfirm: 'Sau khi tạo lại khóa, tất cả EA đã kết nối sẽ bị ngắt kết nối và cần được cấu hình lại. Tiếp tục?',
    regenConfirmBtn: 'Xác nhận đặt lại',
    cancelBtn: 'Hủy',
    copiedTip: 'Đã sao chép',

    licenseTitle: 'Chứng chỉ của tôi (License)',
    licenseId: 'ID Chứng chỉ',
    maxConn: 'Kết nối tối đa',
    activeConn: 'Kết nối hiện tại',
    webhookUrl: 'Webhook URL',

    statsTitle: 'Thống kê tín hiệu',
    statTotal: 'Tổng tín hiệu',
    statDelivered: 'Đã gửi',
    statFailed: 'Thất bại',
    statConnections: 'Kết nối hiện tại',

    signalTitle: 'Bản ghi tín hiệu gần đây',
    signalTime: 'Thời gian',
    signalCmd: 'Lệnh',
    signalSymbol: 'Biểu tượng',
    signalLots: 'Kích thước lot',
    signalStatus: 'Trạng thái',
    signalLicense: 'Chứng chỉ',
    statusDelivered: 'Đã gửi',
    statusPending: 'Đang chờ',
    statusFailed: 'Thất bại',
    statusExpired: 'Hết hạn',
    noSignal: 'Chưa có bản ghi tín hiệu nào',
    loadMore: 'Tải thêm',

    offlineBuffer: 'Bộ đệm ngoại tuyến',
    offlineBufferDesc: 'Khi được kích hoạt, các tín hiệu tích lũy trong thời gian ngoại tuyến sẽ được gửi khi EA kết nối lại (tắt theo mặc định để ngăn ngừa thua lỗ)',

    docTitle: 'Hướng dẫn sử dụng',
    docContent: `
<div class="doc-section">
  <p class="doc-section-title">📡 Cách thức hoạt động của WikiConnector</p>
  <p>WikiConnector nhận tín hiệu TradingView theo thời gian thực thông qua <strong>kết nối WebSocket liên tục</strong> và tự động thực hiện giao dịch trong phần mềm giao dịch.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">① Cài đặt EA trong phần mềm giao dịch</p>
  <ol class="doc-steps">
    <li><strong>Mở thư mục dữ liệu</strong>: Menu phần mềm giao dịch → Tệp → Mở thư mục dữ liệu</li>
    <li><strong>Sao chép tệp EA</strong>: Sao chép tệp EA vào thư mục <code>Experts/</code></li>
    <li><strong>Làm mới trình duyệt</strong>: Mở trình duyệt → nhấp chuột phải vào "Chuyên gia" → Làm mới. <strong>SignalReceiver</strong> sẽ xuất hiện trong danh sách</li>
    <li><strong>Kích hoạt giao dịch tự động</strong>: Nút "Giao dịch tự động" trên thanh công cụ phía trên phải có màu 🟢 xanh lá</li>
    <li><strong>Áp dụng vào biểu đồ</strong>: Kéo SignalReceiver vào bất kỳ biểu đồ nào. Khi cửa sổ cài đặt xuất hiện, hãy cấu hình các tham số</li>
  </ol>
  <div class="doc-tip"><strong>Mẹo:</strong> Chỉ cần áp dụng EA trên một biểu đồ là đủ để xử lý tín hiệu của tất cả các biểu tượng. Không cần áp dụng riêng lẻ trên từng biểu đồ.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">② Cấu hình tham số EA</p>
  <p>Có hai loại tham số: <strong>bắt buộc</strong> (License / SecretKey) và <strong>tham số mặc định</strong> (được sử dụng khi JSON tín hiệu không chứa trường cụ thể; giá trị trong tín hiệu luôn được ưu tiên hơn giá trị mặc định của EA).</p>
  <div class="doc-warn"><strong>Cảnh báo bảo mật:</strong> License và SecretKey là rào cản duy nhất bảo vệ tài khoản của bạn. Nếu bị rò rỉ, bất kỳ ai cũng có thể gửi lệnh giao dịch đến phần mềm giao dịch của bạn. Đừng chụp ảnh màn hình hoặc chia sẻ chúng với người khác. Khuyến nghị thay đổi SecretKey thường xuyên.</div>
  <p>Sau khi hoàn tất thiết lập, tên EA + <strong>😊</strong> sẽ xuất hiện ở góc trên bên phải của biểu đồ, cho biết đã kết nối với máy chủ. Nếu hiển thị 😞, hãy kiểm tra xem nút "Giao dịch tự động" có màu xanh lá không.</p>
</div>

<div class="doc-section">
  <p class="doc-section-title">③ Viết mã Pine Script cho tín hiệu</p>
  <p>WikiConnector sử dụng hàm <code>alert()</code> để kích hoạt tín hiệu, không phải phương thức <code>strategy.entry(alert_message=)</code>. Đây là hai cơ chế khác nhau, đừng trộn lẫn chúng.</p>
  <div class="doc-danger"><strong>Quan trọng: alert.freq_all</strong> — Theo mặc định, trong Pine Script, chỉ <code>alert()</code> đầu tiên trong cùng một nến được kích hoạt, các lệnh tiếp theo bị loại bỏ một cách âm thầm. Nếu bạn cần gửi nhiều tín hiệu liên tiếp (ví dụ: trong đảo ngược: đóng vị thế bán trước rồi mở vị thế mua), bạn phải thêm <code>alert.freq_all</code> vào mỗi <code>alert()</code>, nếu không tín hiệu thứ hai sẽ không bao giờ đến được máy chủ.</div>
<pre>//@version=6
strategy("Chiến lược WikiConnector", overlay=true)

// Xác định thông báo tín hiệu (thay YOUR_LICENSE và YOUR_KEY bằng giá trị của bạn)
buyMessage       = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"buy","symbol":"'  + syminfo.ticker + '","lots":0.1}'
sellMessage      = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"sell","symbol":"' + syminfo.ticker + '","lots":0.1}'
closebuyMessage  = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closebuy","symbol":"'  + syminfo.ticker + '"}'
closesellMessage = '{"license":"YOUR_LICENSE","key":"YOUR_KEY","cmd":"closesell","symbol":"' + syminfo.ticker + '"}'

// Ví dụ về điều kiện chiến lược (đường trung bình động 3/13 cắt nhau)
longCondition  = ta.crossover(ta.sma(close, 3),  ta.sma(close, 13))
shortCondition = ta.crossunder(ta.sma(close, 3), ta.sma(close, 13))

// Sử dụng alert.freq_all để đảm bảo gửi nhiều tín hiệu trong cùng một nến
if longCondition
    alert(closesellMessage, alert.freq_all)  // Đóng vị thế bán trước
    alert(buyMessage,       alert.freq_all)  // Sau đó mở vị thế mua

if shortCondition
    alert(closebuyMessage, alert.freq_all)   // Đóng vị thế mua trước
    alert(sellMessage,     alert.freq_all)   // Sau đó mở vị thế bán</pre>
</div>

<div class="doc-section">
  <p class="doc-section-title">④ Tạo Cảnh báo trong TradingView</p>
  <p>URL Webhook:</p>
  <div class="doc-url-box">https://api-gw.interface003.com/api/mtbridge/webhook/</div>
  <ol class="doc-steps">
    <li>Nhấp chuột phải vào biểu đồ → "<strong>Thêm Cảnh báo...</strong>" hoặc <strong>Alt+A</strong></li>
    <li>Làm điều kiện kích hoạt, chọn <strong>"Chỉ các lệnh gọi hàm alert()"</strong> (quan trọng!)</li>
    <li>Chọn ngày hết hạn càng dài càng tốt, hoặc "Không có thời hạn"</li>
    <li>Hộp Tin nhắn <strong>để mặc định, không nhập gì cả</strong> (nội dung tín hiệu được xác định bởi alert() trong mã)</li>
    <li>Cài đặt thông báo: đánh dấu <strong>Webhook URL</strong> và nhập địa chỉ trên; <strong>bỏ chọn "Gửi văn bản thuần túy"</strong></li>
    <li>Nhấp "Tạo" để lưu Cảnh báo</li>
  </ol>
  <div class="doc-tip"><strong>Mẹo:</strong> Chức năng Webhook yêu cầu đăng ký TradingView Pro trở lên.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑤ Giải thích định dạng JSON tín hiệu</p>
  <p><strong>Trường bắt buộc:</strong><code>license</code> (ID ủy quyền), <code>key</code> (khóa), <code>cmd</code> (lệnh), <code>symbol</code> (tên biểu tượng)</p>
  <p><strong>Trường tùy chọn:</strong><code>lots</code> (kích thước lot), <code>price</code> (giá lệnh chờ), <code>sl_points / sl_price / sl_pct</code> (stop loss ba tùy chọn), <code>tp_points / tp_price / tp_pct</code> (take profit ba tùy chọn), <code>magic</code>, <code>comment</code>, <code>signal_id</code>, <code>expiry_seconds</code> (mặc định 300 giây)</p>
  <p><strong>Các lệnh được hỗ trợ:</strong><code>buy</code> · <code>sell</code> · <code>buylimit</code> · <code>selllimit</code> · <code>buystop</code> · <code>sellstop</code> · <code>closebuy</code> · <code>closesell</code> · <code>closeall</code> · <code>closeallorders</code></p>
  <div class="doc-tip"><strong>Ưu tiên stop loss/take profit:</strong><code>sl_price</code> (giá cố định)&gt; <code>sl_points</code> (điểm)&gt; <code>sl_pct</code> (phần trăm). Nếu cả ba đều là 0, không có stop loss nào được đặt, tương tự cho take profit.</div>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑥ Danh sách kiểm tra trước khi vận hành</p>
  <ul class="doc-checklist">
    <li class="ok">✅ Nút giao dịch tự động của phần mềm giao dịch 🟢 xanh lá</li>
    <li class="ok">✅ EA ở góc trên bên phải biểu đồ hiển thị 😊 (đã kết nối với máy chủ)</li>
    <li class="ok">✅ License / SecretKey khớp chính xác với các giá trị trong JSON TradingView</li>
    <li class="ok">✅ Điều kiện kích hoạt Cảnh báo "<strong>Chỉ các lệnh gọi hàm alert()</strong>"</li>
    <li class="ok">✅ Mỗi <code>alert()</code> đã được thêm <code>alert.freq_all</code></li>
    <li class="ok">✅ Webhook URL: <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code></li>
    <li class="ok">✅ Hộp Tin nhắn để mặc định, trống</li>
    <li class="no">❌ Đã bỏ chọn "Gửi văn bản thuần túy"</li>
  </ul>
</div>

<div class="doc-section">
  <p class="doc-section-title">⑦ Mẹo bảo mật và rủi ro</p>
  <div class="doc-warn">
    <strong>Bảo mật tài khoản:</strong><br>
    · Đừng chụp ảnh màn hình License và SecretKey hoặc chia sẻ chúng với bất kỳ ai<br>
    · Nếu bạn nghi ngờ khóa bị rò rỉ, hãy đặt lại SecretKey ngay lập tức trong bảng điều khiển<br>
    · Khuyến nghị thay đổi SecretKey thường xuyên
  </div>
  <div class="doc-warn">
    <strong>Quản lý rủi ro giao dịch:</strong><br>
    · Luôn đặt stop loss, không chạy chiến lược tự động mà không có bảo vệ<br>
    · Khuyến nghị rủi ro mỗi giao dịch nằm trong khoảng 1-2% số dư tài khoản<br>
    · Trước các dữ liệu kinh tế quan trọng (NFP, CPI, FOMC), khuyến nghị tạm dừng giao dịch tự động
  </div>
  <div class="doc-tip">
    <strong>Thực hành tốt nhất:</strong><br>
    · Kiểm tra trước trên tài khoản demo ít nhất 1-2 tuần để xác nhận liên kết hoạt động bình thường trước khi chuyển sang tài khoản thực<br>
    · Trên tài khoản thực, bắt đầu với kích thước lot tối thiểu (0,01 lot)<br>
    · Sử dụng VPS (như Tianyun Cloud VPS) để giữ phần mềm giao dịch và EA trực tuyến 24/7
  </div>
</div>`,
    docSections: [
      {
        title: '1. Định dạng tín hiệu Webhook',
        content: `Trong hộp Tin nhắn của Cảnh báo TradingView, nhập JSON sau:
<pre>{
  "license": "{{LicenseIDcủa bạn}}",
  "key": "{{SecretKeycủa bạn}}",
  "cmd": "buy",
  "symbol": "{{ticker}}",
  "lots": 0.1,
  "sl_points": 500,
  "tp_points": 1000,
  "magic": 12345,
  "comment": "TV Signal"
}</pre>
<p>Các lệnh <strong>cmd</strong> được hỗ trợ: buy / sell / buylimit / selllimit / buystop / sellstop / closebuy / closesell / closeall / closeallorders</p>`
      },
      {
        title: '2. Địa chỉ Webhook TradingView',
        content: `<p>Trong cài đặt Cảnh báo TradingView, đặt URL Webhook như sau:</p>
<pre>https://api-gw.interface003.com/api/mtbridge/webhook/</pre>
<p>Trong hộp Tin nhắn, nhập định dạng JSON tín hiệu ở trên và thay thế license và key bằng giá trị của riêng bạn.</p>`
      },
      {
        title: '3. Cài đặt WikiConnector EA',
        content: `<p>1. Tải xuống WikiConnector EA (tệp .ex5)</p>
<p>2. Sao chép EA vào thư mục <code>MQL5/Experts</code> của MT5</p>
<p>3. Mở EA trong MT5 và nhập <strong>License ID</strong> và <strong>Secret Key</strong></p>
<p>4. Cho phép EA thực hiện kết nối WebSocket (trong Tùy chọn MT5 → EA, kích hoạt quyền kết nối mạng)</p>`
      },
      {
        title: '4. Giới hạn tốc độ',
        content: `<p>Tối đa <strong>30 yêu cầu / 60 giây</strong> cho mỗi Giấy phép. Vượt quá giới hạn sẽ trả về lỗi 429.</p>
<p>Nếu bạn cần tần suất cao hơn, vui lòng liên hệ dịch vụ khách hàng để nâng cấp gói của bạn.</p>`
      }
    ],

    faqTitle: 'Câu hỏi thường gặp',
    faqs: [
      {
        q: 'Tôi nên làm gì nếu khóa của tôi bị rò rỉ?',
        a: 'Nhấp "Tạo lại" trong bảng điều khiển. Khóa cũ sẽ ngay lập tức không còn hiệu lực và tất cả kết nối EA sẽ bị ngắt. Cấu hình lại EA với khóa mới.'
      },
      {
        q: 'Các tín hiệu sẽ được gửi lại sau khi EA kết nối lại không?',
        a: 'Theo mặc định là không (để ngăn ngừa thua lỗ). Nếu bạn cần gửi lại, hãy kích hoạt "Bộ đệm ngoại tuyến" trong bảng điều khiển. Khi EA kết nối lại, nó sẽ nhận các tín hiệu tích lũy trong thời gian ngoại tuyến.'
      },
      {
        q: 'Một Giấy phép có thể kết nối bao nhiêu tài khoản MT?',
        a: 'Mỗi Giấy phép hỗ trợ tối đa 10 kết nối WebSocket đồng thời, cho phép tối đa 10 terminal MT nhận cùng một tín hiệu cùng một lúc.'
      },
      {
        q: 'MT4 có được hỗ trợ không?',
        a: 'Phiên bản hiện tại chủ yếu hỗ trợ MT5. Phiên bản MT4 của EA đang được phát triển. Hãy chờ đón!'
      },
      {
        q: 'Độ trễ tín hiệu là bao nhiêu?',
        a: 'Độ trễ trung bình là <100ms. Với Tianyun Cloud VPS, có thể thấp tới 1ms.'
      },
      {
        q: 'Làm cách nào để kiểm tra Webhook có hoạt động chính xác không?',
        a: 'Trong danh sách chứng chỉ, kiểm tra "Số lượng kết nối hiện tại". Nếu lớn hơn 0, EA đang trực tuyến. Sau khi gửi tín hiệu kiểm tra, hãy kiểm tra "Bản ghi tín hiệu gần đây" để xem trạng thái "Đã gửi".'
      }
    ],
    faqGroups: [
      {
        title: '🌲 Pine Script và gửi tín hiệu',
        items: [
          {
            q: 'Tôi sử dụng hai alert() để đóng và mở, nhưng phần mềm giao dịch chỉ nhận được một tín hiệu.',
            a: 'Đây là giới hạn mặc định của Pine Script: trong cùng một nến, chỉ alert() đầu tiên được kích hoạt. Giải pháp là <strong>thêm tham số <code>alert.freq_all</code> vào mỗi alert()</strong>:<br><code>alert(closesellMessage, alert.freq_all)</code><br><code>alert(buyMessage, alert.freq_all)</code>'
          },
          {
            q: 'Tôi nên chọn điều kiện kích hoạt nào cho Cảnh báo?',
            a: 'Khi sử dụng hàm <code>alert()</code>, bạn phải chọn <strong>"Chỉ các lệnh gọi hàm alert()"</strong>. Nếu bạn đang sử dụng phương thức <code>strategy.entry(..., alert_message=xxx)</code>, hãy chọn "Order fills only". Hai phương thức không thể trộn lẫn.'
          },
          {
            q: 'Tôi nên đặt gì trong hộp Tin nhắn?',
            a: 'Khi sử dụng phương thức <code>alert()</code>, <strong>để hộp Tin nhắn ở mặc định, không nhập gì cả</strong>. Nội dung tín hiệu được xác định bởi chuỗi bên trong <code>alert(xxx)</code> trong mã và Webhook sẽ nhận JSON đó.'
          }
        ]
      },
      {
        title: '🔌 Kết nối và nhận tín hiệu',
        items: [
          {
            q: 'Biểu tượng EA hiển thị khuôn mặt đỏ khóc 😞. Tôi nên làm gì?',
            a: 'Kiểm tra xem nút "Giao dịch tự động" trên thanh công cụ của phần mềm giao dịch có màu xanh lá không. Nếu màu đỏ, hãy nhấp để chuyển sang màu xanh lá. EA sẽ tự động trở lại trạng thái bình thường.'
          },
          {
            q: 'Tôi đã gửi tín hiệu từ TradingView nhưng phần mềm giao dịch không phản hồi.',
            a: 'Kiểm tra theo thứ tự này:<br>1. Giao dịch tự động của phần mềm giao dịch có màu xanh lá không?<br>2. Bảng EA có hiển thị "Connected" không?<br>3. URL Webhook có phải là <code>https://api-gw.interface003.com/api/mtbridge/webhook/</code> không?<br>4. Điều kiện kích hoạt Cảnh báo có phải là "Chỉ các lệnh gọi hàm alert()" không?<br>5. Mỗi alert() đã được thêm <code>alert.freq_all</code> chưa?<br>6. license và key trong JSON có khớp chính xác với cài đặt EA không?'
          }
        ]
      },
      {
        title: '💰 Thực thi giao dịch',
        items: [
          {
            q: 'Lệnh thất bại. Nguyên nhân là gì?',
            a: 'Nguyên nhân phổ biến: Số dư không đủ / Tên biểu tượng không khớp (cần cấu hình Symbol Mapping) / Kích thước lot vượt quá / Độ trượt quá lớn (tăng InpDeviation) / Thị trường đóng cửa. Kiểm tra nhật ký "Chuyên gia" ở cuối phần mềm giao dịch để biết thông tin lỗi cụ thể.'
          },
          {
            q: 'Lệnh không có stop loss hoặc take profit?',
            a: 'Kiểm tra: ① JSON tín hiệu có bao gồm các trường như <code>sl_points</code> / <code>tp_points</code> v.v. không?; ② Các tham số stop loss/take profit mặc định của EA có bằng 0 không? Nếu cả hai đều không được đặt, lệnh sẽ không có stop loss hoặc take profit.'
          },
          {
            q: 'Tên biểu tượng không khớp. Tôi nên làm gì?',
            a: 'Kích hoạt Symbol Mapping trong tham số EA:<br>Đặt <code>InpEnableMap1 = true</code><br>Đặt <code>InpMapping1 = XAUUSD|GOLD</code> (TênTradingView|TênPhầnMềmGiaoDịch)'
          },
          {
            q: 'Tôi có thể kiểm tra trước trên tài khoản demo không?',
            a: '<strong>Được khuyến nghị mạnh mẽ!</strong> Trong lần sử dụng đầu tiên, bạn nên kiểm tra trên tài khoản demo ít nhất 1-2 tuần để xác nhận liên kết hoạt động bình thường và thực thi lệnh chính xác trước khi chuyển sang tài khoản thực. Bắt đầu với kích thước lot tối thiểu 0,01.'
          }
        ]
      }
    ]
  }
}

// fallback：其他语言 fallback 到英文
const fallback = t.en

/**
 * 获取当前语言的文案
 * @param {string} lang - store.state.locale
 * @returns {object}
 */
// Prettier formats this declaration without a space, while the project ESLint rule requires one.
// eslint-disable-next-line space-before-function-paren
export function getContent(lang) {
  return t[lang] || fallback
}

export default t
